/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	var FormElementBase = __webpack_require__(1)(fox);
	
	if (typeof NodeList !== 'undefined' && !NodeList.prototype.forEach) {
		NodeList.prototype.forEach = function () {
			return Array.prototype.forEach.apply(this, arguments);
		};
	}

	return fox.extend({
		__constructor: function () {
			this.super('__constructor', arguments);

			if (!('selector' in this.params) && this.key) {
				this.params.selector = '[name^=' + this.key + ']';
			}
		},

		init: function () {
			this.form = this.formLayer.getFormDomNode();

			var initResult = this.super('init', arguments);
			var nodes = this.nodes = this.getNodes();

			if (!nodes.length) {
				throw new Error("Can't find dom node by selector: " + this.params.selector);
			}

			this.value = '';

			return initResult;
		},

		getNodes: function () {
			return this.womContainer ?
				this.womContainer.dom(this.params.selector) :
				this.form.querySelectorAll(this.params.selector);
		},

		registerEventCallbacks: function () {
			var _this = this;

			this.nodes.forEach(function (node) {
				_this.formLayer.addDomHandler({
					event: 'invalid',
					target: node,
					callback: function (el, alias, p, event) {
						event.preventDefault();

						return false;
					}
				});

				_this.formLayer.addDomHandler({
					event: 'change',
					target: node,
					callback: _this._onChange.bind(_this)
				});
			});
		},

		_onChange: function () {
			var value = this.getValue();
			
			function dispatch (value) {
				return this.dispatchEvent('change', {value: value});
			};

			if (fox.isPromise(value)) {
				return value.then(dispatch.bind(this));
			}
			
			return dispatch.call(this, value);
		},

		validate: function () {
			var result = Array.prototype.every.call(this.nodes, function (node) {
				if (node.validity)
					return node.validity.valid;
					
				return true;
			});

			if (!result)
				return this._returnValidateResult(result);

			var parentResult = this.super('validate', arguments);

			if (fox.isPromise(parentResult)) {
				return parentResult.then(function (resp) {
					return fox.merge(resp, this._returnValidateResult(resp.result && result));
				}.bind(this));
			}

			return this._returnValidateResult(result);
		},

		disable: function () {
			this.nodes.forEach(function (node) {
				if ('disabled' in node) {
					node.disabled = true;
				}
			});

			return this.super('disable', arguments);
		},

		enable: function () {
			this.nodes.forEach(function (node) {
				if ('disabled' in node) {
					node.disabled = false;
				}
			});

			return this.super('enable', arguments);
		},

		getValue: function () {
			if (!this.value) this.value = '';

			return this.super('getValue', arguments);
		}
	}, FormElementBase, null, 'FormElementDomBase');
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	var FormElementValidator = __webpack_require__(4)(fox);

	var FormElementBase = fox.extend(function FormElementBase (params, form) {
		this.params = params || {};
		this.formLayer = form;
		
		this.key = this.params.name;
		this.valid = true;
		this.noValidate = this.params.noValidate;
		this.validateOnFly = this.params.validateOnFly;
		this.valuePostProcessing = (this.formLayer.getOption('valuePostProcessing') || []).concat(this.params.valuePostProcessing || []);
		
		if (fox.isArray(this.params.validators)) {
			var validator = this._createUserValidator();

			this.params.validators.forEach(validator.addChecker, validator);
		}

		this.__constructor();
	}, {
		__constructor: function () {
			var _this = this;
			var getter = null;

			if ('womContainer' in this.params) {
				if (fox.wom.isSelector(_this.params.womContainer)) {
					getter = function () {return _this.formLayer.rwom1(_this.params.womContainer);};
				} else if (fox.oop.instanceOf(_this.params.womContainer, 'Controller')) {
					getter = function () {return _this.params.womContainer;};
				} else if (fox.isFunction(_this.params.womContainer)) {
					getter = function () {return _this.params.womContainer();};
				}

				if (getter === null) {
					throw new Error('Wrong womContainer parameter. Accepts: womSelector like "#alias, .class, .etc", Function, Controller class instance.');
				}

				Object.defineProperty(this, 'womContainer', {
					enumerable: true,
					get: getter
				});
			}

			this.formLayer.handleEvent('@this', 'change_' + this.key, function (params) {
				if (this.skip) return false;

				this.formLayer.dispatchEvent('change', fox.merge({field: this.key}, params));

				if (this.validateOnFly && !this.noValidate) {
					this.validateWithBroadcast();
				}
			}.bind(this), {
				prefix: [this.key, 'element', 'on', 'change'].join('_'),
				sync: true
			});
		},
		/**
		 * 
		 * @return {any} [description]
		 */
		super: function () {
			var args = fox.clone(arguments);

			return fox.callSuperMethod.apply(this, args.concat('super'));
		},

		/**
		 * 
		 * @return {boolean} [description]
		 */
		inDom: function () {
			if (this.womContainer) {
				return this.womContainer.isEmbedded();
			}

			return this.formLayer.getFormContainer().isEmbedded();
		},

		init: function () {return this;},

		dispatchEvent: function (event, params) {
			this.formLayer.dispatchEvent([event, this.key].join('_'), fox.merge({}, params));
		},

		getValue: function () {
			if (this.valuePostProcessing.length) {
				this.value = this.valuePostProcessing.reduce(function (value, next) {
					return next(value, this.key);
				}.bind(this), this.value);
			}

			return this.value;
		},

		setValue: function (value, broadcast) {
			this.value = value;

			if (broadcast) this.dispatchEvent('change', {value: this.getValue()});

			return this;
		},
		reset: function () {
			this.value = '';

			return this;	
		},

		disable: function () {
			this.disabled = true;
			this.dispatchEvent('disabled', {disabled: this.disabled});

			return this;
		},
		enable: function () {
			this.disabled = false;
			this.dispatchEvent('enabled', {disabled: this.disabled});

			return this;
		},

		/**
		 *
		 * @return {Promise<object>|object} [description]
		 */
		validate: function () {
			if (this.noValidate)
				return this._returnValidateResult(true);

			if (!this.userValidator)
				return this._returnValidateResult(true);

			return this.userValidator.validate(this.getValue()).then(function (resp) {
				return fox.merge(resp, this._returnValidateResult(resp.result));
			}.bind(this));
		},
		
		/**
		 * 
		 * Validate with result broadcasting
		 * @return {Promise<object>|object} 
		 */
		validateWithBroadcast: function () {
			var validateResult = this.validate();
			var dispatch = function (data) {
				this.formLayer.dispatchEvent(!data.result ? 'form_not_valid' : 'form_valid', [data]);

				return data;
			}.bind(this);

			if (!fox.isPromise(validateResult)) {
				return dispatch(validateResult);
			}

			return validateResult.then(dispatch);
		},

		/**
		 * 
		 * @param  {boolean} result [description]
		 * @return {object}        [description]
		 */
		_returnValidateResult: function (result) {
			return { result: (this.valid = result), field: this.key };
		},

		/**
		 * 
		 * @return {FormElementValidator} [description]
		 */
		_createUserValidator: function () {
			return this.userValidator || (this.userValidator = new FormElementValidator(this));
		}
	}, null, 'FormElementBase');

	fox.FormElementBase = FormElementBase;

	return FormElementBase;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	var FormElementBase = __webpack_require__(0)(fox);
	var ArrayProto = Array.prototype;

	return fox.extend({
		__constructor: function () {
			this.super('__constructor', arguments);

			this.formLayer.handleEvent('@this', 'input_' + this.key, function (params) {
				return this.formLayer.dispatchEvent('input', fox.merge({field: this.key}, params));
			}.bind(this));
		},

		registerEventCallbacks: function () {
			this.super('registerEventCallbacks', arguments);

			if (!fox.inArray(['radio', 'checkbox'], this.inputType)) {
				this.formLayer.addDomHandler({
					event: 'input',
					target: this.nodes[0],
					callback: function () {
						this.dispatchEvent('input', {value: this.getValue()});
					}.bind(this)
				});
			}

			if (this.inputType === 'submit') {
				this.formLayer.addDomHandler({
					event: 'click',
					target: this.nodes[0],
					callback: function () {
						this.submitIsPressed = true;
					}.bind(this)
				});

				this.formLayer.handleEvent('@this', 'submit', function () {
					delete this.submitIsPressed;
				}.bind(this), {
					prefix: 'sendTypeSubmitValue'
				})
			}
		},

		init: function () {
			var initResult = this.super('init', arguments);

			this.inputType = this.nodes[0].type;

			this.registerEventCallbacks();

			if (ArrayProto.some.call(this.nodes, function (node) {return node.name.match(/\w+\[\]$/) !== null;})) {
				this.valueAsArray = true;
			} else {
				this.delimiter = this.params.delimiter || ',';
			}

			return initResult;
		},

		getValue: function () {
			if (!this.inDom()) return this.super('getValue', arguments);

			switch (this.inputType) {
				case 'checkbox':
				case 'radio':
					var values = ArrayProto.reduce.call(this.nodes, function (acc, node) {
						if (node.checked) acc.push(node.value);

						return acc;
					}, []);

					if (this.valueAsArray) {
						this.value = values;
					} else {
						this.value = values.join(this.delimiter);
					}
				break;
				case 'submit':
					if (!this.submitIsPressed) {
						this.value = '';
					} else {
						this.value = this.nodes[0].value;
					}
				break;
				default:
					this.value = this.nodes[0].value;
			}

			return this.super('getValue', arguments);
		},

		setValue: function (value) {
			if (!this.inDom()) return this.super('setValue', arguments);

			var processed = true;

			switch (this.inputType) {
				case 'checkbox':
					if (!fox.isArray(value)) {
						if (fox.isString(value)) {
							value = value.split(this.delimiter);
						} else {
							value = [];
						}
					}

					ArrayProto.some.call(this.nodes, function (node) {
						node.checked = fox.inArray(value, node.value);
					});
				break;
				case 'radio':
					processed = ArrayProto.some.call(this.nodes, function (node) {
						return node.value === value && (node.checked = true);
					});
				break;
				case 'submit':
					value = this.nodes[0].value;
				break;
				default:
					this.nodes[0].value = value;
			}

			return processed && this.super('setValue', arguments) || this;
		},

		reset: function () {
			this.value = '';

			switch (this.inputType) {
				case 'checkbox':
				case 'radio':
					this.nodes.forEach(function (node) {
						node.checked = false;
					});
				break;
				case 'submit':
					this.value = this.nodes[0].value;
				break;
				default:
					this.nodes[0].value = this.value;
			}

			return this.super('reset', arguments);
		}
	}, FormElementBase, null, 'FormElementDomInput');
}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (fox) {
	'use strict';

	fox.registerWidget('SimpleForm', {
		/**
		 * @param {Object} values
		 * @returns {Promise}
		 */
		submit: function (values) {
			return fox.Promise.resolve(values).then(function (_values) {
				this.dispatchEvent('submit', _values);

				return _values;
			}.bind(this));
		}
	}, 'Controller');
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	var foxValidatorShim = __webpack_require__(5)(fox);

	return fox.extend(function FormElementValidator (element) {
		this.element = element;
		
		this._checkers = [];
		this._resultHistory = {};
		this._inProgress = {};
	}, {
		/**
		 * 
		 * @param {function} fn (value, <FormElementValidator>): {result:boolean, message:string}
		 */
		addChecker: function (checker) {
			if (fox.isObject(checker))
				checker = foxValidatorShim(checker);

			if (fox.isFunction(checker) && !fox.inArray(this._checkers, checker)) {
				var checkerIndex = this._checkers.push(checker) - 1;

				checker.toString = function () { return 'checker_' + checkerIndex; };
			}

			return false;
		},

		validate: function (value) {
			if (!this._checkers.length)
				return fox.Promise.resolve({result: true});

			if (fox.isPromise(value))
				return value.then(function (resp) {
					return this._validate(resp);
				}.bind(this));

			return this._validate(value);
		},

		_validate: function (value) {
			var _this = this;
			var inProgress = this._inProgress;
			var hash = this._generateHash(value);

			if (hash in this._resultHistory)
				return fox.Promise.resolve(this._resultHistory[hash]);

			function addInProgress(id, nextResult, value) {
				nextResult.__value = value;

				inProgress[id] = nextResult;

				return nextResult.then(function (result) {
					delete inProgress[id];

					return result;
				}).catch(function (error) {
					delete inProgress[id];

					throw error;
				});
			}

			return this._checkers.reduce(function (prevPromise, next, idx) {
				return prevPromise.then(function (resp) {
					if (resp.result === false)
						return resp;

					var nextId = next.toString();

					if (nextId in inProgress) {
						var inProgressValue = inProgress[nextId].__value;

						return inProgress[nextId].then(function (resp) {
							if (inProgressValue !== value)
								return addInProgress(nextId, next(value, _this), value);

							return resp;
						});
					}

					var nextResult = next(value, _this);

					if (!fox.isPromise(nextResult))
						return nextResult;

					return addInProgress(nextId, nextResult, value);
				});
			}, fox.Promise.resolve({ result: true })).then(function (resp) {
				if (hash)
					this._resultHistory[hash] = resp;

				return resp;
			}.bind(this));
		},

		resetResultCache: function (value) {
			if (!fox.isUndefined(value)) {
				var hash = this._generateHash(value);

				if (hash in this._resultHistory)
					return delete this._resultHistory[hash];
			}

			this._resultHistory = {};

			return true;
		},

		_generateHash: function (value) {
			var hash = null;

			if (fox.isNumeric(value))
				hash = fox.getStringSimpleHash(value.toString());

			if (fox.isString(value))
				hash = fox.getStringSimpleHash(value);

			if (fox.isObject(value) || fox.isArray(value))
				hash = fox.getStringSimpleHash(JSON.stringify(value));

			return hash;
		}
	}, null, 'FormElementValidator')
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (fox) {
	var rules = fox.Validator._._helpers;

	return function (rule) {
		if (!(rule.validator in rules)) {
			throw new TypeError('No such "' + rule.validator + '" validator')
		}

		var ruleInstance = new rules[rule.validator]()
			.setMessage(rule.message || 'Value is invalid')
			.setOptions(rule.options || {});

		return function (value) {
			var result = ruleInstance.setValue(value).validate();

			return {
				result: result,
				message: ruleInstance.getMessage()
			};
		};
	};
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	var FormElementBase = __webpack_require__(0)(fox);
	var ArrayProto = Array.prototype;

	return fox.extend({
		init: function () {
			var initResult = this.super('init', arguments);
			this.registerEventCallbacks();

			this.isMultiple = this.nodes[0].multiple;
			
			return initResult;
		},

		getValue: function () {
			if (!this.inDom()) return this.super('getValue', arguments);

			this.value = ArrayProto.reduce.call(this.nodes[0].options, function (acc, option) {
				if (option.selected) acc.push(option.value);

				return acc;
			}, []);

			if (!this.isMultiple) {
				this.value = this.value[0];
			}

			return this.super('getValue', arguments);
		},

		setValue: function (value) {
			if (!this.inDom()) return this.super('setValue', arguments);

			if (!this.isMultiple) {
				ArrayProto.some.call(this.nodes[0].options, function (option) {
					if (fox.isArray(value)) value = value[0];

					return option.value === value &&
						(option.selected = true) ||
						(option.selected = false);
				});
			} else {
				ArrayProto.reduce.call(this.nodes[0].options, function (acc, option) {
					if (!fox.isArray(value)) {
						value = [value];
					}
					if (fox.inArray(value, option.value)) {
						acc.push(value);
					}
					
					option.selected = fox.inArray(value, option.value);

					return acc;
				}, []);
			}

			return this.super('setValue', arguments);
		},

		reset: function () {
			ArrayProto.forEach.call(this.nodes[0].options, function (option) {
				option.selected = false;
			});

			this.value = this.isMultiple ? [] : this.getValue();

			return this;
		}
	}, FormElementBase, null, 'FormElementDomSelect');
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	var FormElementInput = __webpack_require__(2)(fox);

	return fox.extend({}, FormElementInput, null, 'FormElementDomTextarea');
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	var FormElementBase = __webpack_require__(0)(fox);

	return fox.extend({
		__constructor: function () {
			this.params.womContainer = function () {
				return this.uploader.rwom1('#' + this.uploader.state);
			}.bind(this);

			this.super('__constructor', arguments);
					
			if (fox.wom.isSelector(this.params.uploader)) {
				this.uploader = this.formLayer.rwom1(this.params.uploader);
			} else if (fox.oop.instanceOf(this.params.uploader, 'Controller')){
				this.uploader = this.params.uploader;
			}

			if (!this.uploader)
				throw new Error('Uploader is missing for "' + this.key + '" field');

			this.uploader.addHook(function () {return false;}, 'onStartInitUpload');

			this.formLayer.handleEvent(this.uploader, 'switchState', function () {
				return this.init();
			}.bind(this), {
				prefix: ['watch', 'uploader', 'input', 'state'].join('_')
			});

			this.validateExistingImage = this.params.validateExistingImage || false;
		},

		init: function () {
			var previosValue = this.value;

			if (this.uploader.state === 'input') {
				this.super('init', arguments);
				this.registerEventCallbacks();

				this.value = null;

				if (this.disabled) {
					this.disable();
				}
				
				if (previosValue) {
					this.dispatchEvent('change', {value: null});
				}
			} else {
				if (this.womContainer.isEmbedded()) {
					this.nodes = this.womContainer.element;
				} else {
					this.womContainer.wait('addedToDom').then(function () {
						this.nodes = this.womContainer.element;
					}.bind(this));
				}
			}

			return this;
		},

		registerEventCallbacks: function () {
			var _this = this;

			if (!this.params.lazyUpload) {
				this.nodes.forEach(function (node) {
					_this.formLayer.addDomHandler({
						event: 'change',
						target: node,
						callback: _this.uploadFiles.bind(_this)
					});
				});
			}
		},

		setValue: function (value) {
			try {
				this.uploader.setValue(value);
			} catch (e) {
				fox.exception(e);
			}

			return this.super('setValue', arguments);
		},

		getValue: function (files) {
			if (!files && this.params.lazyUpload && this._getFiles()) {
				return this.uploadFiles();
			}

			return !files && this.value || this.uploadFiles();
		},

		uploadFiles: function () {
			var args = fox.clone(arguments);

			args[0] = this.nodes[0];

			if (this.uploader.state === 'progress' && this.inProgress) return this.inProgress;

			if (this._getFiles() && this.uploader.changeHandler.apply(this.uploader, args)) {
				this.inProgress = this.uploader.initUpload(this._getFiles()).then(function (resp) {
					delete this.inProgress;

					if (this.uploader.getOption('useOneApi')) {
						this.value = fox.objectGet(resp, 'params.answer.resource');
					} else {
						this.value = resp.map(function (oneResp) {
							return fox.objectGet(oneResp, 'params.answer.resource');
						});
					}

					this.dispatchEvent('change', {value: this.super('getValue', arguments)});

					return this.value;
				}.bind(this));

				return this.inProgress;
			}

			return false;
		},

		validate: function () {
			if (this.uploader.state !== 'input' && !this.validateExistingImage)
				return this._returnValidateResult(true);

			return this.super('validate', arguments);
		},

		_getFiles: function () {
			var node = this.nodes && this.nodes[0];

			return node && node.files && node.files.length && node.files || false;
		}
	}, FormElementBase, null, 'FormElementDomUploader');
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
    var FormElementBase = __webpack_require__(1)(fox);

    /**
     * {
     *     type: 'computed',
     *     combine: ['field-2', 'field-1'],
     *     formatter: function (values) {return {get: function, set: function}}
     * }
     */

    function defaultFormatter (values) {
        return {
            get: function () {return values.join('/');},
            set: function () {return values.split('/');}
        };
    }

    return fox.extend({
        __constructor: function () {
            this.super('__constructor', arguments);

            this.combine = fox.isArray(this.params.combine) && this.params.combine || [];
            this.formatter = fox.isFunction(this.params.formatter) && this.params.formatter || defaultFormatter;

            if (this.combine.length) {
                this.formLayer.wait('@this', 'internal_form_ready', {
                    prefix: [this.key, 'form', 'ready'].join('_'),
                    sync: true
                }).then(this.onFormReady.bind(this));
            }
        },

        onFormReady: function () {
            if (!this.combine.length) {
                this.formLayer.removeOption('elements' + this.key);
                return this.formLayer.removeElement(this.key);
            }

            this.combine.forEach(function (key) {
                if (key in this.formLayer._elements) {
                    this.formLayer._elements[key].skip = true;

                    this.formLayer.handleEvent('@this', 'change_' + key, function (params) {
                        this.dispatchEvent('change', {value: this.getValue()});
                    }.bind(this), {
                        prefix: [key, 'events', 'proxy', 'to', this.key].join('_'),
                        sync: true
                    });
                }
            }, this);
        },

        getValue: function () {
            var _this = this;

            var returnValue = this.combine.reduce(function (prev, next) {
                var value = this.formLayer.getElement(next).getValue();

                if (!('async' in prev) && fox.isPromise(value)) {
                    prev.async = value.then(function (value) {
                        prev.values.push(value);

                        return value;
                    });
                } else if ('async' in prev) {
                    prev.async = prev.async.then(function () {
                        return fox.isPromise(value) ? value : fox.Promise.resolve(value);
                    }).then(function (value) {
                        prev.values.push(value);

                        return value;
                    });
                } else {
                    prev.values.push(value);
                }

                return prev;
            }.bind(this), {values: []});

            if ('async' in returnValue) return returnValue.async.then(function () {
                this.value = this.formatter(returnValue.values).get();

                return this.super('getValue', arguments);
            }.bind(this));

            this.value = this.formatter(returnValue.values).get();

            return this.super('getValue', arguments);
        },

        setValue: function (value) {
            var _this = this;
            var values = this.formatter(value).set();

            if (fox.isArray(values) && values.length === this.combine.length) {
                values.forEach(function (value, idx) {
                    this.formLayer.getElement(this.combine[idx]).setValue(value);
                }, this);

                return this.super('setValue', arguments);
            }

            return this;
        },

        _returnValidateResult: function () {
            return fox.merge(this.super('_returnValidateResult', arguments), {
                combine: this.combine
            });
        },

        disable: function () {
            return this.combine.every(function (field) {
                return this.formLayer.disable(field); 
            }, this) && this.super('disable', arguments);
        },

        enable: function () {
            return this.combine.every(function (field) {
                return this.formLayer.enable(field); 
            }, this) && this.super('enable', arguments);
        }
    }, FormElementBase, null, 'FormElementComputed');
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


if (!String.prototype.ucfirst) {
	String.prototype.ucfirst = function() {
		var str = this;
		if (str.length) {
			str = str.charAt(0).toUpperCase() + str.slice(1);
		}

		return str;
	}
}

if (true) {
	__webpack_require__(11);
} else {
	require('script!fox-core/dist/fox.js');
}

// shim for IE in particular
if (!('Promise' in window)) {
	window.Promise = fox.Promise;
}

var lib = fox.lib = fox.initDefaultLibrary();

fox.jQuery = __webpack_require__(14);
window.jQuery = fox.jQuery;
window.$ = fox.jQuery;

fox.getEnv = function (path) {
	return fox.objectGet(environment, path);
};

fox.setEnv = function (path, value) {
	return fox.objectSet(environment, path, value);
};

fox.createApplication = function (options, env) {
	var wom = this.createEnvironment(lib);
	var app = wom.loadWidget(options.widget || 'App', options || {});

	this.site = app;
	this.wom = app.getWom();
	this.setEnv = app.setEnv.bind(app);
	this.getEnv = app.getEnv.bind(app);
	app.setEnv(env || {});
};

var resources = {};
fox._r = function (alias, path) {
	return resources[alias] || (resources[alias] = path);
};

__webpack_require__(15)(fox);
__webpack_require__(79)(fox);

try {
	var main = __webpack_require__(84);

	if (window.customization) {
		var c11n = window.customization;

		if (fox.isFunction(c11n)) {
			c11n = c11n(fox);
		}

		c11n.resources(fox);
		main(fox, environment && environment.staticUrl);
		c11n.nonResources(fox);
	} else {
		main(fox, environment && environment.staticUrl);
	}

	if (typeof _fox_init_ === 'function') {
		_fox_init_();
	}
} catch (e) {
	if (typeof __blankPage === 'function') {
		__blankPage(e);
	}

	console.error(e);
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(12)(__webpack_require__(13))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript === "function")
		execScript(src);
	else
		eval.call(null, src);
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "!function(t,e){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=e():\"function\"==typeof define&&define.amd?define([],e):\"object\"==typeof exports?exports.fox=e():t.fox=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,\"a\",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p=\"\",e(e.s=19)}([function(t,e,n){var i=n(9);i.extend=function(t,e,n,r){var o=function(){},s=typeof t,a;e=e||function(){},r=r||\"foxClass\",\"object\"===s?(a=i.keys(t),t=Object.create(t),o=function(){this._myProps=a,this._className=r},i.mixin(t,e.prototype),o.prototype=t):(a=i.keys(e),o=function(){this._myProps=a,this._className=r},o.prototype=e.prototype||e);var u;u=e.prototype&&e.prototype.constructor?e.prototype.constructor:function(){};var c;c=\"function\"===s?t:n||u;var l;return l=function(){c.apply(this,arguments)},l.prototype=new o,l.prototype.constructor=l,l.prototype.superclass=e.prototype,l},t.exports=i},function(t,e,n){\"use strict\";function i(t){this._node=t,t._foxedNode=this}function r(t){return t&&t.getAttribute(\"class\")||\"\"}var o=n(0),s=t.exports={};s.event={stop:function(t){t.preventDefault(),t.stopPropagation()}},s.Node=i,s.create=function(t){return this.wrap(document.createElement(t))},s.wrap=function(t){return!!t&&(t instanceof s.Node?t:this.isElement(t)?t._foxedNode?t._foxedNode:new s.Node(t):void 0)},s.isElement=function(t){return-1!==[\"object\",\"function\"].indexOf(typeof t)&&t.nodeType>0},s.sel1=function(t){var e=this.selectFirst(t);return!!e&&this.wrap(e)},s.on=function(t,e,n){return e?o.isArray(e)?o.each(e,function(e){this.on(t,e,n)},this):(e.addEventListener?e.addEventListener(t,n,!1):e.attachEvent(\"on\"+t,n),e):(o.log(\"fox.dom.on: empty element passed\",!0),!1)},s.off=function(t,e,n){return e?o.isArray(e)?o.each(e,function(e){this.off(t,e,n)},this):(e.removeEventListener?e.removeEventListener(t,n):e.detachEvent(\"on\"+t,n),e):(o.log(\"fox.dom.on: empty element passed\",!0),!1)},s.addClass=function(t,e){return!!e&&(o.isArray(e)||this.detectFragment(e)?o.each(e,function(e){this.addClass(t,e)},this):this.hasClass(t,e)?e:(e.setAttribute(\"class\",o.trim(r(e).split(\" \").concat(t).join(\" \"))),e))},s.removeClass=function(t,e){if(!e)return!1;if(o.isArray(e)||this.detectFragment(e))return o.each(e,function(e){this.removeClass(t,e)},this);if(!this.hasClass(t,e))return!1;var n=r(e).split(\" \").filter(function(e){return e!==t});e.setAttribute(\"class\",n.join(\" \"))},s.hasClass=function(t,e){return-1!==r(e).split(\" \").indexOf(t)},s.detectFragment=function(t){return t&&\"#document-fragment\"===t.nodeName},s.select=function(t,e,n,i){var r;if(o.isArray(e))return r=[],o.each(e,function(e){r=o.merge(this.select(t,e))},this),r;if(\"@document\"===t)return r=(n||window).document,i?r:[r];var s=e||(n||window).document;return o.isString(t)?i?(r=s.querySelector(t),r?[r]:[]):Array.prototype.slice.call(s.querySelectorAll(t)):[t]},s.selectFirst=function(t,e,n){return this.select(t,e,n,!0)[0]},s.target=function(t){return t=t||window.event,t.target||t.srcElement},s.getDocument=function(){return document},s.getStyleSheets=function(){return document.styleSheets},s.isDomNode=function(t){return t&&!!t.nodeType},s.documentHasFocus=function(){return!o.isFunction(document.hasFocus)||document.hasFocus()},s.createFragmentFromHtml=function(t){var e=document.createElement(\"div\"),n=document.createDocumentFragment();e.innerHTML=t;for(var i=0;i<e.childNodes.length;i++){var r=e.childNodes[i].cloneNode(!0);3!==r.nodeType&&n.appendChild(r)}return n}},function(t,e,n){\"use strict\";function i(t){r.defineProperty.call(this,\"_id\",r.uniqueId(\"c\"),{enumerable:!1,writable:!1}),this.embedAddress=[-1],r.each(t,function(t,e){this[e]=t},this),this._handlers={},this._hrefs={},this._prepared=null,this.vars=[],this.varPositions={},this.address=[],this.parentCtx&&(this.lib=this.parentCtx.lib),this.__constructor()}var r=n(0),o=n(29),s=n(31),a=n(28),u=n(32),c=r.extend(i,r.merge({__constructor:function(){this.on(\"prepare\",this.prepare,this),this.on(\"compile\",this.compile,this),this.on(\"plain_variables\",this.getPlainVariables,this)},addVars:function(t,e){return!r.isUndefined(e)&&r.isArray(e)||(e=this.vars),r.each(t,function(t,n){var i=t[4]||\"default\";e.push({variable:t,address:r.clone(this.address),subject:i,indx:n})},this),this},prepare:function(){return this._prepared=this.templateRecursion(this.node),this.emit(\"prepare\"),this},_beforeCompile:function(t,e,n){this.target=t,this.data=e,this.opts=n||{},this.opts.scopes=this.opts.scopes||{},this._binds={}},compile:function(t,e,n,i){function o(){var t=this.cloneFragment(this._prepared);return t.childNodes.length&&this.vars.length&&this.walkVariables(t),this.compileComponents(t,this.data,this.opts),t}this._beforeCompile(t,e,n);var s;if(i=i||{},i.iterateScope){var a=this.getIterator(this.data[i.iterateScope]);for(s=this.doc.createDocumentFragment(),r.objectSet(this.opts.scopes,[\"subjectIterator\",i.iterateScope],a);a.iterate();)s.appendChild(o.call(this,this.opts))}return s||(s=o.call(this,this.opts)),s.childNodes.length&&this.embedByAddress(this.target,s),delete this.target,this},cloneFragment:function(t){var e=this.doc.createDocumentFragment();return r.each(t.childNodes,function(t){e.appendChild(t.cloneNode(!0))}),e},embedByAddress:function(t,e,n){var i;n=n||this.embedAddress;for(var o=0;o<n.length;o++)-1!==(i=n[o])&&t.childNodes[i]&&(t=t.childNodes[i]);return r.isNull(e)?t:this._embedToTarget(t,e,i)},_embedToTarget:function(t,e,n){return-1===n?(t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e),t):(t.parentNode.insertBefore(e,t.nextSibling),t.parentNode)}},o,s,a,u),null,\"ComponentBase\");t.exports={create:function(t){return new c(t)},constructor:c}},function(t,e,n){\"use strict\";var i=n(0),r=t.exports={};r.instanceOf=function(t,e){for(var n=t;n;){if(n._className===e)return!0;n=n.superclass}return!1},r.getParents=function(t){for(var e=t,n=[];e;)n.push(e._className),e=e.superclass;return n},r.createCallback=function(t,e){return i.isObject(t)&&t.subj?t:{subj:t,scope:e}},r.getRealCallback=function(t){if(i.isFunction(t))return t;if(i.isFunction(t.subj))return t.scope?i.bind(t.subj,t.scope):t.subj;if(!~t.subj.indexOf(\":\"))return i.bind(t.scope[t.subj],t.scope);var e,r=n(7)(),o=t.subj.split(\":\");switch(o[0]){case\"handlerDom\":if(t.scope&&(e=t.scope.getOption(\"handlerDom.\"+o[1]))||(e=fox.site.getOption(\"handlerDom.\"+o[1])),!i.isFunction(e))throw\"Callback for \"+o[1]+\" dom handler does not exist\";return i.bind(e,t.scope);case\"handlerWom\":if((e=t.scope.getOption(\"handlerWom.\"+o[1]))||(e=fox.site.getOption(\"handlerWom.\"+o[1])),!i.isFunction(e))throw\"Handler for \"+o[1]+\" wom handler does not exist\";return i.bind(e,t.scope)}if(o.length>0&&r.isSelector(o[0])){var s=r.selectFirst(o[0],[t.scope]);if(s&&i.isFunction(s[i.trim(o[1])]))return i.bind(s[i.trim(o[1])],s)}throw console.log(t),\"Invalid callback: \"+t.subj}},function(t,e,n){\"use strict\";var i=n(0),r=n(1),o=n(2).constructor,s=[\"addattr\",\"addclass\",\"addattribute\"],a=i.extend({__constructor:function(){this.callParent(\"__constructor\",arguments),this.actionNode=this.node,this.node=this.actionNode[2],this.actions={}},prepare:function(){i.each(this.actionNode[1],function(t,e){i.inArray(s,e.toLowerCase())&&(this.actions[e]=t)},this),i.each(this.actionNode[3],function(t){var e=t[1].toLowerCase();i.inArray(s,e)&&!this.actions.hasOwnProperty(t[1])&&(this.actions[t[1]]=\"\")},this),i.count(this.actions)||this.off(\"compile\").off(\"plain_variables\"),this.addVars(this.actionNode[3])},compile:function(t,e,n){if(this._beforeCompile(t,e,n),this.embedAddress.length<2){for(var i=this.parentCtx;i.embedAddress.length<2;)i=i.parentCtx;this.applyActions(this.actions,this.embedByAddress(i.target,null,i.embedAddress),this.vars,this.data,this.opts.scopes)}else this.applyActions(this.actions,this.embedByAddress(t,null),this.vars,this.data,this.opts.scopes)},applyActions:function(t,e,n,o,s){function a(t,n){switch(n?n=this.applyRuntimeVariables(n):(n=this.getVariableByAttrName(t.toLowerCase()),n=n&&this.getVariableValue(n)),t.toLowerCase()){case\"addattr\":case\"addattribute\":var o=n.split(\":\"),s=o.shift(),a=\"\";o.length?(a=o.length>1?o.join(\":\"):o[0],i.isEmpty(a)||e.setAttribute(s,a)):e.setAttribute(s,a);break;case\"addclass\":i.isEmpty(n)||1!==e.nodeType||r.addClass(n,e)}}if(!r.isDomNode(e))return!1;i.isEmpty(t)||i.each(t,function(t,e){a.call(this,e,t)},this)},embedByAddress:function(t,e,n){var i=this.callParent(\"embedByAddress\",arguments);return i.parentNode&&(3===i.nodeType||n&&n.length&&n[n.length-1]>-1)&&i.parentNode||i}},o,null,\"ComponentAction\");t.exports={mixin:{createActionComponent:function(t){var e=i.clone(t);return e[0]=\"action\",this.createComponentByTag(e),this}},create:function(t){return new a(t)},constructor:a}},function(t,e,n){(function(t,i,r){!function(t,n){n(e)}(0,function(e){\"use strict\";function o(t,e){for(var n=0,i=t.length;n<i;n++)if(t[n]===e)return n;return-1}function s(t){var e=t._promiseCallbacks;return e||(e=t._promiseCallbacks={}),e}function a(t,e){if(2!==arguments.length)return At[t];At[t]=e}function u(t){var e=typeof t;return null!==t&&(\"object\"===e||\"function\"===e)}function c(t){return\"function\"==typeof t}function l(t){return null!==t&&\"object\"==typeof t}function h(t){return null!==t&&\"object\"==typeof t}function f(){setTimeout(function(){for(var t=0;t<kt.length;t++){var e=kt[t],n=e.payload;n.guid=n.key+n.id,n.childGuid=n.key+n.childId,n.error&&(n.stack=n.error.stack),At.trigger(e.name,e.payload)}kt.length=0},50)}function d(t,e,n){1===kt.push({name:t,payload:{key:e._guidKey,id:e._id,eventName:t,detail:e._result,childId:n&&n._id,label:e._label,timeStamp:Ot(),error:At[\"instrument-with-stack\"]?new Error(e._label):null}})&&f()}function p(t,e){var n=this;if(t&&\"object\"==typeof t&&t.constructor===n)return t;var i=new n(m,e);return A(i,t),i}function g(){return new TypeError(\"A promises callback cannot return that same promise.\")}function m(){}function v(t){try{return t.then}catch(t){return Pt.error=t,Pt}}function _(t,e,n,i){try{t.call(e,n,i)}catch(t){return t}}function y(t,e,n){At.async(function(t){var i=!1,r=_(n,e,function(n){i||(i=!0,e!==n?A(t,n,void 0):x(t,n))},function(e){i||(i=!0,O(t,e))},\"Settle: \"+(t._label||\" unknown promise\"));!i&&r&&(i=!0,O(t,r))},t)}function b(t,e){e._state===St?x(t,e._result):e._state===Et?(e._onError=null,O(t,e._result)):k(e,void 0,function(n){e!==n?A(t,n,void 0):x(t,n)},function(e){return O(t,e)})}function w(t,e,n){e.constructor===t.constructor&&n===N&&t.constructor.resolve===p?b(t,e):n===Pt?(O(t,Pt.error),Pt.error=null):c(n)?y(t,e,n):x(t,e)}function A(t,e){t===e?x(t,e):u(e)?w(t,e,v(e)):x(t,e)}function j(t){t._onError&&t._onError(t._result),C(t)}function x(t,e){t._state===Ct&&(t._result=e,t._state=St,0===t._subscribers.length?At.instrument&&d(\"fulfilled\",t):At.async(C,t))}function O(t,e){t._state===Ct&&(t._state=Et,t._result=e,At.async(j,t))}function k(t,e,n,i){var r=t._subscribers,o=r.length;t._onError=null,r[o]=e,r[o+St]=n,r[o+Et]=i,0===o&&t._state&&At.async(C,t)}function C(t){var e=t._subscribers,n=t._state;if(At.instrument&&d(n===St?\"fulfilled\":\"rejected\",t),0!==e.length){for(var i=void 0,r=void 0,o=t._result,s=0;s<e.length;s+=3)i=e[s],r=e[s+n],i?P(n,i,r,o):r(o);t._subscribers.length=0}}function S(){this.error=null}function E(t,e){try{return t(e)}catch(t){return Tt.error=t,Tt}}function P(t,e,n,i){var r=c(n),o=void 0,s=void 0;if(r){if((o=E(n,i))===Tt)s=o.error,o.error=null;else if(o===e)return void O(e,g())}else o=i;e._state!==Ct||(r&&void 0===s?A(e,o):void 0!==s?O(e,s):t===St?x(e,o):t===Et&&O(e,o))}function T(t,e){var n=!1;try{e(function(e){n||(n=!0,A(t,e))},function(e){n||(n=!0,O(t,e))})}catch(e){O(t,e)}}function N(t,e,n){var i=this,r=i._state;if(r===St&&!t||r===Et&&!e)return At.instrument&&d(\"chained\",i,i),i;i._onError=null;var o=new i.constructor(m,n),s=i._result;if(At.instrument&&d(\"chained\",i,o),r===Ct)k(i,o,t,e);else{var a=r===St?t:e;At.async(function(){return P(r,o,a,s)})}return o}function R(t,e,n){return t===St?{state:\"fulfilled\",value:n}:{state:\"rejected\",reason:n}}function M(t,e){return xt(t)?new Nt(this,t,!0,e).promise:this.reject(new TypeError(\"Promise.all must be called with an array\"),e)}function H(t,e){var n=this,i=new n(m,e);if(!xt(t))return O(i,new TypeError(\"Promise.race must be called with an array\")),i;for(var r=0;i._state===Ct&&r<t.length;r++)k(n.resolve(t[r]),void 0,function(t){return A(i,t)},function(t){return O(i,t)});return i}function D(t,e){var n=this,i=new n(m,e);return O(i,t),i}function W(){throw new TypeError(\"You must pass a resolver function as the first argument to the promise constructor\")}function F(){throw new TypeError(\"Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.\")}function I(){this.value=void 0}function V(t){try{return t.then}catch(t){return Dt.value=t,Dt}}function L(t,e,n){try{t.apply(e,n)}catch(t){return Dt.value=t,Dt}}function U(t,e){for(var n={},i=t.length,r=new Array(i),o=0;o<i;o++)r[o]=t[o];for(var s=0;s<e.length;s++){n[e[s]]=r[s+1]}return n}function B(t){for(var e=t.length,n=new Array(e-1),i=1;i<e;i++)n[i-1]=t[i];return n}function G(t,e){return{then:function(n,i){return t.call(e,n,i)}}}function q(t,e){var n=function(){for(var n=this,i=arguments.length,r=new Array(i+1),o=!1,s=0;s<i;++s){var a=arguments[s];if(!o){if((o=J(a))===Wt){var u=new Ht(m);return O(u,Wt.value),u}o&&!0!==o&&(a=G(o,a))}r[s]=a}var c=new Ht(m);return r[i]=function(t,n){t?O(c,t):void 0===e?A(c,n):!0===e?A(c,B(arguments)):xt(e)?A(c,U(arguments,e)):A(c,n)},o?$(c,r,t,n):z(c,r,t,n)};return n.__proto__=t,n}function z(t,e,n,i){var r=L(n,i,e);return r===Dt&&O(t,r.value),t}function $(t,e,n,i){return Ht.all(e).then(function(e){var r=L(n,i,e);return r===Dt&&O(t,r.value),t})}function J(t){return!(!t||\"object\"!=typeof t)&&(t.constructor===Ht||V(t))}function K(t,e){return Ht.all(t,e)}function Y(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function Z(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function Q(t,e){return xt(t)?new Ft(Ht,t,e).promise:Ht.reject(new TypeError(\"Promise.allSettled must be called with an array\"),e)}function X(t,e){return Ht.race(t,e)}function tt(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function et(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function nt(t,e){return l(t)?new Vt(Ht,t,e).promise:Ht.reject(new TypeError(\"Promise.hash must be called with an object\"),e)}function it(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function rt(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function ot(t,e){return l(t)?new Lt(Ht,t,!1,e).promise:Ht.reject(new TypeError(\"RSVP.hashSettled must be called with an object\"),e)}function st(t){throw setTimeout(function(){throw t}),t}function at(t){var e={resolve:void 0,reject:void 0};return e.promise=new Ht(function(t,n){e.resolve=t,e.reject=n},t),e}function ut(t,e,n){return xt(t)?c(e)?Ht.all(t,n).then(function(t){for(var i=t.length,r=new Array(i),o=0;o<i;o++)r[o]=e(t[o]);return Ht.all(r,n)}):Ht.reject(new TypeError(\"RSVP.map expects a function as a second argument\"),n):Ht.reject(new TypeError(\"RSVP.map must be called with an array\"),n)}function ct(t,e){return Ht.resolve(t,e)}function lt(t,e){return Ht.reject(t,e)}function ht(t,e){return Ht.all(t,e)}function ft(t,e){return Ht.resolve(t,e).then(function(t){return ht(t,e)})}function dt(t,e,n){return xt(t)||l(t)&&void 0!==t.then?c(e)?(xt(t)?ht(t,n):ft(t,n)).then(function(t){for(var i=t.length,r=new Array(i),o=0;o<i;o++)r[o]=e(t[o]);return ht(r,n).then(function(e){for(var n=new Array(i),r=0,o=0;o<i;o++)e[o]&&(n[r]=t[o],r++);return n.length=r,n})}):Ht.reject(new TypeError(\"RSVP.filter expects function as a second argument\"),n):Ht.reject(new TypeError(\"RSVP.filter must be called with an array or promise\"),n)}function pt(t,e){Kt[Ut]=t,Kt[Ut+1]=e,2===(Ut+=2)&&Yt()}function gt(){return void 0!==Bt?function(){Bt(vt)}:mt()}function mt(){return function(){return setTimeout(vt,1)}}function vt(){for(var t=0;t<Ut;t+=2){(0,Kt[t])(Kt[t+1]),Kt[t]=void 0,Kt[t+1]=void 0}Ut=0}function _t(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function yt(){At.on.apply(At,arguments)}function bt(){At.off.apply(At,arguments)}var wt={mixin:function(t){return t.on=this.on,t.off=this.off,t.trigger=this.trigger,t._promiseCallbacks=void 0,t},on:function(t,e){if(\"function\"!=typeof e)throw new TypeError(\"Callback must be a function\");var n=s(this),i=void 0;i=n[t],i||(i=n[t]=[]),-1===o(i,e)&&i.push(e)},off:function(t,e){var n=s(this),i=void 0,r=void 0;e?(i=n[t],-1!==(r=o(i,e))&&i.splice(r,1)):n[t]=[]},trigger:function(t,e,n){var i=s(this),r=void 0;if(r=i[t])for(var o=0;o<r.length;o++)(0,r[o])(e,n)}},At={instrument:!1};wt.mixin(At);var jt=void 0;jt=Array.isArray?Array.isArray:function(t){return\"[object Array]\"===Object.prototype.toString.call(t)};var xt=jt,Ot=Date.now||function(){return(new Date).getTime()},kt=[],Ct=void 0,St=1,Et=2,Pt=new S,Tt=new S,Nt=function(){function t(t,e,n,i){this._instanceConstructor=t,this.promise=new t(m,i),this._abortOnReject=n,this._init.apply(this,arguments)}return t.prototype._init=function(t,e){var n=e.length||0;this.length=n,this._remaining=n,this._result=new Array(n),this._enumerate(e),0===this._remaining&&x(this.promise,this._result)},t.prototype._enumerate=function(t){for(var e=this.length,n=this.promise,i=0;n._state===Ct&&i<e;i++)this._eachEntry(t[i],i)},t.prototype._settleMaybeThenable=function(t,e){var n=this._instanceConstructor,i=n.resolve;if(i===p){var r=v(t);if(r===N&&t._state!==Ct)t._onError=null,this._settledAt(t._state,e,t._result);else if(\"function\"!=typeof r)this._remaining--,this._result[e]=this._makeResult(St,e,t);else if(n===Ht){var o=new n(m);w(o,t,r),this._willSettleAt(o,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(i(t),e)},t.prototype._eachEntry=function(t,e){h(t)?this._settleMaybeThenable(t,e):(this._remaining--,this._result[e]=this._makeResult(St,e,t))},t.prototype._settledAt=function(t,e,n){var i=this.promise;i._state===Ct&&(this._abortOnReject&&t===Et?O(i,n):(this._remaining--,this._result[e]=this._makeResult(t,e,n),0===this._remaining&&x(i,this._result)))},t.prototype._makeResult=function(t,e,n){return n},t.prototype._willSettleAt=function(t,e){var n=this;k(t,void 0,function(t){return n._settledAt(St,e,t)},function(t){return n._settledAt(Et,e,t)})},t}(),Rt=\"rsvp_\"+Ot()+\"-\",Mt=0,Ht=function(){function t(e,n){this._id=Mt++,this._label=n,this._state=void 0,this._result=void 0,this._subscribers=[],At.instrument&&d(\"created\",this),m!==e&&(\"function\"!=typeof e&&W(),this instanceof t?T(this,e):F())}return t.prototype._onError=function(t){var e=this;At.after(function(){e._onError&&At.trigger(\"error\",t,e._label)})},t.prototype.catch=function(t,e){return this.then(void 0,t,e)},t.prototype.finally=function(t,e){var n=this,i=n.constructor;return n.then(function(e){return i.resolve(t()).then(function(){return e})},function(e){return i.resolve(t()).then(function(){throw e})},e)},t}();Ht.cast=p,Ht.all=M,Ht.race=H,Ht.resolve=p,Ht.reject=D,Ht.prototype._guidKey=Rt,Ht.prototype.then=N;var Dt=new I,Wt=new I,Ft=function(t){function e(e,n,i){return Y(this,t.call(this,e,n,!1,i))}return Z(e,t),e}(Nt);Ft.prototype._makeResult=R;var It=Object.prototype.hasOwnProperty,Vt=function(t){function e(e,n){var i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=arguments[3];return tt(this,t.call(this,e,n,i,r))}return et(e,t),e.prototype._init=function(t,e){this._result={},this._enumerate(e),0===this._remaining&&x(this.promise,this._result)},e.prototype._enumerate=function(t){var e=this.promise,n=[];for(var i in t)It.call(t,i)&&n.push({position:i,entry:t[i]});var r=n.length;this._remaining=r;for(var o=void 0,s=0;e._state===Ct&&s<r;s++)o=n[s],this._eachEntry(o.entry,o.position)},e}(Nt),Lt=function(t){function e(e,n,i){return it(this,t.call(this,e,n,!1,i))}return rt(e,t),e}(Vt);Lt.prototype._makeResult=R;var Ut=0,Bt=void 0,Gt=\"undefined\"!=typeof window?window:void 0,qt=Gt||{},zt=qt.MutationObserver||qt.WebKitMutationObserver,$t=\"undefined\"==typeof self&&void 0!==t&&\"[object process]\"==={}.toString.call(t),Jt=\"undefined\"!=typeof Uint8ClampedArray&&\"undefined\"!=typeof importScripts&&\"undefined\"!=typeof MessageChannel,Kt=new Array(1e3),Yt=void 0;Yt=$t?function(){var e=t.nextTick,n=t.versions.node.match(/^(?:(\\d+)\\.)?(?:(\\d+)\\.)?(\\*|\\d+)$/);return Array.isArray(n)&&\"0\"===n[1]&&\"10\"===n[2]&&(e=i),function(){return e(vt)}}():zt?function(){var t=0,e=new zt(vt),n=document.createTextNode(\"\");return e.observe(n,{characterData:!0}),function(){return n.data=t=++t%2}}():Jt?function(){var t=new MessageChannel;return t.port1.onmessage=vt,function(){return t.port2.postMessage(0)}}():void 0===Gt?function(){try{var t=n(59);return Bt=t.runOnLoop||t.runOnContext,gt()}catch(t){return mt()}}():mt();if(\"object\"==typeof self)self;else{if(\"object\"!=typeof r)throw new Error(\"no global: `self` or `global` found\");r}var Zt;At.async=pt,At.after=function(t){return setTimeout(t,0)};var Qt=ct,Xt=function(t,e){return At.async(t,e)};if(\"undefined\"!=typeof window&&\"object\"==typeof window.__PROMISE_INSTRUMENTATION__){var te=window.__PROMISE_INSTRUMENTATION__;a(\"instrument\",!0);for(var ee in te)te.hasOwnProperty(ee)&&yt(ee,te[ee])}var ne=(Zt={asap:pt,cast:Qt,Promise:Ht,EventTarget:wt,all:K,allSettled:Q,race:X,hash:nt,hashSettled:ot,rethrow:st,defer:at,denodeify:q,configure:a,on:yt,off:bt,resolve:ct,reject:lt,map:ut},_t(Zt,\"async\",Xt),_t(Zt,\"filter\",dt),Zt);e.default=ne,e.asap=pt,e.cast=Qt,e.Promise=Ht,e.EventTarget=wt,e.all=K,e.allSettled=Q,e.race=X,e.hash=nt,e.hashSettled=ot,e.rethrow=st,e.defer=at,e.denodeify=q,e.configure=a,e.on=yt,e.off=bt,e.resolve=ct,e.reject=lt,e.map=ut,e.async=Xt,e.filter=dt,Object.defineProperty(e,\"__esModule\",{value:!0})})}).call(e,n(17),n(55).setImmediate,n(8))},function(t,e,n){\"use strict\";var i=n(0),r=n(38);t.exports=i.extend(r,{fillServiceInfo:function(){this._service={},this._service._iteration=this.i+1,this._service._first=!this.i,this._service._last=this.i+1===this.count,this._service._count=this.count,this._service._key=this.key||this.i},get:function(t){return i.inArray([\"_iteration\",\"_first\",\"_last\",\"_count\",\"_key\"],t)?this._service[t]:this._get(t)},walk:function(t){},applyModifiers:function(t){i.each(t,function(e){this[\"apply\"+i.ucfirst(t.name)+\"Modifier\"](t.params)},this)}},null,\"DataIterator\")},function(t,e,n){\"use strict\";function i(t,e){for(var i=!0,r=0,o=e.length;r<o;r++){var s=e[r];switch(s.type){case\"&\":i=i&&!!t.getOption(s.value);break;case\".\":var a=n(3);i=i&&a.instanceOf(t,s.value);break;case\"#\":i=i&&t.getAlias()===s.value;break;case\"@\":i=i&&t.getId()===Number(s.value)}}return i}function r(t,e){var n,o,a=[];if(t&&t._widgets)for(n in t._widgets)o=t._widgets[n],i(o,e.selectors)&&a.push(o),e.recursive&&(a=s.merge(a,r(o,e)));return a}function o(t,e){var n,i,r=this;!function(t){n=t,n.setWom(r)}(e),function(t){i=t}(t.getOptionsInstance());var c=t,l={},h={},f={},d=[];this.getOptionsManager=function(){return i},this.getEventManager=function(){return n},this.getLibrary=function(){return c},this.selectFirst=o.selectFirst,this.select=o.select,this.isSelector=o.isSelector,this.matchWidget=o.matchWidget,this.getObject=function(t){return d[t]||!1},this.registerObject=function(t){t.setId(d.push(t)-1),s.isUndefined(f[t._objClass])&&(f[t._objClass]={}),f[t._objClass][t.getId()]=t},this.removeObjectFromRegistry=function(t){var e=t.getId(),n=t._objClass;d[e]=null,n&&!s.isEmpty(f[n])&&delete f[n][e],this.getOptionsManager().destroy(e),this.getEventManager().removeObject(t),t=null,s.arrayRevageToValue(d)},this.loadWidget=function(t,e){var n=this.getWidget(t);if(n){var i=new n(e||{},this);return i._widgetClass=n._widgetClass,i._ns=n._ns,i}return!1},this.getWidget=function(t){var e,n,i,r=t.split(\":\");if(e=1===r.length&&s.objectGet(l,r[0])||s.objectGet(h,r))return e;if(n=c.getWidget(t)){switch(i=\"Controller\"===t&&u||a,n.parent){case\"Controller\":i=u;break;case\"Widget\":i=a;break;default:n.parent&&(i=n.parent&&this.getWidget(n.parent))}e=s.extend(n.obj,i,null,n.name),e._widgetClass=n.name,e._ns=n.ns,n.front&&(l[n.name]=e),s.objectSet(h,[n.ns,n.name],e)}else console.log(t+\" missing!!!\");return e},this.getRoot=function(){return this.getObject(0)},this.getTemplate=function(t){return c.getTemplate(t)}}var s=n(0),a=n(52),u=n(16),c=/((~?)([@\\.#&]){1}([\\w\\-]+)+?){1}(([@\\.#&]){1}([\\w\\-]+)+?)?/g,l=/\\[{1}([\\w\\d\\-.=><]+)\\]{1}/gi,h=/^([\\d\\w#.@]+)+|(?!\\[+)([\\w\\d\\-.=]+)+(?=\\]+)/gi;o.select=function(t,e){if(this instanceof o){var n=this.getRoot();s.isUndefined(e)&&(e=n)}else if(s.isUndefined(e))throw new TypeError(\"Missing root object in static usage\");s.isArray(e)||(e=[e]);for(var a=c.exec(t),u=[];null!==a;)u=[],s.each(e,function(t){if(\"@\"===a[3]){switch(a[4]){case\"root\":s.isUndefined(n)||u.push(n);break;case\"this\":u.push(t);break;case\"parent\":u.push(t.getParent());break;default:var e;this instanceof o?(e=this.getObject(a[4]))&&u.push(e):u=s.merge(u,r(t,{selectors:[{type:a[3],value:a[4]}],recursive:!0}))}a[6]&&u[0]&&(i(u[0],[{type:a[6],value:a[7]}])||(u=[]))}else{var c={selectors:[{type:a[3],value:a[4]},{type:a[6],value:a[7]}],recursive:!!a[2]};u=s.merge(u,r(t,c))}},this),a=c.exec(t),e=u;return u},o.selectFirst=function(t,e){var n=this.select(t,e);return!!n.length&&n[0]},o.isSelector=function(t){return s.isString(t)&&s.inArray([\"~\",\"@\",\"#\",\".\",\"&\"],t[0])},o.matchWidget=function(t,e,n){function i(t,e,n){if(t=s.isArray(t)?t[0]:t,-1!==t.indexOf(\"&\"))return a(t,e,n);if(null!==t.match(l))return r(t,e,n);if(0===t.indexOf(\"@\"))switch(t){case\"@this\":return n._id===e._id;case\"@parent\":return n.getParent()._id===e._id;case\"@root\":return 0===e._id;default:return parseInt(t.slice(1))===e._id}return e._womMatch.hasOwnProperty(t)}function r(t,e,n){var r=t.match(h);return t=r.shift(),!0===i(t,e,n)&&r.every(function(t){return-1!==t.indexOf(\"=\")?(t=t.split(\"=\"),\"true\"===t[1]&&(t[1]=!0),\"false\"===t[1]&&(t[1]=!1),s.isSet(e.options[t[0]])&&e.options[t[0]]==t[1]):!!e.options[t]})}function a(t,e,n){var r=t.split(\"&\"),o=r.slice(1);return!0===i(r.slice(0,1),e,n)&&o.every(function(t){return!!e.options[t]})}function u(t,e,n){if(0===t.length)return!1;if(1===t.length){switch(t[0].charAt(0)){case\"~\":t[0]=t[0].slice(1);break;case\"#\":case\".\":return i.apply(this,arguments)&&e.getParent()===n}return i.apply(this,arguments)}var r=t[t.length-1];if(0===r.indexOf(\"~\")){if(!0===i(r.slice(1),e,n)){var o,s;e=e.getParent();t:for(var a=t.length-1;a--;)for(;e;){if(o=u(t.slice(0,a+1),e,n),!0===s&&!1===o&&void 0!==t[a]){s=!1;continue t}if(!0===o&&(e.getParent()===n||void 0===t[a-1]&&-1!==[\"~\",\"@\"].indexOf(t[a][0])))return!0;s=o,e=e.getParent()}}}else{if(\"@parent\"===r)return t.splice(t.length-1,1),u(t,e,n.getParent());if(!0===i(r,e,n))return t.splice(t.length-1,1),e.getParent()&&u(t,e.getParent(),n)}return!1}if(s.isUndefined(n)&&!(this instanceof o))throw new TypeError(\"Missing root object in static usage\");return u(t.split(\" \"),e,n||this.getObject(0))},t.exports=function(){return{matchWidget:o.matchWidget,selectFirst:o.selectFirst,select:o.select,isSelector:o.isSelector,Wom:o}}},function(t,e){var n;n=function(){return this}();try{n=n||Function(\"return this\")()||(0,eval)(\"this\")}catch(t){\"object\"==typeof window&&(n=window)}t.exports=n},function(t,e,n){var i=n(56);t.exports=i,i.microtime=function(){var t=(new Date).getTime()/1e3;parseInt(t,10);return t},i.objectGet=function(t,e){for(var n=i.isArray(e)?e:(e||\"\").split(\".\"),r=t,o=0,s=n.length;o<s;o++){if(!r||void 0===r[n[o]])return;r=r[n[o]]}return r},i.objectSet=function(t,e,n){for(var r=i.isArray(e)?e:(e||\"\").split(\".\"),o=t,s=0,a=r.length-1;s<a;s++)i.isObject(o[r[s]])||(o[r[s]]={}),o=o[r[s]];return i.isEmpty(r[s])||(o[r[s]]=n),!0},i.objectRemove=function(t,e){var n=i.isArray(e)?e:(e||\"\").split(\".\"),r=t,o=n.pop();return!(!n.length||(r=i.objectGet(t,n)))||(delete r[o],!0)},i.isUndefined(i._isObject)&&(i._isObject=i.isObject),i.isObject=function(t){return(\"[object Object]\"===Object.prototype.toString.call(t)||\"[object global]\"===Object.prototype.toString.call(t))&&!i.isUndefined(t)},i.isUndefined(i._isEmpty)&&(i._isEmpty=i.isEmpty),i.isEmpty=function(t){return!!(i.isUndefined(t)||i.isNull(t)||i.isNaN(t))||(i.isBoolean(t)?!t:i.isString(t)?-1!==[\"false\",\"0\",\"undefined\"].indexOf(t)||0===t.length:!(i.isFunction(t)||i.isRegExp(t)||i.isDate(t))&&(i.isObject(t)?i._isEmpty(t):i.isArray(t)?0===t.length:i.isNumber(t)?0===t:void 0))},i.isSet=function(t){return!i.isUndefined(t)},i.objectIsSet=function(t,e){return i.isSet(i.objectGet(t,e))},i.merge=function(){var t,e=arguments[0],n=Array.prototype.slice.call(arguments,1).reverse(),r=n.pop();for(t=i.isObject(e)?i.isObject:i.isArray;r;){if(!t(r))throw new TypeError(\"Argument type differs from target\");if(i.isObject(e))for(var o in r)e[o]=r[o];else e=e.concat(r);r=n.pop()}return e},i.mergeRecursive=function(){var t,e=arguments[0],n=Array.prototype.slice.call(arguments,1).reverse(),r=n.pop();for(t=i.isObject(e)?i.isObject:i.isArray;r;){if(!t(r))throw new TypeError(\"Argument type differs from target\");for(var o in r)e[o]&&(i.isArray(e[o])&&i.isArray(r[o])||i.isObject(e[o])&&i.isObject(r[o]))?e[o]=i.mergeRecursive(e[o],r[o]):i.isObject(e)?e[o]=r[o]:e.push(r[o]);r=n.pop()}return e},i.arrayUnique=i.uniq,i.trim=function(t,e){return i.isString(t)?!e&&String.prototype.trim?t.trim():t.replace(new RegExp(\"^[\"+e+\"]+\",\"g\"),\"\").replace(new RegExp(\"[\"+e+\"]+$\",\"g\"),\"\"):t},i.upCharFirstLetter=i.ucfirst=function(t){return t.slice(0,1).toUpperCase()+t.slice(1)},i.toQueryString=function(t,e){var n=[];return function t(r,o){i.each(r,function(r,s){var a=o?o+\"[\"+s+\"]\":s;i.isObject(r)||i.isArray(r)?t(r,a):n.push(a+\"=\"+(e?encodeURIComponent(r):r))})}(t),n.join(\"&\")},i.isNumeric=function(t){return!isNaN(parseFloat(t))&&isFinite(t)&&parseFloat(t)==t},i.isHash=function(t){return i.isObject(t)&&i.isUndefined(t.superclass)},i.arrayWithout=i.without,i.inArray=i.contains,i.getObjectKeys=Object.keys,i.arrayRelation=function(t,e){if(!t)return!1;if(\"DataLayer\"===t._objClass)return t.getObjectValue(e);if(\"DataObject\"===t._objClass)return t.get(e);for(var n=e.split(\".\"),r=n.pop(),o=0;o<n.length;o++){var s=n[o];if(i.isEmpty(t))return!1;if(i.isArray(t[s])){if(!(t=t[s][0]))return!1}else{if(!i.isObject(t[s]))return!1;if(t[s].collection&&(t=i.clone(t),i.merge(t[s],i.toArray(t[s].collection).shift())),t[s]._objClass)return t[s].get(n.slice(o).join(\".\"));t=t[s]}}return t[r]},i.removeArrayRow=i.without,i.clone=function(t,e){var n;if(i.isArguments(t)||i.isArray(t)&&!e)return Array.prototype.slice.call(t);if(i.isObject(t))n={};else{if(!i.isArray(t))return t;n=[]}return i.each(t,function(t,r){i.isString(r)?n[r]=e?i.clone(t,!0):t:n.push(e?i.clone(t,!0):t)}),n},i.split=function(t,e,n){var r=t.split(e);if(!i.isSet(n)||n>r.length)return r;if(n<=1)return t;var o=n-1,s=r.splice(o,r.length-o);return r.push(s.join(e)),r},i.getCallback=function(t){if(i.isFunction(t))return t;if(i.isArray(t)&&2===t.length&&i.isString(t[1])&&i.isObject(t[0])&&i.isFunction(t[0][t[1]]))return t[0][t[1]];throw\"Invalid callback\"},i.sortByField=function(t,e){return t.sort(function(t,n){return t[e]<n[e]?-1:t[e]>n[e]?1:0})},i.isDl=function(t){return!i.isUndefined(t)&&\"DataLayer\"===t._objClass},i.mixin=function(t){for(var e=1,n=arguments.length;e<n;e++)for(var i in arguments[e])t[i]||(t[i]=arguments[e][i]);return t},i.isUndefined(i._count)&&(i._count=i.count),i.count=function(t){switch(!0){case i.isDl(t):return t.getCount();case i.isArray(t):case i.isString(t):return t.length;case i.isObject(t):return i.getObjectKeys(t).length}return 0},i.isUndefined(i._each)&&(i._each=i.each),i.each=function(t,e,n){try{i._each(t,e,n)}catch(e){if(\"__fox_break_exception__\"===e)return t;i.exception(e,\"Caught each exception: \")}return t},i.isUndefined(i._filter)&&(i._filter=i.filter),i.filter=function(t,e){var n=i.isObject(t)?{}:[];if(e=e||function(t){return!i.isEmpty(t)},i.isObject(t))for(var r in t)e(t[r])&&(n[r]=t[r]);else i.isArray(t)?n=t.filter(e):i.isString(t)&&(n=Array.prototype.filter.call(t,e).join(\"\"));return n},i.exception=function(t,e){return e||(e=\"Caught exception: \"),i.isString(t)?console.error(e,t):console.error(e,t.message,t.stack)},i.log=function(t,e,n){},i.isUndefined(i._extend)&&(i._extend=i.extend),i.break=\"__fox_break_exception__\",i.arrayRevageToValue=function(t){if(!i.isArray(t))return t;for(var e=t[t.length-1];t.length>0&&(i.isUndefined(e)||i.isNull(e));)t.pop(),e=t[t.length-1];return t},i.genUniqueId=function(t,e){var n=/[xy]/g,r=(new Date).getTime();return i.isString(t)||(t=\"xy\"),i.isRegExp(e)||(e=n),t.replace(e,function(t){var e=(r+16*Math.random())%16|0;return(\"x\"===t?e:7&e|8).toString(16)})},i.callSuperMethod=function(t,e,n){var r=[e[0],e[1],e[2],e[3],e[4],e[5]],o=r[5]?r[5]:this;return r[5]=o.superclass,!!r[5]&&(i.inArray(o._myProps,t)?r[5][t].apply(this,r):r[5][n||\"callParent\"].apply(this,[t,r]))},i.defineProperty=function(t,e,n){return t?(n=n||{writable:!1,value:e},i.keys(n).some(function(t){return i.contains([\"set\",\"get\",\"value\"],t)})||(n.value=e),Object.defineProperty(this,t,n),this):this},i.uniqid=i.uniqueId,i.getStringSimpleHash=function(t,e){var n=5381;if(!i.isString(t))return n;for(var r=t.length;r;)n=33*n^t.charCodeAt(--r);return n>>>=0,i.isNumber(e)?n.toString(e):n},i.isPromise=function(t){return!fox.isNull(t)&&\"object\"==typeof t&&i.isFunction(t.then)}},function(t,e,n){\"use strict\";var i=n(0),r=n(14),o=n(11),s=t.exports={};s.toInt=function(t){return 0|t},s.lt=function(t,e){return parseFloat(t)<e[0]},s.gt=function(t,e){return parseFloat(t)>e[0]},s.lte=function(t,e){return parseFloat(t)<=e[0]},s.gte=function(t,e){return parseFloat(t)>=e[0]},s.eq=function(t,e){var n=!1;return 1==e.length&&(n=t==e[0]),i.each(e,function(e){t==e&&(n=!0)}),n},s.notEq=function(t,e){return t!=e[0]},s.empty=function(t,e){return i.isEmpty(t)},s.emptyDl=function(t,e){return i.isEmpty(t&&t.collection)},s.notEmpty=function(t,e){return!i.isEmpty(t)},s.notEmptyDl=function(t,e){return!i.isEmpty(t&&t.collection)},s.truncate=function(t,e){var n=e[0],r=e[1]?e[1]:\"\";e[2]&&e[2];return t=i.isObject(t)?t.toString():t,t.length<=n?t:t.substr(0,n)+r},s.json=function(t,e){console.log(t),console.log(e)},s.mod=function(t,e){return t%e[0]},s.not=function(t,e){return!t},s.count=function(t,e){return i.count(t)},s.countDl=function(t,e){return i.count(t.collection)},s.dateFormat=function(t,e){if(!t)return t;var n=r.resolveDate(t);if(!n||i.isNaN(n))return t;if(\"today\"===e[1]){n.getFullYear()||(n=new Date((t||\"\").replace(/-/g,\"/\").replace(/[TZ]/g,\" \")));var s=((new Date).getTime()-n.getTime())/1e3,a=Math.floor(s/86400);if(isNaN(a)||a<0)return;return 0===a&&s<86400&&o.getPhrase(\"today\")||1===a&&o.getPhrase(\"yesterday\")||r.dateFormat(e[0],t)}return r.dateFormat(e[0],t)},s.fileSize=function(t,e){if(!t)return t;return\"gb\"===e[0]?(t/Math.pow(1024,3)).toFixed(2):(t/Math.pow(1024,2)).toFixed(2)},s.timeLength=function(t,e){if(!t)return t;var n,r,o;if(t>3600?(n=Math.floor(t/3600),r=Math.floor((t-3600*n)/60),o=Math.floor(t-3600*n-60*r)):(r=Math.floor(t/60),o=Math.floor(t-60*r)),n<10&&(n=\"0\"+n),r<10&&n>=1&&(r=\"0\"+r),o<10&&(o=\"0\"+o),i.isEmpty(e))return n?n+\":\"+r+\":\"+o:r+\":\"+o;var s=i.isNumeric(n)?e[0].replace(\"h\",1*n+\" h\"):e[0].replace(\"h\",\"\");return s=s.replace(\"m\",r+\" min\"),s=s.replace(\"s\",o)},s.dateAgo=function(t,e){var n=new Date(t||\"\"),i=r.daysInMonth(),s=29===i?366:365,a=(new Date).getTime();n.getFullYear()||(n=new Date((t||\"\").replace(/-/g,\"/\").replace(/[TZ]/g,\" \")));var u=(a-n.getTime())/1e3,c=Math.floor(u/86400);if(!(isNaN(c)||c<0))return u<60&&o.getPhraseAgo(\"now\")||u<120&&o.getPhraseAgo(\"minuteAgo\")||u<3600&&o.getPhraseAgo(\"minutesAgo\",Math.floor(u/60))||u<7200&&o.getPhraseAgo(\"hourAgo\")||u<86400&&o.getPhraseAgo(\"hoursAgo\",Math.floor(u/3600))||1==c&&o.getPhraseAgo(\"yesterday\")||c<7&&o.getPhraseAgo(\"daysAgo\",c)||7==c&&o.getPhraseAgo(\"weekAgo\")||c<i&&o.getPhraseAgo(\"weeksAgo\",Math.floor(c/7))||c==i&&o.getPhraseAgo(\"monthAgo\")||c<s&&o.getPhraseAgo(\"monthsAgo\",Math.floor(c/i))||c==s&&o.getPhraseAgo(\"yearAgo\")||o.getPhraseAgo(\"yearsAgo\",Math.floor(c/s))},s.limit=function(t,e){return i.isEmpty(t)?[]:i.isArray(t)?t.slice(0,e[0]):i.isObject(t)&&\"DataLayer\"===t._objClass?(t._index=t._index.slice(0,e[0]),t):void console.log(\"Iteratable modifier applied to noniteratable object\")},s.list=function(t,e){var n=[];return i.isArray(t)?(i.each(e,function(e){n.push(t[e-1])}),n):i.isObject(t)&&\"DataLayer\"===t._objClass?(i.each(e,function(e){n.push(t._index[e-1])}),t._index=n,t):void i.log(\"Iteratable modifier applied to noniteratable object\")},s.shift=function(t,e){return i.isArray(t)?t[0]:t},s.number_format=s.numberFormat=function(t,e){if(e=e||[],!i.isNumeric(t))return\"\";var n,r,o,s,a=isNaN(e[0]=Math.abs(e[0]))?0:e[0],u=e[1]?e[1]:\",\",c=e[2]?e[2]:\".\";r=parseInt(s=t.toString()).toString(),0!==a&&(o=-1===s.indexOf(\".\")?\"\":s.substr(s.indexOf(\".\")+1,s.length-1),o.length>a?o=o.substr(0,a):o+=i.range(a-o.length).map(function(){return\"0\"}).join(\"\")),i.isNumeric(r.charAt(0))||(n=r.charAt(0),r=r.slice(1));for(var l=r.length-3;l>0;l-=3)r=r.substr(0,l)+c+r.substr(l,r.length-1);return n&&(r=n+r),o?r+u+o:r},s.replace_text=function(t,e){return t=t.replace(new RegExp(e[0],\"g\"),e[1])},s.lowerCase=function(t,e){return t=i.isObject(t)?t.toString():t,t.toLowerCase()},s.currencyFormat=function(t,e){return r.currencyFormat(t)},s.isOnline=function(t,e){var n=0,i=new Date,o=new Date(i.getUTCFullYear(),i.getUTCMonth(),i.getUTCDate(),i.getUTCHours(),i.getUTCMinutes(),i.getUTCSeconds());if(t){var s=r.resolveDate(t);n=new Date(s.getUTCFullYear(),s.getUTCMonth(),s.getUTCDate(),s.getUTCHours(),s.getUTCMinutes(),s.getUTCSeconds()).getTime()}return(o.getTime()-n)/1e3<=300},s.html=function(t,e){var n=[\"script\",\"html\"],r=[\"onclick\",\"onchange\",\"onclose\",\"oncontextmenu\",\"ondblclick\",\"ondrag\",\"ondragend\",\"ondragenter\",\"ondragexit\",\"ondragleave\",\"ondragover\",\"ondragstart\",\"ondrop\",\"onfocus\",\"onblur\",\"oninput\",\"oninvalid\",\"onload\",\"onkeydown\",\"onkeypress\",\"onkeyup\",\"onmousedown\",\"onmouseenter\",\"onmouseleave\",\"onmousemove\",\"onmouseout\",\"onmouseover\",\"onmouseup\",\"onmousewheel\",\"onscroll\",\"onsubmit\",\"onsuspend\"].join(\"|\");if(!i.isString(t))return t;var o=(i.isArray(e)&&e||[]).reduce(function(t,e){return i.inArray(t,e)?t:t.concat(e)},n).join(\"|\"),s=new RegExp(\"<(\"+o+\")+[^>]*>([^<]*(</(\"+o+\"))?>)?\",\"mgi\"),a=new RegExp(\"\\\\s+(\"+r+')+=\"[^\"]+\"',\"mgi\");return t.replace(s,\"\").replace(a,\"\").concat(\"__HTML__\")},s.math=function(t,e){var n=e[0].toLowerCase(),i=1*t,r=1*e[1];switch(n){case\"sub\":i-=r;break;case\"add\":i+=r;break;case\"mul\":i*=r;break;case\"div\":i/=r}return i},s.formatCurrentDate=function(t,e){return r.dateFormat(e[0],new Date)},s.getMonths=function(t,e){return r.getMonthsArray(e[0])},s.getRange=function(t,e){var n=e[0],i=e[1],o=e[2];return r.getRange(n,i,o)},s.truncateRows=function(t,e){var n=Number(e[0]),i=t.split(\"\\n\"),r=e[1]||\"\";return i.length>1?[i.slice(0,n).join(\"\\n\"),\"\"!==i[n-1]?r:\"\"].join(\"\"):i[0]},s.toNavigatorAlias=function(t){return r.toNavigatorAlias(t)},s.ucfirst=function(t){return t=i.isObject(t)?t.toString():t,i.isString(t)?i.upCharFirstLetter(t):t},s.transformLinks=function(t){var e=/(https?:\\/\\/)+([\\d\\w\\.\\-]*\\/)+([\\d\\w\\-\\/\\?\\+\\._%#&=])*/gim;return i.isString(t)&&t.replace(e,function(t){return['<a target=\"_blank\" href=\"',t,'\">',t,\"</a>\"].join(\"\")})},s.inList=function(t,e){return i.inArray(e[0].split(\",\"),String(t))},s.getValueByKey=function(t,e){return t[e]},s.and=function(t,e){return t&&e[0]},s.or=function(t,e){return t||e[0]},s.timeLeft=function(t,e){var n=new Date(t||\"\"),i=\"\",r=e[0];n.getFullYear()||(n=new Date((t||\"\").replace(/-/g,\"/\").replace(/[TZ]/g,\" \")));var o=((new Date).getTime()-n.getTime())/1e3;return!(o>0)&&(o=-o,r&&\"days\"!==r||(i=Math.ceil(o/86400)),\"hours\"===r&&(i=Math.ceil(o/3600)),i)},s.timeLeftChecker=function(t){var e=new Date(t||\"\");e.getFullYear()||(e=new Date((t||\"\").replace(/-/g,\"/\").replace(/[TZ]/g,\" \")));var n=((new Date).getTime()-e.getTime())/1e3;return!(n>0)&&(n=-n,n/86400<1?\"hours\":\"days\")},s.transformNewLines=function(t){return i.isString(t)&&t.replace(/\\n/g,\"<br>\")||t}},function(t,e,n){\"use strict\";var i=t.exports={};i.getPhraseAgo=function(t,e){e=e||\"\";var n=this.getLang(),i=this.phrases[n],r=i.ago;return\"function\"==typeof i[t]?i[t](e).replace(\"%d\",e).replace(\"%a\",r):i[t].replace(\"%d\",e).replace(\"%a\",r)},i.getPhrase=function(t,e){e=void 0!==e?e:\"\";var n=this.getLang(),i=this.phrases[n];return\"function\"==typeof i[t]?i[t](e):\"object\"==typeof i[t]&&\"\"!==e?i[t][e]:i[t]},i.getLang=function(){var t=\"en\";return\"undefined\"!=typeof fox&&void 0!==fox.i18n&&(t=fox.i18n.getISOLang()),t},i.phrases={},i.phrases.en={ago:\"ago\",now:\"just now\",minuteAgo:\"1 minute %a\",minutesAgo:\"%d minutes %a\",hourAgo:\"1 hour %a\",hoursAgo:\"%d hours %a\",yesterday:\"yesterday\",today:\"today\",daysAgo:\"%d days %a\",weekAgo:\"1 week %a\",weeksAgo:\"%d weeks %a\",monthAgo:\"1 month %a\",monthsAgo:\"%d months %a\",yearAgo:\"1 year %a\",yearsAgo:\"%d years %a\",months:[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"],monthsShort:[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"June\",\"July\",\"Aug\",\"Sept\",\"Oct\",\"Nov\",\"Dec\"],weekdays:[\"Sunday\",\"Monday\",\"Tuesday\",\"Wednesday\",\"Thursday\",\"Friday\",\"Saturday\"],weekdaysShort:[\"Sun\",\"Mon\",\"Tue\",\"Wed\",\"Thu\",\"Fri\",\"Sat\"]},i.phrases.es={ago:\"hace\",now:\"ahora\",minuteAgo:\"%a 1 minuto\",minutesAgo:\"%a %d minutos\",hourAgo:\"%a 1 hora\",hoursAgo:\"%a %d horas\",yesterday:\"ayer\",today:\"hoy\",daysAgo:\"%a %d días\",weekAgo:\"%a 1 semana\",weeksAgo:\"%a %d semanas\",monthAgo:\"%a un mes\",monthsAgo:\"%a %d meses\",yearAgo:\"%a 1 año\",yearsAgo:\"%a %d años\",months:[\"Enero\",\"Febrero\",\"Marzo\",\"Abril\",\"Mayo\",\"Junio\",\"Julio\",\"Agosto\",\"Septiembre\",\"Octubre\",\"Noviembre\",\"Diciembre\"],monthsShort:[\"Ene\",\"Feb\",\"Marzo\",\"Abr\",\"Mayo\",\"Jun\",\"Jul\",\"Ago\",\"Sept\",\"Oct\",\"Nov\",\"Dic\"],weekdays:[\"Domingo\",\"Lunes\",\"Martes\",\"Miércoles\",\"Jueves\",\"Viernes\",\"Sábado\"],weekdaysShort:[\"Dom\",\"Lun\",\"Mar\",\"Mié\",\"Jue\",\"Vie\",\"Sáb\"]},i.phrases.de={ago:\"vor\",now:\"jetzt\",minuteAgo:\"%a 1 Minute\",minutesAgo:\"%a %d Minuten\",hourAgo:\"%a 1 Stunde\",hoursAgo:\"%a %d Stunden\",yesterday:\"gestern\",today:\"heute\",daysAgo:\"%a %d Tagen\",weekAgo:\"%a 1 Woche\",weeksAgo:\"%a %d Wochen\",monthAgo:\"%a 1 Monat\",monthsAgo:\"%a %d Monaten\",yearAgo:\"%a 1 Jahr\",yearsAgo:\"%a %d Jahren\",months:[\"Januar\",\"Februar\",\"Marz\",\"April\",\"Mai\",\"Juni\",\"Juli\",\"August\",\"September\",\"Oktober\",\"November\",\"Dezember\"],monthsShort:[\"Jan\",\"Feb\",\"Marz\",\"Apr\",\"Mai\",\"Juni\",\"Juli\",\"Aug\",\"Sept\",\"Okt\",\"Nov\",\"Dez\"],weekdays:[\"Sonntag\",\"Montag\",\"Dienstag\",\"Mittwoch\",\"Donnerstag\",\"Freitag\",\"Sonnabend\"],weekdaysShort:[\"So\",\"Mo\",\"Di\",\"Mi\",\"Do\",\"Fr\",\"Sa\"]},i.phrases.ru={ago:\"назад\",now:\"только что\",minuteAgo:\"1 минуту %a\",minutesAgo:function(t){return this.numpfRu(t,\"%d минута %a\",\"%d минуты %a\",\"%d минут %a\")},hourAgo:\"1 час  %a\",hoursAgo:function(t){return this.numpfRu(t,\"%d час %a\",\"%d часа %a\",\"%d часов %a\")},yesterday:\"вчера\",today:\"сегодня\",daysAgo:function(t){return this.numpfRu(t,\"%d день %a\",\"%d дня %a\",\"%d дней %a\")},weekAgo:\"1 неделю %a\",weeksAgo:function(t){return this.numpfRu(t,\"%d неделю %a\",\"%d недели %a\",\"%d недель %a\")},monthAgo:\"1 месяц %a\",monthsAgo:function(t){return this.numpfRu(t,\"%d месяц %a\",\"%d месяца %a\",\"%d месяцев %a\")},yearAgo:\"1 год %a\",yearsAgo:function(t){return this.numpfRu(t,\"%d год %a\",\"%d года %a\",\"%d лет %a\")},months:[\"Январь\",\"Февраль\",\"Март\",\"Апрель\",\"Май\",\"Июнь\",\"Июль\",\"Август\",\"Сентябрь\",\"Октябрь\",\"Ноябрь\",\"Декабрь\"],monthsShort:[\"Янв\",\"Февр\",\"Март\",\"Апр\",\"Май\",\"Июнь\",\"Июль\",\"Авг\",\"Сент\",\"Окт\",\"Нояб\",\"Дек\"],weekdays:[\"Воскресенье\",\"Понедедльник\",\"Вторник\",\"Среда\",\"Четверг\",\"Пятница\",\"Суббота\"],weekdaysShort:[\"Вс\",\"Пн\",\"Вт\",\"Ср\",\"Чт\",\"Пт\",\"Сб\"],numpfRu:function(t,e,n,i){var r=t%10;return 1===r&&(1===t||t>20)?e:r>1&&r<5&&(t>20||t<10)?n:i}}},function(t,e,n){\"use strict\";var i=n(0),r=n(2),o=r.constructor,s=n(4),a=i.extend(i.mixin({__constructor:function(){this.callParent(\"__constructor\",arguments),this.conditionNode=this.node,this.node=this.conditionNode[2],this.myVars=[]},prepare:function(){this.createActionComponent(this.conditionNode).addVars(this.conditionNode[3],this.myVars),this.callParent(\"prepare\",arguments)},compile:function(t,e,n){n=i.clone(n||{}),this._beforeCompile(t,e,n);var r,o=this.myVars[0],s=(o.variable[0],o.variable[3],this.getVariableValue(o));switch(o.variable[1].toLowerCase()){case\"empty\":r=i.isEmpty(s);break;case\"notempty\":r=!i.isEmpty(s)}return!0===r?this.callParent(\"compile\",[this.target,this.data,this.opts]):!1===r?this.emit(\"false-compile\",this.target,this.data,this.opts):void 0},prepareMyPlainVariables:function(){return this.myVars.map(function(t){return t.variable[0]}).concat(this.callParent(\"prepareMyPlainVariables\",arguments))}},s.mixin),o,null,\"ComponentIf\");t.exports={create:function(t){return new a(t)},constructor:a}},function(t,e,n){\"use strict\";var i=n(0),r=n(1),o=r.nodeMethods={};t.exports=r,o.create=function(t){this._node=t},o.node=function(){return this._node},o.on=function(t,e){return r.on(t,this._node,i.bind(e,this)),this},o.addClass=function(t){return r.addClass(t,this._node),this},o.removeClass=function(t){return r.removeClass(t,this._node),this},o.switchClass=function(t){return this[this.hasClass(t)?\"removeClass\":\"addClass\"](t),this},o.exchangeClass=function(t,e,n){return void 0===n&&(n=!1),n?this.removeClass(e).addClass(t):this.removeClass(t).addClass(e),this},o.hasClass=function(t){return r.hasClass(t,this._node)},o.attr=function(){return arguments.length?1===arguments.length?this._node.getAttribute(arguments[0]):(this._node.setAttribute(arguments[0],arguments[1]),this):this},o.html=function(){if(this._node)return arguments.length?(this._node.innerHTML=arguments[0],this):this._node.innerHTML},o.val=function(){switch(this._node.tagName.toLowerCase()){case\"input\":case\"select\":return this._node.value}},o.append=function(t){return this._node.appendChild(r.wrap(t).node()),this},o.insertBefore=function(t){var e=this._node.parentNode;return e?(t instanceof r.Node||(t=r.wrap(t)),e.insertBefore(t.node(),this._node),this):this},o.insertAfter=function(t){var e=this._node.parentNode;return e?(t instanceof r.Node||(t=r.wrap(t)),e.insertBefore(t.node(),this._node.nextSibling),this):this},o.remove=function(){var t=this._node.parentNode;return t?(t.removeChild(this._node),r.wrap(t)):this},o.replace=function(t){var e=this._node.parentNode;return e?(t instanceof r.Node||(t=r.wrap(t)),e.replaceChild(t.node(),this._node),t):this},o.up=function(t){return t?i.isNumeric(t)?r.wrap(this._node.parentNode).up(t-1):void 0:r.wrap(this._node.parentNode)},o.down=function(t){if(!t){for(var e=this._node.childNodes,n=0,i=e[n];i&&3===i.nodeType;)i=e[++n];return!!i&&r.wrap(i)}return r.wrap(r.selectFirst(t,this._node))},o.collect=function(t){return t?r.select(t,this._node):(i.log(\"There's no selector for collect\",!0),!1)},o.prev=function(t){if(!t){for(var e=this._node.previousSibling;e&&3===e.nodeType;)e=e.previousSibling;return!!e&&r.wrap(e)}return!1},o.next=function(t){if(!t){for(var e=this._node.nextSibling;e&&3===e.nodeType;)e=e.nextSibling;return!!e&&r.wrap(e)}return!1},o.hide=function(){return\"none\"!==this._node.style.display&&(this._node.__preHideDisplayState__=this._node.style.display,this._node.style.display=\"none\"),this},o.show=function(){return\"none\"===this._node.style.display&&(this._node.style.display=this._node.__preHideDisplayState__?this._node.__preHideDisplayState__:\"block\"),this},r.Node=i.extend(r.Node,o,null,\"FoxDomNode\");var s=function(t){var e=[];t&&(i.isString(t)?e=r.select(t):i.isArray(t)?e=t:(r.isElement(t)||t instanceof r.Node)&&(e=[t]),this._nodes=i.map(e,function(t){return r.wrap(t)}))};s.prototype._walk=function(t,e){return i.each(this._nodes,function(n){return n[t].apply(n,e)}),this},i.each(o,function(t,e){s.prototype[e]=function(){return this._walk(e,arguments)}}),s.prototype.node=function(){return!!this._nodes.length&&this._nodes[0].node()},s.prototype.nodes=function(){return this._nodes},r.query=function(t){return new s(t)}},function(t,e,n){\"use strict\";function i(t,e){var n=t;this.name=e||o.genUniqueId(\"xyxxxy\"),Object.defineProperty(this,\"url\",{enumerable:!0,get:function(){return n}}),Object.defineProperty(this,\"__fakeFile\",{enumerable:!0,get:function(){return!0}})}function r(t){var e=t;Object.defineProperty(this,\"length\",{enumerable:!0,get:function(){return e.length}}),Object.defineProperty(this,\"item\",{enumerable:!0,value:function(t){return e[t]}}),Object.defineProperty(this,\"__fakeFileList\",{enumerable:!0,get:function(){return!0}})}var o=n(0),s=n(11),a=t.exports={};a.resolveDate=function(t){var e;return t instanceof Date?e=t:o.isNumeric(t)?(o.isString(t)||(t=t.toString()),e=new Date(t.length>10?1*t:1e3*t)):e=new Date(t.toString().replace(/-/g,\"/\")),e},a.dateFormat=function(t,e){function n(t){return t.toString().replace(/^([0-9])$/,\"0$1\")}var i=this.resolveDate(e),r=i.getHours(),o=i.getDay(),a=i.getDate(),u=i.getMonth(),c=i.getFullYear(),l={a:s.getPhrase(\"weekdaysShort\",o),A:s.getPhrase(\"weekdays\",o),d:n(a),e:a,b:s.getPhrase(\"monthsShort\",u),B:s.getPhrase(\"months\",u),m:n(u+1),y:c.toString().substr(2,2),Y:c,H:n(r),I:n(r%12||12),l:r%12||12,M:n(i.getMinutes()),p:r<12?\"AM\":\"PM\",P:r<12?\"am\":\"pm\",S:n(i.getSeconds())};for(var h in l)t=t.replace(\"%\"+h,l[h]);return t},a.addDays=function(t){var e=new Date,n=e.getTime(),i=new Date(n+24*t*60*60*1e3);return e.setTime(i.getTime()),e},a.getMonthsArray=function(t){return t&&\"long\"!==t?\"short\"===t?s.getPhrase(\"monthsShort\"):void 0:s.getPhrase(\"months\")},a.localStorage=function(){function t(){try{var t=\"localStorage\"in window&&null!==window.localStorage,e=\"__\"+Math.round(1e7*Math.random());return t?(window.localStorage.setItem(e,\"\"),window.localStorage.removeItem(e),window.localStorage):{}}catch(t){return{}}}function e(){var e=t(),i=e[n[0]];return i&&o.isFunction(i)&&i.apply(e,n.slice(1))}var n=o.clone(arguments);return e.apply(this,n)},a.daysInMonth=function(t,e){var n;return n=new Date,33-new Date(e||n.getFullYear(),t||n.getMonth(),33).getDate()},a.getRemainingTime=function(t,e){var n,i,r,o=[];return r=void 0===e?(new Date).getTime():e instanceof Date?e.getTime():new Date(e.replace(/-/g,\"/\")).getTime(),i=t instanceof Date?t.getTime():new Date(t.toString().replace(/-/g,\"/\")).getTime(),n=function(t,e){var n={86400:0,3600:1,60:2};return t[n[e]]=Math.floor(t[3]/e),t[n[e]]*e},o[3]=Math.floor((i-r)/1e3),o[3]<0?console.log(\"startDate more finite time\"):(o[3]-=n(o,86400),o[3]-=n(o,3600),o[3]-=n(o,60),o.join(\":\"))},a.getCurrentTimezone=function(){return-1*(new Date).getTimezoneOffset()/60},a.getRange=function(t,e,n){for(var i=Number(t)||0,r=Number(e)||10,o=Number(n)||1,s=[],a=i;a<=r;a+=o)s.push(a);return s},a.toNavigatorAlias=function(t){var e=/[\\'\\\";,~`:№;\\!@#\\$%\\^&\\*\\[\\]\\.\\{\\}\\+\\(\\)\\<\\>\\?\\|\\\\\\/]/g;return t.replace(e,\"\").replace(/^[_\\s]+|[_\\s]+$/g,\"\").replace(/[-_\\s]+/g,\"-\").toLowerCase()},a.getViewportSize=function(){var t=window,e=\"inner\";return\"innerWidth\"in window||(e=\"client\",t=document.documentElement||document.body),{width:t[e+\"Width\"],height:t[e+\"Height\"]}},a.isTouchDevice=function(){return\"ontouchstart\"in window||\"DocumentTouch\"in window&&document instanceof window.DocumentTouch},a.generateGoogleCalendarLink=function(t){var e=[\"dates\",\"text\",\"details\",\"location\"],n=[\"http://www.google.com/calendar/event?action=TEMPLATE\"];return o.each(e,function(e){var i=t[e];i&&n.push([e,window.encodeURIComponent(i)].join(\"=\"))}),n.join(\"&\")},a.createBlob=function(t){var e=new Date,n=(e.getTime(),t.split(\",\"));if(2!==n.length)return!1;for(var i=window.atob(n[1]),r=n[0].split(\":\")[1].split(\";\")[0],s=o.genUniqueId()+\".\"+r.split(\"/\").pop(),a=new ArrayBuffer(i.length),u=new Uint8Array(a),c=0;c<i.length;c++)u[c]=i.charCodeAt(c);var l;try{if(this.safari())throw\"this is safari\";l=new File([a],s,{type:r})}catch(t){l=new Blob([a],{type:r}),l.name=s,l.lastModifiedDate=e}finally{return l}},a.countPercent=function(t,e){return parseFloat(e)*parseFloat(t)/100},a.getPercent=function(t,e){return 100*parseFloat(e)/parseFloat(t)},a.safari=function(){return o.isString(navigator.vendor)&&-1!==navigator.vendor.indexOf(\"Apple\")},a.currencyFormat=function(t){var e=\"\";switch(t.toLowerCase()){case\"usd\":e=\"$\";break;case\"eur\":e=\"€\";break;default:e=\"$\"}return e},a.createFakeUrlFile=function(t,e){return new i(t,e)},a.createFakeFileList=function(t){return new r(t)},a.unused=function(){}},function(t,e,n){\"use strict\";function i(t,e){this.setWom(e),this.__constructor(t)}var r=n(0),o=n(3);t.exports=r.extend(i,{_defineProperty:r.defineProperty,setWom:function(t){return this._defineProperty(\"_wom\",t),this},getWom:function(){return this._wom},getEm:function(){return this._wom.getEventManager()},getOm:function(){return this._wom.getOptionsManager()},_getObjectClass:function(){return\"BaseObject\"},__constructor:function(t){this._defineProperty(\"_objClass\",this._getObjectClass()),this._womHandlers={},this._events={},this._womWaitingActivationHandlers={},this._registerOptionsWeights={},r.isUndefined(t)&&(t={}),this._wom.registerObject(this),this.options={},this._options={},this._skippedOptions={},this._wrappedMethods={},this._prepared=!1,this._transitOptions=t.__transit__,delete t.__transit__,this.registerOptions(\"\",this._transitOptions,0,\"__transit__\"),this.registerOptions(\"\",t,0,\"configure of \"+this.getCaption()),this.alias=t.alias||\"object_\"+this.getId(),this.configure(t),this._active=!0,this._disabled=!1,this._children={},this._reactivationPool=[],this._running=!1,this._inited=!1,this._initedHandlers=!1,this._isRun=!1,this.requiredWidgets=[],this.requiredResources=[],this._widgets={},this._widgetGroups={},this._group=null,this._widgetClass=null,this._widgetsToEmbed=[],this.visual=!1,this._domHandlers={}},configure:function(t){this._fillWomPatterns()},_fillWomPatterns:function(){var t=this,e=\"#\"+this.alias;for(this._womMatch={},this._womMatch[e]=!0;t;){var n=\".\"+t._className;this._womMatch[n]=!0,this._womMatch[n+e]=!0,this._womMatch[e+n]=!0,t=t.superclass}},setId:function(t){return this._defineProperty(\"_id\",t),this},getId:function(){return this._id},isActive:function(){var t=this.getParent();return t?this._active&&t.isActive():this._active},setActiveState:function(t){return this._active=t,this},setWidgetGroupOption:function(t,e,n){return r.objectSet(this._widgetGroups,[t,\"options\",e],n),this},getGroup:function(){return this._group},setGroup:function(t){this._group=t;var e=this.getParent();return e&&(e._widgetGroups[t]||(e._widgetGroups[t]={list:[]}),e._widgetGroups[t].list.push(this.getAlias())),this},getWidgetsByGroup:function(t){var e={};return r.each(this._widgets,function(n,i){n._group===t&&(e[i]=n)}),e},removeWidgetsByGroup:function(t){return r.each(this.getWidgetsByGroup(t),function(t,e){this.removeEmbeddedWidget(e)},this),this},setAlias:function(t){return this.alias=t,this},getAlias:function(){return this.alias},getClass:function(){return this._className},handleEvent:function(t,e,n,i){if(void 0===i&&(i=!0),r.isObject(i)||(i={listenHistory:!!i}),i.performer=this,i.prefix=i.prefix?[this.getHash(),i.prefix].join(\"_\"):this.getHash(),!o.instanceOf(this,\"App\")&&r.isObject(t)&&\"Navigator\"==t._widgetClass&&\"modified_0\"!=e){var s=fox.Navigator.get(0)||\"home\";void 0===i.checker&&(i.checker=function(){return(fox.Navigator.get(0)||\"home\")==s})}return this.getEm().handle(t,e,n,i)},wait:function(t,e,n,i){if(void 0===n&&(!r.isObject(e)&&void 0!==e||!r.isString(t)&&!r.isArray(t)||(e=t,t=\"@this\")),r.isObject(n)||(n={}),n.once=!0,n.performer=this,n.prefix=this.getHash()+\"_\"+(n.prefix||\"noPrefix\"),!o.instanceOf(this,\"App\")&&r.isObject(t)&&\"Navigator\"==t._widgetClass&&\"modified_0\"!=e){var s=fox.Navigator.get(0)||\"home\";void 0===n.checker&&(n.checker=function(){return(fox.Navigator.get(0)||\"home\")==s})}return this.getEm().handlePromise(t,e,n,i)},registerOptions:function(t,e,n,i){if(r.isHash(i)||(i={code:i}),i.inline=1,n&&!0!==n)this.getOm().register(\"@\"+this.getId()+(t?\" \"+t:\"\"),e,n,i);else{var o=t||\"@this\";this._registerOptionsWeights[o]?this._registerOptionsWeights[o]-=1:this._registerOptionsWeights[o]=-1,this.getOm().register(\"@\"+this.getId()+(t?\" \"+t:\"\"),e,this._registerOptionsWeights[o],i)}return this},_getOptionsFromRegistry:function(){var t=[],e={};return r.each(this.getOm().get(),function(n,i){this._wom.matchWidget(i,this)&&r.each(n,function(n,o){function s(t){return t.desc.weight&&-1===o.indexOf(\"!\")&&-1===o.indexOf(\"--\")||function(t){var e=r.filter(i.split(\" \")),n={\"!\":0,w:0,l:0,\"#\":0,\".\":0},s=0;r.each(e,function(t,e){-1!==t.indexOf(\".\")&&n[\".\"]++,-1!==t.indexOf(\"&\")&&n[\".\"]++,-1!==t.indexOf(\"#\")&&n[\"#\"]++}),-1!==o.indexOf(\"!\")&&(n[\"!\"]=1),-1!==o.indexOf(\"--\")&&(t.desc.delete=1),o=o.replace(/--|!/g,\"\"),n.l=0|t.desc.level,n.w=0|t.lWeight,t.desc.weightDesc=n,s=1e6*n[\"!\"]+1e5*n.w+1e3*n.l+100*n[\"#\"]+n[\".\"]+1,t.desc.weight=s}(t),t.name=o,t}n=n.map(s),t=r.merge(t,n),e[o]=r.merge(e[o]||[],n)})},this),t.sort(function(t,e){var n=t.desc.weight,i=e.desc.weight;return n<i?-1:n==i?0:1}),r.each(t,function(t){var e=t.name;if(r.objectSet(this._options,e,t),t.desc.delete)return void r.objectRemove(this.options,e);var n=t.value;r.objectSet(this.options,e,n)},this),this._skippedOptions=e,t},_setHooksFromOptions:function(){r.each(this.options.hooks||{},this.addHook,this)},wrapMethod:function(t,e){if(this._wrappedMethods[t])return void console.log(\"Method \"+t+\" has already been wrapped\");var n=this[t]||e;if(!r.isFunction(n))return void console.log(this[t],Object.prototype.toString.call(this[t]));this[\"__wrapped__\"+t]=n,this[t]=r.bind(function(){this.getEm().dispatchHook(this,t,arguments,{hookedMethod:\"__wrapped__\"+t})},this)},_wrapMethodsFromOptions:function(){r.each(this.getOption(\"wrapMethods\")||{},function(t,e){this.wrapMethod(e,t)},this)},_prepare:function(){this._prepared||(this._prepared=!0,this.preparing())},preparing:function(){this._getOptionsFromRegistry(),this._wrapMethodsFromOptions(),this._setHooksFromOptions(),this.setGroup(this.getOption(\"group\")||\"default\"),this.setActiveState(!!this.getOption(\"active\"))},setOption:function(t,e){return r.objectSet(this.options,t,e),this},removeOption:function(t){return r.objectRemove(this.options,t),this},getOption:function(t){var e=r.objectGet(this.options,t);if(void 0!==e)return e;var n=t.split(\".\"),i=\"$\"+n.shift(),o=n.join(\".\");if(e=this.options[i]){var s=/^(.*?):(.*)/.exec(e),a=this.wom1(s[1]);if(a)return a.getOption(s[2]+(o?\".\"+o:\"\"))}},hasOption:function(t){return r.objectIsSet(this.options,t)},requireOption:function(t){var e=this.getOption(t);if(void 0===e)throw\"Widget \"+this.getCaption()+\" requires option: \"+t;return e},prepareOptions:function(t,e){t||(t={});for(var n in e)if(r.isArray(e[n])){t[n]||(t[n]={});for(var i=0,o=e[n].length;i<o;i++)this.prepareOptions(t[n],e[n][i])}else if(e[n].default&&!r.isSet(t[n])&&(t[n]=e[n].default),e[n].mandatory&&!0===e[n].mandatory&&!r.isSet(t[n]))throw'Missing option \"'+n+'\"'},getCaption:function(){return this.getClass()+\"(\"+this.getId()+\" : \"+this.getAlias()+(this.getParent()?\" -> \"+this.getParent().getAlias():\"\")+\")\"},dropHandler:function(t){this.getEm().dropHandler(t)},getHash:function(){return this._id+\"_\"+this._objClass},dispatchEvent:function(t,e){this.getEm().dispatch(this,t,e)},hookWrapper:function(t){this.getEm().dispatchHook(this,t,Array.prototype.slice.call(arguments,1))},addHook:function(t,e){var n={performer:this,prefix:this.getHash()};r.isString(t)&&(t=o.getRealCallback(o.createCallback(t,this))),this.getEm().handleHook(this,e,t,n)},callParent:r.callSuperMethod,setParent:function(t){return this._parentId=t.getId(),this},getParent:function(){return this._wom.getObject(this._parentId)},handlePlugin:function(t,e,n,i){i=i||{},i.performer=this,this.getEm().handlePlugin(t,e,n,i)},applyPlugins:function(t,e){var n=\"applyPlugins\"+r.ucfirst(t),i=Array.prototype.slice.call(arguments,1);return i[0]=this.getId()+\"_\"+e,this.getEm()[n].apply(this.getEm(),i)}},null,\"BaseObject\")},function(t,e,n){\"use strict\";var i=n(0),r=n(1),o=n(3),s=n(5),a=n(15),u={autoRunEmbeddedWidgets:!0,active:!0};t.exports=i.extend({_getObjectClass:function(){return\"Controller\"},configure:function(t){this.registerOptions(\"\",u,0,\"controllerDefaultOptions\"),this.callParent(\"configure\",arguments)},isInited:function(){return this._inited},isRun:function(){return this._isRun},waitEvent:function(t,e,n,r){this.handleEvent(t,e,n,i.merge(r||{},{once:!0,prefix:\"waitDep\"}))},_performStateDependency:function(t,e){var n=i.isObject(t.subject)?[t.subject]:this._wom.select(t.subject,[this]);if(!n.length)return void i.log('StageDeps error: cannot find element by \"'+t.subject+'\" query',this,t);n.length>1&&i.log('StageDeps warning: multiple elements found by \"'+t.subject+'\" query. Using first'),this.handleEvent(n[0],t.event,i.bind(e,this),{listenHistory:!0,once:!0,desc:t,prefix:\"stateDep\"})},run:function(){if(this._prepare(),this.getOption(\"disabled\"))return this._disabled=!0,void i.log(\"Widget \"+this.getCaption()+\" disabled by option\");var t=this.getOption(\"stateDeps.run\");return t?this._performStateDependency(t,this._run):this._run()},_run:function(){var t=this.beforeRun();return t&&t.then?t:this.isActive()||this.getOption(\"runInactive\")?(this.activatePoolWidgets(),this.dispatchEvent(\"running\"),this.hookWrapper(\"running\"),void this.afterRun()):void i.log(\"skipping run of inactive widget \"+this.getCaption())},init:function(){},beforeRun:function(){if(this._inited||(i.log(\"init -> widget \"+this.getCaption()),this.getEm().registerObject(this),this.hookWrapper(\"init\"),this._inited=!0,!1!==this.getOption(\"active\")&&this._active&&this.dispatchEvent(\"activate\"),this.dispatchEvent(\"inited\")),this.visual||!this.getParent()?this._childrenContainerWidget=this:this.getParent()&&(this._childrenContainerWidget=this.getParent()._childrenContainerWidget),i.log(\"run -> widget \"+this.getCaption()),this._running)return i.log(\"already running\"),!1;var t=this._loadResources();if(t)return t.then(function(){this.run()}.bind(this));this._initedHandlers||(this.setExternalDomHandlers(),this.createWomHandlers(),this._initedHandlers=!0),this.embedWidgetsFromOptions(),this.hookWrapper(\"prepareEmbeddedWidgets\"),i.each(this._widgets,function(t,e){t.isRun()||(t._prepare(),this.getOption(\"widgetGroupInfo.\"+t.getGroup()+\".manualActivation\")||t.run())},this),this.hookWrapper(\"initWithChildren\")},_loadResources:function(){if(this._resourcesFullfilled)return!1;var t=[this.requireResources,this.getOption(\"requireResources\")].reduce(function(t,e){return i.isFunction(e)&&t.push(e.bind(this)),t}.bind(this),[]);return!!t.length&&(console.log(\"widget \"+this._widgetClass+\"(\"+this.alias+\") requires resource(s)\"),this._running=!0,new Promise(function(e,n){t.reduce(function(t,e){return t.then(e)},s.Promise.resolve(!0)).then(function(){this._resourcesFullfilled=!0,this._running=!1,e(this)}.bind(this)).catch(function(){throw new Error(\"Error in loading required resources for widget \"+this.getCaption())}.bind(this))}.bind(this)))},embedWidgetsFromOptions:function(){var t,e=this.options.widgets;if(i.isObject(e))t=i.toArray(i.each(this.options.widgets,function(t,e){t.__transit__=i.objectGet(this._options,\"widgets.\"+e),t.alias=e},this));else{if(!i.isArray(e))return this;t=e.filter(function(t){return t.__transit__=i.objectGet(this._options,\"widgets.\"+t.alias),t.alias},this)}return t.sort(function(t,e){var n=t.womPriority||0,i=e.womPriority||0;return n<i?1:n>i?-1:0}).forEach(function(t){if(!t.widget)return!1;this._embedWidget(t.alias,t.widget,t)},this),this},prepareEmbeddedWidgets:function(){},initWithChildren:function(){},running:function(){},afterRun:function(){return this._isRun=!0,!0},setExternalDomHandlers:function(){i.each(this.options.handlers,function(t,e){t.targetWidget&&this.addDomHandler(t,e)},this),i.each(this.getOption(\"handleDom\"),function(t,e){t.targetWidget&&this.addDomHandler(t,e)},this)},createWomHandlers:function(){i.each(this.getOption(\"handleWom\")||{},function(t,e){if(!t.widget||!t.event||!t.callback)return!1;this.handleEvent(t.widget,t.event,t.callback,t.params||{})},this),i.each(this.getOption(\"forwardWom\")||{},function(t,e){if(i.isString(t)){var n,r,o=t.split(\":\"),s=o[0];o[1]?(o=o[1].split(\"->\"),n=o[0],r=o[1]||e):(n=e,r=e),this.forwardEvent(s,n,r)}},this)},forwardEvent:function(t,e,n,i){var r=n||e;i=i||{},i.prefix=\"forward_to_\"+r,i.listenHistory=!0,this.handleEvent(t,e,function(){this.dispatchEvent(r,i)},i)},addHandler:function(t,e){return this.addDomHandler(t,e)},addDomHandler:function(t,e){if(i.isObject(t)?e&&(t.alias=e):t={alias:arguments[0],target:arguments[1],event:arguments[2],callback:arguments[3]},t.event||(t.event=\"click\"),t.callback&&(t.callback=o.createCallback(t.callback,this)),t.targetWidget)return void this.handleEvent(t.targetWidget,\"addedToDom\",function(n,r){var o=i.clone(t);delete o.targetWidget,r.addDomHandler(o,e)},{prefix:\"domHandler\"+e+\"_\"+this.getId(),listenHistory:!0,sync:!0});var n;if(r.isDomNode(t.target))n=[t.target];else{var s=i.isArray(t.target)?t.target:[t.target],a=t.container?this.getWidgetNodes(t.container):this.getMyNodes();n=[];for(var u=0;u<s.length;u++)if(r.isDomNode(s[u]))n.push(s[u]);else for(var c=0,l=a.length;c<l;c++)n=i.merge(n,s[u]?r.select(s[u],a[c]):[a[c]])}this._domHandlers[t.event]||(this._domHandlers[t.event]={});var h=t.callback.subj+\"_\"+t.callback.scope._widgetClass;this._domHandlers[t.event][h]||(this._domHandlers[t.event][h]=[]);for(var c=0,l=n.length;c<l;c++){var f=n[c];-1===this._domHandlers[t.event][h].indexOf(f)?(this._domHandlers[t.event][h].push(f),r.on(t.event,f,function(t,e){return function(n){if(e.eventChecker&&!i.getCallback(e.eventChecker)(n,f,t))return void i.log(\"Event did not pass checker\");if(e.callback){o.getRealCallback(e.callback).call(t,this,e.alias,t,n)}else t.domEventHandler.call(t,this,e.alias,t,n)}}(this,t))):i.log(\"Skip adding duplicate dom handler\",t.event,this,f)}},domEventHandler:function(t,e,n,i){console.log(\"Unhadled dom event: \"+e,t,i)},activating:function(){},activate:function(t){this._active=!0;var e=function(t){this.dispatchEvent(\"activate\"),i.log(\"Activating: \"+this.getAlias()+\" (\"+this.getClass()+\")\"),this.activatePoolWidgets(t,!0),this.activating(t)}.bind(this);if(this.isRun())this._firstActivation=!1,e(t);else{i.log(\"Not inited, running\");var n=this.run();n&&n.then?n.then(function(){e(t)}):e(t)}},activatePoolWidgets:function(t,e){this.getEm().activateHandlers(this),this._reactivationPool.length?i.each(this._reactivationPool,function(e){i.log(this.getCaption()+\": reactivating child \"+e);var n=this.requireEmbeddedWidget(e);n.isActive()||this.getOption(\"widgetGroupInfo.\"+n.getGroup()+\".manualActivation\")||setTimeout(function(){n.activate(t)},1)},this):e&&i.each(this._widgets,function(e,n){e.isActive()&&(i.log(this.getCaption()+\": activating child by option \"+n),this.getOption(\"widgetGroupInfo.\"+e.getGroup()+\".manualActivation\")||e.activate(t))},this),this._reactivationPool=[]},deactivate:function(){return i.each(this._widgets,function(t,e){t.isActive()?(i.log(this.getAlias()+\": child \"+e+\" is active, pushing to reactivating pool\"),t.deactivate(),this._reactivationPool.push(e)):i.log(this.getAlias()+\": child \"+e+\" is NOT active\")},this),this._active=!1,i.log(\"Deactivating: \"+this.getAlias()+\" (\"+this.getClass()+\")\"),this},switchEmbeddedWidget:function(t,e){var n=this.requireEmbeddedWidget(t);if(i.log(\"Widget \"+this.getCaption()+\" switching group widget to \"+n.getCaption()),n.isActive())return void i.log(\"Already active: \"+t+\" (\"+n.getClass()+\")\");var r=n.getGroup();return this._active?(i.each(i.objectGet(this._widgetGroups,[r,\"list\"]),function(e){if(t!=e){var n=this.requireEmbeddedWidget(e);n.isActive()&&n.deactivate()}},this),n.activate(e)):(i.each(i.objectGet(this._widgetGroups,[r,\"list\"]),function(t){this._reactivationPool=i.arrayWithout(this._reactivationPool,t)},this),this._reactivationPool.push(t)),this.dispatchEvent(\"switchedEmbeddedWidget\",t),!0},requireEmbeddedWidget:function(t){var e=this.getEmbeddedWidget(t);if(!e)throw new Error('Widget \"'+this.alias+'\" tries to acces unexisted ebmebbed widget \"'+t+'\"');return e},getEmbeddedWidget:function(t){return this._widgets[t]||!1},wom:function(t){return this._wom.select(t,[this])},wom1:function(t){return this._wom.selectFirst(t,[this])},rwom:function(t){var e=this._wom.select(t,[this]);if(!e.length)throw new Error(\"Widget by path \"+t+\" required but missing\");return e},rwom1:function(t){var e=this._wom.selectFirst(t,[this]);if(!e)throw new Error(\"Widget by path \"+t+\" required but missing\");return e},embedWidgets:function(t,e){i.each(t,function(t,n){var i=this.embedWidget(n,t.widget,t);i&&(e?i.run():i._prepare())},this)},embedWidget:function(t,e,n){if(this.options.widgets||(this.options.widgets={}),n=n||{},n.widget=e,this.options.widgets[t]=n,this.isInited())return this._embedWidget(t,e,n||{})},removeEmbeddedWidgets:function(t){return t?this.removeEmbeddedWidget(t):i.each(this._widgets,function(t,e){t.removeEmbeddedWidgets(),this.removeEmbeddedWidget(e)},this),this},removeEmbeddedWidget:function(t){var e=this._widgets[t];this._widgets[t]&&this._widgetGroups[this._widgets[t].getGroup()]&&(this._widgetGroups[this._widgets[t].getGroup()].list=i.arrayWithout(this._widgetGroups[this._widgets[t].getGroup()].list,t)),this._reactivationPool=i.without(this._reactivationPool,t),e.removeEmbeddedWidgets(),this._wom.removeObjectFromRegistry(e),delete this._widgets[t],i.isObject(this.options.widgets)&&delete this.options.widgets[t]},destroy:function(){var t=this.getParent();return t?t.removeEmbeddedWidget(this.getAlias()):(this.removeEmbeddedWidgets(),this._wom.removeObjectFromRegistry(this))},removeSelf:function(){return this.destroy()},_embedWidget:function(t,e,n){if(!this.getEmbeddedWidget(t)){var r=e;if(i.isString(e))n.alias=t,n.widget=e,e=this._wom.loadWidget(e,n);else if(!o.instanceOf(e,\"BaseObject\"))return void console.log(\"Attempt to load invalid widget with alias (\"+t+\") object from \"+this.getCaption());if(!e)return void console.log(\"Attempt to load missing widget (\"+r+\") from \"+this.getCaption());e.setAlias(t).setParent(this),this._widgets[t]=e,!this._active&&this.isRun()&&e._active&&(e._active=!1,this._reactivationPool.push(t))}return this.getEmbeddedWidget(t)},getApi:function(t,e){var n=this.getEmbeddedWidget(t);if(!n){if(void 0===e)throw new Error(\"You must configure your Api widget\");n=this.embedWidget(t,\"Api\",e),!0===this.isInited()&&n&&n.run()}return n}},a,null,\"Controller\")},function(t,e){function n(){throw new Error(\"setTimeout has not been defined\")}function i(){throw new Error(\"clearTimeout has not been defined\")}function r(t){if(l===setTimeout)return setTimeout(t,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(t,0);try{return l(t,0)}catch(e){try{return l.call(null,t,0)}catch(e){return l.call(this,t,0)}}}function o(t){if(h===clearTimeout)return clearTimeout(t);if((h===i||!h)&&clearTimeout)return h=clearTimeout,clearTimeout(t);try{return h(t)}catch(e){try{return h.call(null,t)}catch(e){return h.call(this,t)}}}function s(){g&&d&&(g=!1,d.length?p=d.concat(p):m=-1,p.length&&a())}function a(){if(!g){var t=r(s);g=!0;for(var e=p.length;e;){for(d=p,p=[];++m<e;)d&&d[m].run();m=-1,e=p.length}d=null,g=!1,o(t)}}function u(t,e){this.fun=t,this.array=e}function c(){}var l,h,f=t.exports={};!function(){try{l=\"function\"==typeof setTimeout?setTimeout:n}catch(t){l=n}try{h=\"function\"==typeof clearTimeout?clearTimeout:i}catch(t){h=i}}();var d,p=[],g=!1,m=-1;f.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];p.push(new u(t,e)),1!==p.length||g||r(a)},u.prototype.run=function(){this.fun.apply(null,this.array)},f.title=\"browser\",f.browser=!0,f.env={},f.argv=[],f.version=\"\",f.versions={},f.on=c,f.addListener=c,f.once=c,f.off=c,f.removeListener=c,f.removeAllListeners=c,f.emit=c,f.prependListener=c,f.prependOnceListener=c,f.listeners=function(t){return[]},f.binding=function(t){throw new Error(\"process.binding is not supported\")},f.cwd=function(){return\"/\"},f.chdir=function(t){throw new Error(\"process.chdir is not supported\")},f.umask=function(){return 0}},function(t,e,n){\"use strict\";var i=n(0),r=n(7)(),o=n(51),s=t.exports=Object.create(i),a=n(46),u=n(48);s.defineProperty(\"VERSION\",\"0.6.0\"),s.defineProperty(\"_isNewfe\",!0),s.defineProperty(\"_isNewFe\",!0),s.RSVP=n(5),s.Promise=s.RSVP.Promise,s.dom=n(13),s.cookie=n(45)(),s.dictionary=n(47)(s),s.oop=n(3),s.image=n(49),s.css=a(s);var c=u(s);s.registerImage=c.register,s.unregisterImage=c.unregister,s.BaseObject=n(15),s.utils=n(14),s.regexp=n(50),s.registerService=function(t,e){s[t]=e},s.createEnvironment=function(t){var e=o();return new r.Wom(t,e)};var l=n(26);s.createLibrary=n(57),s.initDefaultLibrary=function(){var t=s.createLibrary();return s.registerWidget=t.registerWidget.bind(t),s.registerTemplate=t.registerTemplate.bind(t),s.registerOptions=t.registerOptions.bind(t),s.registerMixin=function(t,e,n){s.registerWidget(t,e,n||\"Mixin\")},s.checkTemplate=function(e){var n=!1;try{n=t.getTemplate(e)}catch(t){n=!1}finally{return!1!==n}},l(t),t},s.registerTemplateModifier=n(43)},function(t,e,n){t.exports=n(18)},function(t,e,n){function i(t){return n(r(t))}function r(t){var e=o[t];if(!(e+1))throw new Error(\"Cannot find module '\"+t+\"'.\");return e}var o={\"./processor/components/action\":4};i.keys=function(){return Object.keys(o)},i.resolve=r,t.exports=i,i.id=20},function(t,e,n){function i(t){return n(r(t))}function r(t){var e=o[t];if(!(e+1))throw new Error(\"Cannot find module '\"+t+\"'.\");return e}var o={\"./processor/components/base\":2};i.keys=function(){return Object.keys(o)},i.resolve=r,t.exports=i,i.id=21},function(t,e,n){function i(t){return n(r(t))}function r(t){var e=o[t];if(!(e+1))throw new Error(\"Cannot find module '\"+t+\"'.\");return e}var o={\"./processor/components/else\":33};i.keys=function(){return Object.keys(o)},i.resolve=r,t.exports=i,i.id=22},function(t,e,n){function i(t){return n(r(t))}function r(t){var e=o[t];if(!(e+1))throw new Error(\"Cannot find module '\"+t+\"'.\");return e}var o={\"./processor/components/foreach\":35};i.keys=function(){return Object.keys(o)},i.resolve=r,t.exports=i,i.id=23},function(t,e,n){function i(t){return n(r(t))}function r(t){var e=o[t];if(!(e+1))throw new Error(\"Cannot find module '\"+t+\"'.\");return e}var o={\"./processor/components/elseif\":34,\"./processor/components/if\":12};i.keys=function(){return Object.keys(o)},i.resolve=r,t.exports=i,i.id=24},function(t,e,n){function i(t){return n(r(t))}function r(t){var e=o[t];if(!(e+1))throw new Error(\"Cannot find module '\"+t+\"'.\");return e}var o={\"./processor/components/import\":36};i.keys=function(){return Object.keys(o)},i.resolve=r,t.exports=i,i.id=25},function(t,e,n){\"use strict\";var i=\"./processor/components/\";t.exports=function(t){t.registerResource(\"template-components\",n(21)(i+\"base\"),\"base\"),t.registerResource(\"template-components\",n(20)(i+\"action\"),\"action\"),t.registerResource(\"template-components\",n(24)(i+\"if\"),\"if\"),t.registerResource(\"template-components\",n(22)(i+\"else\"),\"else\"),t.registerResource(\"template-components\",n(23)(i+\"foreach\"),\"foreach\"),t.registerResource(\"template-components\",n(25)(i+\"import\"),\"import\")}},function(t,e,n){\"use strict\";function i(t,e,n){this._data={};var i=n.getResource(\"template-components\",\"base\");return i?(this.base=i.create({doc:e,lib:n,node:t}),this.base.prepare(),this):r.exception(\"Missing base component in library\")}var r=n(0);t.exports=function(t,e,n){return new i(t,e,n)},i.prototype.setAlias=function(t){return this.alias=t,this},i.prototype.setData=function(t,e){return this._data[e||\"default\"]=t,this},i.prototype.setVar=function(t,e,n){return r.objectSet(this._data,[n||\"default\",t],e),this},i.prototype.bindVar=function(t,e,n,i){if(\"default\"!==i||t.__cloned||(t=r.clone(t),t.__cloned=!0),r.isArray(e))return e.reduce(function(t,e,o){return this.bindVar(t,e,r.isArray(n)?n[o]:null,i)}.bind(this),t);var o={_bind:!0,obj:t,source:e,target:n||e,subject:i||\"bind\"};return this.setVar(o.target,o,o.subject)&&t},i.prototype.compile=function(t){var e={defaultScope:\"default\"};t=t||{},this._data.default&&(r.isArray(this._data.default)||r.isDl(this._data.default)||r.isObject(this._data.default)&&this._data.default.collection)&&(t.iterateScope=\"default\");var n=this.base.doc.createDocumentFragment();return this.base.compile(n,this._data,e,t),n},i.prototype.getPlainVariables=function(){return this.base.plainVariables||this.base.getPlainVariables(),this.base.plainVariables}},function(t,e,n){\"use strict\";var i=n(0);t.exports={createComponentByTag:function(t,e){var n=t[0].toLowerCase(),r=this.lib.getResource(\"template-components\",n);if(r){var o={doc:this.doc,parentCtx:this,node:t,embedAddress:i.clone(this.address)};return e&&i.merge(o,e),r.create(o)}return!1},compileComponents:function(){this.emit.apply(this,[\"compile\"].concat(i.clone(arguments)))}}},function(t,e,n){\"use strict\";var i=n(0),r=n(42);t.exports={callParent:i.callSuperMethod,getIterator:r.getIterator,_addHandler:function(t,e,n){i.isUndefined(this._handlers[t])&&(this._handlers[t]=[]);var r=i.objectGet(this._hrefs,[n,t]);return i.isUndefined(r)?(i.objectSet(this._hrefs,[n,t],this._handlers[t].push(e)-1),!0):(this._handlers[t].splice(r,1,e),!0)},_removeHandler:function(t,e){var n=i.objectGet(this._hrefs,[e,t]);return!i.isUndefined(n)&&(n===this._handlers[t].length-1?this._handlers[t].splice(n,1):this._handlers[t][n]=null,i.objectRemove(this._hrefs,[e,t]),!0)},on:function(t,e,n){var r={func:e};return this.parentCtx&&(i.isUndefined(n)||(r.context=n),this.parentCtx._addHandler.call(this.parentCtx,t,r,this._id)),this},off:function(t){return this.parentCtx&&this.parentCtx._removeHandler.call(this.parentCtx,t,this._id),this},emit:function(t){var e=i.toArray(arguments).slice(1),n=i.clone(this._handlers[t]);return i.isArray(n)&&n.length&&i.each(n.reverse(),function(t){if(!i.isNull(t))return t.context?t.func.apply(t.context,e):t.func.apply(null,e)}),!0}}},function(t,e,n){\"use strict\";var i=n(0),r=/\\&[\\w]+;/g,o={\"&nbsp;\":\" \",\"&amp;\":\"&\",\"&uarr;\":\"↑\",\"&darr;\":\"↓\",\"&copy;\":\"©\",\"&raquo;\":\"»\",\"&larr;\":\"←\",\"&rarr;\":\"→\",\"&lt;\":\"<\",\"&gt;\":\">\",\"&quot;\":'\"',\"&mdash;\":\"—\"};t.exports=function(t){return i.isString(t)&&t.replace(r,function(t){return o[t]||t})||t}},function(t,e,n){\"use strict\";var i=n(0),r=n(30);t.exports={templateRecursion:function(t,e){function n(t,e){t=t||[];for(var n=t.length,i=0;i<n;i++){if(t[i][1]===e)return!0}return!1}function o(t,e){if(i.isEmpty(t)||this.createComponentByTag(t))return!1;this.address[this.currentAddressIndex]++;var o,s=t[0],a=t[1],u=t[2],c=t[3],l=(t[4],i.clone(a,!0));switch(s){case\"textNode\":o=this.doc.createTextNode(r(l.text));break;default:o=this.doc.createElement(s);c&&o.setAttribute(\"data-shift\",this.vars.length);i.each(l,function(t,e){n(c,e)&&\"src\"===e&&(e=\"__src\"),o.setAttribute(e,t)})}this.addVars(c),e.appendChild(o),this.templateRecursion(u,o)}return i.isUndefined(e)&&(e=this.doc.createDocumentFragment()),!i.isEmpty(t)&&(this.currentAddressIndex=this.address.length,this.address.push(-1),i.each(t,function(t){return o.call(this,t,e)},this),this.address.pop(),this.currentAddressIndex--,e)}}},function(t,e,n){\"use strict\";var i=n(0),r=n(10),o=(n(1),e.TPL_VAR_RGX=/&&(\\d+)&&/g);t.exports={fillVarPositions:function(t,e,n){i.objectGet(this.varPositions,t)||i.objectSet(this.varPositions,t,[]);var r=i.objectGet(this.varPositions,t);if(i.isUndefined(n))return r.push(e)-1;var o=r[n];return r[n]=e,i.objectSet(this.varPositions,t,r.slice(0,n+1).concat(r.slice(n+1).map(function(t){return t[0]+=e[1]-o[1],t}))),n},bindVariable:function(t,e,n){var r=t.source+\"_\"+(t.target||t.source)+\"_\"+(t.subject||\"bind\"),o=this._binds[r];return o?(o.elvars.push({el:e,variable:n}),o.apply(o.value)):(o=this._binds[r]={value:i.isUndefined(t.obj[t.source])?\"\":t.obj[t.source],prev:\"\",elvars:[{el:e,variable:n}],apply:function(e){o.prev=o.value,o.value=e,i.each(o.elvars,function(e){this.applyVariable(o.value,e.el,e.variable,o.prev,t)},this)}.bind(this)},Object.defineProperty(t.obj,t.source,{get:function(){return o.value},set:function(t){o.apply(t)}}),o.apply(o.value))},walkVariables:function(t){var e,n;i.each(this.vars,function(r){n=t,e=this.getVariableValue(r,!0);for(var o=r.address.length,s=0;s<o;s++){var a=n.childNodes[r.address[s]];a&&(n=a)}if(n instanceof DocumentFragment)return!1;i.isObject(e)&&e._bind?this.bindVariable(e,n,r.variable):(e=this._prepareVariable(e),this.applyVariable(e,n,r.variable,null,r))},this)},_prepareVariable:function(t){return i.isNull(t)?\"\":i.isUndefined(t)?\"\":i.isNaN(t)?\"\":i.isNumber(t)?t.toString():!1===t?\"\":t},applyVariable:function(t,e,n,r,s,a){var u,c=this,l=n[1],h=this.applyModifiers(n[3],t,r),f=e.getAttribute(\"data-shift\")||e.dataShift,d=l+\"_\"+f;switch(e.removeAttribute(\"data-shift\"),e.dataShift=f,t=this._prepareVariable(h[0]),r=this._prepareVariable(h[1]),l){case\"__internal\":break;case\"__text\":for(;e.firstChild;)e.removeChild(e.firstChild);var p=t.split&&t.split(\"__HTML__\")||[];p.length>1?e.innerHTML=p[0]:e.appendChild(this.doc.createTextNode(t));break;case\"src\":u=e.getAttribute(\"__src\"),e.removeAttribute(\"__src\");default:if(u||(u=e.getAttribute(l)),u){if(i.isString(r)&&!o.test(u)&&i.objectGet(s,\"_bind\")){var g=(c.varPositions[d]||[])[n[5]]||[0,u.length],m=[u.slice(0,g[0]),t,u.slice(g[0]+g[1])].join(\"\");c.fillVarPositions(d,[g[0],t.length],n[5]),t=m}else t=i.objectGet(s,\"_bind\")?this.applyRuntimeVariables(u,f,function(e,r,o){return s!==o&&i.isObject(o)?e:(n[5]=c.fillVarPositions(d,[r,t.length],n[5]),t)}):this.applyRuntimeVariables(u,f);i.trim(t).length||(t=\"\")}e.setAttribute(l,t)}},getVariableValue:function(t,e){var n,r=this.opts.scopes,o=t.variable[0];return r.namePattern&&r.namePattern.some(function(t,e){if(~o.indexOf(t.pattern))return n=o===t.pattern?t.iterator.obj:t.iterator.get(o.substr(t.pattern.length+1)),!0})||(n=r.subjectIterator&&r.subjectIterator[t.subject]?r.subjectIterator[t.subject].get(o):i.arrayRelation(this.data[t.subject],o)),e||(n=this.applyModifiers(t.variable[3],n)[0]),n},applyModifiers:function(t,e,n){return i.isArray(t)&&t.length>0&&i.each(t,function(t){var o=i.map(t.params,i.bind(function(t){return this.applyRuntimeVariables(t)},this));r.hasOwnProperty(t.name)&&(e=r[t.name](e,o),n=n&&r[t.name](n,o))},this),[e,n]},applyRuntimeVariables:function(t,e,n){return t.toString().replace(o,function(t,r,o){var s=this.vars[Number(e||0)+Number(r)],a=this.getVariableValue(s);return i.isFunction(n)?n(t,o,a,s):this._prepareVariable(a)}.bind(this))},getVariableByAttrName:function(t){var e=i.filter(this.vars,function(e){return(i.isString(e.variable[1])?e.variable[1].toLowerCase():e.variable[1])===t});return e.length&&e[0]||\"\"},getPlainVariables:function(){return this.emit(\"plain_variables\")&&this.setPlainVariables(this.prepareMyPlainVariables())},prepareMyPlainVariables:function(){return this.vars.map(function(t){return t.variable[0]})},prepareToTransit:function(t){return t},setPlainVariables:function(t){if(t=this.prepareToTransit(t),this.parentCtx)return this.parentCtx.setPlainVariables(t);this.plainVariables=i.uniq((this.plainVariables||this.prepareMyPlainVariables()).concat(t))}}},function(t,e,n){\"use strict\";var i=n(0),r=n(4),o=n(2).constructor,s=i.extend(i.mixin({__constructor:function(){this.callParent(\"__constructor\",arguments),this.elseNode=this.node,this.node=this.elseNode[2],this.embedAddress=this.parentCtx.embedAddress,this.off(\"compile\").on(\"false-compile\",this.compile,this)},prepare:function(){this.createActionComponent(this.elseNode).callParent(\"prepare\",arguments)}},r.mixin),o,null,\"ComponentElse\");t.exports={create:function(t){return new s(t)},constructor:s}},function(t,e,n){\"use strict\";var i=n(0),r=n(12).constructor,o=i.extend({__constructor:function(){if(this.parentCtx&&\"ComponentIf\"!==this.parentCtx._className)throw new Error(\"This component cannot use without if statement\");this.callParent(\"__constructor\",arguments),this.embedAddress=this.parentCtx.embedAddress},addComponent:function(){return this.parentCtx.elseIfComponents.push(this),this}},r,null,\"ComponentElseIf\");t.exports={create:function(t){return new o(t)},constructor:o}},function(t,e,n){\"use strict\";var i=n(0),r=n(4),o=n(2).constructor,s=i.extend(i.mixin({__constructor:function(){return this.callParent(\"__constructor\",arguments),this.foreachNode=i.clone(this.node,!0),this.node=this.foreachNode[2],this},_prepareIterateEnv:function(){return this.rowScopeName=this.foreachNode[1].item,i.isEmpty(this.foreachNode[3][0])||\"from\"!==this.foreachNode[3][0][1]||(this.dataSrc=this.foreachNode[3][0],this.foreachNode[3].shift()),this},prepare:function(){this.createActionComponent(this.foreachNode),this.callParent(\"prepare\",arguments),this._prepareIterateEnv().addVars(this.foreachNode[3])},compile:function(t,e,n){this._beforeCompile(t,e,n);var r=this.getVariableValue({subject:\"default\",variable:this.dataSrc});if(i.isUndefined(r)||i.isNull(r))return this;var o=this._iterator=this.getIterator(r);if(this.opts.scopes.namePattern=this.opts.scopes.namePattern||[],this.opts.scopes.namePattern.some(function(t){return t.pattern===this.rowScopeName},this))return this;for(this.opts.scopes.namePattern.unshift({pattern:this.rowScopeName,iterator:o});!i.isUndefined(o.iterate());)this.callParent(\"compile\",[t,this.data,this.opts]);return delete this._ea,delete this._last,delete this._firstNode,delete this._iterator,this.opts.scopes.namePattern.shift(),this},embedByAddress:function(t,e){i.isUndefined(this._ea)&&(this._ea=i.clone(this.embedAddress)),i.isUndefined(this._last)&&(this._last=this._ea[this._ea.length-1]);var n=i.clone(arguments);return this._last>-1&&(this._ea[this._ea.length-1]=this._last,e.childNodes.length>1?this._last+=e.childNodes.length:this._last++,n.push(this._ea)),this.callParent(\"embedByAddress\",n)},_embedToTarget:function(t,e,n){return-1===n?(1===this._iterator.i&&t.firstChild&&!this._firstNode&&(this._firstNode=t.firstChild),this._firstNode?t.insertBefore(e,this._firstNode)&&t:t.appendChild(e)&&t):this.callParent(\"_embedToTarget\",arguments)},prepareToTransit:function(){return this.callParent(\"prepareToTransit\",arguments).map(function(t){var e=t.split(\".\").slice(1);return[this.dataSrc[0]].concat(e).join(\".\")},this)}},r.mixin),o,null,\"ComponentForeach\");t.exports={create:function(t){return new s(t)},constructor:s}},function(t,e,n){\"use strict\";var i=n(0),r=n(2),o=r.constructor,s=n(4),a=i.extend(i.mixin({__constructor:function(){this.dynamicImport=!1,this.reassignedVars=[],this.children=this.node[2]||[],this.callParent(\"__constructor\",arguments)},_getTemplate:function(t){var e=null;try{e=this.lib.getTemplate(t)}catch(t){}finally{return e}},_isDynamicName:function(t){return!1!==this._getVarByName(\"name\",t)},_getVarByName:function(t,e){var n=!1;return i.isArray(e)&&e.some(function(e){return e[1]===t&&(n=e,!0)})&&n},_getReassignedVars:function(t,e){return Object.keys(t).filter(function(t){return\"$\"===t[0]}).map(function(n){return[n,t[n],this._getVarByName(n,e)]},this)},_injectChildren:function(t){function e(t,n){return(t[2]||[]).length&&(t[2]=t[2].reduce(function(t,i,r){return\"children\"===i[0]?t=t.slice(0,r).concat(n,t.slice(r+1)):e(i,n),t},t[2])),t}return t=i.clone(t,!0),t.map(function(t){return e(t,this.children)},this)},prepare:function(){var t=this.name=i.objectGet(this.node,[\"1\",\"name\"]),e=null;this._isDynamicName(this.node[3])?(this.dynamicImport=!0,this.addVars(this.node[3])):e=this._getTemplate(t),this.reassignedVars=this._getReassignedVars(this.node[1],this.node[3]),e&&(this.node=this._injectChildren(e),this.callParent(\"prepare\",arguments))},compile:function(t,e,n){if(this.reassignedVars.length&&(e=i.clone(e,!0),this.reassignedVars.forEach(function(t){var n=t[0].slice(1);n in e.default||(e.default[n]=t[1],!1!==t[2]&&(e.default[n]=e.default[t[2][0]]))})),!this.dynamicImport)return this.callParent(\"compile\",[t,e,n]);this._beforeCompile(t,e,n);var r=null,o=null,s=null;this.vars.length&&(r=this._prepareVariable(this.getVariableValue(this.vars[0]))),i.isString(r)&&r.length&&(o=this.applyRuntimeVariables(this.name),o.length||(o=r),s=this._getTemplate(o),this._prepared=s?this.templateRecursion(this._injectChildren(s)):this.doc.createDocumentFragment());var a=this.callParent(\"compile\",[t,e,n]);return delete this._prepared,a}},s.mixin),o,null,\"ComponentImport\");t.exports={create:function(t){return new a(t)},constructor:a}},function(t,e,n){\"use strict\";var i=n(0),r=n(6);t.exports=i.extend({iterate:function(){return this.i>=this.count?void(this.i=0):(this.obj=this.data[this.i],this.fillServiceInfo(),this.i++,this.obj)},_get:function(t){return i.arrayRelation(this.obj,t)},getCount:function(){return this.data.length}},r,null,\"ArrayIterator\")},function(t,e){function n(t){this.data=t,this.i=0,this._prepare&&this._prepare(),this.count=this.getCount()}t.exports=n},function(t,e,n){\"use strict\";var i=n(0),r=n(6);t.exports=i.extend({applyLimitModifier:function(t){this.data._index=this.data._index.slice(0,t[0])},applyListModifier:function(t){var e=[];return i.each(t,function(t){e.push(this.data._index[t-1])},this),this.data._index=e,e},iterate:function(){return this.i>=this.count?(this.i=0,void this.data.resetIterator(\"templater\")):(this.obj=this.data.iterateObject(\"templater\"),this.obj&&(this.fillServiceInfo(),this.i++),this.obj)},getCount:function(){return this.data.getCount()},_get:function(t){return this.obj.get(t)}},r,null,\"DatalayerIterator\")},function(t,e,n){\"use strict\";function i(){this.iterate=function(){}}t.exports=i},function(t,e,n){\"use strict\";var i=n(0),r=n(6);t.exports=i.extend({_prepare:function(){this._index=[],i.each(this.data,function(t,e){\"_\"!==e.substr(0,1)&&this._index.push(e)},this)},iterate:function(){return this.i>=this.count?void(this.i=0):(this.obj=this.data[this._index[this.i]],this.key=this._index[this.i],this.fillServiceInfo(),this.i++,this.obj)},_get:function(t){return i.arrayRelation(this.obj,t)},getCount:function(){return this._index.length}},r,null,\"ObjectIterator\")},function(t,e,n){\"use strict\";function i(t){if(t.walk)return t;if(r.isEmpty(t))return new o;var e;return r.isArray(t)?e=\"arr\":r.isObject(t)&&(\"DataLayer\"===t._objClass?e=\"datalayer\":t.collection?(e=\"arr\",t=r.toArray(t.collection)):e=\"obj\"),\"arr\"===e?new s(t):\"obj\"===e?new a(t):new u(t)}var r=n(0),o=n(40),s=n(37),a=n(41),u=n(39),c={};t.exports={getIterator:i,addUtil:function(t,e){c[t]=e}}},function(t,e,n){var i=n(10);t.exports=function(t,e){return\"function\"==typeof e&&(i[t]=e)}},function(t,e,n){\"use strict\";function i(t,e){var n=u.exec(t);if(!n)return!1;var i=[n[5],e,!0],r=[];return n[6]&&n[6].substr(1).split(\"|\").forEach(function(t){var e=t.split(\":\");r.push({name:e.shift(),params:e})}),r.length&&i.push(r),n[2]&&(4===i.length||i.push([]),i.push(n[2])),i}function r(t){var e=[];return s.each(t,function(t){if(t.tag||t.children.length){if(!t.tag)return void(e=e.concat(r(t.children)));var n=[t.tag];if(!s.isEmpty(t.attr)){if(!s.isUndefined(t.attr.__text)){for(var o=t.attr.__text.split(c),a=0,u=o.length;a<u;a++)a%2?t.children.push({tag:\"span\",attr:{},children:[],vars:[i(o[a],\"__text\")]}):o[a].length&&t.children.push({tag:\"textNode\",attr:{text:o[a]}});delete t.attr.__text}s.isEmpty(t.attr)||(n[1]=t.attr)}var l=r(t.children);s.isEmpty(l)||(n[1]=n[1]||{},n[2]=l),s.isEmpty(t.vars)||(n[1]=n[1]||{},n[2]=n[2]||[],n[3]=t.vars),e.push(n)}}),e}function o(t){for(var e,n,i=new a,o=i.addChild(),u=[i],c=0,h=t.length,f=\"\",d=function(){o.abbr=f,l(o),f=\"\"},p=0;c<h;){switch(e=t.charAt(c),n=c?t.charAt(c-1):\"\",e){case\"{\":p++,f+=e;break;case\"}\":p--,f+=e;break;case\"(\":if(p){f+=e;break}d(),\"+\"!==n&&\">\"!==n&&(o=o.parent.addChild()),u.push(o),o=o.addChild();break;case\")\":if(p){f+=e;break}if(d(),o=u.pop(),c<h-1&&\"*\"===t.charAt(c+1)){for(var g,m=\"\",v=c+2;v<h&&(g=t.charAt(v),s.isNumeric(g));v++)m+=g;for(c+=m.length+1,m=parseInt(m||1,10);1<m--;)o.parent.addChild(o)}break;case\"+\":if(p)break;d(),o=o.parent.addChild();break;case\">\":if(p)break;d(),o=o.addChild();break;default:f+=e}c++}return d(),r(i.children)}var s=n(0),a=function(t){this.children=[],this.attr={},this.vars=[],this.abbr=t||\"\",this.parent=null,this.addChild=function(t){return t=t||new a,t.parent=this,this.children.push(t),t}},u=/(\\$(\\w*)\\[((([\\w\\.\\,\\(\\)]*)(\\|[^\\[\\]]*)?))\\])/,c=/(\\$\\w*\\[.*?\\]+)/g,l=function(t){for(var e,n,i=t.abbr,r=i.length,o=-1,a=\"\",u=\"tag\",c=null,l={\".\":\"class\",\"#\":\"id\"},h={\"{\":[\"}\",\"text\"],\"[\":[\"]\",\"attributes\"]},f=function(){if(u){switch(u){case\"tag\":t.tag=a;break;case\"class\":t.attr.class=(t.attr.class?t.attr.class+\" \":\"\")+decodeURI(a);break;case\"attributes\":for(var e,n=/([-\\w]+)=(\"[^\"\\\\\\\\]*(?:\\\\\\\\.[^\"\\\\\\\\]*)*\"|'[^'\\\\\\\\]*(?:\\\\\\\\.[^'\\\\\\\\]*)*'|[^\\s]+)/g;e=n.exec(a);)t.attr[e[1]]=decodeURI(s.trim(e[2],\"\\\"'\"));break;case\"text\":t.attr.__text=a;break;case\"id\":t.attr.id=a}a=\"\"}};o++<r;){if(e=i.charAt(o),c){if(e===c){f(),c=null,u=null;continue}}else{if(n=h[e]){f(),c=n[0],u=n[1];continue}if(n=l[e]){f(),u=n;continue}}a+=e}return a.length&&f(),t};t.exports=o},function(t,e,n){\"use strict\";function i(){var t={},e=null,n=this;this.params={},Object.defineProperty(this,\"cookies\",{get:function(){var i=r.getStringSimpleHash(document.cookie,16);return e!==i&&(e=i,t=n._parse(document.cookie)),t}})}var r=n(0);i.prototype.setParameter=function(t,e){this.params[t]=e},i.prototype._parse=function(t){return\"\"===t?{}:t.split(\";\").reduce(function(t,e){var n=e.replace(/^\\s+/,\"\").replace(/\\s+$/,\"\").split(\"=\");return t[n[0]]=n[1],t},{})},i.prototype.get=function(t){return!r.isUndefined(this.cookies[t])&&this.cookies[t]},i.prototype.getAll=function(){return this.cookies},i.prototype.set=function(t,e,n,i,r,o){var s,a=o||this.params.sameSite,u=a?\"; SameSite=\"+a:\"\",c=\"https:\"===document.location.protocol?\"; Secure\":\"\";n&&(s=new Date,s.setTime(s.getTime()+n)),r=r?\"; domain=\"+r:\"\",i=\"; path=\"+(i||\"/\"),document.cookie=t+\"=\"+escape(e)+(n?\"; expires=\"+s.toGMTString():\"\")+r+i+c+u},i.prototype.remove=function(t){document.cookie=t+\"=; expires=Thu, 01-Jan-1970 00:00:01 GMT\"},i.prototype.empty=function(t){return r.isUndefined(this.cookies[t])},t.exports=function(){return new i}},function(t,e,n){\"use strict\";function i(t){return!(!t||!t.replace)&&t.replace(/[\\.\\/]/g,\"_\")}function r(t){for(var e=s.getStyleSheets(),n=e.length-1;n>=0;n--){var i=[];try{i=e[n].cssRules}catch(t){console.log(t,n),i=[]}if(i&&i.length)for(var r=i.length-1;r>=0;r--)t(i[r],e[n])}}var o=n(0),s=n(13);t.exports=function(t){return{addStyleSheet:function(e,n,r){r=r||{},n=i(n);var o=!0,a=n&&s.sel1(\"#\"+n);switch(a||(a=s.create(\"style\"),o=!1),n&&a.attr(\"id\",n),r.type){case 2:a.html(a.html()+e);break;case 3:a.html(e,a.html());break;default:a.html(e)}o||s.sel1(\"head\").append(a),t.site&&!r.skipEvent&&t.site.dispatchEvent(\"cssModified\",a)},dropStyleSheet:function(t){s.query(\"#\"+i(t)).remove()},truncateStyleSheet:function(t){s.query(\"#\"+i(t)).html(\"\")},hasStyleSheet:function(t){return!!s.sel1(\"#\"+t)},addRule:function(e){var n=s.getStyleSheets(),i=n[n.length-1];i.insertRule(e,i.cssRules.length),t.site.dispatchEvent(\"cssModified\",i)},setRuleProperty:function(t,e,n){t.style.setProperty(e,n)},getRuleProperty:function(t,e){return t.style.getProperty(e)},findRules:function(t,e,n){var i,s=[];return r(function(n,r){if(n.style){var a=1;o.each(t,function(t,r){switch(t[0]){case\"~\":i=n.style.getPropertyValue(t.substr(1)),i&&-1!==i.indexOf(e[r])||(a=0);break;default:i=n.style.getPropertyValue(t),e&&e[r]?i!==e[r]&&(a=0):i||(a=0)}}),a&&s.push(n)}}),s}}}},function(t,e,n){\"use strict\";function i(t){this.lang=\"default\",this.phrases={},this.foxInstance=t}var r=n(0),o=n(1),s=r.extend(i,{setLanguage:function(t){this.lang=t,this._commit()},mergeValues:function(t){this.phrases=r.mergeRecursive(this.phrases,t),this._commit()},registerValues:function(t){this.phrases=r.mergeRecursive(this.phrases,t),this._commit()},_updateNode:function(t){var e=t.getAttribute(\"data-fox-alias\");if(!this.phrases[e])return!1;var n=this.phrases[e];return n.default||(n.default=t.innerHTML),t.innerHTML=n[this.lang]||n.default,!0},_commit:function(){var t=this,e=this.foxInstance;if(!e.site)return!1;this.handlerExists||(this.handlerExists=!0,e.site.getEm().handleHook(\"~.Widget\",\"onStopRendering\",function(){r.each(o.select(\"[data-fox-alias]\",this.fragment),t._updateNode,t)},{prefix:\"_dictionary_\"}));var n=[];if(r.each(o.select(\"[data-fox-alias]\"),function(e){t._updateNode(e)&&n.push(e)}),e.Navigator){e.Navigator.addClickHandler(e.site.element);var i={};r.each(n,function(t){for(;t=t.parentNode;){var n=t.getAttribute(\"data-widget-id\");if(n){i[n]=e.wom.selectFirst(\"@\"+n);break}}}),r.each(i,function(t){t.setDomHandlers(),t.dispatchEvent(\"addedToDom\")})}}},null,\"FoxDictionaty\");t.exports=function(t){return new s(t)}},function(t,e,n){\"use strict\";var i=n(0),r=n(1);t.exports=function(t){function e(){s=1,t.wom.getEventManager().handleHook(\"~.Widget\",\"onStopRendering\",function(){t.each(t.dom.select(\"img\",this.fragment),function(e){t.each(a,function(t,n){if(!t.deleted){var i=e.getAttribute(\"src\");i&&-1!==i.indexOf(n)&&(t.rollback.push(function(){e.setAttribute&&e.setAttribute(\"src\",i)}),e.setAttribute(\"src\",t.src))}})})},{prefix:\"registerImage\"}),t.wom.getEventManager().handle(\"@root\",\"cssModified\",function(e){t.each(a,function(e,n){e.deleted||t.each(t.css.findRules([\"~background-image\"],[n]),function(i){t.css.addStyleSheet(i.selectorText+\" {background-image: url(\"+e.src+\")}\",\"image_\"+n,{skipEvent:!0}),e.rollback.push(function(){t.css.dropStyleSheet(\"image_\"+n)})})})})}function n(n,o,u){var c=t.css,l=a[n.toLowerCase()]={current:o};l.rollback=[],l.src=o,u&&(i.each(c.findRules([\"~background-image\"],[n]),function(t){c.addStyleSheet(t.selectorText+\" {background-image: url(\"+l.src+\")}\",\"image_\"+n,{skipEvent:!0}),l.rollback.push(function(){c.dropStyleSheet(\"image_\"+n)})}),i.each(r.select(\"img\"),function(t){if(t.getAttribute(\"src\")&&-1!==t.getAttribute(\"src\").indexOf(n)){var e=t.getAttribute(\"src\");l.rollback.push(function(){t.setAttribute&&t.setAttribute(\"src\",e)}),t.setAttribute(\"src\",l.src)}})),s||e()}function o(t){var e=a[t.toLowerCase()];e&&(e.deleted=!0,i.each(e.rollback,function(t){t()}),delete a[t.toLowerCase()])}var s,a={};return{register:n,unregister:o}}},function(t,e,n){\"use strict\";function i(t){this._params=t,this._loaded=!1,this._image=new Image,o.on(\"load\",this._image,this._onload.bind(this)),o.on(\"error\",this._image,this._onerror.bind(this))}var r=n(0),o=n(1),s=n(5),a=t.exports={},u=/^data:(image\\/\\w{3,});base64/;a._image=i,a.create=function(t){return new i(t||{})},i.prototype._onload=function(){this._loaded=!0,this._params.loadCallback&&this._params.loadCallback()},i.prototype._onerror=function(){},i.prototype.setSize=function(t){var e=t.split(\"x\");return this._params.width=e[0],this._params.height=e[1],this},i.prototype.setType=function(t){return this._params.type=t,this},i.prototype.setQuality=function(t){return this._params.quality=t,this},i.prototype.load=function(t,e){var n=t||this._params.url;return e&&(this._params.loadCallback=e),this._image.src=n,this},i.prototype.get=function(){var t=r.clone(arguments);return this._image=new Image,this._params.crossOrigin&&(this._image.crossOrigin=this._params.crossOrigin),new s.Promise(function(e,n){o.on(\"load\",this._image,function(){return this._onload(),e(this._image)}.bind(this)),o.on(\"error\",this._image,function(){return this._onerror(),n(this._image)}.bind(this)),this.load.apply(this,t)}.bind(this))},i.prototype.getDataUrl=function(t,e){if(!this._loaded)return this.get().then(function(){this.getDataUrl(t,e)}.bind(this)),!1;var n,i,r,o,s=this._image.width-this._params.width,a=this._image.height-this._params.height;if(this._image.width>this._image.height?s<5:this._image.width<this._image.height?a<5:s<5&&a<5)return t(this._image.src);n=document.createElement(\"canvas\"),i=n.getContext(\"2d\"),r=this._image,n.width=this._params.width||r.width,n.height=n.width*(r.height/r.width);var u=!1;if(e&&\"image/png\"===this.getBase64MimeType()&&(u=!0),!u&&s>1.5*this._params.width&&a>1.5*this._params.height){var c=document.createElement(\"canvas\"),l=c.getContext(\"2d\");c.width=.5*r.width,c.height=.5*r.height,l.drawImage(r,0,0,c.width,c.height),l.drawImage(c,0,0,.5*c.width,.5*c.height),i.drawImage(c,0,0,.5*c.width,.5*c.height,0,0,n.width,n.height),o=n.toDataURL(\"image/\"+(this._params.type||\"png\"),this._params.quality?this._params.quality/100:1),c=null}else i.drawImage(r,0,0,n.width,n.height),o=n.toDataURL(\"image/\"+(this._params.type||\"png\"),this._params.quality?this._params.quality/100:1);n=null,t(o,Array.prototype.slice.call(arguments,1))},i.prototype.isBase64=function(){var t=this._params.url;return r.isString(t)&&null!==t.match(u)},i.prototype.getBase64MimeType=function(){var t=this._params.url;return this.isBase64(t)&&t.match(u)[1]};var c=function(t){for(var e=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\",n=\"data:image/jpeg;base64,\",i=0;i<t.length;){var r,o,s=255&t.charCodeAt(i++),a=255&t.charCodeAt(i++),u=255&t.charCodeAt(i++),c=s>>2,l=(3&s)<<4|a>>4;isNaN(a)?r=o=64:(r=(15&a)<<2|u>>6,o=isNaN(u)?64:63&u),n+=e.charAt(c)+e.charAt(l)+e.charAt(r)+e.charAt(o)}return n};i.prototype.getWithProgress=function(t,e){t=t||this._params.url;var n=this,i=new XMLHttpRequest;return new s.Promise(function(o,s){i.onprogress=function(t){if(0===t.total)return s(new Error(\"Null size image\"));var n=Math.floor(t.loaded/t.total*100);r.isFunction(e)&&e(n)},i.onload=function(){if(200===i.status){var t=c(i.responseText);return n._image.src=t,o(n._image)}return s(new Error(\"Wrong response with httpStatus:\"+i.status))},i.open(\"GET\",t,!0),i.overrideMimeType(\"text/plain; charset=x-user-defined\"),i.send(null)})}},function(t,e,n){\"use strict\";var i=t.exports={};i.decimal=/^\\d+(\\.?\\d+)?$/,i.url=/^(https?:\\/\\/)*[\\w\\-\\.]+\\.\\w{2,}(\\/[\\S]*)*$/,i.urlStrictProtocol=/^https?:\\/\\/[\\w\\-\\.]+\\.\\w{2,}(\\/[\\S]*)*$/,i.int=/^\\d+$/,i.email=/^[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.?)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,i.ip=/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/,i.hostname=/^(?![\\S]{64,})[^\\d\\-][a-z0-9\\-]+\\.(?:[a-z0-9\\-]+\\.)*[a-z0-9\\-]+[^\\-]$/i},function(t,e,n){\"use strict\";function i(){var t;r.call(this),this._objectHandlers={},this._womHandlers=[],this._handlersFlat=[],this._uniqGroups={},this.setWom=function(e){if(s.isUndefined(e))throw new ReferenceError(\"Missing wom object\");if(!(e instanceof a))throw new TypeError(\"Wom must be instance of Wom object\");return t=e,this},this.getWom=function(){if(s.isUndefined(t))throw new ReferenceError(\"Wom is not assigned to this Observer\");return t}}var r=n(54),o=n(5).Promise,s=n(0),a=n(7)().Wom,u=n(3);t.exports=function(){return new i},r.mixin(i.prototype),i.prototype.handlePlugin=function(t,e,n,i){var r=function(t){var i=t.getId()+\"_\"+e;this.plugin(i,u.getRealCallback(n))}.bind(this),o=this.getWom();i||(i={}),i.performer&&(n=u.createCallback(n,i.performer)),o.isSelector(t)?(s.each(o.select(t,i.performer),r,this),i.performer&&(i.once=!0,i.prefix=i.prefix||\"_handleplugin_\"+e,this.handle(t,\"inited\",function(t,e){r(e)},i))):r(t)},i.prototype.dispatchHook=function(t,e,n,i){i=s.merge({hook:!0,hookedMethod:e,hookedArguments:n},i||{}),this.dispatch(t,\"_hook_\"+s.ucfirst(e),i)},i.prototype.handleHook=function(t,e,n,i){return i=i||{},i.hook=!0,i.sync=!0,i.listenHistory=!1,this.handle(t,\"_hook_\"+e,n,i)},i.prototype.dispatch=function(t,e,n){n=n||{};var i={params:n,performer:t,event:e};if(t._events[e]=n,s.log(\"Dispatch event  \"+t.getCaption()+\":\"+e,!1,n),n.hook){var r,o=e.replace(\"_hook_\",\"_hook_onStart\"),a=e.replace(\"_hook_\",\"_hook_on\"),u=e.replace(\"_hook_\",\"_hook_onStop\"),c=[];if(r=this.executeHandlers(i,this.getMatchedHandlers(t,o)),s.filter(r,function(t){return!1===t}).length)return s.log(\"Blocked by \"+o,c),void this.executeHandlers(i,this.getMatchedHandlers(t,u));r=this.getMatchedHandlers(t,a),r?this.executeHandlers(i,r):t[n.hookedMethod].apply(t,n.hookedArguments),this.executeHandlers(i,this.getMatchedHandlers(t,u))}else this.executeHandlers(i,this.getMatchedHandlers(t,e))},i.prototype.handlePromise=function(t,e,n,i){return new o(s.isFunction(i)?function(r,o){i(r,o,t,e,n)}:s.bind(function(i,r){this.handle(t,e,function(t,e,n){i({params:t,performer:e,event:n})},n)},this))},i.prototype.handle=function(t,e,n,i){s.isObject(i)||(i={listenHistory:!!i});var r=this._createHandler(t,e,n,i);if(i.prefix&&this._uniqGroups[i.prefix]&&this._uniqGroups[i.prefix][r.hash]){var o=this._uniqGroups[i.prefix][r.hash];o.deleted&&(o.callback=r.callback,o.params=r.params,o.deleted=!1),r=o}else{r.id=this._handlersFlat.push(r)-1,r.params&&r.params.performer&&(r.params.performer._womHandlers[r.id+\":\"+r.hash]=r),i.prefix&&s.objectSet(this._uniqGroups,[i.prefix,r.hash],r);for(var a in r.targets)if(this._objectHandlers[a]||(this._objectHandlers[a]={}),s.isArray(r.event))for(var u=0;u<r.event.length;u++)this._objectHandlers[a][r.event[u]]?this._objectHandlers[a][r.event[u]].push(r):this._objectHandlers[a][r.event[u]]=[r];else this._objectHandlers[a][e]?this._objectHandlers[a][e].push(r):this._objectHandlers[a][e]=[r];for(var a in r.womTargets)this._womHandlers.push({target:a,handler:r}),r.womHandlerIds.push(this._womHandlers.length-1)}if(r.params.listenHistory){var c,l;for(var h in r.targets)if(c=this.getWom().getObject(h),l=s.objectGet(c,[\"_events\",e])){this.executeHandler({params:l,performer:c,event:e},r);break}}return r},i.prototype.getMatchedHandlers=function(t,e){var n,i,r,o=t.getId(),a=!1;if(this._objectHandlers[o]&&this._objectHandlers[o][e])for(a=a||{},r=this._objectHandlers[o][e],n=0,i=r.length;n<i;n++)s.isUndefined(a[r[n].hash])&&(a[r[n].hash]=r[n]);if(this._objectHandlers[o]&&this._objectHandlers[o].all)for(a=a||{},r=this._objectHandlers[o].all,n=0,i=r.length;n<i;n++)s.isUndefined(a[r[n].hash])&&(a[r[n].hash]=r[n]);return a},i.prototype._createHandler=function(t,e,n,i){s.isObject(i)||(i={listenHistory:!!i}),s.isArray(n)?s.each(n,function(t,e){n[e]=u.createCallback(t,i.performer)}):n=[u.createCallback(n,i.performer)];var r,o={},a=!1;if(t||s.log(\"~~~~~\",t,n,i),s.isArray(t))throw new Error(\"Array target doesn not support\");if(s.isString(t))if(r=t,\"@this\"!==t&&\"@parent\"!==t){a={};var c=this.getWom().select(t,i.performer),l=0;s.each(c,function(t){o[t.getId()]=!0,l=1}),l&&\"#\"===t[0]&&-1===t.indexOf(\" \")||(a[t]=i.performer||this.getWom().getRoot())}else o[i.performer[\"@this\"===t?\"_id\":\"_parentId\"]]=!0;else t&&(r=t.getId(),o[r]=!0);return r=r+\"_\"+(e.join?e.join(\"_\"):e)+\"_\"+(i.prefix||\"noPrefix\"),{hash:r,womHandlerIds:[],objHandlerIds:[],callback:n,active:!0,deleted:!1,targets:o,womTargets:a,event:e,params:i,drop:function(){this.deleted=!0}}},i.prototype.registerObject=function(t){s.each(this._womHandlers,function(e){if(!e)return!1;if(this.getWom().matchWidget(e.target,t,e.handler.params.performer)){e.handler.targets[t._id]=!0,this._objectHandlers[t._id]||(this._objectHandlers[t._id]={});var n=e.handler.event;if(s.isArray(n))for(var i=0,r=n.length;i<r;i++)this._objectHandlers[t._id][n[i]]?this._objectHandlers[t._id][n[i]].push(e.handler):this._objectHandlers[t._id][n[i]]=[e.handler];else this._objectHandlers[t._id][n]?this._objectHandlers[t._id][n].push(e.handler):this._objectHandlers[t._id][n]=[e.handler]}},this)},i.prototype.removeObject=function(t){var e,n;s.isNumeric(t)?e=parseInt(t):s.isObject(t)&&t.getId&&(e=t.getId()),n=new RegExp(\"^@\"+e+\"_\"),s.each(this._handlersFlat,function(t,n){if(!t)return!1;var i=!(!t.params.performer||t.params.performer.getId()!==e);delete this._objectHandlers[e],i&&(this._handlersFlat[n]=null,s.each(this._womHandlers,function(t,e){if(null===t)return!1;t.handler.id===n&&(this._womHandlers[e]=null,e===this._womHandlers.length-1&&this._womHandlers.splice(e,1))},this),s.each(this._uniqGroups,function(t,e){s.each(t,function(t,i){t.id===n&&(s.count(this._uniqGroups[e])>1?delete this._uniqGroups[e][i]:delete this._uniqGroups[e])},this)},this),s.each(this._objectHandlers,function(t,e){s.each(t,function(t,i){s.each(t,function(t,r){t.id===n&&(this._objectHandlers[e][i][r]=null)},this),this._objectHandlers[e][i]=s.filter(this._objectHandlers[e][i],function(t){return null!==t})},this)},this))},this),s.each([this._handlersFlat,this._womHandlers],s.arrayRevageToValue),s.each(this._plugins,function(t,e){if(n.test(e))throw delete this._plugins[e],s.break},this)},i.prototype.executeHandlers=function(t,e){var n=[];return s.each(e,function(e){n=s.merge(n,this.executeHandler(t,e))},this),n},i.prototype.executeHandler=function(t,e){var n=!1;if(!e.deleted){if(e.params.checker&&!e.params.checker(t.params))return void s.log(\"checker not passed\",e);if(e.params.performer&&!e.params.performer.isActive())if(e.params.alwaysActive)s.log(\"Always active handler @@ \",e);else{if(!e.params.listenHistory)return void s.log(\"Skip handler execution due to performer widget is inactive\",e);n=!0}e.params.once&&(this._handlersFlat[e.id].deleted=!0);var i=t.params,r=t.performer,o=t.event,a=[],c=[];return s.each(e.callback,function(t){t=u.getRealCallback(t),c.push(function(){return s.log(\"Execute handler #\"+e.id+\" (\"+e.hash+\").\"),i.hookedArguments?t.apply(r,i.hookedArguments):t.call(r,i,r,o)})}),n?(e.params.performer._womWaitingActivationHandlers[e.id]=c,s.log(\"---sleep---\",e.params.performer.getCaption(),e.hash)):s.each(c,function(t){e.params.sync?a.push(t()):setTimeout(t,1)}),a}},i.prototype.activateHandlers=function(t){s.each(t._womWaitingActivationHandlers,function(e,n){s.log(\"---wake---\",t.getCaption(),this._handlersFlat[n],t.ccc),s.each(e,function(t){t()})},this),t._womWaitingActivationHandlers={}},i.prototype.dropHandler=function(t){void 0!==this._handlersFlat[t]&&(this._handlersFlat[t].deleted=!0)}},function(t,e,n){\"use strict\";var i=n(0),r=n(1),o=n(3),s=n(16),a=n(27),u=n(44),c=i.getStringSimpleHash,l=i.extend({_getObjectClass:function(){return\"Widget\"},__constructor:function(t){this.callParent(\"__constructor\",arguments),this._templaters={},this.templateOptions={},this._readyToRender=!0,this._rendered=!1,this._readyToEmbed=!0,this._indom=!1,this._active=!0,this._firstActivation=!0,this.element=null,this.fragment=null,\"undefined\"!=typeof window&&(this.window=window),this._childrenElts=[],this._embedCounter=0,this._parentEmbedState=1,this.visual=null,this.visualParent=!1,this._bindVariables=[]},configure:function(t){this.registerOptions(\"\",{embed:{widget:\"@parent\",location:\"inside\"}},0,\"controllerDefaultOptions\"),this.callParent(\"configure\",arguments)},prepareTemplateProcessor:function(t,e){var n=a(t,this.window.document,this._wom.getLibrary());return e&&n.setAlias(e),i.each(this.getOption(\"templateEnv\"),n.setData,n),n},init:function(){return this.getOption(\"bindVariables\")&&i.isArray(this.getOption(\"bindVariables\"))&&this.bindTemplateVariables(this.templateOptions,this.getOption(\"bindVariables\"),null,\"default\"),this.callParent(\"init\",arguments)},getTemplater:function(t){var e,n;if(t||(t=this.getOption(\"template\")),!(e=this._templaters[t]))try{n=/^[\\w_]*$/.test(t)?this._wom.getTemplate(t):u(t)}catch(t){i.exception(t)}finally{n?this._templaters[t]=e=this.prepareTemplateProcessor(n,t):e=!1}return e},getTemplateOptions:function(){return i.isObject(this.templateOptions)||(this.templateOptions={}),i.mixin(this.templateOptions,i.isObject(this.getOption(\"templateOptions\"))?this.getOption(\"templateOptions\"):{})},_prepare:function(){this.callParent(\"_prepare\",arguments),null===this.visual&&(this.visual=!1!==this.options.visual)},isEmbedded:function(){return this._indom},isRendered:function(){return this._rendered},getWidgetNodes:function(t){var e=this.wom(t,[this])[0];return e?e.fragment&&e.fragment.childNodes.length?[e.fragment]:e.element||[]:[]},getMyNodes:function(){return this.getWidgetNodes(\"@this\")},setDomHandlers:function(){i.each(this.options.handlers,function(t,e){t.targetWidget||this.addDomHandler(t,e)},this),i.each(this.getOption(\"handleDom\"),function(t,e){t.targetWidget||this.addDomHandler(t,e)},this)},dom:function(t){return r.select(t,[this.getMyNodes()],this.window)},dom1:function(t){return r.selectFirst(t,[this.getMyNodes()],this.window)},rdom:function(t){var e=r.select(t,[this.getMyNodes()],this.window);if(!e.length)throw\"Element by path \"+t+\" of widget \"+this.getCaption()+\" required but missing\";return e},rdom1:function(t){var e=r.selectFirst(t,this.getMyNodes(),this.window);if(!e)throw\"Element by path \"+t+\" of widget \"+this.getCaption()+\" required but missing\";return e},setHandlers:function(){return this.setDomHandlers()},setTemplateOptions:function(){var t=arguments;return i.isObject(t[0])&&(this.templateOptions=t[0]),t[0]&&i.isString(t[0])&&void 0!==t[1]&&(this.templateOptions[t[0]]=t[1]),this},bindTemplateVariables:function(){var t=i.clone(arguments);return t.length&&this._bindVariables.push(t)},deactivate:function(t){return this._indom=!1,this.callParent(\"deactivate\",arguments)},activating:function(t){this.getOption(\"manualRender\")||this._firstActivation||this._readyToRender&&this.render(),this._firstActivation=!1},afterRun:function(){return null===this.visual&&(this.visual=!1!==this.options.visual),this.callParent(\"afterRun\",arguments),this.getOption(\"manualRender\")||(this.options.autoRender||this._rendered)&&this.render(),!0},render:function(){if(this.visual){var t=this.getOption(\"stateDeps.render\");if(t)return i.log(\"Found state dep for render of \"+this.getCaption()),i.log(\"======================>\"+this.alias+\" (\"+this._widgetClass+\") performing state dep for render\"),this._performStateDependency(t,this._render);this._render()}},_render:function(t){if(!this.isActive())return void i.log(\"skipping render of inactive widget \"+this.getCaption());i.log(\"render -> widget \"+this.getCaption()),this.beforeRender(),this.skipRender()||this.hookWrapper(\"rendering\"),this.afterRender(),!0!==t&&this.embed()},beforeRender:function(){i.log(\"beforeRender -> widget \"+this.getCaption()),this._childrenElts=[],this._indom&&i.each(this._widgets,function(t){t._indom&&this._childrenElts.push(t)},this);var t=this.getOption(\"embed.container\")||this.getOption(\"container\");if(!this.getOption(\"dontReuseSn\")&&this.window.reuseSn&&!1===this._wom.getRoot().ready&&t){var e=r.select(t,this.visualParent.element);if(e.length&&e[0].childNodes.length){var n=e[0],o=n.getAttribute(\"data-widget-alias\")===this.getAlias()&&n.getAttribute(\"data-widget-class\")===this.getClass();if(\"inside\"!==this.getOption(\"embed.location\")||o){var s=n.getAttribute(\"data-widget-hash\");s&&o&&!this.getOption(\"dontReuseSnByHash\")?this._skipRender=parseInt(s):(this._skipRender=!0,this.element=e)}}}this._rendered=!1,this._indom=!1},rendering:function(){i.log(\"Rendering -> widget \"+this.getCaption());var t,e=this.getTemplater();if(e)try{t=this.getTemplateOptions(),e.setData(t),this._bindVariables.length&&(this.templateOptions=this._bindVariables.reduce(function(t,n){return\"default\"===n[3]?t=e.bindVar.apply(e,n):e.bindVar.apply(e,n),t}.bind(this),this.templateOptions)),this.fragment=e.compile()}catch(t){i.exception(t),this.fragment=this.createFragment()}else this.fragment=this.createFragment()},navigatorAddClickHandler:function(){var t=this._wom.getRoot().wom1(\".Navigator\");t&&t.addClickHandler(this.fragment,{draggable:!this.getOption(\"previewMode\")})},afterRender:function(){this.skipRender()||this.navigatorAddClickHandler(),this.setDomHandlers(),this._rendered=!0},embed:function(){var t=this.getOption(\"stateDeps.embed\");if(t)return this._performStateDependency(t,this._embed);this._embed()},_embed:function(){var t,e=this.getOption(\"embed\")||{};e.container||(e.container=this.options.container);var n=e.widget;if(!n)return console.log(\"Missing embed widget for \"+this.getCaption()),!1;if(o.instanceOf(n,\"Controller\"))t=n;else if(this._wom.isSelector(n)&&(!(t=this.wom1(n))||!1===t._isRun))return this.waitEvent(n,\"running\",function(t,e){this._embed()},{prefix:\"waitWidgetToEmbed_\"+this.getHash(),listenHistory:!0}),!!t;if(!t)return console.log(\"Invalid embed widget for \"+this.getCaption(),n),!1;this.getOption(\"manualRender\")?(this.visualParent=t._childrenContainerWidget,t._childrenContainerWidget.isEmbedded()?this.beforeEmbed():this.waitEvent(t._childrenContainerWidget,\"addedToDom\",this.beforeEmbed)):(this._parentEmbedState--,this.handleEvent(t._childrenContainerWidget,\"addedToDom\",function(t,e){if(this.visual&&(this.visualParent=e,this._parentEmbedState!==e._embedCounter)){if(!this._readyToEmbed)return!1;this._parentEmbedState=e._embedCounter,this.beforeEmbed()}},{prefix:\"embed_\"+this.getHash(),listenHistory:!0}))},beforeEmbed:function(){if(!this.isActive())return void i.log(\"skipping embedding of inactive widget \"+this.getCaption());i.log(\"Embeding -> widget \"+this.getCaption()+\" embedding to \"+this.visualParent.getCaption()),this.window=this.visualParent.getWindow(),this.hookWrapper(\"embedding\"),this.afterEmbed()},embedding:function(){this.skipRender()||(this.element&&\"inside\"!==this.getOption(\"embed.location\")&&i.each(this.element,function(t){t.parentNode&&t.parentNode.removeChild(t)}),this.element=[]);var t=r.select(this.requireOption(\"embed.container\"),this.visualParent.element);i.each(t,function(t){this._rendered||this._render(!0),\"inside\"===this.getOption(\"embed.location\")&&(t.setAttribute(\"data-widget-alias\",this.getAlias()),t.setAttribute(\"data-widget-class\",this.getClass()),t.setAttribute(\"data-widget-id\",this.getId())),this.skipRender()||this.hookWrapper(\"embedToDom\",t),this._rendered=!1},this)},embedToDom:function(t){if(!this._readyToEmbed)return console.log(\"Embeding BLOCKED \"+this.getCaption()),!1;var e,n=this.fragment;switch(this.getOption(\"embed.location\")){case\"inside\":var i=t.cloneNode(!1);i.appendChild(n);var r=c(i.innerHTML);this.skipRenderByHash()&&parseInt(i.getAttribute(\"data-widget-hash\"))===r?(this.element.push(t),this.setDomHandlers()):(i.setAttribute(\"data-widget-hash\",r),this.element.push(i),t.parentNode&&t.parentNode.replaceChild(i,t),t.innerHTML=\"<br>\");break;case\"above\":for(;n.childNodes.length;)this.element.push(n.childNodes[0]),t.parentNode.insertBefore(n.childNodes[0],t);break;case\"under\":for(;e=n.childNodes.length;)this.element.unshift(n.childNodes[e-1]),t.parentNode.insertBefore(n.childNodes[e-1],t.nextSibling);break;case\"lastChild\":for(;e=n.childNodes.length;)this.element.unshift(n.childNodes[0]),t.appendChild(n.childNodes[0]);break;case\"firstChild\":for(;e=n.childNodes.length;)this.element.unshift(n.childNodes[e-1]),t.insertBefore(n.childNodes[e-1],t.firstChild)}},afterEmbed:function(){this._indom=!0,this._embedCounter++,i.log(\"ADDED \"+this.getCaption()),this.dispatchEvent(\"addedToDom\"),this.hookWrapper(\"addedToDom\"),this._skipRender=!1},getWindow:function(){return this.window||window},addedToDom:function(){},removeFromDom:function(t,e){(this._indom||!this.element||this.element.length)&&(this._indom=!1,i.each(this.element,function(t){if(\"inside\"===this.getOption(\"embed.location\")){var e=t.cloneNode(!1);e.removeAttribute(\"data-widget-alias\"),e.removeAttribute(\"data-widget-class\"),e.removeAttribute(\"data-widget-id\"),t.parentNode&&t.parentNode.replaceChild(e,t)}else t.parentNode&&t.parentNode.removeChild(t)},this))},destroy:function(){this.removeFromDom(),this.callParent(\"destroy\",arguments)},removeEmbedChildren:function(){i.each(i.objectGet(this.getEm(),[\"_objectHandlers\",this.getId(),\"addedToDom\"]),function(t){t.handler.deleted=!0},this)},createFragment:function(t){return this.fragment=r.createFragmentFromHtml(t),this.getFragment()},skipRender:function(){return!0===this._skipRender},skipRenderByHash:function(){return this._skipRender&&!0!==this._skipRender},getFragment:function(){return this.fragment}},s,null,\"Widget\");t.exports=l},function(t,e,n){(function(t,e){!function(t,n){\"use strict\";function i(t){\"function\"!=typeof t&&(t=new Function(\"\"+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var i={callback:t,args:e};return c[u]=i,a(u),u++}function r(t){delete c[t]}function o(t){var e=t.callback,i=t.args;switch(i.length){case 0:e();break;case 1:e(i[0]);break;case 2:e(i[0],i[1]);break;case 3:e(i[0],i[1],i[2]);break;default:e.apply(n,i)}}function s(t){if(l)setTimeout(s,0,t);else{var e=c[t];if(e){l=!0;try{o(e)}finally{r(t),l=!1}}}}if(!t.setImmediate){var a,u=1,c={},l=!1,h=t.document,f=Object.getPrototypeOf&&Object.getPrototypeOf(t);f=f&&f.setTimeout?f:t,\"[object process]\"==={}.toString.call(t.process)?function(){a=function(t){e.nextTick(function(){s(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage(\"\",\"*\"),t.onmessage=n,e}}()?function(){var e=\"setImmediate$\"+Math.random()+\"$\",n=function(n){n.source===t&&\"string\"==typeof n.data&&0===n.data.indexOf(e)&&s(+n.data.slice(e.length))};t.addEventListener?t.addEventListener(\"message\",n,!1):t.attachEvent(\"onmessage\",n),a=function(n){t.postMessage(e+n,\"*\")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){s(t.data)},a=function(e){t.port2.postMessage(e)}}():h&&\"onreadystatechange\"in h.createElement(\"script\")?function(){var t=h.documentElement;a=function(e){var n=h.createElement(\"script\");n.onreadystatechange=function(){s(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){a=function(t){setTimeout(s,0,t)}}(),f.setImmediate=i,f.clearImmediate=r}}(\"undefined\"==typeof self?void 0===t?this:t:self)}).call(e,n(8),n(17))},function(t,e){function n(t){\"use strict\";if(void 0===this||null===this)throw new TypeError;var e=Object(this),n=e.length>>>0;if(\"function\"!=typeof t)throw new TypeError;for(var i=[],r=arguments.length>=2?arguments[1]:void 0,o=0;o<n;o++)if(o in e){var s=e[o];t.call(r,s,o,e)&&i.push(s)}return i}function i(){this._plugins={}}function r(t,e){for(var n in t)e[n]=t[n];return e}t.exports=i,i.mixin=function(t){r(i.prototype,t)},i.prototype.applyPlugins=function(t){if(this._plugins[t])for(var e=Array.prototype.slice.call(arguments,1),n=this._plugins[t],i=0;i<n.length;i++)n[i].apply(this,e)},i.prototype.applyPlugins0=function(t){var e=this._plugins[t];if(e)for(var n=0;n<e.length;n++)e[n].call(this)},i.prototype.applyPlugins1=function(t,e){var n=this._plugins[t];if(n)for(var i=0;i<n.length;i++)n[i].call(this,e)},i.prototype.applyPlugins2=function(t,e,n){var i=this._plugins[t];if(i)for(var r=0;r<i.length;r++)i[r].call(this,e,n)},i.prototype.applyPluginsWaterfall=function(t,e){if(!this._plugins[t])return e;for(var n=Array.prototype.slice.call(arguments,1),i=this._plugins[t],r=e,o=0;o<i.length;o++)n[0]=r,r=i[o].apply(this,n);return r},i.prototype.applyPluginsWaterfall0=function(t,e){var n=this._plugins[t];if(!n)return e;for(var i=e,r=0;r<n.length;r++)i=n[r].call(this,i);return i},i.prototype.applyPluginsWaterfall1=function(t,e,n){var i=this._plugins[t];if(!i)return e;for(var r=e,o=0;o<i.length;o++)r=i[o].call(this,r,n);return r},i.prototype.applyPluginsWaterfall2=function(t,e,n,i){var r=this._plugins[t];if(!r)return e;for(var o=e,s=0;s<r.length;s++)o=r[s].call(this,o,n,i);return o},i.prototype.applyPluginsBailResult=function(t){if(this._plugins[t])for(var e=Array.prototype.slice.call(arguments,1),n=this._plugins[t],i=0;i<n.length;i++){var r=n[i].apply(this,e);if(void 0!==r)return r}},i.prototype.applyPluginsBailResult1=function(t,e){if(this._plugins[t])for(var n=this._plugins[t],i=0;i<n.length;i++){var r=n[i].call(this,e);if(void 0!==r)return r}},i.prototype.applyPluginsBailResult2=function(t,e,n){if(this._plugins[t])for(var i=this._plugins[t],r=0;r<i.length;r++){var o=i[r].call(this,e,n);if(void 0!==o)return o}},i.prototype.applyPluginsBailResult3=function(t,e,n,i){if(this._plugins[t])for(var r=this._plugins[t],o=0;o<r.length;o++){var s=r[o].call(this,e,n,i);if(void 0!==s)return s}},i.prototype.applyPluginsBailResult4=function(t,e,n,i,r){if(this._plugins[t])for(var o=this._plugins[t],s=0;s<o.length;s++){var a=o[s].call(this,e,n,i,r);if(void 0!==a)return a}},i.prototype.applyPluginsBailResult5=function(t,e,n,i,r,o){if(this._plugins[t])for(var s=this._plugins[t],a=0;a<s.length;a++){var u=s[a].call(this,e,n,i,r,o);if(void 0!==u)return u}},i.prototype.applyPluginsAsyncSeries=i.prototype.applyPluginsAsync=function(t){var e=Array.prototype.slice.call(arguments,1),n=e.pop(),i=this._plugins[t];if(!i||0===i.length)return n();var o=0,s=this;e.push(r(n,function(t){return t?n(t):++o>=i.length?n():void i[o].apply(s,e)})),i[0].apply(this,e)},i.prototype.applyPluginsAsyncSeries1=function(t,e,n){var i=this._plugins[t];if(!i||0===i.length)return n();var o=0,s=this,a=r(n,function(t){return t?n(t):++o>=i.length?n():void i[o].call(s,e,a)});i[0].call(this,e,a)},i.prototype.applyPluginsAsyncSeriesBailResult=function(t){var e=Array.prototype.slice.call(arguments,1),n=e.pop();if(!this._plugins[t]||0===this._plugins[t].length)return n();var i=this._plugins[t],o=0,s=this;e.push(r(n,function(){return arguments.length>0?n.apply(null,arguments):++o>=i.length?n():void i[o].apply(s,e)})),i[0].apply(this,e)},i.prototype.applyPluginsAsyncSeriesBailResult1=function(t,e,n){var i=this._plugins[t];if(!i||0===i.length)return n();var o=0,s=this,a=r(n,function(t,r){return arguments.length>0?n(t,r):++o>=i.length?n():void i[o].call(s,e,a)});i[0].call(this,e,a)},i.prototype.applyPluginsAsyncWaterfall=function(t,e,n){if(!this._plugins[t]||0===this._plugins[t].length)return n(null,e);var i=this._plugins[t],o=0,s=this,a=r(n,function(t,e){return t?n(t):++o>=i.length?n(null,e):void i[o].call(s,e,a)});i[0].call(this,e,a)},i.prototype.applyPluginsParallel=function(t){var e=Array.prototype.slice.call(arguments,1),n=e.pop();if(!this._plugins[t]||0===this._plugins[t].length)return n();var i=this._plugins[t],o=i.length;e.push(r(n,function(t){if(!(o<0))return t?(o=-1,n(t)):(o--,0===o?n():void 0)}));for(var s=0;s<i.length;s++)if(i[s].apply(this,e),o<0)return},i.prototype.applyPluginsParallelBailResult=function(t){var e=Array.prototype.slice.call(arguments,1),i=e[e.length-1];if(!this._plugins[t]||0===this._plugins[t].length)return i();for(var o,s=this._plugins[t],a=s.length,u=[],c=0;c<s.length;c++)e[e.length-1]=function(t){return r(i,function(){t>=a||(u.push(t),arguments.length>0&&(a=t+1,u=n.call(u,function(e){return e<=t}),o=Array.prototype.slice.call(arguments)),u.length===a&&(i.apply(null,o),a=0))})}(c),s[c].apply(this,e)},i.prototype.applyPluginsParallelBailResult1=function(t,e,i){var o=this._plugins[t];if(!o||0===o.length)return i();for(var s,a=o.length,u=[],c=0;c<o.length;c++){var l=function(t){return r(i,function(){t>=a||(u.push(t),arguments.length>0&&(a=t+1,u=n.call(u,function(e){return e<=t}),s=Array.prototype.slice.call(arguments)),u.length===a&&(i.apply(null,s),a=0))})}(c);o[c].call(this,e,l)}},i.prototype.hasPlugins=function(t){var e=this._plugins[t];return e&&e.length>0},i.prototype.plugin=function(t,e){if(Array.isArray(t))return void t.forEach(function(t){this.plugin(t,e)},this);this._plugins[t]?this._plugins[t].push(e):this._plugins[t]=[e]},i.prototype.apply=function(){for(var t=0;t<arguments.length;t++)arguments[t].apply(this)}},function(t,e,n){(function(t){function i(t,e){this._id=t,this._clearFn=e}var r=void 0!==t&&t||\"undefined\"!=typeof self&&self||window,o=Function.prototype.apply;e.setTimeout=function(){return new i(o.call(setTimeout,r,arguments),clearTimeout)},e.setInterval=function(){return new i(o.call(setInterval,r,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},i.prototype.unref=i.prototype.ref=function(){},i.prototype.close=function(){this._clearFn.call(r,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(53),e.setImmediate=\"undefined\"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate=\"undefined\"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(e,n(8))},function(t,e,n){var i,r;(function(){function n(t){function e(e,n,i,r,o,s){for(;o>=0&&o<s;o+=t){var a=r?r[o]:o;i=n(i,e[a],a,e)}return i}return function(n,i,r,o){i=j(i,o,4);var s=!P(n)&&A.keys(n),a=(s||n).length,u=t>0?0:a-1;return arguments.length<3&&(r=n[s?s[u]:u],u+=t),e(n,i,r,s,u,a)}}function o(t){return function(e,n,i){n=x(n,i);for(var r=E(e),o=t>0?0:r-1;o>=0&&o<r;o+=t)if(n(e[o],o,e))return o;return-1}}function s(t,e,n){return function(i,r,o){var s=0,a=E(i);if(\"number\"==typeof o)t>0?s=o>=0?o:Math.max(o+a,s):a=o>=0?Math.min(o+1,a):o+a+1;else if(n&&o&&a)return o=n(i,r),i[o]===r?o:-1;if(r!==r)return o=e(p.call(i,s,a),A.isNaN),o>=0?o+s:-1;for(o=t>0?s:a-1;o>=0&&o<a;o+=t)if(i[o]===r)return o;return-1}}function a(t,e){var n=H.length,i=t.constructor,r=A.isFunction(i)&&i.prototype||h,o=\"constructor\";for(A.has(t,o)&&!A.contains(e,o)&&e.push(o);n--;)(o=H[n])in t&&t[o]!==r[o]&&!A.contains(e,o)&&e.push(o)}var u=this,c=u._,l=Array.prototype,h=Object.prototype,f=Function.prototype,d=l.push,p=l.slice,g=h.toString,m=h.hasOwnProperty,v=Array.isArray,_=Object.keys,y=f.bind,b=Object.create,w=function(){},A=function(t){return t instanceof A?t:this instanceof A?void(this._wrapped=t):new A(t)};void 0!==t&&t.exports&&(e=t.exports=A),e._=A,A.VERSION=\"1.8.3\";var j=function(t,e,n){if(void 0===e)return t;switch(null==n?3:n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)};case 4:return function(n,i,r,o){return t.call(e,n,i,r,o)}}return function(){return t.apply(e,arguments)}},x=function(t,e,n){return null==t?A.identity:A.isFunction(t)?j(t,e,n):A.isObject(t)?A.matcher(t):A.property(t)};A.iteratee=function(t,e){return x(t,e,1/0)};var O=function(t,e){return function(n){var i=arguments.length;if(i<2||null==n)return n;for(var r=1;r<i;r++)for(var o=arguments[r],s=t(o),a=s.length,u=0;u<a;u++){var c=s[u];e&&void 0!==n[c]||(n[c]=o[c])}return n}},k=function(t){if(!A.isObject(t))return{};if(b)return b(t);w.prototype=t;var e=new w;return w.prototype=null,e},C=function(t){return function(e){return null==e?void 0:e[t]}},S=Math.pow(2,53)-1,E=C(\"length\"),P=function(t){var e=E(t);return\"number\"==typeof e&&e>=0&&e<=S};A.each=A.forEach=function(t,e,n){e=j(e,n);var i,r;if(P(t))for(i=0,r=t.length;i<r;i++)e(t[i],i,t);else{var o=A.keys(t);for(i=0,r=o.length;i<r;i++)e(t[o[i]],o[i],t)}return t},A.map=A.collect=function(t,e,n){e=x(e,n);for(var i=!P(t)&&A.keys(t),r=(i||t).length,o=Array(r),s=0;s<r;s++){var a=i?i[s]:s;o[s]=e(t[a],a,t)}return o},A.reduce=A.foldl=A.inject=n(1),A.reduceRight=A.foldr=n(-1),A.find=A.detect=function(t,e,n){var i;if(void 0!==(i=P(t)?A.findIndex(t,e,n):A.findKey(t,e,n))&&-1!==i)return t[i]},A.filter=A.select=function(t,e,n){var i=[];return e=x(e,n),A.each(t,function(t,n,r){e(t,n,r)&&i.push(t)}),i},A.reject=function(t,e,n){return A.filter(t,A.negate(x(e)),n)},A.every=A.all=function(t,e,n){e=x(e,n);for(var i=!P(t)&&A.keys(t),r=(i||t).length,o=0;o<r;o++){var s=i?i[o]:o;if(!e(t[s],s,t))return!1}return!0},A.some=A.any=function(t,e,n){e=x(e,n);for(var i=!P(t)&&A.keys(t),r=(i||t).length,o=0;o<r;o++){var s=i?i[o]:o;if(e(t[s],s,t))return!0}return!1},A.contains=A.includes=A.include=function(t,e,n,i){return P(t)||(t=A.values(t)),(\"number\"!=typeof n||i)&&(n=0),A.indexOf(t,e,n)>=0},A.invoke=function(t,e){var n=p.call(arguments,2),i=A.isFunction(e);return A.map(t,function(t){var r=i?e:t[e];return null==r?r:r.apply(t,n)})},A.pluck=function(t,e){return A.map(t,A.property(e))},A.where=function(t,e){return A.filter(t,A.matcher(e))},A.findWhere=function(t,e){return A.find(t,A.matcher(e))},A.max=function(t,e,n){var i,r,o=-1/0,s=-1/0;if(null==e&&null!=t){t=P(t)?t:A.values(t);for(var a=0,u=t.length;a<u;a++)(i=t[a])>o&&(o=i)}else e=x(e,n),A.each(t,function(t,n,i){((r=e(t,n,i))>s||r===-1/0&&o===-1/0)&&(o=t,s=r)});return o},A.min=function(t,e,n){var i,r,o=1/0,s=1/0;if(null==e&&null!=t){t=P(t)?t:A.values(t);for(var a=0,u=t.length;a<u;a++)(i=t[a])<o&&(o=i)}else e=x(e,n),A.each(t,function(t,n,i){((r=e(t,n,i))<s||r===1/0&&o===1/0)&&(o=t,s=r)});return o},A.shuffle=function(t){for(var e,n=P(t)?t:A.values(t),i=n.length,r=Array(i),o=0;o<i;o++)e=A.random(0,o),e!==o&&(r[o]=r[e]),r[e]=n[o];return r},A.sample=function(t,e,n){return null==e||n?(P(t)||(t=A.values(t)),t[A.random(t.length-1)]):A.shuffle(t).slice(0,Math.max(0,e))},A.sortBy=function(t,e,n){return e=x(e,n),A.pluck(A.map(t,function(t,n,i){return{value:t,index:n,criteria:e(t,n,i)}}).sort(function(t,e){var n=t.criteria,i=e.criteria;if(n!==i){if(n>i||void 0===n)return 1;if(n<i||void 0===i)return-1}return t.index-e.index}),\"value\")};var T=function(t){return function(e,n,i){var r={};return n=x(n,i),A.each(e,function(i,o){var s=n(i,o,e);t(r,i,s)}),r}};A.groupBy=T(function(t,e,n){A.has(t,n)?t[n].push(e):t[n]=[e]}),A.indexBy=T(function(t,e,n){t[n]=e}),A.countBy=T(function(t,e,n){A.has(t,n)?t[n]++:t[n]=1}),A.toArray=function(t){return t?A.isArray(t)?p.call(t):P(t)?A.map(t,A.identity):A.values(t):[]},A.size=function(t){return null==t?0:P(t)?t.length:A.keys(t).length},A.partition=function(t,e,n){e=x(e,n);var i=[],r=[];return A.each(t,function(t,n,o){(e(t,n,o)?i:r).push(t)}),[i,r]},A.first=A.head=A.take=function(t,e,n){if(null!=t)return null==e||n?t[0]:A.initial(t,t.length-e)},A.initial=function(t,e,n){return p.call(t,0,Math.max(0,t.length-(null==e||n?1:e)))},A.last=function(t,e,n){if(null!=t)return null==e||n?t[t.length-1]:A.rest(t,Math.max(0,t.length-e))},A.rest=A.tail=A.drop=function(t,e,n){return p.call(t,null==e||n?1:e)},A.compact=function(t){return A.filter(t,A.identity)};var N=function(t,e,n,i){for(var r=[],o=0,s=i||0,a=E(t);s<a;s++){var u=t[s];if(P(u)&&(A.isArray(u)||A.isArguments(u))){e||(u=N(u,e,n));var c=0,l=u.length;for(r.length+=l;c<l;)r[o++]=u[c++]}else n||(r[o++]=u)}return r};A.flatten=function(t,e){return N(t,e,!1)},A.without=function(t){return A.difference(t,p.call(arguments,1))},A.uniq=A.unique=function(t,e,n,i){A.isBoolean(e)||(i=n,n=e,e=!1),null!=n&&(n=x(n,i));for(var r=[],o=[],s=0,a=E(t);s<a;s++){var u=t[s],c=n?n(u,s,t):u;e?(s&&o===c||r.push(u),o=c):n?A.contains(o,c)||(o.push(c),r.push(u)):A.contains(r,u)||r.push(u)}return r},A.union=function(){return A.uniq(N(arguments,!0,!0))},A.intersection=function(t){for(var e=[],n=arguments.length,i=0,r=E(t);i<r;i++){var o=t[i];if(!A.contains(e,o)){for(var s=1;s<n&&A.contains(arguments[s],o);s++);s===n&&e.push(o)}}return e},A.difference=function(t){var e=N(arguments,!0,!0,1);return A.filter(t,function(t){return!A.contains(e,t)})},A.zip=function(){return A.unzip(arguments)},A.unzip=function(t){for(var e=t&&A.max(t,E).length||0,n=Array(e),i=0;i<e;i++)n[i]=A.pluck(t,i);return n},A.object=function(t,e){for(var n={},i=0,r=E(t);i<r;i++)e?n[t[i]]=e[i]:n[t[i][0]]=t[i][1];return n},A.findIndex=o(1),A.findLastIndex=o(-1),A.sortedIndex=function(t,e,n,i){n=x(n,i,1);for(var r=n(e),o=0,s=E(t);o<s;){var a=Math.floor((o+s)/2);n(t[a])<r?o=a+1:s=a}return o},A.indexOf=s(1,A.findIndex,A.sortedIndex),A.lastIndexOf=s(-1,A.findLastIndex),A.range=function(t,e,n){null==e&&(e=t||0,t=0),n=n||1;for(var i=Math.max(Math.ceil((e-t)/n),0),r=Array(i),o=0;o<i;o++,t+=n)r[o]=t;return r};var R=function(t,e,n,i,r){if(!(i instanceof e))return t.apply(n,r);var o=k(t.prototype),s=t.apply(o,r);return A.isObject(s)?s:o};A.bind=function(t,e){if(y&&t.bind===y)return y.apply(t,p.call(arguments,1));if(!A.isFunction(t))throw new TypeError(\"Bind must be called on a function\");var n=p.call(arguments,2),i=function(){return R(t,i,e,this,n.concat(p.call(arguments)))};return i},A.partial=function(t){var e=p.call(arguments,1),n=function(){for(var i=0,r=e.length,o=Array(r),s=0;s<r;s++)o[s]=e[s]===A?arguments[i++]:e[s];for(;i<arguments.length;)o.push(arguments[i++]);return R(t,n,this,this,o)};return n},A.bindAll=function(t){var e,n,i=arguments.length;if(i<=1)throw new Error(\"bindAll must be passed function names\");for(e=1;e<i;e++)n=arguments[e],t[n]=A.bind(t[n],t);return t},A.memoize=function(t,e){var n=function(i){var r=n.cache,o=\"\"+(e?e.apply(this,arguments):i);return A.has(r,o)||(r[o]=t.apply(this,arguments)),r[o]};return n.cache={},n},A.delay=function(t,e){var n=p.call(arguments,2);return setTimeout(function(){return t.apply(null,n)},e)},A.defer=A.partial(A.delay,A,1),A.throttle=function(t,e,n){var i,r,o,s=null,a=0;n||(n={});var u=function(){a=!1===n.leading?0:A.now(),s=null,o=t.apply(i,r),s||(i=r=null)};return function(){var c=A.now();a||!1!==n.leading||(a=c);var l=e-(c-a);return i=this,r=arguments,l<=0||l>e?(s&&(clearTimeout(s),s=null),a=c,o=t.apply(i,r),s||(i=r=null)):s||!1===n.trailing||(s=setTimeout(u,l)),o}},A.debounce=function(t,e,n){var i,r,o,s,a,u=function(){var c=A.now()-s;c<e&&c>=0?i=setTimeout(u,e-c):(i=null,n||(a=t.apply(o,r),i||(o=r=null)))};return function(){o=this,r=arguments,s=A.now();var c=n&&!i;return i||(i=setTimeout(u,e)),c&&(a=t.apply(o,r),o=r=null),a}},A.wrap=function(t,e){return A.partial(e,t)},A.negate=function(t){return function(){return!t.apply(this,arguments)}},A.compose=function(){var t=arguments,e=t.length-1;return function(){for(var n=e,i=t[e].apply(this,arguments);n--;)i=t[n].call(this,i);return i}},A.after=function(t,e){return function(){if(--t<1)return e.apply(this,arguments)}},A.before=function(t,e){var n;return function(){return--t>0&&(n=e.apply(this,arguments)),t<=1&&(e=null),n}},A.once=A.partial(A.before,2);var M=!{toString:null}.propertyIsEnumerable(\"toString\"),H=[\"valueOf\",\"isPrototypeOf\",\"toString\",\"propertyIsEnumerable\",\"hasOwnProperty\",\"toLocaleString\"];A.keys=function(t){if(!A.isObject(t))return[];if(_)return _(t);var e=[];for(var n in t)A.has(t,n)&&e.push(n);return M&&a(t,e),e},A.allKeys=function(t){if(!A.isObject(t))return[];var e=[];for(var n in t)e.push(n);return M&&a(t,e),e},A.values=function(t){for(var e=A.keys(t),n=e.length,i=Array(n),r=0;r<n;r++)i[r]=t[e[r]];return i},A.mapObject=function(t,e,n){e=x(e,n);for(var i,r=A.keys(t),o=r.length,s={},a=0;a<o;a++)i=r[a],s[i]=e(t[i],i,t);return s},A.pairs=function(t){for(var e=A.keys(t),n=e.length,i=Array(n),r=0;r<n;r++)i[r]=[e[r],t[e[r]]];return i},A.invert=function(t){for(var e={},n=A.keys(t),i=0,r=n.length;i<r;i++)e[t[n[i]]]=n[i];return e},A.functions=A.methods=function(t){var e=[];for(var n in t)A.isFunction(t[n])&&e.push(n);return e.sort()},A.extend=O(A.allKeys),A.extendOwn=A.assign=O(A.keys),A.findKey=function(t,e,n){e=x(e,n);for(var i,r=A.keys(t),o=0,s=r.length;o<s;o++)if(i=r[o],e(t[i],i,t))return i},A.pick=function(t,e,n){var i,r,o={},s=t;if(null==s)return o;A.isFunction(e)?(r=A.allKeys(s),i=j(e,n)):(r=N(arguments,!1,!1,1),i=function(t,e,n){return e in n},s=Object(s));for(var a=0,u=r.length;a<u;a++){var c=r[a],l=s[c];i(l,c,s)&&(o[c]=l)}return o},A.omit=function(t,e,n){if(A.isFunction(e))e=A.negate(e);else{var i=A.map(N(arguments,!1,!1,1),String);e=function(t,e){return!A.contains(i,e)}}return A.pick(t,e,n)},A.defaults=O(A.allKeys,!0),A.create=function(t,e){var n=k(t);return e&&A.extendOwn(n,e),n},A.clone=function(t){return A.isObject(t)?A.isArray(t)?t.slice():A.extend({},t):t},A.tap=function(t,e){return e(t),t},A.isMatch=function(t,e){var n=A.keys(e),i=n.length;if(null==t)return!i;for(var r=Object(t),o=0;o<i;o++){var s=n[o];if(e[s]!==r[s]||!(s in r))return!1}return!0};var D=function(t,e,n,i){if(t===e)return 0!==t||1/t==1/e;if(null==t||null==e)return t===e;t instanceof A&&(t=t._wrapped),e instanceof A&&(e=e._wrapped);var r=g.call(t);if(r!==g.call(e))return!1;switch(r){case\"[object RegExp]\":case\"[object String]\":return\"\"+t==\"\"+e;case\"[object Number]\":return+t!=+t?+e!=+e:0==+t?1/+t==1/e:+t==+e;case\"[object Date]\":case\"[object Boolean]\":return+t==+e}var o=\"[object Array]\"===r;if(!o){if(\"object\"!=typeof t||\"object\"!=typeof e)return!1;var s=t.constructor,a=e.constructor;if(s!==a&&!(A.isFunction(s)&&s instanceof s&&A.isFunction(a)&&a instanceof a)&&\"constructor\"in t&&\"constructor\"in e)return!1}n=n||[],i=i||[];for(var u=n.length;u--;)if(n[u]===t)return i[u]===e;if(n.push(t),i.push(e),o){if((u=t.length)!==e.length)return!1;for(;u--;)if(!D(t[u],e[u],n,i))return!1}else{var c,l=A.keys(t);if(u=l.length,A.keys(e).length!==u)return!1;for(;u--;)if(c=l[u],!A.has(e,c)||!D(t[c],e[c],n,i))return!1}return n.pop(),i.pop(),!0};A.isEqual=function(t,e){return D(t,e)},A.isEmpty=function(t){return null==t||(P(t)&&(A.isArray(t)||A.isString(t)||A.isArguments(t))?0===t.length:0===A.keys(t).length)},A.isElement=function(t){return!(!t||1!==t.nodeType)},A.isArray=v||function(t){return\"[object Array]\"===g.call(t)},A.isObject=function(t){var e=typeof t;return\"function\"===e||\"object\"===e&&!!t},A.each([\"Arguments\",\"Function\",\"String\",\"Number\",\"Date\",\"RegExp\",\"Error\"],function(t){A[\"is\"+t]=function(e){return g.call(e)===\"[object \"+t+\"]\"}}),A.isArguments(arguments)||(A.isArguments=function(t){return A.has(t,\"callee\")}),\"function\"!=typeof/./&&\"object\"!=typeof Int8Array&&(A.isFunction=function(t){return\"function\"==typeof t||!1}),A.isFinite=function(t){return isFinite(t)&&!isNaN(parseFloat(t))},A.isNaN=function(t){return A.isNumber(t)&&t!==+t},A.isBoolean=function(t){return!0===t||!1===t||\"[object Boolean]\"===g.call(t)},A.isNull=function(t){return null===t},A.isUndefined=function(t){return void 0===t},A.has=function(t,e){return null!=t&&m.call(t,e)},A.noConflict=function(){return u._=c,this},A.identity=function(t){return t},A.constant=function(t){return function(){return t}},A.noop=function(){},A.property=C,A.propertyOf=function(t){return null==t?function(){}:function(e){return t[e]}},A.matcher=A.matches=function(t){return t=A.extendOwn({},t),function(e){return A.isMatch(e,t)}},A.times=function(t,e,n){var i=Array(Math.max(0,t));e=j(e,n,1);for(var r=0;r<t;r++)i[r]=e(r);return i},A.random=function(t,e){return null==e&&(e=t,t=0),t+Math.floor(Math.random()*(e-t+1))},A.now=Date.now||function(){return(new Date).getTime()};var W={\"&\":\"&amp;\",\"<\":\"&lt;\",\">\":\"&gt;\",'\"':\"&quot;\",\"'\":\"&#x27;\",\"`\":\"&#x60;\"},F=A.invert(W),I=function(t){var e=function(e){return t[e]},n=\"(?:\"+A.keys(t).join(\"|\")+\")\",i=RegExp(n),r=RegExp(n,\"g\");return function(t){return t=null==t?\"\":\"\"+t,i.test(t)?t.replace(r,e):t}};A.escape=I(W),A.unescape=I(F),A.result=function(t,e,n){var i=null==t?void 0:t[e];return void 0===i&&(i=n),A.isFunction(i)?i.call(t):i};var V=0;A.uniqueId=function(t){var e=++V+\"\";return t?t+e:e},A.templateSettings={evaluate:/<%([\\s\\S]+?)%>/g,interpolate:/<%=([\\s\\S]+?)%>/g,escape:/<%-([\\s\\S]+?)%>/g};var L=/(.)^/,U={\"'\":\"'\",\"\\\\\":\"\\\\\",\"\\r\":\"r\",\"\\n\":\"n\",\"\\u2028\":\"u2028\",\"\\u2029\":\"u2029\"},B=/\\\\|'|\\r|\\n|\\u2028|\\u2029/g,G=function(t){return\"\\\\\"+U[t]};A.template=function(t,e,n){!e&&n&&(e=n),e=A.defaults({},e,A.templateSettings);var i=RegExp([(e.escape||L).source,(e.interpolate||L).source,(e.evaluate||L).source].join(\"|\")+\"|$\",\"g\"),r=0,o=\"__p+='\";t.replace(i,function(e,n,i,s,a){return o+=t.slice(r,a).replace(B,G),r=a+e.length,n?o+=\"'+\\n((__t=(\"+n+\"))==null?'':_.escape(__t))+\\n'\":i?o+=\"'+\\n((__t=(\"+i+\"))==null?'':__t)+\\n'\":s&&(o+=\"';\\n\"+s+\"\\n__p+='\"),e}),o+=\"';\\n\",e.variable||(o=\"with(obj||{}){\\n\"+o+\"}\\n\"),o=\"var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\\n\"+o+\"return __p;\\n\";try{var s=new Function(e.variable||\"obj\",\"_\",o)}catch(t){throw t.source=o,t}var a=function(t){return s.call(this,t,A)};return a.source=\"function(\"+(e.variable||\"obj\")+\"){\\n\"+o+\"}\",a},A.chain=function(t){var e=A(t);return e._chain=!0,e};var q=function(t,e){return t._chain?A(e).chain():e};A.mixin=function(t){A.each(A.functions(t),function(e){var n=A[e]=t[e];A.prototype[e]=function(){var t=[this._wrapped];return d.apply(t,arguments),q(this,n.apply(A,t))}})},A.mixin(A),A.each([\"pop\",\"push\",\"reverse\",\"shift\",\"sort\",\"splice\",\"unshift\"],function(t){var e=l[t];A.prototype[t]=function(){var n=this._wrapped;return e.apply(n,arguments),\"shift\"!==t&&\"splice\"!==t||0!==n.length||delete n[0],q(this,n)}}),A.each([\"concat\",\"join\",\"slice\"],function(t){var e=l[t];A.prototype[t]=function(){return q(this,e.apply(this._wrapped,arguments))}}),A.prototype.value=function(){return this._wrapped},A.prototype.valueOf=A.prototype.toJSON=A.prototype.value,A.prototype.toString=function(){return\"\"+this._wrapped},i=[],void 0!==(r=function(){return A}.apply(e,i))&&(t.exports=r)}).call(this)},function(t,e,n){\"use strict\";function i(){this._resources={},this._currentNs=null,this.registerResource(s,{}),this.registerResource(a,{}),this.registerResource(u,{}),this.registerResource(c,o.create()),this.registerWidget(\"Controller\"),this.registerWidget(\"Widget\")}var r=n(9),o=n(58),s=\"preWidget\",a=\"preWidgetNs\",u=\"templates\",c=\"options\";i.prototype.mixin=r.mixin,i.prototype.merge=r.merge,i.prototype.extend=r.extend,i.prototype.registerResource=function(){var t=arguments[0],e=arguments[1],n=arguments[2],i=r.isUndefined(n)?t:[t,n].join(\".\");return r.objectSet(this._resources,i,e),this},i.prototype.getResource=function(t,e){var n=e?[t,e].join(\".\"):t,i=r.objectGet(this._resources,n);return i&&e&&r.isFunction(i.get)&&(i=i.get(e)),i},i.prototype.getResources=function(t){return r.isUndefined(t)?r.mapObject(this._resources,function(t){return r.isFunction(t.get)?t.get():t}):this.getResource(t)},i.prototype.registerTemplate=function(t,e){this.registerResource(u,e,t.toLowerCase())},i.prototype.getTemplate=function(t){if(!t)return!1;var e=this.getResource(u,t.toLowerCase());if(!e)throw new Error(\"Template with name: \"+t.toLowerCase()+\" not found\");return e},i.prototype.registerOptions=function(){var t=this.getOptionsInstance();return t.register.apply(t,arguments)},i.prototype.getOptionsInstance=function(){return this._resources[c]},i.prototype.getWidget=function(t){var e,n=t.split(\":\");return e=1===n.length?this.getResource(s,n[0]):this.getResource(a,n),e&&(r.isUndefined(this.getResource(s,e.name))||this.getResource(s,e.name.ns===e.ns))&&(e.front=1),e},i.prototype.registerWidget=function(t,e,n,i){return e={obj:e,name:t},r.isUndefined(n)||(e.parent=n),r.isNull(this._currentNs)||(e.ns=this._currentNs,this.registerResource(a,e,[this._currentNs,t].join(\".\"))),r.isUndefined(i)||(e.ns=i),this.registerResource(s,e,t),e},i.prototype.setCurrentNamespace=function(t){return this._currentNs=t,this},i.prototype.libMerge=function(){var t,e,n=r.clone(arguments);1===n.length&&r.isArray(n[0])&&(n=n[0]);for(var o=function(t,e){if(!r._isEmpty(t)){var n=this.getResource(e);return n||this.registerResource(e,n={}),r.isFunction(n.merge)?n.merge(t):r.mixin(n,t)}};t=n.shift();)t instanceof i?e=t.getResources():r.isObject(t)&&(e=t),r.each(e,o,this);return this},t.exports=function(){return new i}},function(t,e,n){\"use strict\";function i(){var t={};this.get=function(){return t}}var r=n(9);t.exports={create:function(){return new i},constructor:i},i.prototype.destroy=function(t){var e=\"@\"+t,n=this.get();r.each(r.getObjectKeys(n),function(t){r.inArray(t.split(\" \"),e)&&delete n[t]})},i.prototype.merge=function(t){var e=this.get(),n=t;t instanceof i&&(n=t.get()),r.each(n,function(t,n){var i=e[n];i?r.isObject(i)&&r.each(t,function(t,e){i[e]?r.isArray(i[e])&&(i[e]=i[e].concat(t)):i[e]=t}):e[n]=t})},i.prototype.register=function(t,e,n,i){function o(t,e,s,a){r.each(e,function(e,u){var c=r.clone(s),l=r.clone(a);if(l.push(u),r.isHash(e)&&!e._variables_&&!e._fox_)return o(t,e,c,l);var h=c.join(\" \");t[h]||(t[h]={});var f=l.join(\".\");if(t[h][f]||(t[h][f]=[]),r.isHash(e)&&e._fox_){e.path=h,e.lWeight=n;var d=e.desc.weightDesc;d.w=0|n,e.desc.weight=1e6*d[\"!\"]+1e5*d.w+1e3*d.l+100*d[\"#\"]+d[\".\"]+1,e.name=f,t[h][f].push(e)}else{var p=t[h][f].length;p&&void 0!==i&&i.inline&&!n&&(n=t[h][f][p-1].lWeight-1),t[h][f].push({value:e,lWeight:n||0,desc:i,path:h,_fox_:1})}})}if(r.isEmpty(e))return this;r.isEmpty(t)&&(t=\"@root\"),o(this.get(),e,[t],[])}},function(t,e){}])});"

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.2.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-05-20T17:23Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var arr = [];

var document = window.document;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "2.2.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isPlainObject: function( obj ) {
		var key;

		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		// Not own constructor property must be Object
		if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {

			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf( "use strict" ) === 1 ) {
				script = document.createElement( "script" );
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {

				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval

				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {

						// Inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE9-10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	register: function( owner, initial ) {
		var value = initial || {};

		// If it is a node unlikely to be stringify-ed or looped over
		// use plain assignment
		if ( owner.nodeType ) {
			owner[ this.expando ] = value;

		// Otherwise secure it in a non-enumerable, non-writable property
		// configurability must be true to allow the property to be
		// deleted with the delete operator
		} else {
			Object.defineProperty( owner, this.expando, {
				value: value,
				writable: true,
				configurable: true
			} );
		}
		return owner[ this.expando ];
	},
	cache: function( owner ) {

		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return an empty object.
		if ( !acceptData( owner ) ) {
			return {};
		}

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ prop ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :
			owner[ this.expando ] && owner[ this.expando ][ key ];
	},
	access: function( owner, key, value ) {
		var stored;

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase( key ) );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key === undefined ) {
			this.register( owner );

		} else {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );

				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;

			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <= 35-45+
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://code.google.com/p/chromium/issues/detail?id=378607
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data, camelKey;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// with the key as-is
				data = dataUser.get( elem, key ) ||

					// Try to find dashed key if it exists (gh-2779)
					// This is for 2.2.x only
					dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );

				if ( data !== undefined ) {
					return data;
				}

				camelKey = jQuery.camelCase( key );

				// Attempt to get data from the cache
				// with the key camelized
				data = dataUser.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			camelKey = jQuery.camelCase( key );
			this.each( function() {

				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = dataUser.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				dataUser.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
					dataUser.set( this, key, value );
				}
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE9
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE9-11+
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0-4.3, Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
			"screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {
	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {
		div.style.cssText =

			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );
	}

	jQuery.extend( support, {
		pixelPosition: function() {

			// This test is executed only once but we still do memoizing
			// since we can use the boxSizingReliable pre-computing.
			// No need to check if the test was already performed, though.
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
			// since that compresses better and they're computed together anyway.
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		},
		reliableMarginRight: function() {

			// Support: Android 2.3
			// Check if div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container. (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// This support function is only executed once so no memoizing is needed.
			var ret,
				marginDiv = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			marginDiv.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;box-sizing:content-box;" +
				"display:block;margin:0;border:0;padding:0";
			marginDiv.style.marginRight = marginDiv.style.width = "0";
			div.style.width = "1px";
			documentElement.appendChild( container );

			ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );

			documentElement.removeChild( container );
			div.removeChild( marginDiv );

			return ret;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );
	ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

	// Support: Opera 12.1x only
	// Fall back to style even without computed
	// computed is undefined for elems on document fragments
	if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
		ret = jQuery.style( elem, name );
	}

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE9-11+
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = dataPriv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = dataPriv.access(
					elem,
					"olddisplay",
					defaultDisplay( elem.nodeName )
				);
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				dataPriv.set(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = dataPriv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;

			dataPriv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
		opt.duration : opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// Handle most common string cases
					ret.replace( rreturn, "" ) :

					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE8-11+
			// IE throws exception if url is malformed, e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE8-11+
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


jQuery.expr.filters.hidden = function( elem ) {
	return !jQuery.expr.filters.visible( elem );
};
jQuery.expr.filters.visible = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	// Use OR instead of AND as the element is not visible if either is true
	// See tickets #10406 and #13132
	return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE9
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE9
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		box = elem.getBoundingClientRect();
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},
	size: function() {
		return this.length;
	}
} );

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	var widgetsContext = __webpack_require__(16);
	var templatesContext = __webpack_require__(69);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			context(m)(fox);
		});
	}

	__webpack_require__(73)(fox);

	getDeps(widgetsContext);
	getDeps(templatesContext);
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./autocomplete.js": 17,
	"./data/api.js": 18,
	"./data/datalayer.js": 24,
	"./data/widget.js": 25,
	"./desktopNotifications.js": 26,
	"./dialog.js": 27,
	"./dictionary.js": 28,
	"./form/element.js": 29,
	"./form/elements/checkbox.js": 30,
	"./form/elements/file.js": 31,
	"./form/elements/fileUploaderInterface.js": 32,
	"./form/elements/fileuploader.js": 33,
	"./form/elements/fileuploadersimple.js": 34,
	"./form/elements/input.js": 35,
	"./form/elements/radio.js": 36,
	"./form/elements/select.js": 37,
	"./form/elements/textarea.js": 38,
	"./form/form.js": 39,
	"./googleanalytics.js": 40,
	"./grid/grid.js": 41,
	"./grid/list.js": 42,
	"./grid/pager.js": 43,
	"./grid/pager/dragdealer.js": 44,
	"./grid/rpp.js": 45,
	"./list/advancedList.js": 46,
	"./list/list.js": 47,
	"./menu/menu2.js": 48,
	"./mixin.js": 49,
	"./mixin/documentwidget.js": 50,
	"./mixin/form/easyFormValidator.js": 51,
	"./mixin/grid/lazyAppend.js": 52,
	"./mixin/grid/lazyload.js": 53,
	"./mixin/grid/preloader.js": 54,
	"./mixin/preloader.js": 55,
	"./navigator.js": 56,
	"./newForm/domForm.js": 57,
	"./newForm/elements/base.js": 1,
	"./newForm/elements/computed.js": 9,
	"./newForm/elements/dom/base.js": 0,
	"./newForm/elements/dom/input.js": 2,
	"./newForm/elements/dom/select.js": 6,
	"./newForm/elements/dom/textarea.js": 7,
	"./newForm/elements/dom/uploader.js": 8,
	"./newForm/simpleForm.js": 3,
	"./newForm/validator/elementValidator.js": 4,
	"./newForm/validator/foxValidatorShim.js": 5,
	"./passwordRecovery.js": 60,
	"./router.js": 61,
	"./site/app.js": 62,
	"./site/layout.js": 63,
	"./site/page.js": 64,
	"./socket.js": 65,
	"./throughNotifications.js": 66,
	"./tools/tabsSwitcher.js": 67,
	"./windowScrollHandler.js": 68
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function(fox, undefined) {
	fox.registerWidget('Autocomplete', {
		configure: function (options) {
			if (!options.input) {
				throw 'Autocomplete: No input identifier';
			}

			var inputWidget = this.inputWidget = options.inputWidget || '@parent';

			this.registerOptions('', {
				disabled: false,
				input: options.input,
				useCache: true,
				fullTrim: true,

				'widgets.updateApi': {
					widget: 'Api',
					method: options.method
				},
				'widgets.list': {
					widget: 'AdvancedList',
					autoRender: true,
				},
				'handleWom.updateApiReady': {
					widget: '#updateApi',
					event: 'ready',
					callback: 'updateApiResponse'
				},
				'handleDom': {
					inputKeyPress: {
						target: options.input,
						event: 'keypress',
						callback: 'keypress',
						targetWidget: inputWidget
					},
					inputKeyUp: {
						target: options.input,
						event: 'keyup',
						callback: 'keyup',
						targetWidget: inputWidget
					},
					inputFocus: {
						target: options.input,
						event: 'focus',
						callback: 'focus',
						targetWidget: inputWidget
					},
					inputBlur: {
						target: options.input,
						event: 'blur',
						callback: 'blur',
						targetWidget: inputWidget
					}
				},
				'handleWom.parentAddedToDom': {
					widget: inputWidget,
					event: 'addedToDom',
					callback: function () {
						this._input = this.rwom1(this.inputWidget).dom1(this.getOption('input'));
					}.bind(this)
				},
				'handleWom.listAddedToDom': {
					event: 'addedToDom',
					widget: '#list',
					callback: function (params, list) {
						this._container = list.element[0];
					}.bind(this)
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this.KEY_RETURN = 13;

			this.registerOptions('#list', {
				'embed.container': this.getOption('container'),
				'embed.widget': this.inputWidget,
				'tpl.row': this.getOption('template'),
			});

			this._disabled = this.getOption('disabled');
			this._handlers = {};
			this._buffer = [];
			this._items = [];
			
			return this.callParent('init', arguments);
		},

		running: function () {
			this.list = this.rwom1('#list');

			return this.callParent('running', arguments);
		},
		
		enable: function() {
			this._disabled = false;
		},
		
		disable: function() {
			this._disabled = true;
			setTimeout(fox.bind(function() {
				this._hide();
			}, this), 100);
		},
		
		stopEvent: function() {
			if (event.preventDefault) {
				event.preventDefault();
			} else {
				event.returnValue = false;
			}

			if (event.stopPropagation) {
				event.stopPropagation();
			} else {
				event.cancelBubble = true;
			}
		},

		keypress: function(target, alias, performer, event) {
			if (event.keyCode === this.KEY_RETURN) {
				if (this._container.style.display !== 'none' && this._marked) {
					fox.dom.event.stop(event);
				}
			}
		},
		
		keyup: function(target, alias, performer, event) {
			var 
				_arguments = arguments,
				ipRegexp = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
				now = new Date().getTime();

			clearTimeout(this.timer);

			if (this.timestamp === undefined) {
				this.timestamp = now;
			}

			if (this._disabled || event.altKey || event.ctrlKey) {
				return;
			}

			if (this.getOption('fullTrim')) {
				this._input.value = fox.trim(this._input.value);
			} else {
				this._input.value = (this._input.value).replace(/^\s\s*/, '');
			}

			if ((now - this.timestamp) < 1000) {
				this.timer = setTimeout(fox.bind(function () {
					this.keyup.apply(this, _arguments);
				}, this), 1000);
				
				this.timestamp = now;

				return;
			}

			this.timestamp = now;

			if (ipRegexp.test(this._input.value)) {
				return this.submit({ip: this._input.value});
			}

			switch (true) {
				case event.keyCode === this.KEY_RETURN:
					fox.dom.event.stop(event);
					if (this._container.style.display !== 'none') {
						this._hide();
					}

					return this.submit({ip: this._input.value});
				
				case event.keyCode === this.KEY_ESC:
					this._hide();
					break;
			}

			if (this._input.value) {
				var value = this._input.value;
				this._show();

				if (this._emptyPattern && this._input.value.indexOf(this._emptyPattern) === 0) {
					this.clear();
					this._hide();
					return;
				}

				if (!this.getOption('useCache')) {
					this.update(value);

					return;
				}

				if (!this._buffer[this._input.value]) {
					this.rwom1('#updateApi').send({s: this._input.value, r: Math.random()});
				} else {
					this.redraw(this._buffer[this._input.value]);
				}
			} else {
				this.clear();
				this._hide();
			}
		},
		
		focus: function() {
			if (!this._disabled && this.list.getLength()) {
				this._show();
			}
		},
		
		blur: function() {
			if (!this._disabled) {
				setTimeout(fox.bind(function() {
					this._hide();
				}, this), 100);
			}
		},
		
		_show: function() {
			this.dispatchEvent('show');
			this.hookWrapper('show');
		},

		show: function(argument) {
			this._container.style.display = 'block';
		},
		
		_hide: function() {			
			this.dispatchEvent('hide');
			this.hookWrapper('hide');
		},

		hide: function (argument) {
			this._container.style.display = 'none';
		},
		
		_click: function(node) {
			this._input.value = node.getAttribute('data-value');
			this._hide();

			this.hookWrapper('click', node);
		},

		click: function (node) {
			this.submit({id: node.getAttribute('data-id')});
		},
		
		mark: function(elt, alt) {
			this.unmark();

			if (elt) {
				this._marked = fox.dom.addClass('marked', elt);
			} else if (alt) {
				this._marked = fox.dom.addClass('marked', elt);
			}
		},
		
		unmark: function() {
			if (this._marked) {
				fox.dom.removeClass('marked', this._marked);
				this._marked = false;
			}
		},
		
		clear: function() {
			this.list.resetCollection([]);
		},
		
		mouseover: function(node) {
			this.unmark();
			this.mark(node);
		},
		
		markFirst: function() {
			this.mark(this._container.firstChild);
		},
		
		markNext: function() {
			if (!this._marked) {
				this.mark(this._container.firstChild);
				return;
			}

			this.mark(this._marked.nextSibling, this._marked.parentNode.firstChild);
		},
		
		markPrev: function() {
			if (!this._marked) {
				this.mark(this._container.lastChild);
				return;
			}

			this.mark(this._marked.previousSibling, this._marked.parentNode.lastChild);
		},
		
		update: function(value) {
			clearTimeout(this.requestTimeout);
			
			var api = this.getApi('updateApi', {method: this.getOption('method')});

			this.handleEvent(api, ['prepare'], fox.bind(function(data) {
				this._apiInProgress = true;
			}, this));

			this.requestTimeout = setTimeout(function () {
				api.send({
					s: value,
					rand: Math.random()
				}, false);
			}, 300);
		},

		updateApiResponse: function(data) {
			this._buffer[this._input.value] = data;

			if (this._buffer[this._input.value].length) {
				this.redraw(this._buffer[this._input.value]);
			} else {
				this._emptyPattern = this._input.value;
				this.clear();
				this.hide();
			}
		},
		
		redraw: function(items) {
			this.clear();
			this._items = items;
			this.unmark();

			this.wait(this.list, 'addedToDom').then(this.addMouseEvents.bind(this));
			
			this.hookWrapper('draw', items);
		},

		draw: function (items) {
			this.list.resetCollection(items);
		},
		
		submit: function(data, skipClear) {
			this.dispatchEvent('submit', data);

			if (skipClear === undefined) {
				this.clear();
			}
		},

		getItems: function () {
			return this._items;
		},

		addMouseEvents: function () {
			fox.each(this._container.childNodes, fox.bind(function(node) {
				if (typeof node !== 'object') return;

				fox.dom.on('mousedown', node, fox.bind(function() {
					this._click(node);
				}, this));
			}, this));
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {

	var XFormData = window.xFormData = __webpack_require__(19);

	var methods = {
		/**
		 * Set _fakeResponse object property
		 * @param {Number} httpStatus 200, 404, etc
		 * @param {Object} resHeaders response headers
		 * @param {String} resBody    response body
		 */
		setFakeResponse: function (httpStatus, resHeaders, resBody) {
			if (typeof sinon === 'undefined') {
				return false;
			}

			this._originalTransport = this._getTransport();

			this._transport = null;

			sinon.useFakeXMLHttpRequest();

			this._getTransport();

			if (arguments.length === 1) {
				if (fox.isArray(arguments[0])) {
					this._fakeResponse = arguments[0];
				}
			} else {
				httpStatus = httpStatus || 200;
				resHeaders = resHeaders || JSON.stringify({'Content-Type': 'application/json'});

				this._fakeResponse = [httpStatus, resHeaders, resBody];
			}
		},

		configure: function(options) {
			this.registerOptions('', {
				domain: '',
				address: '/api.php', //TODO add to global config
				httpMethod: 'get',
				sendTimezone: false,
				basePath: ''
			}, true, 'defaut api settings');

			this._transport = null;
			this.isService = true;
			this.registerOptions('', options || {}, false, 'configure');
			this.staticParams = {};
			this._complete = false;
			this._startTime = null;
			this._working = null;
			this._fillWomPatterns();
		},

		setStaticParams: function(params) {
			this.staticParams = params;
		},

		isActive: function() {
			return true;
		},

		method: function(method) {
			if (method) {
				this.setOption('method', method);
				return this;
			}

			return this.getOption('method');
		},

		domain: function(domain) {
			if (domain) {
				this.setOption('domain', domain);
				return this;
			}

			return this.getOption('domain');
		},

		alias: function(alias) {
			if (alias) {
				this._alias = alias;
				return this;
			}

			return this._alias;
		},

		section: function(section) {
			if (section) {
				this._section = section;
				return this;
			}

			return this._section;
		},

		action: function(action) {
			if (action) {
				this._action = action;
				return this;
			}

			return this._action;
		},

		setUnloadMessage: function() {
			//console.log('set unload message')
			if (fox.site.activeApiPosts > 1) {
				//console.log('DID NOT SET! its count is ' + fox.site.activeApiPosts)
				return;
			}

			//console.log('SET! now its count is ' + fox.site.activeApiPosts)
			fox.site.oldonbeforeunload = window.onbeforeunload;
			window.onbeforeunload = function() {
				return 'Some uploads are in progress, please wait until them over';
			};
		},

		unsetUnloadMessage: function() {
			//console.log('remove unload message')
			if (fox.site.activeApiPosts > 0) {
				//console.log('DID NOT REMOVE! its count is ' + fox.site.activeApiPosts)
				return;
			}

			//console.log('REMOVE! its count is ' + fox.site.activeApiPosts)
			window.onbeforeunload = fox.site.oldonbeforeunload;
		},

		getTimezone: function() {
			return -1 * (new Date()).getTimezoneOffset() / 60;
		},

		prepare: function (params) {},

		prepareAddressAndParams: function(data, jsonizeToParamsArg) {
			var postBody,i,
				address = this.requireOption('address'),
				params = {
					'_method': this.requireOption('method')
				};

			if (address === '/api.php') {
				var secure = this.getOption('secure');
				if (secure) {
					address = '/sapi/' + secure[0] + '/' + secure[1] + '/' + params._method;
				} else {
					address = '/api/' + params._method;
				}
			}

			if (this.getOption('basePath')) {
				address = this.getOption('basePath') + address;
			}

			if (this.requireOption('sendTimezone')) {
				params.tz = this.getTimezone();
			}

			for (i in this.staticParams) {
				if (this.staticParams.hasOwnProperty(i)) {
					params[i] = this.staticParams[i];
				}
			}

			var staticParams = this.getOption('staticParams');
			for (i in staticParams) {
				if (staticParams.hasOwnProperty(i)) {
					params[i] = staticParams[i];
				}
			}

			if (this.getOption('paramsToPath')) {
				address = address + '/' + data.join('/');
			} else {
				for (i in data) {
					if (data.hasOwnProperty(i)) {
						params[i] = data[i];
					}
				}
			}

			if (jsonizeToParamsArg) {
				params.params = JSON.stringify(params);
			}

			var staticApi = 0;
			var cacheChannel = this.getOption('cacheChannel');
			if (cacheChannel) {
				var url = this._wom.getRoot().getOption('cacheChannels.' + cacheChannel);
				if (url) {
					address = url + '/' + this.requireOption('method');
					delete params._method;
					staticApi = 1;
				}
			}

			if (!staticApi && this.requireOption('httpMethod').toLowerCase() === 'post') {
				postBody = fox.toQueryString(params, !!this.getOption('encodePost'));
			} else {
				address = address + '?' + fox.toQueryString(params, true);
			}

			if (this.getOption('domain') && address.indexOf('http') !== 0) {
				address = this.getOption('domain') + address;
			}

			return {
				address: address,
				params: params,
				postBody: postBody,
				staticApi: staticApi
			};
		},

		send: function(data, jsonizeToParamsArg) {
			this._startTime = new Date().getTime();

			if (this.isService && typeof jsonizeToParamsArg === 'undefined') {
				jsonizeToParamsArg = true; // change to false in future
			}

			this.dispatchEvent('prepare', {params: data});
			this.hookWrapper('prepare', {params: data});

			if (this.getOption('useFormData')) {
				return this._sendFormData(data);
			}

			var anp = this.prepareAddressAndParams(data, jsonizeToParamsArg);
			var socketWidget = this._wom.getRoot().Socket;

			if (this.getOption('useSocket') && !anp.staticApi && socketWidget) {
				if (socketWidget.isReady()) {
					this.clearPullTimer();

					this.waitEvent(socketWidget, 'socketDisconnected', fox.bind(function () {
						this.send(data, jsonizeToParamsArg);
					}, this));

					return socketWidget.sendApiRequest(this, anp.params);
				} else {
					if (fox.isNumeric(this.getOption('pullTimeout'))) {
						this.clearPullTimer();
					}

					if (!this.pullTimer && fox.isNumeric(this.getOption('pullTimeout'))) {
						this.waitEvent(socketWidget, 'socketDisconnected', fox.bind(function () {// nobody knows why this code placed here. copied it to socket part ^^^
							this.send(data, jsonizeToParamsArg);
						}, this));

						this.pullTimer = setInterval(fox.bind(function () {
							if (this.isActive()) {
								this.send(data, jsonizeToParamsArg);
							}

							this.waitEvent(socketWidget, 'socketReady', fox.bind(function () {
								this.clearPullTimer();
							}, this), {alwaysActive: true});
						}, this), this.getOption('pullTimeout'));
					}
				}
			}

			if (this._working) {
				this.dispatchEvent('stopWorking');
			}
			this.dispatchEvent('startWorking');
			this._working = true;
			


			var t = this.openConnection(anp.address);

			if (!anp.staticApi) {
				t.setRequestHeader('Access-Control-Allow-Credentials', 'true');
				t.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			}

			if (this._originalTransport && this._fakeResponse.length === 3) {
				return t.respond(this._fakeResponse[0], this._fakeResponse[1], this._fakeResponse[2]);
			}

			t.send(anp.postBody);
		},

		openConnection: function (address) {
			var t = this._getTransport();

			t.open(this.requireOption('httpMethod'), address, true);

			return t;
		},

		psend: function () {
			var
				handlerParams,
				defParams = {prefix: 'promiseHandler'}
			;

			if (arguments[2] !== undefined) {
				handlerParams = arguments[2];

				defParams = fox.merge(defParams, handlerParams);
			}

			var promise = this.wait('@this', ['success', 'failure', 'error'], defParams, fox.bind(function (resolve, reject, t, e, p) {
				this.getEm().handle(t, e, function (_params, _performer, _event) {
					var data = {
						params: _params,
						performer: _performer,
						event: _event
					};

					if (_event === 'success') {
						resolve(data);
					} else {
						reject(data);
					}
				}, p);
			}, this));

			this.send.apply(this, arguments);

			return promise;
		},

		abort: function () {
			if (this._transport && this._transport.abort) {
				this._transport.abort();
			}
		},

		clearPullTimer: function() {
			if (this.pullTimer) {
				clearInterval(this.pullTimer);
				this.pullTimer = null;
			}
		},

		__getXhr: function() {
			if (window.XMLHttpRequest) {
				return new XMLHttpRequest;
			}

			if (window.ActiveXObject) {
				return new ActiveXObject("Msxml2.XMLHTTP");
			}

			return new ActiveXObject("Microsoft.XMLHTTP");
		},

		__bindRsc: function(xhr) {
			xhr.onreadystatechange = fox.bind(function () {
				if (xhr.readyState == 4) {
					this._onComplete.apply(this, arguments);
				}
			}, this);
		},

		__bindXhrEvents: function(xhr) {
			var events = ['loadstart', 'progress', 'abort', 'error', 'timeout', 'loadend'];

			if (this._originalTransport) {
				events = ['progress', 'abort', 'error', 'load'];
			}

			fox.each(events, function(event) {
				fox.dom.on(event, xhr.upload, fox.bind(function(e) {
					if (event == 'loadstart') {
						this.inProgress = true;
						this.progress = 0;
						this.dispatchEvent(event);
						return;
					}

					if (event == 'progress') {
						var current = Math.floor(e.loaded / e.total * 100);

						if (this.progress < current) {
							this.progress = current;
							this.dispatchEvent(event, {percent: this.progress, loaded: e.loaded, total: e.total});
						}

						return;
					}

					if (this.getOption('beforeUnloadMessage')) {
						window.onbeforeunload = this.oldonbeforeunload;
					}

					this.inProgress = false;
					this.dispatchEvent(event);
				}, this));
			}, this);
		},

		_getTransport: function() {
			if (!this._transport) {
				this._transport = this.__getXhr();
				this.__bindRsc(this._transport);

				if (this._transport.upload) {
					this.__bindXhrEvents(this._transport);
				}
			}

			return this._transport;
		},

		_onComplete: function() {
			this._working = false;
			this.dispatchEvent('stopWorking');

			var response = {transport: this._transport};
			this.lastResponse = response;

			if (this._transport.status >= 300) {
				response.error = 'httpStatus';
				this.dispatchEvent('error', response);
			} else {
				try {
					response.answer = JSON.parse(this._transport.responseText);
					this.dispatchResponseEvent(this.lastResponse);
				} catch (e) {
					response.error = 'jsonParse';
					this.dispatchEvent('error', response);
				}
			}

			if (this.getOption('httpMethod').toLowerCase() == 'post') {
				fox.site.activeApiPosts--;
				this.unsetUnloadMessage();
			}

			if (this._originalTransport) {
				window.XMLHttpRequest.restore();

				this._transport = this._originalTransport;
				this._originalTransport = null;
			}
		},

		dispatchResponseEvent: function(response) {
			if (!response.answer.status) {
				this.dispatchEvent('failure', response);
			} else {
				this.dispatchEvent('success', response);
				this.dispatchEvent('ready', response.answer.response);
			}
		}
	};

	fox.registerWidget('Api', fox.mixin({
		configure: function(options) {
			this.registerOptions('', {
				domain: '',
				address: '/api.php', //TODO add to global config
				httpMethod: 'get',
				jsonizeToParamsArg: false,
				sendTimezone: false,
				pullTimeout: false,
				inboxSocketEvent: false, //listen this event from Socket for socket INBOX
				inboxSocketCallback: false, //inbox socket custom callback or dispatchResponseEvent method
				handleWom: {
					success: {
						widget: '@this',
						event: 'ready',
						callback: 'success'
					},
					failure: {
						widget: '@this',
						event: 'failure',
						callback: 'failure'
					}
				}
			});

			this.lastResponse = null;
			this.callParent('configure', arguments);
		},

		getApi: function () {
			return this;
		},

		success: function() {},
		failure: function() {},

		init: function() {
			var
				isc,
				ise = this.getOption('inboxSocketEvent')
			;

			this._transport = null;
			this.progress = 0;

			this._chunksCount = 0;
			this._chunksSent = 0;
			this._activeChunk = 0;
			this.getOption('autoLoad') && this.send(this.getOption('autoLoadParams') || {});

			if (ise) {
				if (fox.isString(this.getOption('inboxSocketCallback'))) {
					isc = fox.oop.getRealCallback(fox.oop.createCallback(this.getOption('inboxSocketCallback'), this));
				} else if (fox.isFunction(this.getOption('inboxSocketCallback'))) {
					isc = this.getOption('inboxSocketCallback');
				}

				this.handleEvent('@root #socket', ise, isc || this.dispatchResponseEvent, this.getOption('inboxEventParams') || {});
			}
		},

		_sendXFormData: function(data) {
			var
				files = data.listFiles(),
				loadEnd;

			loadEnd = function () {
				this.unsetUnloadMessage();
				this.inProgress = false;
				this.dispatchEvent('loadend');
			};

			if (!files) {
				var fd = new FormData;
				fox.each(data, function(val, name) {
					fd.append(name, val);
				});
				return this._sendFormData(fd);
			}

			var file = files['file'], // temporary, should be rewritten when you, yes YOU, will have time and inspiration
				func = (file.slice ? 'slice' : (file.mozSlice ? 'mozSlice' : (file.webkitSlice ? 'webkitSlice' : 'slice'))),
				fileSize = file.size,
				chunkSize = data.getFileChunkSize(),
				startByte = this._activeChunk * chunkSize,
				endByte = Math.min(fileSize, (this._activeChunk + 1) * chunkSize),
				realChunkSize = endByte - startByte
			;

			this._chunksCount = Math.ceil(fileSize / chunkSize);

			var isLastChunk = this._activeChunk >= this._chunksCount - 1,
				fileId = file.size + '-' + (file.webkitRelativePath || file.fileName || file.name).replace(/[^0-9a-zA-Z_-]/img, '')
			;

			var events = ['loadstart', 'progress', 'abort', 'error', 'timeout', 'loadend'];
			var xhr = this.__getXhr();

			xhr.onreadystatechange = fox.bind(function () {
				if (xhr.readyState == 4) {
					if (xhr.status == 200) {
						if (isLastChunk) {
							this._transport = xhr;
							this._onComplete.apply(this, arguments);
						} else {
							this._activeChunk++;
							return this._sendXFormData(data);
						}
					} else {
						xhr.__foxSend();
					}
				}
			}, this);

			fox.each(events, function(event) {
				fox.dom.on(event, xhr.upload, fox.bind(function(e) {
					switch (event) {
						case 'loadstart':
							if (!this._isNewRequest) {
								break;
							}

							this._isNewRequest = false;
							this.inProgress = true;
							this.progress = 0;
							this.setUnloadMessage();
							this.dispatchEvent(event);
						break;

						case 'progress':
							var loaded = (this._activeChunk * chunkSize + e.loaded),
								current = Math.floor(loaded / fileSize * 100)
							;

							if (this.progress < current) {
								this.progress = current;
								this.dispatchEvent(event, {percent: this.progress, loaded: loaded, total: fileSize});
							}
						break;

						case 'loadend':
							if (!isLastChunk) {
								break;
							}

							loadEnd.call(this);
						break;
					}
				}, this));
			}, this);

			var startUpload = fox.bind(function() {
				var fd = new FormData;
				fox.each(data.listValues(), function(val, key) {
					fd.append(key, val);
				});
				fd.append('__method', this.requireOption('method'));
				fd.append('_method', 'resumableUpload.postChunk');
				fd.append('_fileId', fileId);
				fd.append('_fileName', file.fileName || file.name);
				fd.append('_fileSize', fileSize);
				fd.append('_chunkSize', chunkSize);
				fd.append('_activeChunk', this._activeChunk + 1);
				fd.append('_chunksCount', this._chunksCount);
				fd.append('_isLastChunk', isLastChunk ? '1' : '0');
				fd.append('file', file[func](startByte, endByte));
				xhr.__foxSend = function() {
					xhr.open('POST', '/api.php', true);
					xhr.send(fd);
				};
				xhr.__foxSend();
			}, this);

			if (this._xParts.length) {
				while (this._xParts.indexOf(this._activeChunk + 1) != -1) {
					this._activeChunk++;
				}
			}

			var
				cfd = new FormData,
				cxhr = this.__getXhr()
			;
			cfd.append('_method', 'resumableUpload.checkChunk');
			cfd.append('_fileId', fileId);
			cfd.append('_fileName', file.fileName || file.name);
			cfd.append('_fileSize', fileSize);
			cfd.append('_chunkSize', chunkSize);
			cfd.append('_chunksCount', this._chunksCount);
			cfd.append('_activeChunk', this._activeChunk + 1);
			this.inProgress = true;

			cxhr.onreadystatechange = fox.bind(function() {
				if (cxhr.readyState == 4) {
					if (cxhr.status == 200) {
						var response = JSON.parse(cxhr.responseText);

						if (response && response.status) {
							if (response.response.parts) {
								this._xParts = response.response.parts;
							}

							if (response.response.exists) {
								var loaded = (this._activeChunk * chunkSize + realChunkSize);
								this.dispatchEvent('progress', {percent: Math.floor(loaded / fileSize * 100), loaded: chunkSize, total: fileSize});

								if (this._activeChunk < this._chunksCount) {
									this._activeChunk++;

									return this._sendXFormData(data);
								}

								loadEnd.call(this);
							}

							startUpload();
						}
					} else {
						cxhr.__foxSend();
					}
				}
			}, this);

			cxhr.__foxSend = function() {
				cxhr.open('POST', '/api.php', true);
				cxhr.send(cfd);
			};
			cxhr.__foxSend();
		},

		_sendFormData: function(data) {
			var params;

			if (data instanceof XFormData) {
				this._xParts = [];
				return this._sendXFormData(data);
			}

			if (data instanceof FormData) {
				params = data;
			} else if (fox.isArray(data)) {
				params = new FormData();

				fox.each(data, function (val) {
					if (typeof val[2] !== 'undefined') {
						params.append(val[0], val[1], val[2]);
					} else {
						params.append(val[0], val[1]);
					}
				});
			} else {
				params = new FormData();

				fox.each(data, function(val, name) {
					params.append(name, val);
				});
			}

			if (this.requireOption('sendTimezone')) {
				params.append('tz', this.getTimezone());
			}

			params.append('_method', this.requireOption('method'));

			var address = this.requireOption('address');

			if (this.getOption('domain') && address.indexOf('http') !== 0) {
				address = this.getOption('domain') + address;
			}

			var t = this.openConnection(address);

			t.setRequestHeader('Access-Control-Allow-Credentials', 'true');

			t.send(params);

			this._isNewRequest = false;
		},

		_send: function(data) {
			this._isNewRequest = true;

			if (this.getOption('useFormData')) {
				return this._sendFormData(data);
			}

			var t = this._getTransport();
			var postBody,
				address = this.requireOption('address'),
				params = {
					'_method': this.requireOption('method')
				};

			fox.site.activeApiPosts = 1 + (fox.site.activeApiPosts || 0);
			this.setUnloadMessage();

			t.send(params);
		}

	}, methods), 'Controller');

	var Api = function(options, wom) {
		if (!options) {
			options = {};
		}

		this._objClass = 'Api';
		this.isService = true;
		this.lastResponse = null;

		if (wom) {
			this.setWom(wom);
		}

		this.__constructor(options);
		if (fox.isEmpty(options.withoutEmbed)) {
			fox.site._embedWidget('api_' + this._id, this, {});
		}
		this._prepare();
	};

	Api.sentStack = 0;

	fox.registerService('Api', fox.extend(methods, fox.BaseObject, Api, 'Api'));
	fox.callApi = function(method, params, successCb, failureCb, wom) {
		if (!wom) {
			wom = fox.wom;
		}
		var options = {};
		if (fox.isObject(method)) {
			options = method.options || {};
			method = method.method;
		}

		var api =  new fox.Api(options, wom);
		api.method(method);
		options.domain && api.domain(options.domain);
		api.setOption('paramsToPath', options.paramsToPath);
		if (successCb) {
			wom.getEventManager().handle(api, options.simple ? 'success' : 'ready', function(res) {
				if (fox.isArray(successCb)) {
					fox.bind(successCb[0][successCb[1]], successCb[0])(res, successCb[2]);
				} else {
					successCb(res);
				}
			});
		}

		if (failureCb) {
			wom.getEventManager().handle(api, 'failure', function (res) {
				if (fox.isArray(failureCb)) {
					fox.bind(failureCb[0][failureCb[1]], failureCb[0])(res, failureCb[2]);
				} else {
					failureCb(res);
				}
			});
		}

		api.send(params, false);
		return api;
	},

	fox.requestApi = function(url, data) {
		return new fox.RSVP.Promise(function(resolve, reject) {
			var api =  new fox.Api({withoutEmbed:1}, fox.wom);
			postData = fox.toQueryString(data);
			if (api.getOption('httpMethod').toLowerCase() == 'get' && postData) {
				url += '?' + postData;
			}

			var xhr = api.openConnection(url);
			xhr.onload = function () {
				if (this.status >= 200 && this.status < 300) {
					resolve(xhr.response);
				} else {
					reject({
						status: this.status,
						statusText: xhr.statusText
					});
				}
			};
			xhr.onerror = function () {
				reject({
					status: this.status,
					statusText: xhr.statusText
				});
			};
			xhr.send(postData);
		});
	}
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(20);

function XFormData () {
	this._values = {};
	this._files = {};
	this._fileChunkSize = 0; // means no split to chunks, send in one request
}

module.exports = XFormData;

XFormData.prototype = _.mixin({
	appendValue: function(name, value) {
		this._values[name] = value;
	},

	appendFile: function(name, file) {
		this._files[name] = file;
	},

	listValues: function() {
		return this._values;
	},

	listFiles: function() {
		return this._files;
	},

	getFileChunkSize: function(chunkSize) {
		return this._fileChunkSize;
	},

	setFileChunkSize: function(chunkSize) {
		this._fileChunkSize = chunkSize;
	}
}, Object.prototype);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(21);

module.exports = _;

_.microtime = function() {
	var now = new Date().getTime() / 1000;
	var s = parseInt(now, 10);
	return now;
};

_.objectGet = function(object, path) {
	var arr = _.isArray(path) ? path : (path || '').split('.');
	var cur = object;

	for (var i = 0, l = arr.length; i < l; i++) {
		if (!cur || (typeof cur[arr[i]] === 'undefined')) {
			return undefined;
		} else {
			cur = cur[arr[i]];
		}
	}

	return cur;
};

_.objectSet = function(object, path, value) {
	var arr = _.isArray(path) ? path : (path || '').split('.'), cur = object;

	for (var i = 0, l = arr.length - 1; i < l; i++) {
		if (!_.isObject(cur[arr[i]])) {
			cur[arr[i]] = {};
		}

		cur = cur[arr[i]];
	}

	if (!_.isEmpty(arr[i])) {
		cur[arr[i]] = value;
	}
	
	return true;
};

_.objectRemove = function(object, path) {
	var arr = _.isArray(path) ? path : (path || '').split('.'), cur = object;
	var last = arr.pop();

	if (arr.length) {
		if (!(cur = _.objectGet(object, arr))) {
			return true;
		}
	}
	
	delete cur[last];
	return true;
};

if (_.isUndefined(_._isObject)) {
	_._isObject = _.isObject;
}

_.isObject = function(arg) {
	return ((Object.prototype.toString.call(arg) === '[object Object]') || (Object.prototype.toString.call(arg) === '[object global]')) && !_.isUndefined(arg);
};

if (_.isUndefined(_._isEmpty)) {
	_._isEmpty = _.isEmpty;
}

_.isEmpty = function (arg) {
	if (_.isUndefined(arg) ||
		_.isNull(arg) ||
		_.isNaN(arg)) {
		return true;
	}

	if(_.isBoolean(arg)) {
		return !arg;
	}

	if (_.isString(arg)) {
		return ['false', '0', 'undefined'].indexOf(arg) !== -1 || arg.length === 0;
	}

	if (_.isFunction(arg) ||
		_.isRegExp(arg) ||
		_.isDate(arg)) {
		return false;
	}

	if (_.isObject(arg)) {
		return _._isEmpty(arg);
	}

	if (_.isArray(arg)) {
		return arg.length === 0;
	}

	if (_.isNumber(arg)) {
		return arg === 0;
	}
};

_.isSet = function (arg) {
	return !_.isUndefined(arg);
};

_.objectIsSet = function(object, path) {
	return _.isSet(_.objectGet(object, path));
};

//merge objects or arrays
//return new Array (not reference) if target === Array
_.merge = function() {
	var target = arguments[0];
	var args = Array.prototype.slice.call(arguments, 1).reverse();
	var current = args.pop();
	var checker;

	if (_.isObject(target)) {
		checker = _.isObject;
	} else {
		checker = _.isArray;
	}

	while (current) {
		if (!checker(current)) {
			throw new TypeError('Argument type differs from target');
		}

		if (_.isObject(target)) {
			for (var prop in current) {
				target[prop] = current[prop];
			}
		} else {
			target = target.concat(current);
		}

		current = args.pop();
	}

	return target;
};

//recursive merge objects or arrays
_.mergeRecursive = function() {
	var target = arguments[0];
	var args = Array.prototype.slice.call(arguments, 1).reverse();
	var current = args.pop(), i = 0;
	var checker;

	if (_.isObject(target)) {
		checker = _.isObject;
	} else {
		checker = _.isArray;
	}

	while (current) {
		if (!checker(current)) {
			throw new TypeError('Argument type differs from target');
		}

		for (var prop in current) {
			if (target[prop] && ((_.isArray(target[prop]) && _.isArray(current[prop])) ||  (_.isObject(target[prop]) && _.isObject(current[prop])) ) ) {
				target[prop] = _.mergeRecursive(target[prop], current[prop]);
			} else if (_.isObject(target)) {
				target[prop] = current[prop];
			} else {
				target.push(current[prop]);
			}
		}

		current = args.pop();
	}

	return target;
};

_.arrayUnique = _.uniq;

/**
 * Cut the string for a match at the beginning and at the end
 * @param  {String} str     [description]
 * @param  {String} pattern [description]
 * @return {String}         [description]
 */
_.trim = function(str, pattern) {
	if (!_.isString(str)) {
		return str;
	}

	if (!pattern  && String.prototype.trim) {
		return str.trim();
	}

	return str.replace(new RegExp('^[' + pattern + ']+', 'g'), '').replace(new RegExp('[' + pattern + ']+$', 'g'), '');
};

/**
 * Return string with upper first letter
 * @param  {String} str [description]
 * @return {String}     [description]
 */
_.upCharFirstLetter = _.ucfirst = function(str) {
	return str.slice(0, 1).toUpperCase() + str.slice(1);
};

_.toQueryString = function(obj, encode) {
	var str = [];

	(function rec(obj, prefix) {
		_.each(obj, function(item, key) {
			var p = prefix ? prefix + '[' + key + ']' : key;
			
			if (_.isObject(item) || _.isArray(item)) {
				rec(item, p);
			} else {
				str.push(p + '=' + (encode ? encodeURIComponent(item) : item));
			}

		});
	})(obj);
	
	return str.join('&');
};

//checkers


_.isNumeric = function (arg) {
	return !isNaN(parseFloat(arg)) && isFinite(arg) && (parseFloat(arg) == arg);
};

_.isHash = function(obj) {
	return _.isObject(obj) && _.isUndefined(obj.superclass);
};

_.arrayWithout = _.without;

_.inArray = _.contains;

_.getObjectKeys = Object.keys;

_.arrayRelation = function(obj, scope) {
	if (!obj) return false;
	
	if (obj._objClass === 'DataLayer') {
		return obj.getObjectValue(scope);
	} else if (obj._objClass === 'DataObject') {
		return obj.get(scope);
	}

	var tmp = scope.split('.'), last = tmp.pop();

	for (var i = 0; i < tmp.length; i++) {
		var name = tmp[i];

		if (_.isEmpty(obj)) return false;

		if (_.isArray(obj[name])) {
			obj = obj[name][0];

			if (!obj) return false;
		} else if (_.isObject(obj[name])) {
			if (obj[name].collection) {
				obj = _.clone(obj);
				_.merge(obj[name], _.toArray(obj[name].collection).shift());
			}

			if (obj[name]._objClass) {
				return obj[name].get(tmp.slice(i).join('.'));
			} else {
				obj = obj[name];
			}
		} else {
			return false;
		}
	}

	return obj[last];
};

_.removeArrayRow = _.without;
/**
 * Create clone
 * @param  {*} obj [description]
 * @return {*}     [description]
 */
_.clone = function(obj, recursive) {
	var clone, id;

	if ((_.isArguments(obj) || _.isArray(obj) && !recursive)) {
		return Array.prototype.slice.call(obj);
	} else if (_.isObject(obj)) {
		clone = {};
	} else if (_.isArray(obj)) {
		clone = [];
	} else  {
		return obj;
	}

	_.each(obj, function(val, key) {
		if (_.isString(key)) {
			clone[key] = recursive ? _.clone(val, true) : val;
		} else {
			clone.push(recursive ? _.clone(val, true) : val);
		}
	});

	return clone;
};

_.split = function(string, pattern, count) {
	var arr = string.split(pattern);

	if (!_.isSet(count) || (count > arr.length)) {
		return arr;
	}

	if (count <= 1) {
		return string;
	}

	var c = count - 1;

	var tail = arr.splice(c, arr.length - c);
	arr.push(tail.join(pattern));
	return arr;
};

_.getCallback = function(obj) {
	if (_.isFunction(obj)) {
		return obj;
	}

	if (_.isArray(obj) && obj.length === 2 && _.isString(obj[1])) {
		if (_.isObject(obj[0])) {
			if (_.isFunction(obj[0][obj[1]])) {
				return obj[0][obj[1]];
			}
		}
	}
	throw ('Invalid callback');
};


_.sortByField = function(arr, field) {
	return arr.sort(function(a, b) {
		if (a[field] < b[field]) {
			return -1;
		}

		if (a[field] > b[field]) {
			return 1;
		}

		return 0;
	});
};

_.isDl = function(obj) {
	return !_.isUndefined(obj) && obj._objClass === 'DataLayer';
};

_.mixin = function(obj) {
	for (var i = 1, l = arguments.length; i < l; i++) {
		for (var prop in arguments[i]) {
			if (!obj[prop]) {
				obj[prop] = arguments[i][prop];
			}
		}
	}

	return obj;
};

if (_.isUndefined(_._count)) {
	_._count = _.count;
}

_.count = function(obj) {
	switch (true) {
		case _.isDl(obj):
			return obj.getCount();
		case _.isArray(obj):
		case _.isString(obj):
			return obj.length;
		case _.isObject(obj):
			return _.getObjectKeys(obj).length;
	}

	return 0;
};

if (_.isUndefined(_._each)) {
	_._each = _.each;
}

_.each = function(object, callback, scope) {
	try {
		_._each(object, callback, scope);
	} catch (e) {
		if (e === '__fox_break_exception__') {
			return object;
		} else {
			_.exception(e, 'Caught each exception: ');
		}
	}

	return object;
};

/**
 * Return filtered data
 * @param  {(Array|Object|String)}   obj      [description]
 * @param  {Function} callback for collection item must return true to include in filtered collection
 * @return {(Object|Array|String)}            [description]
 */
if (_.isUndefined(_._filter)) {
	_._filter = _.filter;
}

_.filter = function(obj, callback) {
	var newObj = _.isObject(obj) ? {} : [];
	
	callback = callback || function (v) {return !_.isEmpty(v);};

	if (_.isObject(obj)) {
		for (var prop in obj) {
			if (callback(obj[prop])) {
				newObj[prop] = obj[prop];
			}
		}
	} else if (_.isArray(obj)) {
		newObj = obj.filter(callback);
	} else if (_.isString(obj)) {
		newObj = Array.prototype.filter.call(obj, callback).join('');
	}

	return newObj;
};

_.exception = function (error, msg) {
	if (!msg) {
		msg = 'Caught exception: ';
	}

	if (_.isString(error)) {
		return console.error(msg, error);
	}

	return console.error(msg, error.message, error.stack);
};

_.log = function(msg, printBacktrace, params) {
	/*if (typeof printBacktrace === 'undefined') {
		printBacktrace = false;
	}

	if (printBacktrace) {
		try {
			null();
		} catch (e) {
			var stack = this.parseStack(e.stack);
		}
	} else {
		var stack = [];
	}

	var timeDiff = this.microtime() - this.startTime;
	var niceTime = Math.floor(timeDiff) + String(timeDiff % 1).substring(1, 7);

	if (params) {
		console.log(niceTime + ' ----> ' + msg + ' %O' + stack.join("\n"), params || {});
	} else {
		console.log(niceTime + ' ----> ' + msg + stack.join("\n"));
	}*/
};

/**
* Multifunction extend method
* 1) Create class from object with auto generated void construtor
* 	var newClass = fox.extend({prop: 'someProp', method: function() {...some method...}})
*
* 2) Extend specified constructor function with object
*	-- var newClass = fox.extend(function() {...constructor...}, {prop: 'someProp', method: function() {...some method...}})
*		or
*	-- var newClass = function() {...constructor...}
*	-- fox.extend(newClass, {prop: 'someProp', method: function() {...some method...})
*
* 3) Create new class by extending parent class with object. NOTE: newClass will use parent's constructor in self scope.
*	-- var newClass = fox.extend({prop: 'someProp', method: function() {...some method...}}, parentClass)
*
* 4) Extend some class by another class
*	-- fox.extend(childClass, parentClass)
*	Now childClass has all parentClass's method and properties
*
* Also for 3 and 4 you can access all parent's overwritten methods using superclass:
* this.superclass.someParentMethod.apply(this, arguments)
*/

if (_.isUndefined(_._extend)) {
	_._extend = _.extend;
}

_.break = '__fox_break_exception__';

_.arrayRevageToValue = function (arr) {
	if (!_.isArray(arr)) return arr;

	var lastValue = arr[arr.length - 1];

	while (arr.length > 0 && (_.isUndefined(lastValue) || _.isNull(lastValue))) {
		arr.pop();

		lastValue = arr[arr.length - 1];
	}

	return arr;
};

_.genUniqueId = function(mask, regexp) {
	var defMask = 'xy';
	var defRegexp = /[xy]/g;
	var d = new Date().getTime();

	if (!_.isString(mask)) {
		mask = defMask;
	}

	if (!_.isRegExp(regexp)) {
		regexp = defRegexp;
	}

	return mask.replace(regexp, function(m) {
		var r = (d + Math.random() * 16) % 16 | 0;

		return (m === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
	});
};

_.callSuperMethod = function(method, args, superMethodName) {
	var args1 = [args[0], args[1], args[2], args[3], args[4], args[5]],
		scope = args1[5] ? args1[5] : this;
	
	args1[5] = scope.superclass;

	if (args1[5]) {
		if (_.inArray(scope._myProps, method)) {
			return args1[5][method].apply(this, args1);
		}

		return args1[5][superMethodName || 'callParent'].apply(this, [method, args1]);
	}
	
	return false;
};

_.defineProperty = function (name, value, desc) {
	if (!name) return this;

	desc = desc || {
		writable: false,
		value: value
	};

	if (!_.keys(desc).some(function (val) {return _.contains(['set', 'get', 'value'], val);})) {
		desc.value = value;
	}

	Object.defineProperty(this, name, desc);

	return this;
};

_.uniqid = _.uniqueId;

_.getStringSimpleHash = function (string, radix) {
	var hash = 5381;
	
	if (!_.isString(string)) return hash;

	var i = string.length;

	while(i) {
		hash = (hash * 33) ^ string.charCodeAt(--i);
	}

	hash = hash >>> 0;

	return _.isNumber(radix) ? hash.toString(radix) : hash;
};

_.isPromise = function (mbPromise) {
	return !fox.isNull(mbPromise) && typeof mbPromise === 'object' && _.isFunction(mbPromise.then);
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(23)(module)))

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {

	var methods = {
		//will store fields info .. required only for data modification
		loadConfig: function() {},

		setMethod: function(method) {
			this._method = method;
			this._jsonize = false;
			return this;
		},

		abort: function () {
			this._loadStatus = 'notLoaded';

			this.getApi().abort();
		},

		// can take args ->
		// (key, val) pair or
		// object
		setTransitParameter: function() {
			if (arguments.length === 2) {
				this._transitParameters[arguments[0]] = arguments[1];
			} else if (arguments.length === 1 && fox.isObject(arguments[0])){
				fox.each(arguments[0], function (_val, _key) {
					this._transitParameters[_key] = _val;
				}, this);
			}

			return this;
		},

		isLoaded: function() {
			return this._loadStatus === 'success';
		},

		clearTransitParameters: function(key) {
			if (key !== undefined) {
				if (fox.isString(key) && this._transitParameters[key]) {
					this._transitParameters[key] = null;
					delete this._transitParameters[key];	
				}
			} else {
				this._transitParameters = {};
			}

			return this;
		},

		isActive: function() {
			return true;
		},
		//object commands. For all id is optional. Using pointer by default.

		getApi: function() {
			if (!this._api) {
				this._api = new fox.Api(null, this._wom).method(this._method);
				this._api.setOption('sendTimezone', true).setOption('cacheChannel', this.getOption('cacheChannel'));
				this.handleEvent(this._api, 'success', fox.bind(this.processResponse, this));
				this.handleEvent(this._api, ['error', 'failure'], fox.bind(this.processError, this));
			}
			return this._api;
		},

		activate: function() {
			this.callParent('activate', arguments);
			if (this._loadStatus === 'loading') {
				var last = this.getApi().lastResponse;
				if (last) {
					if (last.error) {
						this.processError(last);
					} else {
						this.processResponse(last);
					}
				} else {
					this._loadStatus = 'notLoaded';
				}
			}
		},

		loading: function () {},

		load: function(doNotReload) {
			if (!this.isReady()) return false;
			if (doNotReload && this.isLoaded()) return;

			this._loadStatus = 'loading';

			this.dispatchEvent('loading');
			this.hookWrapper('loading');
			
			var api = this.getApi();

			if (this._pm) this._pagerModePreLoadHook();

			this._iterators = {};
			
			var loadPromise = this.wait('loaded');

			api.send(
				fox.filter({
					'class': this._class,
					filter: this._filter,
					customFilter: this._customFilter,
					fields: fox.arrayUnique(this._fields),
					sorting: this._sort,
					limit: this._limit,
					offset: this._offset,
					metaFields: this._metaFields,
					transitParameters: this._transitParameters
				}),
				this._jsonize
			);

			return loadPromise;
		},
				
		setReadyState: function(state) {
			this._ready = state;
			return this;
		},
		
		isReady: function() {
			return this._ready;
		},

		processError: function(response) {
			this._loadStatus = 'error';
			this.dispatchEvent('loaded');
			this.dispatchEvent('loadError');
		},

		isEmpty: function() {
			return	fox.isEmpty(this._collection);
		},

		fillIndexedCollection: function () {
			this._indexedCollection = [];
			for(var id in this._collection) {
				this._indexedCollection.push(this._collection[id]);
			}
		},

		processResponse: function(response) {
			this._loadStatus = 'success';
			response.answer && (response = response.answer.response);

			this.hookWrapper('prepareResponse', response);

			this.set(this._apiResponse);

			if (this._pm) {
				this._pagerModePostLoadHook();
			}
			this.hookWrapper('loaded');
		},

		prepareResponse: function(response) {
			this._apiResponse = response.dataLayer || response;
		},
		
		loaded: function() {
			this.dispatchEvent('loaded');
		},
		//setter for LIMIT, OFFSET, FIELDS
		/**
		 *offset: 	set('offset', number);
		 *limit: 	set('limit', [number, number]) or set('limit', number);
		 *fields: 	set('fields', [Array]);
		*/
		set: function (param, val, val2) {
			if (fox.isObject(param)) {
				for (var p in param) {
					this.set(p, param[p]);
				}
				return this;
			}
			if (!param) {
				return this;
			}
			switch(param) {
				case 'filter':
					return this.addFilter.apply(this, Array.prototype.slice.call(arguments, 1));
				case 'sorting':
					return this.addSorting.apply(this, val);
				default:
					if (!fox.isString(param)) {
						return this;
					}
					var method = 'set' + fox.upCharFirstLetter(param);
					if (this[method]) {
						return this['set' + fox.upCharFirstLetter(param)](val);
					}
				break;
			}
			return this;
		},

		get: function (param) {
			return this['get' + fox.upCharFirstLetter(param)]();
		},

		/* GETTERS & SETTERS */
		
		// class
		setClass: function(className) {
			this._class = className;
			return this;
		},

		getClass: function() {
			return this._class;
		},

		//fields

		addFields: function(fields) {
			if (fox.isArray(fields)) {
				this._fields = fox.merge(this._fields, fields);
			}

			return this;
		},

		addField: function(field) {
			this._fields.push(field);
			
			return this;
		},

		setFields: function(fields) {
			this._fields = fields;
			return this;
		},

		fillRelatedDl: function(dl, myPath, relField, myField) {
			var myObj, relObj, relDl, createDl = true;
			while ((myObj = this.iterateObject('fillDl'))) {
				relDl = myObj.get(myPath);
				if (!fox.isSet(relDl)) {
					myObj.set(myPath, createDl ? fox.createDl() : []);
				}
				relDl = myObj.get(myPath);

				while ((relObj = dl.iterateObject('fillDl1'))) {
					if (relObj.get(relField) == myObj.get(myField)) {
						if (createDl) {
							relDl.addObject(relObj);
						}
					}
				}
			}
		},

		// limit && offset
		setLimit: function(val) {
			if (fox.isArray(val)) {
				this._limit = val[0];
				this.setOffset(val[1]);
			} else {
				this._limit = val;
			}
			return this;
		},

		getLimit: function() {
			return this._limit;
		},

		setOffset: function(val) {
			this._offset = val;
			return this;
		},

		getOffset: function() {
			return this._offset;
		},

		/*filter: addFilter({param})
			*Filter {param} structure
				* fields: Array - required
				* values: Array - required
				* condition: String - optional
			*Filter function signature
				* 1) addFilter({filter})
				* 2) addFilter('alias', {filter})
				* 3) addFilter([fields], [values])
				* 4) addFilter([fields], [values], 'condition')
				* 5) addFilter('alias', [fields], [values], 'condition')
				* 6) addFilter([{filter}, {filter1}....])
		*/
		addFilter: function() {
			var filterPrefix = '_jsFilter';

			switch (arguments.length) {
				case 1:
					if (fox.isArray(arguments[0])) {
						fox.each(arguments[0], function(filter) {
							this.addFilter(filter);
						}, this);
						return this;
					} else if (!arguments[0].fields) {
						fox.each(arguments[0], function(filter, alias) {
							filter.alias = alias;
							this.addFilter(filter);
						}, this);
						return this;
					}
					var alias = arguments[0].alias || filterPrefix + this._filterId++;
					delete arguments[0].alias;
					this._filter[alias] = this.checkFilter(arguments[0], true);
				break;
				case 2:
					if (fox.isString(arguments[0]) && fox.isObject(arguments[1])) {
						this._filter[arguments[0]] = this.checkFilter(arguments[1], true);
						break;
					}
					if (fox.isArray(arguments[0], arguments[1])) {
						this._filter[filterPrefix + this._filterId++] = this.checkFilter({fields: arguments[0], values: arguments[1]}, true);
						break;
					}
					this.checkFilter(null, true);
				break;
				case 3: case 4:
					if (fox.isString(arguments[0])) {
						this._filter[arguments[0]] = this.checkFilter({fields: arguments[1], values: arguments[2], condition: arguments[3] || null}, true);
					} else {
						this._filter[filterPrefix + this._filterId++] = this.checkFilter({fields: arguments[0], values: arguments[1], condition: arguments[2] || null}, true);
					}
				break;
			}
			return this;
		},

		setCustomFilter: function(filter) {
			this._customFilter = filter;
			return this;
		},

		dropFilter: function(alias) {
			delete this._filter[alias];
			return this;
		},

		clearAllFilters: function() {
			this._filter = {};
			return this;
		},

		isFilter: function(alias) {
			return !fox.isEmpty(this._filter[alias]) ? true : false;
		},
		
		checkFilter: function(filter, throwError) {
			if (!filter || !filter.fields || (!filter.values && !filter.condition)) {
				if (throwError) {throw new Error('Missing params for filter');} else {return false;}
			}
			if (!filter.fields.length) {
				if (throwError) {throw new Error('Missing fields for filter');} else {return false;}
			}

			if (!filter.condition) {
				delete filter.condition;
			}
			return filter;
		},

		//sort

		addSorting: function(field, descent, alias) {
			alias || (alias = field + '_' + (descent ? 'desc' : 'asc'));
			this._sort[alias] = [field, descent || 0];
			return this;
		},

		dropSorting: function(alias) {
			delete this._sort[alias];
			return this;
		},

		clearSorting: function() {
			this._sort = {};
			return this;
		},

		// meta
		setMetaFields: function(fields) {
			this._metaFields = fields || {};
			return this;
		},

		setMetaField: function(name, value) {
			this.addMetaField(name, value);
		},

		addMetaField: function(name, value) {
			this._metaFields[name] = value || 1;
			return this;
		},

		alterMetaField: function(name, value) {
			if (!this._metaFields[name]) {
				return this.setMetaField(name, value);
			}
			this._metaFields[name] = fox.mergeRecursive(this._metaFields[name], value);
			return this;
		},

		getMetaValue: function(name) {
			return this._meta[name];
		},

		setMeta: function(meta) {
			this._meta = meta;
		},

		setMetaValue: function(name, value) {
			this._meta[name] = value;
		},

		//collection

		setCollection: function(collection) {
			this._collection = collection;
			this.fillIndexedCollection();
			return this;
		},

		getCollection: function() {
			return this._collection;
		},

		getObjectValue: function(name) {
			return this.getObject().get(name);
		},

		getObjectRelation: function(name, dl) {
			return this.getObject().relation(name, dl);
		},

		resetIterator: function(iteratorAlias) {
			delete this._iterators[iteratorAlias];
		},
		
		iterateObject: function(iteratorAlias, params) {
			params = params || {};
			if (!this._iterators[iteratorAlias]) {
				if (!this.getCount()) {
					return false;
				}
				this._iterators[iteratorAlias] = new fox.DataObject(this);
				if (params.backward) {
					this._iterators[iteratorAlias].end();
				}
				return this._iterators[iteratorAlias];
			}

			var obj = this._iterators[iteratorAlias];
			obj = params.backward ? obj.prev() : obj.next();
			
			if (!obj) {
				this._iterators[iteratorAlias] = new fox.DataObject(this);

				return false;
			}

			return obj;
		},

		getObject: function() {
			return new fox.DataObject(this);
		},

		toJSON: function() {
			return JSON.stringify(this.collection);
		},

		addObjects: function(objects, options) {
			if (fox.isArray(objects)) {
				for (var i = 0, length = objects.length; i < length; i++) {
					this.addObject(objects[i], options);
				}
			} else {
				console.log('addObjects requires array');
			}

			return this;

		},

		addObject: function(object, options) {
			if (!object) {
				return false;
			}

			options = options || {};

			var method = options.top ? 'unshift' : 'push';

			if (object.get) {
				this._collection[method](object.getAll());
			} else {
				this._collection[method](object);
			}

			this._iterators = [];
			this.fillIndexedCollection();
			return this;
		},

		extractObjectByIndex: function(index) {
			var obj = this._collection.splice(index, 1)[0];
			this.fillIndexedCollection();
			return obj;
		},

		//local methods
		findOne: function(field, value, params) {
			params = params || {};
			params.one = true;
			return this.find(field, value, params);
		},
		
		find: function(field, value, params) {
			params = params || {};
			var obj, res = [];
			if (fox.isArray(field)) {
				if (field.length !== value.length) {
					console.log('dl find error: fields count should be same as values count');
					return false;
				}
				while ((obj = this.iterateObject('_find'))) {
					var passed = 1;
					for (var i = field.length - 1; i >= 0; i--) {
						passed = passed && obj.get(field[i]) == value[i]
					}
					if (passed) {
						if (params.one) {
							this._iterators._find = false;
							return obj;
						}
						res.push(obj.getAll());
					}
				}
			} else {
				while ((obj = this.iterateObject('_find'))) {
					if (obj.get(field) == value) {
						if (params.one) {
							this._iterators._find = false;
							return obj;
						}
						res.push(obj.getAll());
					}
				}
			}

			if (params.one) {
				return false;
			}
			return fox.createDl().addObjects(res);
		},


		//data & methods for pagination
		_pagerModePreLoadHook: function() {
			if (!this._pager.notSetTotalCount) {
				this.setMetaField('totalCount');
			}
			this.setLimit(this._pager.rpp);
			this.setOffset(this._pager.rpp * (this._pager.cp - 1));
		},

		_pagerModePostLoadHook: function() {
			this._pager = {
				rpp: this.getLimit(),
				cp: (Math.ceil(this.getOffset() / this.getLimit()) + 1),
				total: (Math.ceil(parseInt(this.getMetaValue('totalCount')) / this.getLimit())),
				notSetTotalCount: this._pager.notSetTotalCount
			};
			this._pager.next = (this._pager.cp >= this._pager.total) ? 0 : this._pager.cp + 1;
			this._pager.prev = (this._pager.cp <= 1) ? 0 : this._pager.cp - 1;
		},

		initPagerMode: function(notSetTotalCount) {
			if (!this._pm) {
				this._pm = true;
				this._pager = {
					rpp: this._limit,
					cp: Math.ceil(this.getOffset() / this.getLimit()) + 1,
					prev: 0,
					next: 0,
					total: 0,
					notSetTotalCount: !!notSetTotalCount
				};
			}
			return this;
		},

		clearCollection: function() {
			this._collection = [];
			this._indexedCollection = [];
			this._loadStatus = 'notLoaded';
			return this;
		},

		getCount: function() {
			return fox.count(this._collection);
		},

		getPagerData: function() {
			return this._pager;
		},

		getNextPageNumber: function() {
			return this._pager.next;
		},

		nextPage: function() {
			this.setCp(this.getNextPageNumber());
			this.load();
			return this;
		},

		getPrevPageNumber: function() {
			return this._pager.prev;
		},

		prevPage: function() {
			this.setCp(this.getPrevPageNumber());
			this.load();
			return this;
		},

		changePage: function(num) {
			this.setCp(num).load();
			return this;
		},

		setRpp: function(rpp) {
			this._pager.rpp = rpp;
			this.setCp(1);
			return this;
		},

		getRpp: function() {
			return this._pager.rpp;
		},

		setCp: function(cp) {
			this._pager.cp = cp;
			return this;
		},

		getCp: function() {
			return this._pager.cp;
		},

		clone: function(dl) {
			var props = [
				'_filter',
				'_fields',
				'_sort',
				'_limit',
				'_offset',
				'_metaFields',
				'_class',
				'_method',
				'_jsonize',
				'_autoLoad',
				'_transitParameters',

				//non-options
				'_config',
				'_pm',
				'_collection',
				'_meta',
				'_index',
				'_indexedCollection',
				'_filterId',
				'_sortId',
				'_pager',
				'_objClass',
				'_loadStatus',
				'_iterators',
				'_ready'
			];

			dl = dl || fox.createDataLayer();

			fox.each(props, function(name) {dl[name] = fox.clone(this[name]);}, this);
			return dl;
		}
	};

	var DataLayer = function(options) {
		this._womHandlers = {};
		this._events = {};
		this._womWaitingActivationHandlers = {};
		this._registerOptionsWeights = {};
		this._filter = {}; this._fields = []; this._sort = {}; this._limit = 25; this._offset = 0; this._config = {}; this._pm = false;
		this._collection = []; this._metaFields = {}; this._meta = {}; this._index = {id: null}; this._indexedCollection = [];
		this._filterId = 1;
		this._class = null;
		this._sortId = 1;
		this._pager = {};
		this._objClass = 'DataLayer';
		this._loadStatus = 'notLoaded';
		this._options = {};
		this._iterators = {};
		options = options || {};
		this._handledEvents	= [];
		this._hooks = {};
		this._ready = true;
		this._method = 'dataLayer.view';
		this._jsonize = true;
		this._autoLoad = false;
		this._transitParameters = {};
		this.options = {};

		this.configure.apply(this, arguments);
		if (!options.skipRegistration && fox.wom) {
			this.setWom(fox.wom);

			fox.wom.registerObject(this);
		}
	};

	var DataLayerClass = fox.extend(methods, fox.BaseObject, DataLayer, 'DataLayer');

	fox.registerWidget('Datalayer', fox.mixin({	
		configure: function(options) {
			this.registerOptions('', {
				limit: 25,
				offset: 0,
				method: 'dataLayer.view',
				jsonize: false,
				sendTimezone: true,
				forwardWom: {
					startWorking: '#api',
					stopWorking: '#api'
				},
				'handleWom.processResponse': {
					widget: '#api',
					event: 'success',
					callback: 'processResponse'
				},
				'handleWom.processError': {
					widget: '#api',
					event: ['error', 'failure'],
					callback: 'processError'
				}
			});

			this.callParent('configure', arguments);
		},
		
		_getObjectClass: function () {
			return 'DataLayer';
		},

		init: function() {
			this._filterId = 1;
			//options
			this._filter = {};//this.getOption('filter') || {};
			if (this.getOption('filter')) {
				this.addFilter(this.getOption('filter'));
			}
			
			this._fields = this.getOption('fields') || [];
			this._sort = this.getOption('sorting') || {};
			this._limit = this.requireOption('limit');
			this._offset = this.requireOption('offset');
			this._metaFields = this.getOption('metaFields') || {};
			this._class = this.getOption('class');
			this._method = this.requireOption('method');
			this._jsonize = this.requireOption('jsonize');
			this._autoLoad = this.getOption('autoLoad') || false;
			this._transitParameters = this.getOption('transitParameters') || {};

			//non-options
			this._config = {};
			this._pm = false;
			this._collection = [];
			this._meta = {};
			this._index = {id: null};
			this._indexedCollection = [];
			this._filterId = 1;
			this._sortId = 1;
			this._pager = {};
			this._objClass = 'DataLayer';
			this._loadStatus = 'notLoaded';
			this._iterators = {};
			this._ready = true;

			this.embedWidget('api', 'Api', this.getOption('apiParams') || {});
			this.callParent('init', arguments);
		},

		initWithChildren: function() {
			if (this.getOption('autoLoad')) {
				this.load();
			}
		},

		getApi: function() {
			var api = this.requireEmbeddedWidget('api');

			api
				.setOption('method', this._method)
				.setOption('useSocket', this.getOption('useSocket'))
				.setOption('sendTimezone', this.requireOption('sendTimezone'))
				.setOption('cacheChannel', this.getOption('cacheChannel'));

			return api;
		}


	}, methods), 'Controller');

	fox.createDataLayer = function(options) {
		return new DataLayerClass(options);
	};

	fox.createDl = function() {
		return new DataLayerClass({skipRegistration: true});
	};

	fox.hydrateDl = function (data, dl) {
		return (dl || fox.createDl()).set(data || {});
	};

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Api_Widget', {
		configure: function() {
			this.registerOptions('', {
				manualRender: true,
				autoLoad: false,
				widgets: {
					api: {
						widget: 'Api'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		initWithChildren: function() {
			this.successTemplate = this.requireOption('template');
			this.failureTemplate = this.getOption('failureTemplate');

			if (this.getOption('apiWidget')) {
				this._api = this.rwom1(this.getOption('apiWidget'));
			} else {
				this._api = this.rwom1('#api');
				this._api.setOption('method', this.requireOption('method'));
			}

			if (this.getOption('autoLoad')) {
				this.load();
			}
			
			this.callParent('initWithChildren', arguments);
		},

		activating: function() {
			this.callParent('activating', arguments);

			if (this.getOption('autoLoad')) {
				this.load();
			}
		},

		load: function(apiParams) {
			var params = fox.merge(this.getOption('apiParams') || {}, apiParams || {});

			return this._api.psend(params).then(function (resp) {
				this.setOption('template', this.successTemplate).setTemplateOptions({data: resp.params.answer.response}).render();
			}.bind(this)).catch(function (resp) {
				if (this.failureTemplate) {
					this.setOption('template', this.failureTemplate).setTemplateOptions({data: resp.params.answer.response}).render();
				}
			}.bind(this));
		}

	}, 'Widget');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	fox.registerWidget('DesktopNotifications', {
		configure: function (argument) {

			this.registerOptions('', {
				focusPageOnClick: true,
				onlyInInactiveWindow: false,
				defaultIcon: [fox.getEnv('design.path'), 'images/star.png'].join('/'),
				defaultTimeout: 5
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.notifyAPI = window.Notify;
			this.defaultIcon = this.getOption('defaultIcon');
			this.defaultTimeout = this.getOption('defaultTimeout');

			/*
				icon: '',
	            body: '',
	            tag: '',
	            notifyShow: null,
	            notifyClose: null,
	            notifyClick: null,
	            notifyError: null,
	            timeout: null
			*/

			this.callParent('init', arguments);
		},

		focus: function (argument) {
			window.focus();
		},

		push: function (title, data, onlyInInactiveWindow) {
			if ( this.notifyAPI && this.notifyAPI.needsPermission) {
				this.notifyAPI.requestPermission(fox.bind(function () {
					this.push(title, data);
				}, this));

				return;
			}

			if (fox.isSet(onlyInInactiveWindow) && onlyInInactiveWindow === true) {
				this.showIfInactiveWindow(title, this.mergeParams(data));

				return;
			}

			if (this.getOption('onlyInInactiveWindow')) {
				this.showIfInactiveWindow(title, this.mergeParams(data));

				return;
			}

			this.show(title, this.mergeParams(data));
		},

		mergeParams: function (data) {
			var params = {};

			fox.isObject(data) || (data = {});

			if (!data.icon) {
				params.icon = this.defaultIcon;
			}

			params.icon = data.icon || this.defaultIcon;
			params.timeout = data.timeout || this.defaultTimeout;

			if (data.body) {
				params.body = data.body;			
			}

			params.notifyClick = fox.bind(function () {
				if (this.getOption('focusPageOnClick')) {
					this.focus();
				}

				if (fox.isFunction(data.notifyClick)) {
					data.notifyClick();
				}
			}, this);

			params.notifyShow = fox.bind(function () {
				if (fox.isFunction(data.notifyShow)) {
					data.notifyShow();
				}
			}, this);
			params.notifyClose = fox.bind(function () {
				if (fox.isFunction(data.notifyClose)) {
					data.notifyClose();
				}
			}, this);
			params.notifyError = fox.bind(function () {
				if (fox.isFunction(data.notifyError)) {
					data.notifyError();
				}
			}, this);

			return params;
		},

		showIfInactiveWindow: function (title, data) {
			if (!fox.dom.documentHasFocus()) {
				this.show(title, data);
			}
		},

		show: function (title, params) {
			if (!window.Notify) return false;

			return new window.Notify(title, params).show();
		},

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $, undefined) {
	fox.registerWidget('Dialog', {
		configure: function(options) {
			this.registerOptions('', {
				'embed.widget': '@root',
				template: 'dialog_global_body',
				autoRender: true,
				useUiPosition: false,
				preventHideOnShadowClick: false,
				preventHideOtherPopups: false,
				dialog: {
					show: {
						effect: 'fade',
						duration: 400
					},
					minHeight: 'auto',
					autoOpen: false,
					modal: true,
					resizable: false,
					close: fox.bind(this.hide, this),
				}
			});

			this.registerOptions('.Controller', {
				'embed.container': '.ui-dialog-content'
			});			
			
			this.callParent('configure', arguments);
		},

		_render: function () {
			return this.callParent('_render', [true]);
		},

		embed: function() {
			var div = document.createElement('div');
			div.appendChild(this.fragment);

			this.dialog = $(div).dialog(this.getOption('dialog'));

			if (this.getOption('template')) {
				this.element = this.dialog[0];
			} else {
				var widget = this.dialogMethod('widget');
				this.element = [widget[0]];
			}

			this.embedCall = true;
		},

		init: function() {
			var buttonsOption = this.getOption('dialog.buttons');

			this.embedCall = false;
			
			if (buttonsOption && buttonsOption.length) {
				fox.each(buttonsOption, function (val) {
					val.click = function () {};
				}, this);
			}

			if (this.getOption('useUiPosition') === true) {
				this.registerOptions('.Widget', {
					handleWom: {
						childsAddedToDom: {
							event: 'addedToDom',
							widget: '@this',
							callback: fox.bind(this._center, this),
							'params.prefix': 'childsAddedToDom'
						}
					}
				});
			} else {
				this.registerOptions('.Widget', {
					handleWom: {
						childsAddedToDom: {
							event: 'addedToDom',
							widget: '@this',
							callback: fox.bind(this.centerPopup, this),
							'params.prefix': 'childsAddedToDom'
						}
					}
				});
			}
			
			this.callParent('init', arguments);
		},

		dialogMethod: function(method) {
			return $(this.dialog).dialog(method);
		},

		centerPopup: function () {
			if (!this.element) {
				return;
			}
			setTimeout(fox.bind(function (){
				var elWidth = this.element[0].offsetWidth,
				elHeight = this.element[0].offsetHeight;
				$(this.element[0]).css({
					left: parseInt(($(window).width() - elWidth) / 2 * 100 / $(window).width()) + '%',
					top: parseInt(($(window).height() - elHeight) / 2 * 100 / $(window).height()) + '%'
				});
			}, this), 50);
		},

		show: function() {
			if (this.getOption('preventHideOtherPopups') === true) {
				if (fox.wom.select('~.Mixin_DocumentWidget').some(function (w) {return w.isOpen() === true;})) {
					this.dialog.dialog('option', 'modal', false);

					this.waitEvent('@this', 'hide', function (params, _this) {
						_this.dialog.dialog('option', 'modal', true);
					}, {prefix: 'resetModal'});	
				}
			} else {
				fox.each(fox.wom.select('~.Mixin_DocumentWidget'), function(w) {
					if (w.getId() != this.getId() && w.isOpen()) {
						w.hide();
					}
				}, this);
			}

			if (this.embedCall === false) {
				this.embed();
			}
			
			if (!this._indom) {
				this.afterEmbed();
			}

			this.dispatchEvent('show');

			if (!this.getOption('preventHideOnShadowClick')) {
				$(document).one('click', '.ui-widget-overlay', fox.bind(this.hide, this));
			}

			if (!this.isOpen()) {
				this.dialogMethod('open');
				
				if (this.wom('.Widget').length > 0) {
					this.dispatchEvent('addedToDom');
				}
			}
			
			return this;
		},

		hide: function() {
			this.callParent('hide', arguments);

			if (!this.getOption('preventHideOnShadowClick')) {
				$(document).off('click', '.ui-widget-overlay');
			}

			this.dialogMethod('close');

			return this;
		},

		_center: function () {
			if (this.dialog) {
				this.dialog.dialog(
					'option', 'position', this.getOption('dialog.position') || 
					{ my: 'center', at: 'center', of: window }
				);
			}

			return this;
		},

		setTitle: function (title) {
			if (this.embedCall === false) {
				this.embed();
			}

			this.dialog.dialog('option', 'title', title);

			return this;
		},

		reset: function () {
			if (this.embedCall === false) {
				this.embed();
			}

			this.dialog.dialog( "option", this.getOption('dialog') );
			return this;
		},

		isOpen: function () {
			var isOpen = this.dialogMethod('isOpen');

			return isOpen.length === 0 ? false : isOpen;
		},

		deactivate: function () {
			if (this.isOpen()) {
				this.callParent('deactivate', arguments);
			}
		}

	}, 'Mixin_DocumentWidget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	var _ = {
		Translation: {
			alias: null,
			defaultVal: null,
			context: null,
			toString: function() {
				if (typeof(fox) != "undefined" && fox.i18n) {
					return fox.i18n._getTranslation(this.alias, this.defaultVal, this.context);
				}
				return this.defaultVal;
			}
		},

		getTranslationObject: function(alias, defaultVal, context) {
			return fox.merge(fox.clone(this.Translation), {alias: alias, defaultVal: defaultVal, context: context});
		}
	};

	fox.registerWidget('Dictionary', {
		configure: function() {
			this.registerOptions('', {
				method: 'dictionary.load',
				useCdn: false
			});

			this.defaultLang = 'en';
			this.phrases = {};
			this.phrases[this.defaultLang] = {};
			this.loadedDics = {};
			this.promises = {};

			this.callParent('configure', arguments);
		},

		init: function() {

			fox.i18n || Object.defineProperty(fox, 'i18n', {
				get: function() {return fox.site.rwom1('.Dictionary')}
			});

			if (fox.cookie.get('dic') === 'interim') {
				this.setOption('method', 'dictionary.loadInterim');
			}

			if (fox.cookie.get('i18n-domain')) {
				this.setOption('domain', 'https://' + fox.cookie.get('i18n-domain'));
			}

			if (!fox.isEmpty(this.getOption('dic'))) {
				this.root = this.rwom1('@root');
				this.rootAfterEmbed = this.root.afterEmbed;
				this.rootAfterEmbedCaught = 0;
				this.root.afterEmbed = function() {
					this.rootAfterEmbedCaught = 1;
				}.bind(this);
				setTimeout(function() {
					this._allowRootRender && this._allowRootRender()
				}.bind(this), 5000);
			}

			this.callParent('init', arguments);
		},

		setLang: function(lang) {
			if (this.lang === lang) {
				return;
			}
			this.lang = lang;
			var alias = this.getOption('dic');
			var interim = fox.cookie.get('dic') == 'interim';
			var useCdn = this.getOption('useCdn');
			var promises = [];

			if (!interim && useCdn) {
				this._loadDics(alias, this.lang, promises).then(function() {
					delete this.promises[lang];
				}.bind(this));
			} else {
				if (fox.isArray(alias)) {
					fox.each(alias, function(alias) {
						promises.push(this._loadDic(alias, this.lang));
					}, this);
				} else {
					promises.push(this._loadDic(alias, this.lang));
				}

				this._applyTranslations(promises);
			}
		},

		_applyTranslations: function(promises) {
			fox.RSVP.all(promises).then(function() {
				this.dispatchEvent('loaded');
				this._commit();
				this._allowRootRender && this._allowRootRender();
			}.bind(this));
		},

		_allowRootRender: function() {
			if (!this.rootAfterEmbedCaught) {
				return;
			}
			console.log('allow');
			this.root.afterEmbed = this.rootAfterEmbed;
			if (this.rootAfterEmbedCaught) {
				this.root.afterEmbed();
				this.rootAfterEmbedCaught = 0;
			}
			delete this._allowRootRender;
		},

		_loadDic: function(alias, lang) {
			if (this.promises[alias + '_' + lang]) {
				return this.promises[alias + '_' + lang];
			}
			this.promises[alias + '_' + lang] = new fox.RSVP.Promise(function (resolve, reject) {
				if (lang == this.defaultLang || this.loadedDics[alias + '_' + lang]) {
					return resolve();
				}
				this.loadedDics[alias + '_' + lang] = 1;
				var url = this.getOption('domain') + '/api/' + this.getOption('method');
				fox.requestApi(url, {alias:alias, lang:lang}).then(function (response) {					
					this._parseDictionary(response, lang);
					this.loadedDics[alias + '_' + lang] = 1;
					delete this.promises[alias + '_' + lang];
					resolve();
				}.bind(this)).catch(function(resp) {
					console.error(resp);
				});
			}.bind(this));
			return this.promises[alias + '_' + lang];
		},

		_parseDictionary: function(dictionary, lang) {
			var dict = JSON.parse(dictionary);
			if (!fox.isEmpty(dict)) {
				this.phrases[lang] = fox.mergeRecursive(this.phrases[lang] || {}, dict);
			}
		},

		_loadDics: function(aliases, lang, promises) {
			if (this.promises[lang]) {
				return this.promises[lang];
			}

			this.promises[lang] = new fox.RSVP.Promise(function (resolve) {
				if (lang == this.defaultLang || this.loadedDics[lang]) {
					this._applyTranslations([]);
					return resolve();
				}
				var url = this.getOption('domain') + '/api/dictionary.getUrls';

				fox.requestApi(url, {alias: aliases, lang: lang}).then(function (response) {					
					var urls = JSON.parse(response);
					fox.each(urls, function(url, alias) {
						promises.push(this._loadCdnDic(url, lang));
					}, this);

					this._applyTranslations(promises);
					this.loadedDics[lang] = 1;
					resolve();
				}.bind(this)).catch(function(resp) {
					console.error(resp);
				});	
			}.bind(this));
			return this.promises[lang];
		},

		_loadCdnDic: function(url, lang) {
			return new fox.RSVP.Promise(function(resolve) {
				fox.requestApi(url, []).then(function (response) {
						this._parseDictionary(response, lang);
						resolve();
				}.bind(this)).catch(function(resp) {
					console.error(resp);
				});		
			}.bind(this));
		},

		_updateNode: function(node) {
			var alias = node.getAttribute('data-fox-alias');
			var context = node.getAttribute('data-fox-context') || 'default';

			if (!this.phrases[this.lang] || !this.phrases[this.lang][context] || !this.phrases[this.lang][context][alias]) {
				return false;
			}
			if (!this.phrases[this.defaultLang][context]) {
				this.phrases[this.defaultLang][context] = {};
			}
			if (!this.phrases[this.defaultLang][context][alias]) {
				this.phrases[this.defaultLang][context][alias] = {};
			}

			fox.each(this.phrases[this.lang][context][alias], function(value,attr) {
				if (value) {
					var oldVal = '';
					if (attr === 'text') {
						oldVal = node.innerHTML;
						node.innerHTML = value;
					} else {
						oldVal = node.getAttribute(attr);
						node.setAttribute(attr,value);
					}

					if (!this.phrases[this.defaultLang][context][alias][attr]) {
						this.phrases[this.defaultLang][context][alias][attr] = oldVal;
					}
				}				
			}, this);
			
			return true;
		},

		_commit: function() {
			if (!this.phrases[this.lang]) {
				return;
			}
			if (!this.handlerExists) {
				this.handlerExists = true;
				var dic = this;
				this.getEm().handleHook('~.Widget', 'onStartEmbedToDom', function() {
					fox.each(this.dom('[data-fox-alias]'), dic._updateNode, dic);
					if (fox.Navigator) {
						fox.Navigator.addClickHandler(this.getMyNodes());
						this.setDomHandlers();
					}
				}, {prefix: '_dictionary_'});
			}
			fox.site.afterEmbed();
		},
		getTranslation: function(alias,defaultVal,context) {	
			if (!alias && !defaultVal) {
				return '';
			}
			return _.getTranslationObject(alias, defaultVal, context);
		},

		getISOLang: function(alias,defaultVal,context) {	
			if (!this.lang) {
				return this.defaultLang;
			} else if (this.lang === 'sp') {
				return 'es';
			}
			return this.lang;
		},

		_getTranslation: function(alias,defaultVal,context) {
			context = context || 'js';
			if (!this.lang || this.lang === this.defaultLang || !this.phrases[this.lang] || !this.phrases[this.lang][context] || !this.phrases[this.lang][context][alias]) {
				return defaultVal;
			}

			return this.phrases[this.lang][context][alias].text || defaultVal;
		}

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element', {
		init: function () {
			this.emptyValue = '';
			this.formElement = true;
			this.value = '';
			this.visual = false;
			this.isDisabled = false;

			this.form = this.getParent();
			this._setElement(this.options.elems);
			//this._updateHandler();
		},

		_updateHandler: function() {
			if (this.options.autoApply) {
				this.addDomHandler({target: this.formElement, event:'change', callback: 'changeHandler'}, 'changed');
			}
		},

		running: function() {
			this.handleEvent(this.form, 'elementsUpdated', fox.bind(this.onElementsUpdated, this));
		},

		onElementsUpdated: function() {
			var elems = this.form.getFormElement(this.alias);

			if (elems) {
				this._setElement(elems);
			}

			this._updateHandler();
			this._updateValue();
		},

		_updateValue: function() {
			this._setValue(this.value);
			return;
		},

		_setElement: function(elems) {
			if (!elems.length) {
				return false;
			}
			
			this.formElement = elems[0];
			
			if (!this.formElement.value.length) {
				this.formElement.value = this.value;
			}
		},

		changeHandler: function(elt, alias, scope, e) {
			this.setValue(this.getValue());
		},

		setValue: function (val, noLog) {
			if (typeof val == 'undefined') {
				val = '';
			}

			this._setValue(val);
			this.value = val;
			this.dispatchEvent('valueChanged', this);
			this.dispatchEvent('changed', this);
			this.form._setValue(this.getAlias(), val, noLog);
			return this;
		},

		_setValue: function (val) {
			this.formElement.value = val;
		},

		setValueCallback: function(val) {
			this.setValue(val);
		},

		getValue: function () {
			return this.formElement && this.formElement.value;
		},

		disable: function () {
			this.formElement.disabled = true;
			this.isDisabled = true;
			this.dispatchEvent('disabled', this);
			return this;
		},

		enable: function () {
			this.formElement.disabled = false;
			this.isDisabled = false;
			this.dispatchEvent('enabled', this);
			return this;
		},

		readonly: function (state) {
			var state = (typeof state == 'undefined' ? true : state);
			this.formElement.readOnly = state;
			return this
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_Checkbox', {
		_setValue: function(value) {
			return this[value ? 'check' : 'unCheck']();
		},

		getValue: function() {
			return this.isChecked();
		},

		_updateValue: function() {
			this._setValue(this.value);
		},

		isChecked: function () {
			check = this.formElement.checked ? 1 : 0;
			return check;
		},

		check: function () {
			this.formElement.checked = true;
			return this;
			
		},

		unCheck: function () {
			this.formElement.checked = false;
			return this;
		},

		toggle: function () {
			return this.isChecked() ? this.unCheck() : this.check();
		}

	}, 'Form_Element');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_File', {}, 'Form_Element');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Form_Element_FileUploaderInterface

(function (fox) {

	var	_ = {
		checkFileExtension: function (filesList) {
			var ext, valid;

			valid = [];

			fox.each(filesList, function (val) {
				if (fox.isString(val.name)) {
					ext = val.name.split('.').pop().toLowerCase();

					if (this.validExt.indexOf(ext) === -1) {
						valid.push(val.name);
					}
				}
			}, this);

			return !valid.length;
		},

		validateProcess: function (files) {
			if (files.length) {
				if (this.cfe === true && !_.checkFileExtension.call(this, files)) {
					this.dispatchEvent('fileNotValid', {
						validExt: this.validExt
					});

					return false;
				}

				return true;
			}

			return false;
		}
	};
	
	fox.registerWidget('Form_Element_FileUploaderInterface', {

		init: function () {
			this.emptyValue = {};
			this.formElement = true;
			this.form = this.getParent();
			this.state = null;

			this.cfe = this.getOption('checkFileExtension') || false;
			this.validExt = this.getOption('validExtension') || [];
		
			this.callParent('init', arguments);
		},

		deactivate: function () {
			this.dispatchEvent('deactivate');
			
			this.callParent('deactivate', arguments);
		},

		getValue: function () {
			return this.value || this.emptyValue;
		},

		changeHandler: function (elt, alias, scope, e) {
			this.fileElement = elt;

			return this.validateFilesExtension(elt.files);
		},

		clearFileElement: function () {
			if (this.fileElement) {
				this.fileElement.value = null;
				this.fileElement = null;
			}
		},

		validateFilesExtension: function (files) {
			var valid = _.validateProcess.call(this, files);
			
			if (valid === true) {
				this.dispatchEvent('fileIsValid');
			} else {
				this.clearFileElement();
			}

			return valid;
		},

		disable: function (argument) {
			this.isDisabled = true;
			this.dispatchEvent('disabled', this);
		},

		enable: function (argument) {
			this.isDisabled = false;
			this.dispatchEvent('enabled', this);
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_FileUploader', {
		init: function() {
			var container;

			this.callParent('init', arguments);

			if (this.form.getOption('formContainer')) {
				container = this.form.getOption('formContainer') + ' ' + this.requireOption('container');
			} else {
				container = this.requireOption('container');
			}
			
			this.registerOptions('.Controller', {
				'embed.container': container,
				autoRender: true
			});

			this.initWidgets();
		},

		syncState: function() {
			var upload = this.wom('.Api').pop();

			if (!upload || fox.oop.instanceOf(upload, 'ClientFileUploaderBox')) {
				return;
			}

			this.inProgress = upload.inProgress;

			if (upload.lastResponse) {
				upload.dispatchResponseEvent(upload.lastResponse);
			}
		},

		activate: function() {
			this.syncState();
			this.switchState();
			this.callParent('activate', arguments);
		},

		switchState: function() {
			var w;

			this.callParent('switchState', arguments);

			w = this.getEmbeddedWidget(this.state);
			
			if (this.state == 'exists') {
				this.rwom1('#exists').templateOptions = this.fileInfo;
			}

			if (this.state == 'input') {
				this.rwom1('#input').templateOptions = this.getOption('templateOptions');
			}

			if (w) {
				if (w.isActive()) {
					w.render();
				} else {
					this.switchEmbeddedWidget(this.state);
				}
			}

			return this.state;
		},

		initWidgets: function() {
			var 
			props = fox.merge({
				widget: 'Widget',
				active: false,
				handleDom: {
					changed: {
						target: 'input',
						event: 'change',
						callback: '@parent:changeHandler'
					}
				}
			}, this.getOption('input'));
			this.embedWidget('input', props.widget, props);

			props = fox.merge({
				widget: 'Widget',
				active: false,
				'handleWom.progress': {
					widget: '@parent .Api',
					event: 'progress',
					callback: 'handlerWom:progressBar'
				},
				'handlerWom.progressBar': function(params, uploader) {
					var fileMeta = this.getParent().filesMeta[uploader.getId()];

					if (fileMeta) params.fileName = fileMeta.name;
					this.templateOptions = params;
					this.render();
				}
			}, this.getOption('progress'));
			this.embedWidget('progress', props.widget, props);

			props = fox.merge({
				widget: 'Widget',
				active: false,
				'handleDom.del': {
					target: '.close',
					event: 'click',
					callback: '@parent:del'
				}
			}, this.getOption('exists'));
			this.embedWidget('exists', props.widget, props);

			props = fox.merge({
				widget: 'Widget',
				active: false,
				'handleWom.uploadFailed': {
					event: ['error', 'failure'],
					widget: '@parent .Api',
					callback: function (params, uploader) {
						var fileMeta = this.getParent().filesMeta[uploader.getId()];

						if (fileMeta) this.setTemplateOptions({fileName: fileMeta.name}).render();
					}
				}
			}, this.getOption('failed'));
			
			this.embedWidget('failed', props.widget, props);
		},

		del: function() {
			if (this.isDisabled) {
				return;
			}

			this.fileInfo = {};
			this.form.autoSubmit = true;
			this.setOption('info.skipInfo', true);
			this.setValue(0);
			this.setOption('info.skipInfo', false);
			this.form.autoSubmit = this.form.getOption('autoSubmit');
			this.switchState();
		}
		
	}, 'Form_Element_FileUploaderSimple');
})(fox);


 /* fox-dynamic-injection */ 
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	var Promise = fox.RSVP.Promise;

	var myFormData = function () {
		var _storage = [];

		this.append = function (name, value, filename) {
			_storage.push([name, value, filename]);
		};

		this.getAll = function() {
			return _storage;
		}
	};

	fox.registerWidget('Form_Element_FileUploaderSimple', {
		configure: function(options) {
			this.registerOptions('', {
				upload: {
					method: 'ClientUploadManager.upload',
					beforeUnloadMessage: 'File upload is in progress, please wait until it\'s over',
					useFormData: true,
					widget: null,
					httpMethod: 'post',
					chunkSize: 0
				},
				info: {
					method: 'ClientUploadManager.info',
					widget: null,
					skipInfo: false,
					httpMethod: 'get'
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this.callParent('init', arguments);
			this.uploaderIndex = 0;
			this.uploaders = [];

			this.configureApis();
			this.progress = 0;
			this.inProgress = false;
			this.failed = false;
			this.apiParams = {};
			this.fileInfo = {};
			this.filesMeta = {};
			this._inProgress = [];
			this._queue = [];
			this._globalScope = window;
		},

		running: function() {
			this.switchState();

			this.callParent('running', arguments);
		},

		setFileInfo: function(info) {
			this.setValue(info.id);
			this.fileInfo = info;
			this.switchState();
		},

		setApiParams: function(params) {
			this.apiParams = params;
		},

		switchState: function() {
			if (this.failed) {
				this.state = 'failed';
			} else if (this.inProgress) {
				this.state = 'progress';
			} else if (fox.isEmpty(this.fileInfo)) {
				this.state = 'input';
			} else {
				this.state = 'exists';
			}

			this.dispatchEvent('switchState', this.state);
			return this.state;
		},

		setValue: function (val, noLog) {
			if (typeof val === 'undefined') {
				val = '';
			}

			this._setValue(val);
			this.value = val;
			this.dispatchEvent('valueChanged', this);
			this.dispatchEvent('changed', this);

			if (this.getOption('autoApply')) {
				this.form._setValue(this.getAlias(), val, noLog);
			}

			var params = this.getOption('info.apiParams') || {};
			params.id = val;

			if (!fox.isEmpty(val) && !this.getOption('info.skipInfo') && this.fileInfo.id != val && this.wom1('#info')) {
				this.__infoPromise = this.rwom1('#info').psend(params).then(function (resp) {
					this.__infoPromise = null;

					return fox.objectGet(resp, 'params.answer.response') || {info: {}};
				}.bind(this)).catch(function (err) {
					this.__infoPromise = null;

					throw err;
				}.bind(this));
			}

			if (!val) {
				this.resetValue();
			}

			return this;
		},

		_setValue: function (val) {
			return true;
		},

		resetValue: function() {
			this.setValue(this.emptyValue);
			this.fileInfo = {};
			this.switchState();
		},

		changeHandler: function(elt, alias, scope, e) {
			if (this.callParent('changeHandler', arguments)) {

				if (this._checkWinIe()) this._globalScope = elt.ownerDocument.defaultView;

				this.hookWrapper('initUpload', elt.files);

				if (this.getOption('autoSubmit')) {
					this.form.autoSubmit = true;
				}

				return true;
			}

			return false;
		},

		_checkWinIe: function () {
			var ua = navigator.userAgent;

			var isWindows = navigator.platform === 'Win32';
			var isEdge = /Edge/.test(ua);
			var isIe = /(MSIE|Trident)/.test(ua);

			return isWindows && (isEdge || isIe);
		},

		_checkFileInstance: function (file) {
			if ('__fakeFile' in file)
				return file.__fakeFile;

			return file instanceof this._globalScope.Blob;
		},

		eachFiles: function (files, callback, thisArg) {
			if (!fox.isFunction(callback)) return false;

			if ('length' in files && fox.isFunction(files.item)) {
				var length = files.length;

				for (var i = 0; i < length; i++) {
					callback.call(thisArg || null, files.item(i), i);
				}

				return true;
			}
			
			return fox.each.apply(fox, arguments);
		},

		_initUploadOneApi: function (files, params) {
			var args = fox.clone(arguments);
			var uploader = this.getUploader(0);
			var id = uploader.getId();
			var formData = new myFormData();

			this.failed = false;
			this.filesMeta[id] = [];

			this.eachFiles(files, function (file) {
				if (fox.isObject(file) && file.file) {
					file = file.file;
				}

				if (!this._checkFileInstance(file))
					return false;

				formData.append('file[]', file, file.name);
				this.filesMeta[id].push(file);
			}, this);

			if (!uploader.getOption('skipUploadParams')) {
				fox.each(params, function(val, key) {
					formData.append(key, val);
				});

				fox.each(this.getOption('upload.apiParams'), function(val, key) {
					formData.append(key, val);
				});
			}

			this.sentParams = uploader.sentParams = params;

			return uploader.psend(formData.getAll()).catch(function () {
				return new Promise(function (resolve) {
					this._reupload = function () {
						return this._initUploadOneApi.apply(this, args).then(resolve);
					};
				}.bind(this));
			}.bind(this)).then(function (resp) {
				delete this._reupload;

				return resp;
			}.bind(this));
		},

		_initUploadMultipleApi: function(files, params) {
			var sendFile;
			var sendPromises = [];
			var maxSameTimeUploads = this.getOption('maxSameTimeUploads') || 0;

			sendFile = function (file, _params) {
				var chunkSize = this.getOption('upload.chunkSize');
				var formData = chunkSize ? new xFormData() : new myFormData();

				function _release () {
					this._inProgress.pop();

					var queue = this._queue.pop();

					if (queue) this.dispatchEvent('queue_release_' + queue[0].getId(), queue);
					if (this.getOption('cleanUploaders')) this.destroyUploader(uploader);
				}

				function _send (uploader, data) {
					var id = uploader.getId();

					if (this._inProgress.indexOf(id) === -1) {
						this._inProgress.push(id);
					}

					return uploader.psend(data).then(function (resp) {
						_release.call(this);

						return resp;
					}.bind(this)).catch(function (e) {
						var maxReuploadAmount = this.getOption('maxReuploadAmount') || 0;

						if (!('reupload' in uploader)) uploader.reupload = 0;

						if (e.event === 'error' &&
							maxReuploadAmount > 0 &&
							uploader.reupload < maxReuploadAmount) {
							this.failed = false;
							uploader.reupload++;

							if (false) {
								console.log('Reuploading with uploaderId: ' + id);
							}

							return _send.call(this, uploader, data);
						}

						_release.call(this);
					}.bind(this));
				}

				if (chunkSize) {
					formData.setFileChunkSize(chunkSize);
				}

				formData[chunkSize ? 'appendFile' : 'append']('file', file, file.name);

				var uploader = this.getUploader();

				if (!uploader.getOption('skipUploadParams')) {
					fox.each(_params, function(val, key) {
						formData[chunkSize ? 'appendValue' : 'append'](key, val);
					});
					fox.each(this.getOption('upload.apiParams'), function(val, key) {
						formData[chunkSize ? 'appendValue' : 'append'](key, val);
					});
				}

				this.addFileMeta(uploader.getId(), file);
				uploader.sentParams = _params;
				this.sentParams = _params;

				if (maxSameTimeUploads > 0 && this._inProgress.length === maxSameTimeUploads) {
					this._queue.unshift([uploader, formData.getAll()]);

					uploader.dispatchEvent('loadstart');

					return this.wait('queue_release_' + uploader.getId()).then(function (resp) {
						return _send.apply(this, resp.params);
					}.bind(this));
				}

				return _send.call(this, uploader, formData.getAll());
			};

			this.failed = false;

			this.eachFiles(files, function (file) {
				if (this._checkFileInstance(file)) {
					sendPromises.push(sendFile.call(this, file, params));
				} else if (fox.isObject(file) && this._checkFileInstance(file.file)) {
					sendPromises.push(sendFile.call(this, file.file, file.params || params || {}));
				}
			}, this);

			this.clearFileElement();

			return fox.RSVP.all(sendPromises);
		},

		destroyUploader: function (uploader) {
			this.uploaders = fox.without(this.uploaders, uploader);
			this.uploaderIndex = this.uploaders.length;

			uploader.destroy();
		},

		initUpload: function () {
			return this.getOption('useOneApi') &&
				this._initUploadOneApi.apply(this, arguments) ||
				this._initUploadMultipleApi.apply(this, arguments);
		},

		addFileMeta: function (id, fileMeta) {
			if (!this.filesMeta.hasOwnProperty(id)) this.filesMeta[id] = fileMeta;

			return this;
		},

		removeFileMeta: function (id) {
			return this.filesMeta.hasOwnProperty(id) && delete this.filesMeta[id];
		},

		getUploader: function() {
			var index = this.uploaderIndex++;

			if (!this.uploaders[index]) {
				this._createUploader(index);
			}

			return this.uploaders[index];
		},

		_createUploader: function(index) {
			var
				props = this.getOption('upload'),
				name = 'upload' + (index === 0 ? '' : index),
				uploader
			;

			if (props.widget) {
				if (fox.wom.isSelector(props.widget)) {
					uploader = fox.wom.selectFirst(props.widget);
				} else {
					uploader = props.widget;
				}
			}

			if (!uploader || fox.isString(uploader)) {
				this.embedWidget(name, uploader || 'Api', props);
				this.embedWidgetsFromOptions();
				this.uploaders[index] = this.rwom1('#' + name);
			} else {
				this.uploaders[index] = uploader;
			}

			if (!this.uploaders[index].isRun()) {
				this.uploaders[index].run();
			}

			return this._createListeners(this.uploaders[index]);
		},

		_createListeners: function (uploader) {
			this.handleEvent(uploader, 'loadstart', fox.bind(function(data) {
				this.inProgress = true;
				this.switchState();
				this.dispatchEvent('loadstart', data);
			}, this), {listenHistory: true});

			this.handleEvent(uploader, 'loadend', fox.bind(function(data) {
				this.inProgress = false;
				this.dispatchEvent('loadend', data);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'progress', fox.bind(function(data) {
				if (!this.inProgress) {
					if (uploader.aborted) return delete uploader.aborted;

					uploader.dispatchEvent('loadstart');
					this.dispatchEvent('loadstart', {});
					this.inProgress = true;
				}
				this.dispatchEvent('progress', data);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'ready', fox.bind(function(response) {
				this.setFileInfo(response);
				this.dispatchEvent('ready', response);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'error', fox.bind(function(response) {
				this.failed = true;
				this.switchState();
				this.dispatchEvent('error', response);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'failure', fox.bind(function(response) {
				this.failed = true;
				this.switchState();
				this.dispatchEvent('failure', response);
			}, this), {alwaysActive: true});

			this.handleEvent(uploader, 'abort', function (response) {
				uploader.aborted = true;
				this.inProgress = false;
				this.switchState();
			}.bind(this), {alwaysActive: true});
		},

		unloadNotice: function() {
			return this.getOption('unloadNotice');
		},

		configureApis: function() {
			if (!this.info) {
				var props = this.getOption('info');

				if (!props) {
					return;
				}

				if (props.widget) {
					if (fox.wom.isSelector(props.widget)) {
						this.info = fox.wom.selectFirst(props.widget);
					} else {
						this.info = props.widget;
					}
				}

				this.embedWidget('info', 'Api', props);
				this.embedWidgetsFromOptions();
				this.info = this.rwom1('#info');
			}

			this.handleEvent(this.info, 'ready', function(response) {
				this.setFileInfo(response);
			});
		}

	}, 'Form_Element_FileUploaderInterface');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('Elements_Input', {
		configure: function (options) {
			console.group('Elements_Input configure');
				console.log(options)
			console.groupEnd();
		},

		setProperties: function (properties) {
			this.elem = properties.elem;
			this.tagName = properties.tagName;
			this.type = properties.type;
			this.name = properties.name;

			return this;
		},

		getValue: function () {
			return this.elem.value;
		},

		setValue: function () {
			this.elem.value = val;

			return this;
		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_Radio', {
		_setElement: function(elems) {
			this.formElement = elems;
		},

		/*_updateHandler: function() {
			//debugger;
			if (this.options.autoApply) {
				this.addDomHandler({target: this.formElement, event:'change', callback: 'changeHandler'}, 'changed');
			}
		},*/

		_setValue: function(value){
			fox.each(this.formElement, function(field, i) {
				if (field.value == value) {
					field.checked = true;
				}
			});

			return this;
		},

		getValue: function() {
			var val = null;

			fox.each(this.formElement, function(field, i) {
				field.checked == false;

				if (field.checked == true) {
					return val = field.value;
				}
			});

			return val;
		},

		changeHandler: function(elt, alias, scope, e) {
			if (elt.value != this.value) {
				this.setValue(elt.value);
			};
		},

		disable: function () {
			fox.each(this.formElement, function (el) {
				el.disabled = true;
			});

			this.isDisabled = true;
			this.dispatchEvent('disabled', this);
			return this; 
		},

		enable: function () {
			fox.each(this.formElement, function (el) {
				el.disabled = false;
			});
			
			this.isDisabled = false;
			this.dispatchEvent('enabled', this);
			return this; 
		},
	}, 'Form_Element');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_Select', {
		configure: function(options) {
			this.registerOptions('', {
				isSelected: false,
				updateNodeOnAddToDom: false,
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			var wToListen;

			this.selectedIndx;

			if (this.getOption('updateNodeOnAddToDom') === true) {
				wToListen = this.getParent().wom1(this.getParent().getOption('container'));

				if (wToListen) {
					this.handleEvent(
						wToListen,
						'addedToDom',
						'updateDomNode',
						{alwaysActive: true}
					);
				}
			}
		
			this.callParent('init', arguments);
		},

		updateDomNode: function () {
			var newNode, parent;

			parent = this.getParent();

			if (typeof this.selectedIndx !== 'undefined') {
				newNode = fox.dom.selectFirst(parent.getOption(['formElements', this.getAlias(), 'element'].join('.')), parent.getContainer());
				
				newNode.parentNode && newNode.parentNode.replaceChild(this.formElement, newNode);
			}
		},

		getValue: function () {
			if (this.formElement.multiple) {
				var values = [];

				fox.each(this.formElement.options, function(option, key) {
					if (option.selected) {
						values.push(option.value || option.text);
					}
				}, values);

				return values;
			}

			if (this.formElement.options[this.formElement.selectedIndex]) {
				return  this.formElement.options[this.formElement.selectedIndex].value;
			}

			return  this.emptyValue;
		},

		getSelectedOption: function() {
			if (this.formElement.selectedIndex < 0) {
				return false;
			}

			var selectedOption = this.formElement.options[this.formElement.selectedIndex];

			if (!this.getOption('isSelected')) {
				return false;
			}
			
			return {
				text: selectedOption.innerHTML,
				value: selectedOption.value,
				index: this.formElement.selectedIndex
			};
		},

		_setValue: function (value) {
			this.selectedIndx = this.formElement.selectedIndex;

			fox.each(this.formElement.options, function (optionItem, i) {
				optionItem.selected = false;

				if (value == optionItem.value || (this.formElement.multiple && fox.inArray(value, optionItem.value))) {
					optionItem.selected = true;
					this.setOption('isSelected', true);
				}
			}, this);

			return this;
		}

	}, 'Form_Element');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_Textarea', {}, 'Form_Element');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form', {
		configure: function (options) {
			this.registerOptions('', {
				resetOnBuilt: true,
				container: '@parent',
				loadValuesOnRun: true
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this._values = {}; //need to reset this._values somewhere
			this._beforeBuildValues = {};
			this._defaults = {};
			this._log = [];
			this._redoLog = [];
			this._skipLog = false;
			this._skipCleanRedo = false;
			this._ignoreSubmit = false;
			this._isBuilt = false;
			this._hasSelectors = false;

			this.sendTimer = 250;
			this.sendTimerId = null;
			this.silent = false;

			fox.each(this.options.formElements, function(desc, alias) {
				// defaultValuesLoaded
				if (fox.isSet(desc.defaultValue)) {
					this._defaults[alias] = desc.defaultValue;
				}

				if (fox.isObject(desc.element)) {
					desc.element.autoApply = desc.element.autoApply || this.getOption('autoApply');
					this.embedWidget(alias, desc.element.widget, desc.element);
				} else if (fox.isString(desc.element)) {
					this._hasSelectors = true;
				}
			}, this);
		},

		loadDefaultValues: function() {
			var api = this._getFormDataApi(),
				params = this.getOption('methods.getParams') || {};
			
			this.handleEvent(api, ['success'], fox.bind(function(transport) {
				if (!transport.transport.status) {
					return;
				}
				if (!fox.isEmpty(transport.answer.response)) {
					this._defaults = transport.answer.response;
				}

				if (this._isBuilt) {
					this._updateElements();
					this.resetForm();
				}
				this.dispatchEvent('defaultValuesLoaded');
			}, this));

			api.send(params, false);
		},

		_getFormDataApi: function () {
			var
				api = this.wom1('#formDataApi');

			if (!api) {
				api = this.embedWidget('formDataApi', 'Api', {
					method: this.getOption('methods.get'),
					sendTimezone: true
				});

				api.run();
			}

			return api;
		},

		_getFormSendApi: function () {
			var
				api = this.wom1('#formDataSaveApi');

			if (!api) {
				api = this.embedWidget('formDataSaveApi', 'Api', {
					method: this.getOption('methods.send'),
					sendTimezone: true
				});

				api.run();
			}

			return api;
		},

		loadValues: function() {
			if (this.getOption('methods.get')) {
				this.loadDefaultValues();
			} else {
				this.dispatchEvent('defaultValuesLoaded');
			}
		},

		_embedWidget: function(alias, widget, options) {
			var w  = this.callParent('_embedWidget', arguments);

			if (this.options.formElements[alias] && !fox.isSet(this._defaults[alias])) {
				this._defaults[alias] = w.emptyValue;
			}
			
			return w;
		},

		running: function() {
			if (this.options.loadValuesOnRun) {
				this.loadValues();
			}
			
			if (this._hasSelectors) {
				this.handleEvent(this.requireOption('container'), 'addedToDom', fox.bind(this._runSelectors, this),
					{prefix: 'embed_' + this.getHash(), listenHistory: true}
				);
				//this._performStateDependency({subject: '@this', event: 'elementsUpdated'}, this._createWidgets);
			} else {
				this._performStateDependency({subject: '@this', event: 'defaultValuesLoaded'}, this.built);
			}

			if (!this.getOption('methods.send')) {
				this.silent = true;
				return;
			}
			
			this.api = this._getFormSendApi();
			if (this.getOption('methods.sendMethod')) {
				this.api.setOption('httpMethod', this.getOption('methods.sendMethod'));
			}
			
			if (this.getOption('methods.encodePost')) {
				this.api.setOption('encodePost', this.getOption('methods.encodePost'));
			}
	
			var cb = this.getOption('responseCallback') || fox.bind(function(answer, type) {
				this.hookWrapper('response', {response: answer.answer.response, type: type, answer: answer});
			}, this);

			this.handleEvent(this.api, ['success'], function(answer) {
				cb(answer, 'send');
			});
			
			this.handleEvent(this.api, ['error', 'failure'], function(answer) {
				cb(answer, 'error', 'send');
			});
		},

		getContainer: function() {
			return this.options.formContainer ? fox.dom.selectFirst(this.options.formContainer, this.getParent().element) : this.rwom1(this.getOption('container')).element;
		},

		_runSelectors: function() {
			if (this.getOption('submit')) {
				var performer = this.rwom1(this.getOption('container'));

				if (this.getOption('submit.targetWidget')) {
					performer = this.rwom1(this.getOption('submit.targetWidget'));
				}

				performer.addDomHandler({
					target: this.getOption('submit.target'),
					event: this.getOption('submit.event') || 'submit',
					callback: fox.bind(this._submitHandler, this)
				}, 'submit');
			}

			this._updateElements();
		},

		_updateElements: function() {
			this.formSelectedElements = {};
			fox.each(this.options.formElements, function(desc, alias) {
				if (fox.isString(desc.element)) {
					this.formSelectedElements[alias] = fox.dom.select(desc.element, this.getContainer());
				}
			}, this);

			this._createWidgets();

			this.dispatchEvent('elementsUpdated');
		},

		getFormElement: function(alias) {
			return this.formSelectedElements[alias] || false;
		},

		_createWidgets: function() {
			this.createWidgetsFromSelectors();
			this._performStateDependency({subject: '@this', event: 'defaultValuesLoaded'}, this.built);
		},

		built: function() {
			this._isBuilt = true;

			if (this.getOption('resetOnBuilt')) {
				this.resetForm();
			}
		},

		createWidgetsFromSelectors: function() {
			fox.each(this.options.formElements, function(desc, alias) {
				var elem = this.getFormElement(alias)
				if (desc.element && fox.isString(desc.element) && elem) {
					if (!this.getEmbeddedWidget(alias)) {
						this._embedWidgetByElement(alias, elem, desc.customWidget);
					}
				}
			}, this);

			this.dispatchEvent('formElementsCreated', this._widgets);
		},

		collectData: function() {
			fox.each(this._widgets, function(widget, alias) {
				if (widget.formElement) {
					var value = (fox.isEmpty(widget.getValue()) && !fox.isEmpty(this._defaults[alias])) ? this._defaults[alias] : widget.getValue();
					var value = widget.getValue();
					this._values[alias] = fox.clone(value, true);
				}
			}, this);
			this._preparedValues = {};
			this.hookWrapper('prepareValues', this);

			return this._preparedValues;
		},

		resetForm: function(fields) {
			fox.each(this._widgets, function(widget, alias) {
				if (widget.formElement && (!fields || (fox.isArray(fields) && fox.inArray(fields, alias)))) {
					var val = fox.isSet(this._beforeBuildValues[alias]) ? this._beforeBuildValues[alias] : this._defaults[alias];

					this._values[alias] = val;
					this.setValue(alias, val);
				}
			}, this);

			this._log = [];
			this._redoLog = [];
			this._beforeBuildValues = {};

			this.dispatchEvent('resetForm');
			return this;
		},

		setValue: function(alias, value) {
			if (!this._isBuilt) {
				this._beforeBuildValues[alias] = value;
				return this;
			}
			
			var w = this.getEmbeddedWidget(alias);

			if (w) {
				w.setValue(value);
				var params = {
					field: w.formElement,
					value: value,
					alias: alias
				};
				this.hookWrapper('valueChanged', params);
				this.dispatchEvent('valueChanged', params);
			} else {
				this._setValue(alias, value);
			}
		},

		setValues: function(values) {
			fox.each(values, function(value, alias) {
				this.setValue(alias, value);
			}, this);
		},

		valueChanged: function(params) {

		},

		getValue: function(alias) {
			var w = this.getEmbeddedWidget(alias);

			if (w) {
				return w.getValue();
			}

			return this._getValue(alias);
		},

		_getValue: function(alias) {
			return this._values[alias];
		},

		_logActions: function(alias, value) {
			if (this._values[alias] == value) {
				return;
			}

			if (this._skipLog) {
				this._skipLog = false;
				return;
			}

			if (!this._log.length) {
				this.dispatchEvent('undoListAvailable');
			}

			this._log.push({
				alias: alias,
				undo: fox.clone((this._values[alias] ? this._values[alias] : this._defaults[alias]), true),
				redo: fox.clone(value, true)
			});

			if (this._skipCleanRedo) {
				this._skipCleanRedo = false;
			} else {
				this._redoLog = [];
				this.dispatchEvent('redoListEmpty');
			}
		},

		_setValue: function(alias, value, noLog) {
			if (this._values[alias] == value) {
				return;
			}

			if (JSON.stringify(this._values[alias]) == JSON.stringify(value)) {
				return;
			}

			if (noLog !== true) {
				this._logActions(alias, value);
			}

			this._values[alias] = fox.clone(value, true);

			//this is centralized event for _all_ changes of form value.
			this.dispatchEvent('valueChange', {
				alias: alias,
				value: value
			});
			this.dispatchEvent('valueChanged_' + alias, value);


			if (this.autoSubmit || this.getOption('autoSubmit')) {
				this._submit();
			}

			return this;
		},

		undo: function() {
			var last = this._log.pop();

			if (last) {
				this._skipLog = true;
				this._skipCleanRedo = true;
				this.setValue(last.alias, last.undo);

				if (!this._redoLog.length) {
					this.dispatchEvent('redoListAvailable');
				}

				this._redoLog.push(last);
			}

			if (!this._log.length) {
				this.dispatchEvent('undoListEmpty');
			}

			return this;
		},

		undoAll: function() {
			fox.each(this._log, this.undo, this);
		},

		redo: function() {
			var last = this._redoLog.pop();

			if (last) {
				this._skipCleanRedo = true;
				this.setValue(last.alias, last.redo);
			} else {
				this.dispatchEvent('redoListEmpty');
			}

			return this;
		},

		_embedWidgetByElement: function (alias, elems, customWidget) {
			if (!elems || !elems.length) {
				return;
			}
			var tagName = elems[0].tagName.toLowerCase();
			var autoApply = this.options.autoApply || this.options.formElements[alias].autoApply || false;
			var wOptions = this.options.formElements[alias];
			
			if (!fox.isEmpty(customWidget)) {
				this.embedWidget(alias, customWidget.widget, fox.merge(customWidget, {
					elems: elems,
					autoApply: autoApply
				})).run();
				return this;
			}

			switch (tagName) {
				case 'input':
					var type = elems[0].type;

					switch (type) {
						case 'file':
							this.embedWidget(alias, 'Form_Element_File', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;
						
						case 'checkbox':
							this.embedWidget(alias, wOptions.widget || 'Form_Element_Checkbox', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;

						case 'radio':
							this.embedWidget(alias, 'Form_Element_Radio', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;

						case 'password':
						case 'text':
						case 'hidden':
						default:
							this.embedWidget(alias, 'Form_Element', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;
					};

				break;

				case 'select':
					this.embedWidget(alias, 'Form_Element_Select', fox.merge(wOptions, {
						elems: elems,
						autoApply: autoApply
					})).run();
				break;

				case 'textarea':
					this.embedWidget(alias, 'Form_Element_Textarea', fox.merge(wOptions, {
						elems: elems,
						autoApply: autoApply
					})).run();
				break;
			}
			
			return this;
		},

		prepareValues: function (data) {
			this._preparedValues = this._values;
		},

		_submitHandler: function(el, alias, w, e) {
			e.preventDefault();
			e.stopPropagation();

			if (this._ignoreSubmit) {
				return false;
			}

			this._submit();
			return false;
		},

		_submit: function() {
			this.collectData();
			this.hookWrapper('submit', this._preparedValues);
		},

		submit: function(values) {
			if (!this.silent) {
				if (this.sendTimerId) {
					clearTimeout(this.sendTimerId);
				}

				this.sendTimerId = setTimeout(fox.bind(this._send, this), this.sendTimer);
			}

			this.dispatchEvent('submit', this._preparedValues);
		},

		_send: function() {
			if (this.getOption('sendTimezone') === true) {
				this._preparedValues.tz = fox.utils.getCurrentTimezone();
			}

			this.api.send(this._preparedValues, false);
		},

		response: function(answer, type, msg) {
			console.log('Form default responder: ', answer, type, msg);
		},

		disableAllElements: function() {
			fox.each(this._widgets, function(w, alias) {
				if (fox.oop.instanceOf(w, 'Form_Element')) {
					w.disable();
				}
			}, this);
			return this;
		},

		enableAllElements: function(alias) {
			fox.each(this._widgets, function(w, alias) {
				if (fox.oop.instanceOf(w, 'Form_Element')) {
					w.enable();
				}
			}, this);
			
			return this;
		},

		ignoreSubmit: function(flag) {
			this._ignoreSubmit = flag;
			return this;
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('googleAnalytics', {
		configure: function(options) {
			if (!fox.isEmpty(options.gaCodes)) {
				options.gaCodes = this._prepareAccounts(options.gaCodes);
			}

			this.registerOptions('', options);
			this.callParent('configure', arguments);
		},

		init: function() {
			this._includedSnippet = false;
			this._trackersInfo = {}; // Example. If creacted two trackers. {tracker1 : true, tracker2: true}
			this._linkerParam = null; // Contacin cid (unique client if of google analytics) of user
			this._prevTrackedPage = null;

			var gaCodes = null;

			if (!this.checkAccounts()) {
				gaCodes = this.rwom1('@root').getOption('gaCodes') || fox.getEnv('gaCodes');

				if (!fox.isEmpty(gaCodes)) {
					this.setAccounts(gaCodes);
				}
			}

			if (this.checkAccounts()) {
				this.include();
			}

			this.optOut(!!this.getOption('optOut'));
			this.getOption('settings') && this.setSettings(this.getOption('settings'));

			this.callParent('init', arguments);
		},

		/**
		 * Include snippets for properly working of google analytics
		 * @return {void}
		 */
		include: function() {
			if (this._includedSnippet) {
				return;
			}

			_gaScriptLoaded = false;
			_gaLinkerLoaded = false;

			this._includeSnippet();
			this._includedSnippet = true;
		},

		/**
		 * Include snippet for universal ga. Set global flag _gaScriptLoaded after external script loaded.
		 * @return {void}
		 */
		_includeSnippet: function() {
			(function(i,s,o,g,r,a,m){
				i['GoogleAnalyticsObject']=r;
				i[r]=i[r] || function(){
					(i[r].q=i[r].q||[]).push(arguments)
				},
				i[r].l=1*new Date();
				a=s.createElement(o),
				// begin custom code
				a.onload = function() {
					_gaScriptLoaded = true;
				};
				// end custom code
				m=s.getElementsByTagName(o)[0];
				a.async=1;
				a.src=g;
				m.parentNode.insertBefore(a,m)
			})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
		},

		/**
		 * Return accounts of current widget.
		 * @return {array}
		 */
		getAccounts: function() {
			return this.getOption('accounts');
		},

		/**
		 * Set accounts for current widget.
		 * @param {(string|array)} accounts
		 * @return {void}
		 */
		setAccounts: function(accounts) {
			this.setOption('accounts', this._prepareAccounts(accounts));
		},

		/**
		 * Check if accounts is seted.
		 * @return {boolean}
		 */
		checkAccounts: function() {
			return !fox.isEmpty(this.getAccounts());
		},

		/**
		 * Convert raw accounts to array.
		 * @param {(string|array)} accounts
		 * @return {array}
		 */
		_prepareAccounts: function(accounts) {
			if (fox.isString(accounts)) {
				return accounts.split(',');
			}

			if (fox.isArray(accounts)) {
				return accounts;
			}

			throw 'The first argument should be an array or a string, ' + typeOfArg + ' passed';
		},

		/**
		 * Run google analytics query for all accounts.
		 * @param {Object} params Must contain "method" property
		 * @return {void}
		 */
		query: function(params) {
			fox.each(this.getOption('accounts'), function(account, index) {
				this._query(params, account, index);
			}, this);
		},

		/**
		 * Create tracker, if not exists. Tracker is transport of google analytics.
		 * @param {string} account
		 * @param {string} trackerName alias for tracker
		 * @return {void}
		 */
		_createTracker: function(account, trackerName) {
			if (!fox.isEmpty(this._trackersInfo) && !fox.isEmpty(this._trackersInfo[trackerName]) && this._trackersInfo[trackerName] === true) {
				return;
			}

			var cookieDomain = this.getOption('cookieDomain') || 'auto';
			ga('create', account, cookieDomain, trackerName);//, {siteSpeedSampleRate: 10}
			this._trackersInfo[trackerName] = true;
		},

		/**
		 * Generate tracker name for tracker index.
		 * @param {number} index
		 * @return {string}
		 */
		_getTrackerNameById: function(index) {
			return 'tracker' + index;
		},

		/**
		 * Run google analytics query.
		 * @param {Object} params Must contain "method" property
		 * @param {string} account
		 * @param {number} index Index of tracker and account
		 * @return {void}
		 */
		_query: function(params, account, index) {
			var trackerName = this._getTrackerNameById(index);
			this._createTracker(account, trackerName);
			this._setTrackerDimensions(trackerName);

			if (fox.isObject(params.params)) {
				ga(trackerName + '.send', params.method, params.params);
			} else {
				ga.apply(this, [trackerName + '.send', params.method].concat(params.params));
			}
		},

		/**
		 * Set default google dimensions for tracker with name "trackerName"
		 * @param {string} trackerName
		 * return {void}
		 */
		_setTrackerDimensions: function(trackerName) {
			ga(trackerName + '.set', 'dimension1', fox.isEmpty(fox.site.member) ? "0" : "1");
		},

		/**
		 * Track pageview.
		 * @param {string} page Name of tracked page
		 * @return {void}
		 */
		trackPageview: function(page) {
			if (this._prevTrackedPage === page) {
				return;
			}

			this.query({method: 'pageview', params: {page: '/' + page}});
			this._prevTrackedPage = page;
		},

		/**
		 * Track timing
		 * @param {array} params Example: ['api', 'getSocialNetworkList', 100, 'api']
		 * It is meaning [timingCategory], [timingVar], [timingValue], [timingLabel]
		 * @return {void}
		 */
		trackTiming: function(params) {
			this.query({method: 'timing', params: params});
		},

		/**
		 * Track event
		 * @param  {object} params Example: {'eventCategory': 'iPhone banner', 'eventAction': 'closed'}
		 * @return {void}
		 */
		trackEvent: function(params) {
			this.query({method: 'event', params: params});
		},

		/**
		 * Load linker and set linker param (after ga script loaded).  More information
		 * in https://developers.google.com/analytics/devguides/collection/analyticsjs/cross-domain
		 * @return {void}
		 */
		addLinker: function() {
			if (!this.checkAccounts()) {
				return;
			}

			ga('require', 'linker');

			var
				trackerId = 0,
				account = this.getOption('accounts')[trackerId],
				trackerName = this._getTrackerNameById(trackerId)
			;

			this._createTracker(account, trackerName);

			ga(
				fox.bind(
					function() {
						var tracker = ga.getByName(trackerName);
						this._linkerParam  = tracker.get('linkerParam').replace('_ga=', '');
						_gaLinkerLoaded = true;
					},
					this
				)
			);
		},

		/**
		 * Return linker param (contain cid).
		 * @return {string}
		 */
		getLinkerParam: function() {
			return this._linkerParam;
		},

		optOut: function(status) {
			fox.each(this.getOption('accounts'), function(account, index) {
				window['ga-disable-' + account] = status;
			}, this);
		},

		setSettings: function(settings) {
			fox.each(this.getOption('accounts'), function(account, index) {
				ga(account + '.set', settings);
			}, this);
		}

	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Grid', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true
			});
			this.callParent('configure', arguments);
		},

		getDataLayer: function() {
			return this.dl;
		},

		initDl: function() {
			this.embedWidgetsFromOptions();

			var w = this.wom1('#dl');
			if (w) {
				w.run();
				this.dl = w;
				return;
			}
			
			var dl = this.getOption('dataLayer') || this.getOption('dl');

			if (dl && (dl._objClass == 'DataLayer' || dl._widgetClass == 'Datalayer')) {
				this.dl = dl;
			} else if (dl && fox.isString(dl)) {
				this.dl = fox.wom.selectFirst(dl, this);
			} else if (this.getOption('dlMethod')) {
				this.dl = fox.createDataLayer().setMethod(this.getOption('dlMethod'));
				this.dl.set(dl || {});
			}

			if (this.dl && this.dl.run) {
				this.dl.run();
			}
		},

		initChild: function(alias, options) {
			if (!options.widget) {
				options.widget = 'Grid_' + fox.ucfirst(alias);
				if (options.plugin) {
					options.widget = options.widget + '_' + fox.ucfirst(options.plugin);
				}
			}
			
			if (alias == 'list' && !this.getOption('template')) {
				fox.objectSet(options, ['embed.widget'], '@parent ' + this.getOption('embed.widget'));
				fox.objectSet(options, ['embed.container'], this.getOption('embed.container') || this.getOption('container'));
				this.visual = false;
			}
			this.embedWidget(alias, options.widget, options);

		},

		preparing: function() {
			this.callParent('preparing', arguments);
			this.initDl();
		},

		init: function() {
			this.callParent('init', arguments);

			if (this.dl.run) {
				this.dl.run();
			}

			this.registerOptions('.Controller', {dl: this.dl, dataLayer: this.dl});
			//rpp check
			fox.each(['list', 'pager', 'rpp'], function(alias) {
				if (this.getOption(alias)) {
					this.initChild(alias, this.getOption(alias) || {});
				}
			}, this);

			this.forwardEvent(this.dl, 'startWorking');
			this.forwardEvent(this.dl, 'stopWorking');


			this.handleEvent(this.dl, 'loaded', fox.bind(function() {
				this.dispatchEvent('updated');
			}, this), {prefix: 'gridUpdated'});
		},

		running: function() {
			if (!this.getOption('externalLoad')) {
				this.dl.load();
			}
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid List Widget */

(function(fox) {

	fox.registerWidget('Grid_List', {

		//Widget config
		initCollection: function() {
			this.collection = this.dl;
		},

		addFieldsToDatalayer: function(plainVariables) {
			this.dl.addFields(plainVariables);
		},

		init: function() {
			this.plainVariables = [];
			this._readyToRender = false;
			if (fox.oop.instanceOf(this.getParent(), 'Grid')) {
				this.dl = this.getParent().dl;
			} else {
				this.initDl();
			}

			
			this.callParent('init', arguments);
			this.hookWrapper('addFieldsToDatalayer', this.plainVariables);

			this.forwardEvent(this.dl, 'startWorking');
			this.forwardEvent(this.dl, 'stopWorking');

			this.handleEvent(this.dl, 'loaded', fox.bind(this._loaded, this), {
				'listenHistory': true,
				prefix: 'gridListInit'
			});
		},

		initTpl: function() {
			this.callParent('initTpl', arguments);
			this.plainVariables = this.row.getPlainVariables();
		},

		activate: function() {
			if (this.dl._loadStatus != 'notLoaded') {
				this._readyToRender = true;
			}
			return this.callParent('activate', arguments);
		},

		initDl: function() {
			var dl = this.getOption('dataLayer') || this.getOption('dl');

			if (dl && (dl._objClass == 'DataLayer' || dl._widgetClass == 'Datalayer')) {
				this.dl = dl;
				if (this.dl.run) {
					this.dl.run();
				}
			} else if (dl && fox.isString(dl)) {
				this.dl = fox.wom.selectFirst(dl, this);
			} else if (this.getOption('dlClass')) {
				this.dl = fox.createDataLayer().setClass(this.getOption('dlClass'));
				this.dl.set(dl || {});
			} else if (this.getOption('dlMethod')) {
				this.dl = fox.createDataLayer().setClass(this.getOption('dlMethod'));
				this.dl.set(dl || {});
			}

			if (this.dl.run) {
				this.dl.run();
			}
		},

		//Collection successfully loaded
		_loaded: function() {
			this._readyToRender = true;
			if (this.isActive()/* && this.getParent().getOption('autoRender') === true*/) {
				this.render();
			}
		}
		
	}, 'List');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid Pager Widget */

(function(fox, $) {

	fox.registerWidget('Grid_Pager', {

		//Widget config
		configure: function(options) {
			this.registerOptions('', {
				ignoreActivate: false,
				notSetTotalCount: false,
				pagesCount: 10,
				handleDom: {
					setPage: {
						target: '.page',
						event: 'click',
						callback: function(el, alias, scope) {
							scope.changePage($(el).attr('data-page'));
						}
					}
				},
				'wrapMethods.changePage': true
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this._pagerData = {};
			this.dl = this.options.dataLayer;
			this.dl.initPagerMode(this.getOption('notSetTotalCount'));
			this.navPrefix = this.options.navigatorPrefix;

			if (this.navPrefix) {
				this.handleEvent(fox.Navigator, 'modified_' + this.navPrefix, '_loadPage', {
					listenHistory: true
				});
			}

			this.handleEvent(this.dl, 'loaded', fox.bind(function() {this._calculatePagerData();this.render();} , this));
		},

		_calculatePagerData: function() {
			var data = fox.clone(this.dl.getPagerData()), start, leftOffset, rightOffset, end;

			if (data.total < 2) {
				this.removeFromDom();
				this._indom = false;
				this._rendered = false;
				this._pagerData = data;
			} else {
				data.cp = Number(data.cp);
				data.first = 1;
				var cnt = this.options.pagesCount;

				leftOffset = Math.floor(cnt/2);
				rightOffset = leftOffset;

				if (cnt % 2) {
					leftOffset--;
				}

				//calculating pages block
				if (data.cp <= leftOffset) {
					start = 1;
					rightOffset = rightOffset + (leftOffset - data.cp);
				} else {
					start = data.cp - leftOffset;
				}

				if (data.total <= (data.cp + rightOffset)) {
					end = data.total;
				} else {
					end = data.cp + rightOffset;
					if(end > data.total) {
						end = data.total;
					}
				}

				//do you need to show spacers
				if (start > data.first && cnt < data.total ) {
					data.startSpacer = 1;
				} else {
					data.startSpacer = 0;
				}

				if (data.cp + 2 < data.total) {
					data.endSpacer = 1;
				} else {
					data.endSpacer = 0;
				}

				data.pages = [];

				for (var i = start, l = end; i <= l; i++) {
					data.pages.push({
						id: i,
						page: i,
						current: i === data.cp,
						first: i === data.first,
						last: i === data.total,
						firstInBlock: i === start,
						lastInBlock: i === end
					});
				}
				this._pagerData = data;
			}
		},

		changePage: function(page) {
			if (page == 'next') {
				page = this.dl.getNextPageNumber();
			}

			if (page == 'prev') {
				page = this.dl.getPrevPageNumber();
			}

			if (page === 0) {
				return;
			}

			if (this.navPrefix) {
				fox.Navigator.set(this.navPrefix, page, false);
			} else {
				this._loadPage(page);
			}
			return this;
		},

		_loadPage: function(page) {
			if (this._pagerData.cp != page) {
				this.dl.changePage(fox.isNumeric(page) ? page : 1);
			}
		},

		rendering: function() {
			if (fox.isSet(this._pagerData) && fox.isSet(this._pagerData.total) && (this._pagerData.total < 2)) {
				this.fragment = this.createFragment();
				return ;
			}

			if (!this.row) {
				this.row = this.getTemplater(this.getOption('tpl.container'));
			}

			this.fragment = this.row.setData(this._pagerData).compile();
		},

		activate: function() {
			this._calculatePagerData();
			if (!this.options.ignoreActivate && this._pagerData.cp != 1 && !this.navPrefix) {
				this._loadPage(1);
			}

			if (this.getOption('resetPageOnActivate') && (fox.Navigator.get(this.navPrefix) != this._pagerData.cp)) {
				this._loadPage(1);
			}

			this.callParent('activate', arguments);
		}
	});

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid Pager Widget */

(function(fox) {

	fox.registerWidget('Grid_Pager_Dragdealer', {

		//Widget config
		configure: function(options) {
			this.registerOptions('', {
				'handleDom.setPage': {
					event: 'click',
					callback: 'domEventHandler'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.dl = this.options.dataLayer;
			this.dl.initPagerMode();
			this.ddPage = 1;
			this.pageIndex = {};
			this.currentPageIndex = 0;
			this.pagesThreshold = Math.floor(this.options.pagesCount / 2) - 2;
			this.handleEvent(this.dl, 'loaded', fox.bind(this._applyDlChanges, this));
		},

		_applyDlChanges: function() {
			this.pagerData =  this.dl.getPagerData();
			if (this.pagerData.total < 2) {
				this.removeFromDom();
				this._indom = false;
				this._rendered = false;
			} else {
				if (!this._indom || (this.pagerData.total != this.ddTotal)) {
					this.render();
				} else {
					this.slideToPage(this.pagerData.cp);
				}
			}
		},

		slideToPage: function(page) {
			if (this.ddPage != page) {
				return this.dd.setStep(page);
			}
			var start, end, i, p, el, cel;
			start = page - this.pagesThreshold;
			if (start < 1) {
				start = 1;
			}
			end = start + this.options.pagesCount;
			if (end > this.pagerData.total) {
				end = this.pagerData.total;
			}
			fox.dom.removeClass(this.options.currentPageClass, this.pageNodes[this.currentPageIndex]);
			for (i = 0; i < this.options.pagesCount; i++) {
				el = this.pageNodes[i];
				p = i + start;
				if (p > end) {
					this.pageNodes[i].innerHTML = '';
					this.pageNodes[i].setAttribute('data-page', 0);
					this.pageIndex[i] = 0;
				} else {
					if (p == this.pagerData.cp) {
						fox.dom.addClass(this.options.currentPageClass, this.pageNodes[i]);
						this.currentPageIndex = i;
					}

					this.pageNodes[i].innerHTML = p;
					this.pageNodes[i].setAttribute('data-page', p);
					this.pageIndex[i] = p;
				}
			}
		},

		domEventHandler: function (el, alias, e) {
			if (alias == 'setPage') {
				var page = el.getAttribute('data-page');
				if (!page) {
					return;
				}
				this.dl.changePage(page);
				return;
			}
			return this.callParent('domEventHandler', arguments);
		},

		_ddAnimationCallback: function(x) {
			if (this.dd && this.dd.stepRatios) {
				this.ddPage = x ? this.dd.stepRatios.indexOf(x) : this.dl._pager.cp;
				if(!this.ddPage) this.ddPage = 1;
			};
			this.slideToPage(this.ddPage);
		},

		rendering: function() {
			if (!fox.isSet(this.pagerData) || !fox.isSet(this.pagerData.total) || (this.pagerData.total < 2)) {
				this.fragment = this.createFragment();
				return ;
			}

			this.fragment = fox.Zen(this.options.template);
			this._pagesEl = fox.dom.select(this.options.pagesContainer, this.fragment).shift();
			//TODO check _pagesEl
			this.pageFragment = fox.Zen(this.options.tpl.page).firstChild;
			for (var i = 0, l = this.options.pagesCount; i < l; i++) {
				this._pagesEl.appendChild(this.pageFragment.cloneNode(true));
			}

			this.pageNodes = fox.dom.select(this.options.page, this.fragment);
			this._pagesCountEl = [];
			if (this.options.pagesCountContainer) {
				this._pagesCountEl = fox.dom.select(this.options.pagesCountContainer, this.fragment);
			}
		},

		addedToDom: function() {
			if (!fox.isSet(this.pagerData) || !fox.isSet(this.pagerData.total) || (this.pagerData.total < 2)) {
				return ;
			}
			this.ddTotal = this.pagerData.total;
			this.dd = new Dragdealer(this.options.dragdealerContainer, {
				steps: this.pagerData.total, snap: true, animationCallback: fox.bind(this._ddAnimationCallback, this)
			});
			fox.each(this._pagesCountEl, function(pc) {pc.innerHTML = this.pagerData.total}, this);
		}

	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Rpp Widget */

(function(fox) {

	var _options = {
			variants: {
				'default': '6x10' //also it can be array [10, 20, 30, 40, 50, ...]
			},
			tpl: [
				{
					container: {
						'default': 'select.fox-grid-rpp-container'
					},
					variant: {
						'default': 'option.fox-grid-rpp-variant[value=$[variant]]{$[variant]}'
					}
				}
			],
			handlers: [
				{
					changeRpp: [
						{target: {'default': '.fox-grid-rpp-container'}},
						{event: {'default': 'change'}}
					]
				}
			]
		};

	fox.registerWidget('Grid_Rpp', {

		//this.properties
		variants: null,

		//this.methods
		configure: function(options) {
			this['prepareOptions'](options, _options);
			this.callParent('configure', arguments);
		},

		init: function() {
			this.dl = this.options.dataLayer;
			this.prepareVariants();
			this.handleEvent(this.dl, 'loaded', fox.bind(this._applyDlChanges, this));
		},

		'domEventHandler': function(node, alias, e) {
			switch(alias) {
				case 'changeRpp':
					var value = node.dataset.variant || node.value;
					this.rpp = value;
					this.dl.setRpp(this.rpp).load();
					break;
				default:
					return callParent('domEventHandler', arguments);
			}
		},

		_applyDlChanges: function() {
			if (!this._indom) {
				this.render();
			} else {
				this.visualSwitchRpp(this.dl.getRpp());
			}
		},

		visualSwitchRpp: function(value) {
			this.select.value = value;
		},

		'rendering': function() {
			this.fragment = fox.Zen(this.options.tpl.container);
			this.select = this.fragment.firstChild;
			for (var i = 0, l = this.variants.length; i < l; i++) {
				this.select.appendChild(fox.Zen(this.options.tpl.variant, [{id: i, variant: this.variants[i]}]));
			}
		},

		prepareVariants: function() {
			if (fox.isArray(this.options.variants)) {
				return this.variants = this.options.variants;
			}
			var tmp = this.options.variants.split('x'),
				steps = parseInt(tmp[0]),
				modifier = parseInt(tmp[1]);
				this.variants = [];

			for(var i = 1; i <= steps; i++) {
				this.variants.push(modifier * i);
			}
			return this.variants;
		}

	});

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {

	var _ = {
		initCollection: function () {
			this.dataModel = [];
			this.dataModelLastUpdate = [];
			this.idStart = 1;

			_.updateCollection.call(this, {method: 'add', data: this.getOption('collection') || []});
		},

		transformToDataModel: function (c) {
			var getModObject;

			getModObject = function (data, _id) {
				var
					object = {};

				object.value = data;

				Object.defineProperty(object, '_id', {
					enumerable: true,
					configurable: false,
					writable: false,
					value: _id
				});

				return object;
			};

			if (fox.isArray(c)) {
				return c.map(function (v) {
					return getModObject(v, this.idStart++);
				}, this);
			} else if (fox.isObject(c)) {
				return getModObject(c, this.idStart++);
			} else {
				return getModObject({v: c}, this.idStart++);
			}
		},

		getNodeByItem: function (id) {
			var item;

			item = this.dataModel[id];

			return item &&
				item._domNode &&
					item._domNode.filter(function (el) {return el.nodeType === 1;}) || false;
		},

		setLastDataModel: function (data) {
			this.dataModelLastUpdate = data;
		},

		updateCollection: function (params) {
			var
				method = params.method,
				data = params.data,
				position = params.position,
				id = params.id,
				dm
			;

			switch (method) {
				case 'add':
					position = position === undefined ? 'bottom' : position;

					if (fox.isArray(data)) {
						dm = _.transformToDataModel.call(this, data);

						if (this.dataModel.length === 0) {
							this.dataModel = dm;
						} else {
							if (position === 'top') {
								this.dataModel = dm.concat(this.dataModel);
							} else if (fox.isNumeric(position)) {
								var a, b;

								b = this.dataModel.slice(position);
								a = this.dataModel.slice(0, position);

								this.dataModel = a.concat(dm.concat(b));
							} else {
								this.dataModel = this.dataModel.concat(dm);
							}
						}
					} else {
						dm = _.transformToDataModel.call(this, data);

						if (this.dataModel.length === 0) {
							this.dataModel = [dm];
						} else {
							if (fox.isNumeric(position)) {
								this.dataModel.splice(position, 0, dm);
							} else {
								this.dataModel[position === 'top' ? 'unshift' : 'push'](dm);
							}
						}
					}

					_.setLastDataModel.call(this, this.isEmbedded() === true ? fox.isArray(dm) ? dm : [dm] : this.dataModel);

					return this.dataModelLastUpdate.map(function (v) {
						return v._id;
					});
				case 'update':
					if (id !== undefined) {
						var item = this.dataModel[id];

						if (item && this._active) {
							item.value = data;

							_.setLastDataModel.call(this, [item]);
						} else {
							_.setLastDataModel.call(this, this.dataModel);
						}
					} else {}

					break;
				case 'remove':
					if (id !== undefined) {
						var item = this.dataModel[id];

						if (item) {
							if (item._domNode && item._domNode.length) {
								for (var i = item._domNode.length; i--;) {
									if (item._domNode[i].parentNode) {
										item._domNode[i].parentNode.removeChild(item._domNode[i]);
									}
								}
							}

							this.dataModel.splice(id, 1);
						}
					} else {
						this.dataModel = [];
						_.setLastDataModel([]);

						this.removeFromDom();
					}

					break;
			}
		},

		resetState: function () {
			this.setOption('embed.location', 'inside');
			_.setLastDataModel.call(this, this.dataModel);
		},

		cleanDomReference: function () {
			fox.each(this.dataModel, function (v) {
				v._domNode = null;
			});
		},

		render: function (location) {
			return this.setOption('embed.location', location || 'inside').render();
		}
	};

	fox.registerWidget('AdvancedList', {
		init: function () {
			if (fox.oop.instanceOf(this.getParent(), 'Grid') && !this.getOption('notOverrideListBehavior')) {
				this.dl = this.getParent().dl;
				
				if (this.dl) {
					this.handleEvent(this.dl, 'loaded', fox.bind(this._dlLoaded, this), {
						'listenHistory': true,
						prefix: 'gridAdvancedListInit'
					});
				}
			}

			_.initCollection.call(this);

			this.callParent('init', arguments);
		},

		running: function () {
			this.callParent('running', arguments);

			var container = this.getOption('embed.container') || this.getOption('container');
			var embedWidget = this.wom1(this.getOption('embed.widget'));

			if (embedWidget && fox.oop.instanceOf(embedWidget, 'Widget')) {
				var containerNode = embedWidget.dom1(container);

				if (containerNode && containerNode.childNodes.length) {
					containerNode.innerHTML = '';
				}
			}
		},

		resetCollection: function (c) {
			this.remove();

			if (c !== undefined) {
				this.appendItem(c);
			}
		},

		setCollection: function (c) {
			this.resetCollection(c);
		},

		appendItem: function (item, skipRender) {
			var ids = _.updateCollection.call(this, {method: 'add', data: item});

			if (skipRender !== true) {
				_.render.call(this, 'lastChild');
			}

			return ids;
		},

		prependItem: function (item, skipRender) {
			var ids = _.updateCollection.call(this, {method: 'add', data: item, position: 'top'});

			if (skipRender !== true) {
				_.render.call(this, 'firstChild');
			}

			return ids;
		},

		appendItemBefore: function (item, itemIndx, skipRender) {
			itemIndx = itemIndx - 1;

			this._referenceNodes = _.getNodeByItem.call(this, itemIndx);
			var ids = _.updateCollection.call(this, {method: 'add', data: item, position: itemIndx});

			if (skipRender !== true) {
				_.render.call(this, 'insertBefore');
			}

			return ids;
		},

		updateItem: function (item, itemIndx, skipRender) {
			itemIndx = itemIndx - 1;

			_.updateCollection.call(this, {method: 'update', data: item, id: itemIndx});

			this._referenceNodes = _.getNodeByItem.call(this, itemIndx);

			return skipRender !== true && _.render.call(this, 'replace');
		},

		remove: function (itemIndx) {
			if (itemIndx === undefined) {
				_.updateCollection.call(this, {method: 'remove'});
			} else if (fox.isArray(itemIndx)) {
				fox.each(itemIndx, function (id) {
					_.updateCollection.call(this, {method: 'remove', id: id - 1});
				}, this);
			} else {
				_.updateCollection.call(this, {method: 'remove', id: itemIndx - 1});
			}
		},
		
		embedding: function() {
            if (!this.skipRender()) {
                this.element = [];
            }

            var containers = fox.dom.select(this.requireOption('embed.container'), this.visualParent.element);

            fox.each(containers, function(container) {
                if (!this._rendered) {
                    this._render(true);
                }
                if (this.getOption('embed.location') === 'inside') {
                    container.setAttribute('data-widget-alias', this.getAlias());
                    container.setAttribute('data-widget-class', this.getClass());
                    container.setAttribute('data-widget-id', this.getId());
                }
                if (!this.skipRender()) {
                    this.hookWrapper('embedToDom', container);
                }
                this._rendered = false;
            }, this);
        },

		embedToDom: function (container) {
			this.callParent('embedToDom', arguments);
			var fragment = this.fragment;

			switch (this.getOption('embed.location')) {
				case 'lastChild':
				case 'firstChild':
					this.element = [container];
				break;
				case 'replace':
					var repEl = Array.prototype.filter.call(fragment.childNodes, function (n) {return n.nodeType === 1;});

					if (repEl.length && this._referenceNodes.length) {
						for (var i = this._referenceNodes.length - 1; i >= 0; i--) {
							container.replaceChild(repEl[i], this._referenceNodes[i]);
						}

						this.element.unshift(container);
					}

					this._referenceNodes = null;
				break;
				case 'insertBefore':
					var i;

					if (this._referenceNodes.length) {
						while (i = fragment.childNodes.length) {
							container.insertBefore(fragment.childNodes.item(i - 1), this._referenceNodes[0]);
						}

						this.element.unshift(container);
					}

					this._referenceNodes = null;
				break;
			}
		},

		afterEmbed: function () {
			this.callParent('afterEmbed', arguments);

			_.resetState.call(this);
		},

		removeFromDom: function () {
			this.callParent('removeFromDom', arguments);

			_.resetState.call(this);
		},

		deactivate: function () {
			_.cleanDomReference.call(this);

			this.callParent('deactivate', arguments);
		},

		rendering: function () {
			var insb = this.getOption('embed.location') === 'insertBefore';
			var templater = this.getTemplater(this.getOption('tpl.row'));
			var fragment = document.createDocumentFragment();
			var dl = fox.createDl();
			var dmlup = insb ? this.dataModelLastUpdate.reverse() : this.dataModelLastUpdate;
			var tplo = this.getTemplateOptions();

			fox.each(dmlup, function (v) {
				var i;
				var rowNode;
				var collectionRow = fox.mixin(v.value, tplo, {
					_id: v._id
				});

				dl.setCollection([collectionRow]);
				rowNode = templater.setData(dl).compile();

				v._domNode = [];

				while ((i = rowNode.childNodes.length)) {
					var node = rowNode.childNodes.item(insb ? i - 1 : 0);

					fragment.appendChild(node);
					v._domNode.push(node);
				}
			});

			this.fragment = fragment;
		},

		getLength: function () {
			return this.dataModel.length;
		},

		getRowNode: function (itemIndx) {
			return _.getNodeByItem.call(this, itemIndx - 1);
		},

		getDataById: function (id) {
			var
				data,
				indx,
				j = this.getLength()
			;

			for (var i = 0; i < j; i++) {
				if (this.dataModel[i]._id === Number(id)) {
					return {
						data: this.dataModel[i].value,
						indx: i + 1
					};
				}
			}

			return false;
		},

		getIndexByModel: function (model) {
			var indx = this.dataModel.indexOf(model);

			return indx !== -1 ? indx + 1 : false;
		},

		filter: function () {
			var
				arg1,
				arg2,
				_filter,
				buff = []
			;

			_filter = function (field, value) {
				return this.dataModel.filter(function (v) {
					var itemData = v.value;

					return itemData[field] && value.indexOf(itemData[field]) !== -1;
				});
			};

			if (arguments.length === 1) {
				arg1 = arguments[0];

				if (fox.isObject(arg1) && arg1.field !== undefined) {
					if (arg1.value !== undefined && !fox.isArray(arg1.value)) {
						arg1.value = [arg1.value];
					}

					return _filter.call(this, arg1.field, arg1.value);
				} else if (fox.isArray(arg1)) {
					for (var i = 0; i < arg1.length; i++) {
						if (arg1[i].field !== undefined) {
							if (!fox.isArray(arg1[i].value)) {
								arg1[i].value = [arg1[i].value];
							}

							buff.concat(_filter.call(this, arg1[i].field, arg1[i].value));
						}
					}

					return buff;
				}
			} else if (arguments.length === 2) {
				arg1 = arguments[0];
				arg2 = fox.isArray(arguments[1]) ? arguments[1] : [arguments[1]];

				return _filter.call(this, arg1, arg2);
			}
		},

		getOriginalData: function () {
			return this.dataModel.map(function (dataItem) {
				return dataItem.value;
			});
		},

		_dlLoaded: function (obj, dl, e) {
			this.setCollection(dl.getCollection());
		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid List Widget */

(function(fox, undefined) {

	fox.registerWidget('List', {
		init: function() {
			// this.setOption('$template', '@this:tpl.row');
			this.callParent('init', arguments);

			this.hookWrapper('initTpl');
			this.initCollection();
		},

		initTpl: function() {
			this.row = this.getTemplater(this.getOption('tpl.row'));
		},

		initCollection: function() {
			var source = this.getOption('collection') || [];
			var collectionApi;

			if (fox.isArray(source)) {
				this.collection = source;
			} else if (source) {
				if (fox.isString(source)) {
					collectionApi = this._wom.selectFirst(source, this);
				} else {
					collectionApi = source;
				}

				if (collectionApi) {
					collectionApi.send(collectionApi.getOption('params') || {});

					this.handleEvent(collectionApi, ['success'], fox.bind(function(data) {
						if (this.getOption('apiCustomVar')) {
							this.setCollection(fox.objectGet(data.answer, this.getOption('apiCustomVar')), this.getOption('autoRender'));
						} else {
							this.setCollection(data.answer.response, this.getOption('autoRender'));
						}
					}, this));
				}
			}
		},

		getCollection: function() {
			return this.collection;
		},

		setCollection: function(collection, render) {
			render = !render && true || render;

			this.collection = collection ;

			if (render) this.render();
			
			return this;
		},

		//Render collection
		rendering: function() {
			var emptyRow;
			var tplo = this.getTemplateOptions();

			if (this.getOption('tpl.emptyRow')) {
				emptyRow = this.getTemplater(this.getOption('tpl.emptyRow'));
			}

			if (fox.count(this.collection) === 0 && emptyRow) {
				this.fragment = emptyRow.setData(tplo).compile();
			} else if (this.row) {
				this.fragment = this.row.setData(this.collection)
					.compile(fox.isObject(this.collection) && {iterateScope: 'default'});
			}
		},

		running: function() {
			if (!this.getOption('externalLoad') && this.collectionApi) {
				this.collectionApi.send(this.collectionApi.getOption('params') || {});
			}
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Menu2', {

		running: function () {
			this.mapMenu = fox.site.getOption('map.menu');

			if (!this.mapMenu) {
				return this.callParent('running', arguments);
			}

			this.handleEvent(fox.wom.selectFirst('@root #navi'), 'modified_0', fox.bind(function (page) {
				this._handleNaviChange(page);
			}, this));

			this.callParent('running', arguments);
		},

		_handleNaviChange: function (page) {
			var sectionMatch = false;
			if (fox.isEmpty(page)) {
				page = 'home';
			}

			fox.each(this.mapMenu, function (pages, section) {
				if (section == page) {
					sectionMatch = true;
					this.dispatchEvent('pageChanged', {section: section, page: page});
				}
			}, this);

			if (!sectionMatch) {
				fox.each(this.mapMenu, function (pages, section) {

					fox.each(pages, function (list, alias) {
						if (fox.inArray(list, page)) {
							this.dispatchEvent('pageChanged', {section: section, page: alias});
						}	
					}, this);

				}, this);
			}
		}

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('Mixin', {
		configure: function(options) {
			this._hooks = {};
			this.callParent('configure', arguments);
		},

		hook: function(alias, wom, eventName, myMethod, params) {
			params = params || {};
			params.performer = this;
			params.prefix = this.getHash();

			this._hooks[alias] = this.getEm().handleHook(wom, eventName, fox.bind(this[myMethod], this), params);
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	fox.registerWidget('Mixin_DocumentWidget', {
		configure: function(options) {
			this.registerOptions('', {
				closeOtherPopups: false,
				'embed.widget': '@root'
			});

			this.callParent('configure', arguments);
		},

		isActive: function() {
			return this._active;
		},

		embed: function() {},

		show: function(data) {
			fox.each(fox.wom.select('~.Mixin_DocumentWidget'), function(w) {
				if (w.getId() != this.getId()) {
					w.hide();
				}
			}, this);
			
			if (!this._indom) {
				this.afterEmbed();
			}

			this.dispatchEvent('show', data);
		},
		
		hide: function() {
			this.dispatchEvent('hide');
		},

		deactivate: function() {
			this.hide();
		},

		isOpen: function () {
			return $(this.element).is(':visible');
		}
	});

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
	'use strict';

	fox.registerWidget('Easy_Form_Validator', {
		configure: function () {
			this._formEvents = ['submit', 'formElementsCreated', 'valueChange'];
			this._hangClassLocation = ['this', 'parentNode'];

			this.registerOptions('', {
				errorClass: 'error',
				hangClassLocation: 'this',
				defaultValidator: [{
					validator: 'length',
					options: {min: 2},
					message: 'Minimum 2 letters'
				}]
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this._requiredFields = this.requireOption('requiredFields');
			this._processing = true;
			this._validator = new fox.Validator();

			this.checkRequiredFields();

			this.hook('wrappSubmit', this.requireOption('formWidget'), 'onStartSubmit', 'validate');

			this.callParent('init', arguments);
		},

		running: function () {
			var fn;

			this._form = this.rwom1(this.getOption('formWidget'));

			fox.each(this._formEvents, function (eventName) {
				fn = this._fName(eventName);

				if (this[fn] &&
					fox.isFunction(this[fn])) {
					this.handleEvent(this._form, eventName, fn);
				}
			}, this);

			this.callParent('running', arguments);
		},

		checkRequiredFields: function () {
			if (!fox.isObject(this._requiredFields) &&
				!fox.isArray(this._requiredFields)) {
				this._processing = false;

				fox.exception('Required fields must be array or object type.');
			}
		},

		_fName: function (value) {
			return '_function_' + value;
		},

		validate: function () {
			return this._validate();
		},

		_validate: function (alias) {
			var 
				widget,
				wValue,
				v;

			v = function (_alias) {
				widget = this._form.getEmbeddedWidget(_alias);

				this._validator._clearErrors(_alias);

				if (widget) {
					this.resetElementError(widget);
					wValue = (fox.isEmpty(widget.getValue())) ? '' : widget.getValue();
					this._validator.validate(widget.getAlias(), wValue);
				} else {
					this._validator.validate(_alias, '');
				}
			};

			if (!this._processing) {
				console.log('Skipping form validation...');
				
				return true;
			}

			if (alias === undefined) {
				fox.each(this._requiredFields, v, this);
			} else {
				v.call(this, alias);
			}

			return this._validator.isValid() || this._returnNotValid();
		},

		_returnNotValid: function () {
			this.dispatchEvent('formNotValid', {
				msg: this._validator.getFieldFirstMessage(),
				errorStack: this._validator.getErrors()
			});

			this.hangStyle();

			return false;
		},

		_prepareValidators: function () {
			var widget, currentValidation;

			fox.each(this._requiredFields, function (val) {
				widget = this._form.getEmbeddedWidget(val);

				if (widget) {
					if (widget.getOption('validateOnChange') === true) {
						this.handleEvent(widget, 'valueChanged', fox.bind(function (p, _widget) {
							var	res, a = _widget.alias;
							res = this._validator.validate(a, _widget.getValue);
							if (!res) {
								var o = {};
								o[a] = this._validator.getErrors()[a];
								this.dispatchEvent('formNotValid', {
									msg: this._validator.getFieldFirstMessage(),
									errorStack: o
								});
								this.hangStyle(a);
							} else {
								this.hangStyle(a, true);
							}
						}, this));
					}

					currentValidation =  widget.getOption('validate') || this.getOption('defaultValidator');

					if (currentValidation.length) {
						fox.each(currentValidation, function (val) {
							this._validator.addRule(widget.getAlias(), val);
						}, this);
					}
				} else {
					currentValidation = this._form.getOption('formElements.' + val + '.validate') || this.getOption('defaultValidator');

					if (currentValidation.length) {
						fox.each(currentValidation, function (validator) {
							this._validator.addRule(val, validator);
						}, this);
					}
				}
			}, this);
		},

		hangStyle: function (alias, success) {
			var srcNode, widget;

			if (alias === undefined) {
				fox.each(this._validator.getErrors(), function (val, alias) {
					if ((widget = this._form.getEmbeddedWidget(alias))) {
						srcNode = this.getLocationNode(widget);
						
						fox.dom.addClass(this.getOption('errorClass'), srcNode);
					}

				}, this);
			} else {
				if ((widget = this._form.getEmbeddedWidget(alias))) {
					srcNode = this.getLocationNode(widget);
					
					fox.dom.addClass(success === true && widget.getOption('exchangeErrorClass') && this.getOption('successClass') ? this.getOption('successClass') : this.getOption('errorClass'), srcNode);
				}
			}
		},

		getLocationNode: function (widget) {
			var location, src, childW;

			if (widget.visual === false && widget.hasOwnProperty('state')) {
				childW = widget.requireEmbeddedWidget(widget.state);

				src = (childW.isEmbedded()) ?
					childW.element[0] :
					fox.dom.selectFirst(childW.getOption('embed.container'));
			} else {
				src = widget.formElement;
			}

			location = (widget.getOption('hangClassLocation')) ? 
				widget.getOption('hangClassLocation') :
				this.getOption('hangClassLocation');

			location = fox.trim(location).split(' ');

			if (this._hangClassLocation.indexOf(location[0]) !== -1) {
				if (location.length){
					fox.each(location, function (val) {
						if (val !== 'this') {
							if (fox.dom.isDomNode(src)) {
								src = src[val];
							} else {
								throw 'Element ' + widget.getAlias() + ' is not visual.';
							}
						}
					});
				}
			} else {
				throw 'Wrong "hangClassLocation" option.';
			}

			return src;
		},

		resetElementError: function (widget) {
			var srcNodes, eCl;
			
			eCl = this.getOption('errorClass');

			srcNodes = this.getLocationNode(widget);
			if (!fox.isArray(srcNodes)) {
				srcNodes = [srcNodes];
			}

			fox.each(srcNodes, function(srcNode) {
				if (fox.dom.hasClass(this.getOption('errorClass'), srcNode)) {
					fox.dom.removeClass(eCl, srcNode);

					if (widget.getOption('exchangeErrorClass') && this.getOption('successClass')) {
						fox.dom.addClass(this.getOption('successClass'), srcNodes);
					}
				}
			}, this);
		},

		_function_submit: function () {},

		_function_formElementsCreated: function () {
			this._prepareValidators();
		},

		_function_valueChange: function (changeInfo) {
			var w = this._form.getEmbeddedWidget(changeInfo.alias);

			if (w && this._validator.validate(changeInfo.alias, changeInfo.value)) {
				this.resetElementError(w);

				this._validator._clearErrors(changeInfo.alias);
			}

			return this;
		}

	}, 'Mixin');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerMixin('Grid_Lazy_Append', {
		configure: function(options) {
			console.log('connected lazy append');
			this.callParent('configure', arguments);
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/**
 * 1. 
 */
(function(fox) {
	fox.registerMixin('Grid_Lazyload', {
		configure: function(options) {
			this.callParent('configure', arguments);
		},

		init: function() {
			this.pw = this.getParent();
			this.buf = {};
			this.pending = -1;
			this.hook('wrapPagerClick', '@parent #pager', 'onStartChangePage', 'changePage');
			this.hook('wrapPagerSet', '@parent #pager', 'onStopChangePage', 'preloadNextPage');
			this.hook('listRender', '@parent #list', 'onStartRendering', 'listRender');

			this.waitEvent(this.pw, 'updated', 'firstDlLoad');
		},

		firstDlLoad: function() {
			this.mainDl = this.pw.dl;
			this.cloneDl = fox.createDataLayer();
			this.handleEvent(this.cloneDl, 'loaded', 'cloneDlLoaded');
			this.preloadNextPage();
		},

		changePage: function(num) {
			if (num == 'next') {
				num = this.mainDl.getNextPageNumber();
			}

			if (this.buf[num]) {
				this.buf[num].clone(this.mainDl).dispatchEvent('loaded');
				this.preloadNextPage();
				return false;
			}

			if (this.pending == num) {
				this.waitEvent('@this', 'cloneDlLoaded', function() {
					this.changePage(num);
				});
				return false;
			}

			return true;
		},

		preloadNextPage: function() {
			this.mainDl.clone(this.cloneDl);
			var nextNum = this.cloneDl.getNextPageNumber();
			if (nextNum) {
				this.pending = nextNum;
				this.cloneDl.nextPage();
			}

			return false;
		},

		cloneDlLoaded: function() {
			this.buf[this.cloneDl._pager.cp] = this.cloneDl.clone(fox.createDl());
			this.pending = -1;
			this.dispatchEvent('cloneDlLoaded');
		},

		listRender: function() {
			this.rwom1('@parent #list').setOption('embed.location', 'lastChild');
		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerMixin('Grid_Preloader', {
		configure: function() {
			this.registerOptions('', {
				skipPreloader: true,
				widgets: {
					stub: {
						widget: 'GridStub',
						'embed.widget': '@parent @parent @parent',
						manualRender: true,
						item: {
							title: 'My Scene',
							'_resources.primaryScene.url': '$env[design.url]/images/inactive/ph_video.jpg/w450i'
						},
						list: {
							skipPreloader: true
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		setupStubWidget: function() {
			this.registerOptions('#stub', {
				'embed.container': this.pw.getOption('embed.container') || this.pw.getOption('container'),
				'template': this.pw.getOption('template'),
				'list.tpl.row': this.getOption('list.tpl.row') || this.pw.getOption('list.tpl.row'),
				'list.container': this.pw.getOption('list.container'),
				'list.count': this.getOption('count')
			});

			if (this.getOption('item')) {
				this.registerOptions('#stub', {
					item: this.getOption('item')
				});
			}

		}
	}, 'Preloader');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerMixin('Preloader', {
		configure: function(options) {
			this.registerOptions('', {
				widgets: {
					stub: {
						widget: 'Widget',
						'embed.widget': '@parent @parent @parent',
						manualRender: true
					}
				},
				listen: ['@this']
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this._loadingQueue = {};
			this._showPreloaderTime = 250;
			this._hidePreloaderTime = 2000;
			this._preloading = false;
			this._patternQueue = {};

			this.pw = this.rwom1(this.getOption('target') || '@parent');
			this.setupStubWidget();
			if (!this.getOption('ignoreAddedToDom')) {
				this.handleEvent(this.pw, 'addedToDom', function() {
					this._preloading = false;
					//console.log('addedToDom');
					if (this._preloaderTimer) {
						//console.log('clearTimeout');
						clearTimeout(this._preloaderTimer);
					}
				});
			}
			this.callParent('init', arguments);
			setTimeout(fox.bind(this.setupWaitingWidgets, this), 50);
		},

		setupStubWidget: function() {
			if (this.getOption('template')) {
				this.registerOptions('#stub', {
					template: this.getOption('template'),
					'embed.container': this.getOption('container') || this.pw.getOption('embed.container') || this.pw.getOption('container')
				});
			}
		},

		initWithChildren: function() {
			this.stub = this.rwom1('#stub');
			this.callParent('initWithChildren', arguments);
		},

		setupWaitingWidgets: function() {
			fox.each(this.getOption('listen') || [], function(selector) {
				fox.each(this.pw.wom(selector), function(widget) {
					if ((widget.isActive() && !widget.getOption('skipPreloader')) || this.getOption('alwaysSetup') === true) {
						if (!this._patternQueue[widget.getId()]) {
							this.handleEvent(widget, 'startWorking', 'startLoader', {listenHistory: true});
							this.handleEvent(widget, 'stopWorking', 'stopLoader');
							this._patternQueue[widget.getId()] = widget;
						}
					}
				}, this);
			}, this);
		},

		startLoader: function() {
			if (window.reuseSn && !this._wom.getRoot().ready) {
				console.log(this.pw.getCaption() + ' block preload');
				return false;
			}

			if (this.skipDrawing || this.skipOnce) {
				return false;
			}

			// console.log('start');
			this._preloading = true;
			this._preloaderTimer = setTimeout(fox.bind(this.drawLoader, this), this._showPreloaderTime);
		},

		stopLoader: function() {
			if (this._preloaderTimer) {
				clearTimeout(this._preloaderTimer);
			}

			if (this.skipDrawing === true) {
				return false;
			}

			if (!this._preloading) {
				console.log(this.pw.getCaption() + ' block preload stop');
				return false;
			}

			this._preloading = false;

			if (this.getOption('renderOnStop')) {
				if (this.pw.getOption('embed.location') !== 'inside') {
					this.pw.setOption('embed.location', 'inside');
				}

				this.pw.render();
			}
		},

		drawLoader: function() {
			//console.log('draw');
			this.stub.render();
		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('Navigator', {
		configure: function() {
			this.registerOptions('', {
				hashStart: '#!/',
				updatePeriod: 100,
				basePath: '/',
				type: 'href',
				skipHandlePatterns: {
					api: ['path', '~', new RegExp('^\/api\/')],
					jsmail: ['href', '~', new RegExp('^(javascript\:|mailto\:)')],
					absolute: ['href', '~', new RegExp('^https?:\/\/')],
					hash: ['href', '=', '#']
				}
			});

			if (!fox.Navigator) {
				Object.defineProperty(fox, 'Navigator', {
					get: fox.bind(function() {return this._wom.getRoot().rwom1(this._wom.getRoot().getOption('naviPath') || '#navi');}, this)
				});
			}

			this.pages = [];
			this.callParent('configure', arguments);

			this.clickListener = function (e) {
				return this.clickHandler.call(this, e.currentTarget, e);
			}.bind(this);
		},

		addClickHandler: function(fragment, options) {
			fox.each(fox.dom.select('a', fragment), function(node) {

				if (fox.isSet((options || {}).draggable)) {
					node.setAttribute('draggable', options.draggable);
				}

				var href = node.getAttribute('href');
				if (!this.shouldProcessHref(href)) {
					return;
				}

				fox.dom.off('click', node, this.clickListener);
				fox.dom.on('click', node, this.clickListener);

				if (href.indexOf(this.urlPrefix) === 0) {
					return;
				}
				
				var arr = href.split(this.hashStart);
				if (arr[1]) {
					href = this.urlPrefix + arr[1];
				} else {
					href = this.urlPrefix + fox.trim(href, '/');
				}

				node.setAttribute('href', href);

			}, this);
		},

		init: function() {
			this.setOption('type', this.getOption('navigation.type') || this.getOption('type'));
			this.setOption('basePath', this.getOption('navigation.basePath') || this.getOption('basePath'));
			this.location = null;
			this.virtualLocation = '';
			this.objHash = false;
			this.hashStart = this.getOption('hashStart');
			this.typedAction('init');
			this.process();
			this.callParent('init', arguments);
			if (window.snListen) {
				window.removeEventListener('click', window.snListen);
				window.snHref && this.processHref(window.snHref);
			}
		},

		start: function() {

		},

		setPages: function(pages) {
			this.pages = pages;
		},

		shouldProcessHref: function(href) {
			if (!href) {
				return false;
			}
			var parts = this.parseUrl(href), res = true;
			fox.each(this.getOption('skipHandlePatterns'), function(info, alias) {
				switch (info[1]) {
					case '~':
						res = res && !info[2].exec(parts[info[0]]);
					break;
					case '=':
						res = res && (parts[info[0]] !== info[2]);
					break;
				}
			}, this);

			return res;
		},

		clickHandler: function(node, e) {
			if (node.getAttribute('target')) return true;

			e.preventDefault();
			var href = node.getAttribute('href');
			this.processHref(href);
			return false;
		},

		processHref: function(href) {
			if (!this.shouldProcessHref(href)) {
				return false;
			}

			this.typedAction('clickHandler', href);
			return true;
		},

		hash2obj: function(hash) {
			if (fox.isEmpty(hash)) {
				return {};
			}
			var arr = fox.trim(hash, '/').split('/'), obj = {}, index = 0;
			fox.each(arr, function(value, i) {
				var arr = value.split('=');
				if (arr.length > 1) {
					i = arr.shift();
					value = arr.join('=');
				} else {
					i = index++;
				}
				obj[i] = value;
			});
			return obj;
		},

		obj2hash: function(obj) {
			var hash = [];
			obj = fox.clone(obj);
			fox.each(obj, function(val, name) {
				if (fox.isNumeric(name)) {
					if (val !== undefined) {
						hash.push(val);
						delete obj[name];
					}
				}
			});

			fox.each(obj, function(val, name) {
				if (val !== undefined) {
					hash.push(name + '=' + val);
				}
			});

			return hash.join('/');
		},

		getDiff: function(oldObj, newObj) {
			var diff = {};
			fox.each(oldObj, function(val, name) {
				if (typeof newObj[name] == 'undefined') {
					diff[name] = 'deleted';
				} else if (newObj[name] != oldObj[name]) {
					diff[name] = 'changed';
				}
			});

			fox.each(newObj, function(val, name) {
				if (typeof oldObj[name] == 'undefined') {
					diff[name] = 'added';
				}
			});

			return diff;
		},

		reset: function() {
			this.location = null;
			this.virtualLocation = '';
			this.objHash = {};
		},

		process: function() {
			if (this.typedAction('checkUpdated')) {
				if (this.getOption('type') != 'virtual') {
					var parsedUrl = this.parseUrl(location.href);
					if ((parsedUrl.pathname + parsedUrl.search).indexOf(this.getOption('basePath')) !== 0) {
						return;
					}
				}
				var page = this.typedAction('preprocessHref');
				if (page === false) {
					return;
				}

				var newObj = this.hash2obj(page);
				var diff = (!this.objHash && fox.isEmpty(newObj)) ? { 0: '' } : this.getDiff(this.objHash, newObj);
				this.location = page;
				this.objHash = newObj;

				fox.each(diff, function(val, name) {
					this.dispatchEvent(val + '_' + name, this.get(name));
					this.dispatchEvent('modified_' + name, this.get(name));
				}, this);

				if (!fox.isEmpty(diff)) {
					this.dispatchEvent('modified', diff);
				}
			}
			return this;
		},

		parseUrl: function(url) {
			var pattern = "^(([^:/\\?#]+):)?(//(([^:/\\?#]*)(?::([^/\\?#]*))?))?([^\\?#]*)(\\?([^#]*))?(#(.*))?$";
			var rx = new RegExp(pattern);
			var parts = rx.exec(url);

			var res = {};
			res.href = parts[0] || "";
			res.protocol = parts[1] || "";
			res.host = parts[4] || "";
			res.hostname = parts[5] || "";
			res.port = parts[6] || "";
			res.pathname = parts[7] || "/";
			res.search = parts[8] || "";
			res.hash = parts[10] || "";
			res.path = res.pathname;
			return res;
		},

		parseSearch: function(str) {
			if (fox.isEmpty(str)) {
				str = location.search;
			}

			str = str.indexOf('?') === 0 ? str.substr(1) : str;
			var res = {}, data = str.split('&');
			fox.each(data, function(val) {
				var tmp = val.split('=', 2);
				res[tmp[0]] = tmp[1];
			});

			return res;
		},

		get: function(name) {
			if (this.objHash[name]) {
				return this.objHash[name];
			}
			return false;
		},

		getAll: function() {
			return fox.clone(this.objHash, true);
		},

		bulkSet: function(values, skipEvent) {
			var objHash = fox.clone(this.objHash, true);
			fox.each(values, function(value, name){
				objHash[name] = value;
			});
			return this.update(objHash, skipEvent);
		},

		set: function(name, val, skipEvent) {
			var objHash = fox.clone(this.objHash, true);
			objHash[name] = val;
			return this.update(objHash, skipEvent);
		},

		update: function(obj, skipEvent) {
			var newLocation = this.urlPrefix +  this.obj2hash(obj);

			if (skipEvent && skipEvent < 2) {
				this.location = newLocation;
				this.objHash = obj;
			}

			this.typedAction('update', newLocation, skipEvent);
			return this;
		},

		typedAction: function(action) {
			switch (action) {
				case 'init':
					this.useHash = false;
					switch (this.getOption('type')) {
						case 'hash':
							this.urlPrefix = this.getOption('basePath') + this.hashStart;
							this.useHash = true;
							fox.dom.on('hashchange', this._wom.getRoot().window, fox.bind(this.process, this));
							//setInterval(fox.bind(this.process, this), 100);
						break;
						case 'href':
							this.urlPrefix = this.getOption('basePath');
							fox.dom.on('popstate', this._wom.getRoot().window, fox.bind(this.process, this));
							this.addClickHandler(this._wom.getRoot().window.document);
						break;
						case 'virtual':
							this.urlPrefix = '/';
						break;
					}
					if (this.urlPrefix[this.urlPrefix.length - 1] != '/') {
						this.urlPrefix = this.urlPrefix + '/';
					}
					return;
				break;
				case 'checkUpdated':
					switch (this.getOption('type')) {
						case 'hash':
							var source = location.href;
						break;
						case 'href':
							var source = location.href.replace(location.hash, '')
						break;
						case 'virtual':
							var source = this.virtualLocation;
						break;
					}
					return this.location !== this.typedAction('preprocessHref');
				break;
				case 'preprocessHref':
					switch (this.getOption('type')) {
						case 'href':
							if (~location.href.indexOf(this.hashStart)) {
								var arr = location.href.split(this.hashStart);
								history.replaceState(null, document.title, this.urlPrefix + arr[1]);
							}
							var page = this.parseUrl(location.href).pathname;
						break;
						case 'hash':
							if (~location.href.indexOf(this.hashStart)) {
								var page = this.parseUrl(location.href).hash.substring(this.hashStart.length - 1);
							} else {
								return '';
							}
						break;
						case 'virtual':
							var page = this.virtualLocation;
						break;
					}
					return page.replace(new RegExp('^' + this.getOption('basePath')), '');
				break;
				case 'update':
					switch (this.getOption('type')) {
						case 'hash':
							location.href = arguments[1];
							return;
						break;
						case 'href':
							history[arguments[2] ? 'replaceState' : 'pushState'](null, null, arguments[1]);
						break;
						case 'virtual':
							this.virtualLocation = arguments[1];
						break;
					}
					return this.process();
				break;
				case 'clickHandler':
					switch (this.getOption('type')) {
						case 'href':
							history.pushState(null, null, arguments[1]);
						break;
						case 'hash':
							location.href = arguments[1];
							return;
						break;
						case 'virtual':
							this.virtualLocation = arguments[1];
						break;
					}
					this.process();
				break;


			}
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(fox) {
    'use strict';

    __webpack_require__(3)(fox);

    fox.registerWidget('DomForm', {
        configure: function () {
            this.registerOptions('', {
                formSelector: 'form#base-form',
                formPath: '@parent',
                noValidate: false,
                validateOnFly: false
            });

            this.callParent('configure', arguments);
        },

        init: function () {
            this.callParent('init', arguments);

            this.ready = false;
            this._elements = {};
            this._waitForElements = [];

            this.handleEvent(this.getOption('formPath'), 'addedToDom', this.bootstrapForm.bind(this), {
                prefix: [this.getHash(), 'formContainerInDom'].join('_')
            });

            if (this.getOption('handleDom')) {
                fox.each(this.getOption('handleDom'), function (value) {
                    if (!('targetWidget' in value)) {
                        value.targetWidget = this.getOption('formPath');
                    }

                    if (value.event === 'submit' && !('callback' in value)) {
                        value.callback = this.onFormSubmit.bind(this);
                    }
                }, this);
            }
        },

        _addElement: function (type, options) {
            var ElementConstructor;

            if (typeof type === 'function') {
                ElementConstructor = type;
            } else {
                ElementConstructor = this._getBuiltinElementConstructor(type);
            }

            var element = new ElementConstructor(options, this);

            element.init();

            return this._elements[element.key] = element;
        },

        _getBuiltinElementConstructor: function (type) {
            var require__dom__type = __webpack_require__(58);
            var require__type = __webpack_require__(59);

            var module;

            function get (req, type) {
                var m = req('./' + type + '.js');

                return m(fox);
            }

            try {
                module = get(require__dom__type, type);
            } catch (e) {} finally {
                if (!module) module = get(require__type, type);

                return module;
            }
        },

        _getFormControls: function () {
            var node = this.getFormDomNode();
            var controlsSelectors = [
                'button', 'datalist', 'meter', 'progress',
                'input', 'select', 'textarea'
            ];

            return node && (node.elements || node.querySelectorAll(controlsSelectors.join(',')));
        },

        _checkFormNoValidate: function () {
            var node = this.getFormDomNode();
            var noValidate = false;

            if (node && node.nodeName.toLowerCase() === 'form') {
                if (this.getOption('noValidate') && !node.noValidate) {
                    node.noValidate = noValidate = true;
                } else if (node.noValidate) {
                    this.setOption('noValidate', (noValidate = true));
                }
            }

            return noValidate;
        },

        _dispatchFormReady: function () {
            this.ready = true;

            this.dispatchEvent('internal_form_ready');
            this.dispatchEvent('form_ready');
        },

        deactivate: function () {
            this.ready = false;

            this.callParent('deactivate', arguments);
        },

        elementToWait: function (promise) {
            this._waitForElements.push(promise);

            return this;
        },

        bootstrapForm: function () {
            var elementsOption = fox.clone(this.getOption('elements') || {});
            var noValidate = this._checkFormNoValidate();
            var validateOnFly = this.getOption('validateOnFly');

            function getWaitPromise (widget, params) {
                return new fox.Promise(function (resolve, reject) {
                    var timer = setTimeout(reject.bind(null, params), 5000);
                    
                    return widget.wait('@this', 'addedToDom', {
                        prefix: 'waitWomContainer'
                    }).then(function (resp) {
                        clearTimeout(timer);

                        return resolve(resp);
                    });
                }.bind(this));
            }

            function runElement (elementNode, name) {
                if (!name) return false;
                
                name = name.replace(/^(\w+)__\w+$/, '$1');

                var element = this.getElement(name);
                var widget;

                if (element) {
                    if (element.womContainer) {
                        widget = element.womContainer;

                        if (!widget || !widget.isEmbedded()) {
                            return this.elementToWait(getWaitPromise.call(this, widget, element.params).then(function () {
                                element.init();

                                return element.params.name;
                            }));
                        }
                    }

                    return element.init();
                } else {
                    var elementOptions = this.getOption('elements.' + name) || {};

                    elementOptions.name = name;

                    if (noValidate) {
                        elementOptions.noValidate = noValidate;
                    } else if (validateOnFly) {
                        if (!('validateOnFly' in elementOptions)) {
                            elementOptions.validateOnFly = validateOnFly;
                        }
                    }

                    if (!('selector' in elementOptions)) {
                        elementOptions.selector = '[name="' + name + '"]';
                    }

                    if ('womContainer' in elementOptions) {
                        widget = this.wom1(elementOptions.womContainer);

                        if (!widget || !widget.isEmbedded()) {
                            return this.elementToWait(getWaitPromise.call(this, widget, elementOptions).then(function (resp) {
                                var node = resp.performer.dom1(elementOptions.selector);

                                if (!('type' in elementOptions) && fox.dom.isDomNode(node)) {
                                    elementOptions.type = node.nodeName.toLowerCase();
                                }

                                this._addElement(elementOptions.type, elementOptions);

                                return elementOptions.name;
                            }.bind(this)))
                        }
                    }

                    if (!('type' in elementOptions) && fox.dom.isDomNode(elementNode)) {
                        elementOptions.type = elementNode.nodeName.toLowerCase();
                    }

                    return this._addElement(elementOptions.type, elementOptions);
                }
            }

            fox.each(this._getFormControls(), function (node) {
                var name = node.name;

                try {
                    runElement.call(this, node, name);
                } catch (e) {
                    fox.exception(e);
                } finally {
                    delete elementsOption[name];
                }
            }, this);

            fox.each(elementsOption, runElement, this);

            if (this._waitForElements.length) {
                return fox.Promise.all(this._waitForElements).then(function () {
                    this._waitForElements = [];

                    return this._dispatchFormReady();
                }.bind(this)).catch(function (resp) {
                    this._waitForElements = [];

                    var alias = fox.isString(resp.womContainer) ?
                        resp.womContainer :
                        '@' + resp.womContainer.getId() + '#' + resp.womContainer.getAlias()

                    console.error([
                        'Problem with element: "' + resp.name + '".',
                        'Reason: womContainer with value "' + alias + '" not embedded.'
                    ].join('\n'));
                }.bind(this));
            }

            return this._dispatchFormReady();
        },

        addElement: function () {
            var formContainer = this.rwom1(this.getOption('formPath'));

            if (!formContainer.isEmbedded()) {
                throw new Error('Form container not exists in DOM tree.');
            }

            return this._addElement.apply(this, arguments);
        },

        removeElement: function (key) {
            return delete this._elements[key];
        },

        /**
         * Set value for element
         * @param {string} field
         * @param {any} value
         * @param {boolean} broadcast - true - dispatchEvent('change') for this field
         */
        setValue: function (field, value, broadcast) {
            var element = this.getElement(field);

            return element &&
                !element.skip &&
                element.setValue(value, broadcast);
        },

        /**
         * Set values
         * @param {Object} values
         */
        setValues: function (values) {
            fox.each(values || {}, function (value, key) {
                return this.setValue(key, value);
            }, this);
        },

        /**
         * Returns value for field
         * @param {string} field
         * @returns {boolean|string|Promise}
         */
        getValue: function (field) {
            var element = this.getElement(field);

            return element && element.getValue();
        },
        
        /**
         * Returns all fields values
         * @returns {Object|Promise}
         */
        getValues: function () {
            var elements = this._elements;

            function fillValues (prev, key, value) {
                prev.values[key] = value;

                return value;
            }

            var values = fox.getObjectKeys(elements).reduce(function (prev, next) {
                if (elements[next].skip) return prev;

                var value = elements[next].getValue();

                if (!('async' in prev) && fox.isPromise(value)) {
                    prev.async = value.then(function (value) {
                        return fillValues(prev, next, value);
                    });
                } else if ('async' in prev) {
                    prev.async = prev.async.then(function () {
                        return fox.isPromise(value) ? value : fox.Promise.resolve(value);
                    }).then(function (value) {
                        return fillValues(prev, next, value);
                    });
                } else {
                    prev.values[next] = value;	
                }

                return prev;
            }, {values: {}});

            if ('async' in values) return values.async.then(function () {
                return values.values;
            });

            return values.values;
        },

        /**
         * Returns element instance
         * @param {string} field
         * @returns {boolean|FormElementBase}
         */
        getElement: function (name) {
            return name in this._elements && this._elements[name];
        },

        /**
         * Reset all fields to initial value
         */
        reset: function () {
            fox.each(this._elements, function (element) {
                return element.reset();
            });
        },

        /**
         * Check for form disabling
         * @returns {boolean}
         */
        isDisabled: function () {
            return fox.getObjectKeys(this._elements).every(function (field) {
                return this.getElement(field).disabled;
            }, this);
        },

        _toggleDisabled: function (field, method) {
            var element = this.getElement(field);

            if (element) {
                var promise = this.wait('@this', method + 'd_' + field, {
                    prefix: ['internal', 'toggle', 'disable'].join('_')
                }).then(function () {
                    return this.dispatchEvent(method + 'd', [field]);
                }.bind(this));

                element[method]();

                return promise;
            } else if (!fox.isUndefined(field)) {
                return false;
            }

            return fox.Promise.all(fox.getObjectKeys(this._elements).map(function (field) {
                var element = this.getElement(field);
                var promise = this.wait('@this', method + 'd_' + field, {
                    prefix: ['internal', 'toggle', 'disable'].join('_')
                }).then(function () {
                    return field;
                });

                element[method]();

                return promise;
            }, this)).then(function (fields) {
                return this.dispatchEvent(method + 'd', fields);
            }.bind(this));
        },

        /**
         * Disable all or one element
         * @param {string} [field]
         * @returns {Promise}
         */
        disable: function (field) {
            return this._toggleDisabled(field, 'disable');
        },

        /**
         * Enable all or one element
         * @param {string} [field]
         * @returns {Promise}
         */
        enable: function (field) {
            return this._toggleDisabled(field, 'enable');
        },

        onFormSubmit: function (form, alias, w, e) {
            fox.dom.event.stop(e);

            this.submit();

            return false;
        },

        /**
         * Returns form dom node
         * @returns {DomNode}
         */
        getFormDomNode: function () {
            return this.getFormContainer().dom1(this.getOption('formSelector'));
        },

        /**
         * Returns form container widget
         * @returns {FoxBaseObject}
         */
        getFormContainer: function () {
            return this.rwom1(this.getOption('formPath'));
        },

        /**
         * Main method for recieving values
         * @return {Promise<Object>}
         */
        submit: function () {
            var args = [this.getValues()].concat(fox.clone(arguments));

            if (!this.getOption('noValidate')) {
                return this.validate().then(function (isValid) {
                    return isValid && this.callParent('submit', args);
                }.bind(this));
            }

            return this.callParent('submit', args);
        },

        /**
         * Validate form
         * @returns {Promise<boolean>}
         */
        validate: function () {
            return fox.Promise.all(fox.getObjectKeys(this._elements).map(function (key) {
                var result = this._elements[key].validate();

                return fox.isPromise(result) && result || fox.Promise.resolve(result);
            }, this)).then(function (results) {
                var isValid = results.every(function (result) {return result.result === true;});

                this.dispatchEvent(!isValid ? 'form_not_valid' : 'form_valid', results);

                return isValid;
            }.bind(this));
        }

    }, 'SimpleForm');
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./base.js": 0,
	"./input.js": 2,
	"./select.js": 6,
	"./textarea.js": 7,
	"./uploader.js": 8
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./base.js": 1,
	"./computed.js": 9
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('PasswordRecovery', {
		sendRecoveryMail: function(email, useProdDomain) {
			var api = this.getApi('recovery', {
				method: this.getOption('recoveryMethod') || 'passwordRecovery.sendRecoveryMail'
			});

			this.handleEvent(api, ['success', 'failure', 'error'], fox.bind(function(data) {
				this.dispatchEvent('sendRecoveryMail', data.answer.response);
			}, this));

			var obj = {email: email};

			if (useProdDomain) {
				obj = {email: email, domainProd: 1};
			}

			api.send(obj, false);
		},
		
		validateHash: function(hash) {
			var api = this.getApi('validate', {
				method: this.getOption('validateMethod') || 'passwordRecovery.validateHash'
			});

			this.handleEvent(api, ['success', 'error'], fox.bind(function(data) {
				this.dispatchEvent('validateHash', data.answer.response);
			}, this));

			api.send({hash: hash}, false);	
		},

		changePassword: function(hash, password, confirm) {
			var api = this.getApi('change', {
				method: this.getOption('changeMethod') || 'passwordRecovery.changePassword'
			});

			this.handleEvent(api, ['success'], fox.bind(function(data) {
				this.dispatchEvent('changePassword', data.answer.response);
			}, this));

			api.send({hash: hash, password: password, confirm: confirm}, false);
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Router', {
		configure: function() {
			this.registerOptions('', {
				'routes': {
					'@': '>home',
					'@home': '#home #home',
					'@miss' : '#home #404'
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this._compiles = [];
			this.routes = {};
			var map = this.getOption('map');
			if (map) { //old map format
				this.convertMapToRoutes(map);
			}
			if (this.getOption('routes')) {
				this.addRoutes(this.getOption('routes'));
			}
			
			if (map && map.routes) {
				this.addRoutes(map.routes);
			}

			if (this.getOption('navigator')) {
				this.handleEvent(this.getOption('navigator'), 'modified', function(diff, widget) {
					var location = [];
					fox.each(widget.objHash, function(value, name) {
						if (fox.isNumeric(name)) {
							location.push(value);
						}
					});
					this.navigate(location.join('/'));
				}, {listenHistory: true, prefix: 'foxrouter'});
			}

			var router = fox.Router || Object.defineProperty(fox, 'Router', {
				get: function() {return this._wom.getRoot().rwom1(this._wom.getRoot().getOption('routerPath') || '.Router');}.bind(this)
			});

			this.callParent('init', arguments);
		},

		navigate: function(path) {
			var passedRoute = false;

			if (path[0] === '>') {
				passedRoute = {action: path};
			} else {
				this._compiles.some(function (route) {
					var match = path.match(route.re);
					var params = {};

					if (match === null) return false;

					fox.each(route.index, function(i, name) {
						params[name] = match[i];
					});

					passedRoute = {action: route.action, params: params, path: path};
					
					return true;
				}, this);
			}

			if (passedRoute) {
				this.hookWrapper('setActiveRoute', passedRoute);
			} else {
				this.hookWrapper('setActiveRoute', {
					action: this.routes['@' + path] || this.routes['@miss'] || {},
					path: path,
					params: {}
				});
			}

			this.hookWrapper('execute');
		},

		setActiveRoute: function (route) {
			this._passedRoute = route;
		},

		execute: function() {
			var passedRoute = this._passedRoute;
			fox.log('execute', passedRoute);

			if (fox.isObject(passedRoute.action) &&
				passedRoute.action.hasOwnProperty('checker') &&
				fox.isFunction(passedRoute.action.checker)) {
				var checkerRes = passedRoute.action.checker(passedRoute);

				if (!checkerRes) {
					passedRoute.action = passedRoute.action.action;
				} else {
					return this.navigate(checkerRes);
				}
			}

			if (fox.isFunction(passedRoute.action)) {
				return this.navigate(passedRoute.action(passedRoute));
			}
			if (fox.wom.isSelector(passedRoute.action)) {
				var w = fox.wom.selectFirst(passedRoute.action), parents, parent;
				if (!w) {
					parents = passedRoute.action.split(' ').reverse();
				} else {
					parents = [w];
					parent = w.getParent();
					while (parent) {
						if (parent.isActive()) {
							break;
						}
						parents.push(parent);
						parent = parent.getParent();
					}
				}

				var prefix = '@root ', fail;
				var fail = parents.reverse().some(function (w) {
					if (fox.wom.isSelector(w)) {
						prefix = prefix + w + ' ';
						w = fox.wom.selectFirst(prefix);

						if (!w) {
							console.log('Cannot find action widget ', passedRoute);
							return true;
						}
					}

					var parent = w.getParent();
					var oldValue = parent.getOption('widgetGroupInfo.' + w.getGroup() + '.manualActivation');
					parent.setOption('widgetGroupInfo.' + w.getGroup() + '.manualActivation', true);
					parent.switchEmbeddedWidget(w.getAlias(), passedRoute.params);
					parent.setOption('widgetGroupInfo.' + w.getGroup() + '.manualActivation', oldValue);

					return false;
				});
				
				if (fail) return;

				if (this._wom.getRoot().handleFoxReady) {
					this._wom.getRoot().handleFoxReady();
				}
			} else if (passedRoute.action[0] == '>') {
				var redirect = passedRoute.action.substr(1);
				if (redirect.indexOf('http') === 0) {
					fox.Navigator.update({0: 'home'}, true);
					document.location.href = redirect;
				} else {
					if (redirect[0] == '>') {
						fox.Navigator.update({0: redirect.substr(1)}, 2);
					} else {
						fox.Navigator.set(0, redirect);
					}
				}
			}
		},

		convertMapToRoutes: function(map) {
			var routes = {};
			fox.each(map.pages, function(widgetAlias, pageAlias) {
				if (widgetAlias[0] == '@') {
					routes[pageAlias + '(/*tail)'] = widgetAlias.replace('@', '>');
				} else {
					routes[pageAlias + '(/*tail)'] = '#' + widgetAlias + ' #' + pageAlias;
				}
			}, this);
			fox.each(map.denied, function(reason, pageAlias) {
				var action = reason;
				while (map.special[action] && map.special[action] != action) {
					action = map.special[action];
				}
				
				if (!action) {
					return;
				}
				
				if (fox.isFunction(action)) {
					routes[pageAlias + '(/*tail)'] = action;
				} else {
					routes[pageAlias + '(/*tail)'] = routes[action + '(/*tail)'] || routes[action] || function() {return 'join'};
				}
			}, this);
			this.addRoutes(routes);
		},

		addRoute: function(route, action) {
			this.routes[route] = action;
			this._compile();
		},

		addRoutes: function(routes) {
			this.routes = fox.merge(this.routes, routes);
			this._compile();
		},

		_compile: function() {
			var wAddendum = function(str) {
				return str.match(/^>*/g, str)[0].length - str.match(/^<*/g, str)[0].length;
			};var tmp = {};
			var routes = fox.getObjectKeys(this.routes).sort(function(a, b) {
				var aWeight = a.split(/[*:/]/).length + wAddendum(a),
					bWeight = b.split(/[*:/]/).length + wAddendum(b);tmp[a]=aWeight;tmp[b]=bWeight;
				return aWeight < bWeight ? 1 : (aWeight == bWeight ? 0 : -1);
			});
			this._compiles = [];
			var optionalParam = /\((.*?)\)/g;
			var namedParam    = /(\(\?)?:(\w+)/g;
			var splatParam    = /\*(\w+)/g;
			var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
			var addendumParam = /^([<>]*)/g;
			
			fox.each(routes, function(route) {
				if (route[0] == '@') {
					return;
				}
				var tmp = route.replace(escapeRegExp, '\\$&')
					.replace(addendumParam, '')
					.replace(optionalParam, '($1)?')
					.replace(namedParam, function(match, optional, name) {
						return optional ? match : '(<' + name + '>[^/?]+)';
					})
					.replace(splatParam, '(<$1>[^?]*?)');
				var index = {};
				tmp = tmp.replace(/\((\<(\w+)\>)/g, function(match, tag, name, len, source) {
					index[name] = source.substr(0, len).split('(').length;
					return '(';
				});

				this._compiles.push({re: new RegExp('^' + tmp + '(?:\\?([\\s\\S]*))?$', 'i'), action: this.routes[route], index: index});
			}, this);
		}

	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('App', {
		__constructor: function () {
			this.callParent('__constructor', arguments);
			this.ready = false;
			this.environment = {};
		},

		configure: function(options) {
			if (typeof startTime !== 'undefined') {
				this._loadTime = new Date().getTime() - startTime;
			} else {
				this._loadTime = false;
			}

			this.registerOptions('', {
				widgets: {
					logoutApi: {
						widget: 'Api',
						method: 'site.authorizer.logout'
					},
					navi: {
						womPriority: 2,
						widget: 'Navigator',
						'$navigation': '@root:navigation'
					},
					socket: {
						womPriority: 1,
						widget: 'Socket'
					},
					router: {
						womPriority: 1,
						widget: 'Router',
						'$map': '@root:map',
						'navigator': '@root #navi'
					}
				},
				handleWom: {
					logout: {
						widget: '#logoutApi',
						event: 'ready',
						callback: function() {
							window.location.reload();
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		handleFoxReady: function(waitTime) {
			if (!this._readyHandler) {
				this._readyHandler = {};
				this.handleEvent('~.Api', 'startWorking', function(data, api) {
					if (!this._readyHandler.collecting) {
						return;
					}

					if (!this._readyHandler.stopWaitingTimeout) {
						this._readyHandler.stopWaitingTimeout = setTimeout(fox.bind(function () {
							this._readyHandler.collecting = false;
						}, this), 1000);
					}
					if (!this._readyHandler.waitApi[api.getId()]) {
						this._readyHandler.waitApi[api.getId()] = true;
						this._readyHandler.count++;
					}
				}, {prefix: 'foxReady'});
				this.handleEvent('~.Api', 'stopWorking', function(data, api) {
					if (!this._readyHandler.working) {
						return;
					}

					if (this._readyHandler.waitApi[api.getId()]) {
						this._readyHandler.waitApi[api.getId()] = false;
						this._readyHandler.count--;
						if (!this._readyHandler.count) {
							this._readyHandler.working = false;
							setTimeout(function() {
								fox.ready = true;
								this.ready = true;
								this.dispatchEvent('fox_ready');
								window.postMessage("fox_ready", "*");
							}.bind(this), 500);
						}
					}
				}, {prefix: 'foxReady'});
			}
			if (this._readyHandler.working) {
				return;
			}
			this._readyHandler.waitApi = {};
			this._readyHandler.count = 0;
			this._readyHandler.collecting = true;
			this._readyHandler.working = true;
			this._readyHandler.stopWaitingTimeout = null;
			this._readyHandler.maxTime = setTimeout(fox.bind(function () {
				if (this._readyHandler.working && !this._readyHandler.count) {
					this._readyHandler.collecting = false;
					this._readyHandler.working = false;
					fox.ready = true;
					this.ready = true;
					window.postMessage("fox_ready", "*");
					this.dispatchEvent('fox_ready');
				}
			}, this), waitTime || 500);
		},

		init: function() {
			this.registerOptions('~.Widget', {
				'templateEnv.env': this.environment
			});
			
			this.callParent('init', arguments);
			this.customInit();
		},

		initWithChildren: function() {
			this.handleFoxReady(3000);
			this.callParent('initWithChildren', arguments);
			this.embedWidgets(this.getOption('map.widgets'), true);

			this.rwom1('#navi').start();
		},
		 
		setElement: function(node) {
			this.element = node;
		},

		running: function() {
			if (!this.element) {
				this.element = document;
			}

			this.afterEmbed();

			var ga = this.wom1('#googleAnalytics');

			if (this._loadTime && ga) {
				ga.trackTiming(['load', 'app', this._loadTime, 'app', 100]);
			}
		},

		//TODO remove 
		
		gotoPage: function(alias, params) {
			var skipEvent;

			if (fox.isUndefined(alias)) {
				alias = 'home';
			}

			if (params) {
				params[0] = alias;
			} else {
				params = {0: alias};
			}

			if (fox.isSet(params.skipEvent)) {
				skipEvent = params.skipEvent;
				delete params.skipEvent;
			} else {
				skipEvent = null;
			}

			this.rwom1('#navi').update(params, skipEvent);

			if (skipEvent) {
				this._gotoPage(alias);
			}
		},
		
		runPage: function(alias, params) {
			this.gotoPage(alias, params);
		},

		_gotoPage: function(alias) {
			this.rwom1('#router').navigate(alias);
		},

		customInit: function() {
			if (document.location.href.indexOf('splash=1') !== -1) {
				fox.cookie.set('splash', 1);
			}

			this._customData = {};

			this.dl = this._wom.loadWidget('Datalayer').set(this.getOption('site'));
			
			this.page = {};
			this.layout = {};

			this.registerOptions('.Site_Layout', {'embed.container': this.getOption('container') || 'body .wrapper'});
			
			this.setEnv('cookie', fox.cookie.getAll());
			
			if (this.options.design && !this.getEnv('design')) {
				this.setEnv('design', this.options.design);
			}
			
			if (this.options['billing'] && !this.getEnv('billing')) {
				this.setEnv('billing', this.options.billing);
			}
			
			if (this.options['public'] && !this.getEnv('public')) {
				this.setEnv('public', this.options['public'] || {});
			}

			if (this.options.member) {
				this.member = fox.hydrateDl(this.options.member);
				this.setOption('$map', '@this:mapMember');

				this.registerOptions('~.Widget', {
					'templateEnv.member': this.member
				});
			} else {
				this.member = false;
				this.setOption('$map', '@this:mapGuest');
			}

			if (this.options.client) {
				this.client = this.options.client;
			} else {
				this.client = false;
			}

			this.registerOptions('~.Api', {'domain': this.getOption('siteDomain')});
		},

		setCustomData: function(name, data) {
			this._customData[name] = data;
			return this;
		},

		getCustomData: function(name) {
			return this._customData[name]; 	
		},

		cleanCustomData: function(name) {
			delete this._customData[name];
			return this;
		},

		login: function(member, hash, redirectHash) {
			if (member.collection) {
				this.member = fox.hydrateDl(member);
			} else if (member) {
				this.member = fox.createDl().addObject(member);
			} else {
				this.member = false;
			}

			this.dispatchEvent('logged', member);
		},

		logout: function() {
			this.member = false;
			this.rwom1('#logoutApi').send();
		},

		setEnv: function() {
			var args = fox.clone(arguments);

			if (args.length === 1) {
				fox.each(args[0], function (value, path) {
					if (fox.isNumeric(path) && value.path && value.value) {
						return this.setEnv(value.path, value.value);
					}

					return this.setEnv(path, value);
				}, this);
			} else if (args.length === 2) {
				fox.objectSet(this.environment, args[0], args[1]);
			}
			
			return fox;
		},

		getEnv: function(path) {
			return fox.objectGet(this.environment, path);
		},
	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('Site_Layout', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				active: false,
				pageContainer: '#container',
				dontReuseSnByHash: true,
				'widgetGroupInfo.pages.manualActivation': true
			});

			this._active = false;

			this.callParent('configure', arguments);
		},

		init: function() {
			if (!this.getOption('template')) {
				this.setOption('template', this._widgetClass);
			}

			this.registerOptions('.Site_Page', {'embed.container': this.getPageContainer()});

			this.callParent('init', arguments);
		},

		activating: function() {
			fox.site.layout = {
				widget: this,
				alias: this.alias,
				info: {}
			};

			return this.callParent('activating', arguments);
		},

		runPage: function() {
			var cp = fox.site.getCurrentPage();
			this.getParent().switchEmbeddedWidget(this.alias);

			fox.site.page = {
				widget: this.rwom1('#' + cp.alias),
				alias: cp.alias,
				info: this.getOption('widgets.' + cp.alias)
			};

			var page = this.rwom1('#' + cp.alias);
			page._prepare();
			page.runPage();
		},

		getPageContainer: function() {
			return this.getOption('pageContainer');
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Widget */
(function(fox) {

	fox.registerWidget('Site_Page', {
		
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				active: false,
				description: '',
				keywords: '',
				dontReuseSnByHash: true
			});
			this._active = false;
			this._controlledParams = {};

			this.callParent('configure', arguments);
		},

		init: function() {
			if (this.getOption('naviParamsControl')) {
				this._readyToRender = false;
				this.handleEvent(fox.Navigator, 'modified', 'controlledNaviParamsHandler');
			}

			if (!this.getOption('template')) {
				this.setOption('template', this._widgetClass);
			}
			
			this.callParent('init', arguments);
			this._sitepage = this.alias;
		},

		activating: function() {
			fox.site.page = {
				widget: this,
				alias: this.alias,
				info: {}
			};
			return this.callParent('activating', arguments);
		},

		runPage: function() {
			this.getParent().switchEmbeddedWidget(this.alias);
		},

		setTitle: function() {
			var st = this._wom.getRoot().dl.getObjectValue('title') || 'MC',
				pt = this.getOption('title');
				pt = fox.isFunction(pt) ? pt.call(null) : pt;
			document.title = (pt ? pt + ' | ' : '') + st;
		},

		setPageOptions: function() {
			var st, pt, titlePage, titleOg, titleTwitter, description, descriptionOg, descriptionTwitter, keywords;
			
			if (!this.getOption('dynamicTitle') && !!fox.site.dl) {
				st = fox.site.dl.getObjectValue('title') || 'MC';
				pt = this.getOption('title');
				pt = fox.isFunction(pt) ? pt.call(null) : pt;
				titlePage = (pt ? pt + ' | ' : '') + st;
				
				document.title = titlePage;
				(titleOg = document.querySelector('meta[property="og:title"]')) &&
				titleOg.setAttribute('content', titlePage);
				(titleTwitter = document.querySelector('meta[name="twitter:title"]')) &&
				titleTwitter.setAttribute('content', titlePage);
			}

			desc = this.getOption('description');
			desc = fox.isFunction(desc) ? desc.call(null) : desc;
			(description = document.querySelector('meta[name="description"]')) &&
			description.setAttribute('content', desc);
			(descriptionOg = document.querySelector('meta[property="og:description"]')) &&
			descriptionOg.setAttribute('content', desc);
			(descriptionTwitter = document.querySelector('meta[name="twitter:description"]')) &&
			descriptionTwitter.setAttribute('content', desc);

			(keywords = document.querySelector('meta[name="keywords"]')) &&
			keywords.setAttribute('content',  this.getOption('keywords'));
		},

		activate: function() {
			var changed = this.controlledNaviParamsUpdated();
			this.callParent('activate', arguments);
			this.controlledNaviParamsChanged();

			fox.site.page = {alias: this.getAlias()};

			this.hookWrapper('setPageOptions');
			this.dispatchEvent('setPageOptions');
		},

		controlledNaviParamsChanged: function() {
			this.dispatchEvent('controlledNaviParamsChanged');
		},

		controlledNaviParamsHandler: function() {
			if (this.controlledNaviParamsUpdated()) {
				this.controlledNaviParamsChanged();
			}
		},

		controlledNaviParamsUpdated: function() {
			var changed = false;
			fox.each(this.getOption('naviParamsControl'), function(paramName) {
				var value = fox.Navigator.get(paramName);
				if (this._controlledParams[paramName] != value) {
					this._controlledParams[paramName] = value;
					changed = true;
				}
			}, this);
			return changed;
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
	'use strict';

	var _ = {
		ERROR_SERVERCONNECT: 'server error',

		MIN_TIMEOUT_SOCKET_RECONNECT: 1000,
		MAX_TIMEOUT_SOCKET_RECONNECT: 30000,

		INBOX_EVENT_PREFIX: 'inboxSocketEvent',

		attemptsCount: 0,
		
		socketReady: function () {
			this._isReady = true;
			this.dispatchEvent('socketReady');
		},

		sendApi: function(api, params) {
			var message = {
				wom: '@' + api.getId(),
				params: params
			};

			this.socket.send(message);
		},

		getTimeout: function () {
			var result = this.MIN_TIMEOUT_SOCKET_RECONNECT * Math.pow(Math.E, this.attemptsCount);

			if (result < this.MAX_TIMEOUT_SOCKET_RECONNECT) {
				this.attemptsCount++;

				return result;
			}


			return this.MAX_TIMEOUT_SOCKET_RECONNECT;
		}
	};

	fox.registerWidget('Socket', {
		configure: function(options) {
			var l = document.location;

			this.registerOptions('', {
				'address': l.protocol + '//' + l.hostname + ':' + l.port,
				'path': '/ws'
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.waitPool = [];
			this.inboxPool = [];
			this._isReady = false;
			if (navigator.userAgent === 'FoxPhantom') {
				return false;
			}

			if (window.io) {
				this.socketInited();
			} else {
				var script = document.createElement('script');
				script.onload = fox.bind(this.socketInited, this);
				script.src = this.getOption('address') + (this.getOption('path') || '') + '/socket.io/socket.io.js';
				document.body.appendChild(script);
			}

			Object.defineProperty(this._wom.getRoot(), 'Socket', {
				get: function() {return this._wom.getRoot().rwom1('#socket');}.bind(this)
			});
		},

		socketConnect: function () {
			if (!this.socket) {
				this.socket = window.io.connect(this.getOption('address'), {
					path: (this.getOption('path') || '') + '/socket.io',
					enablesXDR: true,
					reconnection: true,
					reconnectionDelay: _.getTimeout()
				});
			} else {
				setTimeout(fox.bind(function () {
					this.socket.connect();
				}, this), _.getTimeout());
			}
		},

		socketInited: function() {
			if (typeof window.io === 'undefined') {
				return;
			}

			this.socketConnect();

			this.socket.on('message', fox.bind(this.inbox, this));

			this.socket.on('connect', fox.bind(function() {
				_.socketReady.call(this);
				fox.each(this.waitPool, function(request) {
					_.sendApi.apply(this, request);
				}, this);
			}, this));

			this.socket.on('reconnecting',fox.bind(function() {
				this._isReady = false;
			}, this));

			this.socket.on('connect_error',fox.bind(function(e) {
				this._isReady = false;
				this.dispatchEvent('socketConnectError');

				if (e.message === _.ERROR_SERVERCONNECT) {
					this.socket.disconnect();
				} else {
					this.socketConnect();
				}
			}, this));

			this.socket.on('disconnect',fox.bind(function(e) {
				console.log('Socket disconnected:', e);
				this._isReady = false;
				this.dispatchEvent('socketDisconnected');
				this.socketConnect();
			}, this));
		},

		isReady: function() {
			return this._isReady;
		},

		sendApiRequest: function(api, params) {
			if (this.socket) {
				return _.sendApi.call(this, api, params);
			}

			this.waitPool.push([api, params]);
		},

		inbox: function(message) {
			this.inboxPool.push(message);

			try {
				message = JSON.parse(message);
				message.response = message.response ? JSON.parse(message.response) : {};
			} catch (e) {
				return;
			}

			var transit = (message || {}).transit || {};

			if (transit.wom) {
				var w = fox.wom.selectFirst(transit.wom);
				if (!w) {
					return;
				}
				w.dispatchResponseEvent({answer: message.response});
			} else if (transit.topic) {
				this.dispatchEvent([_.INBOX_EVENT_PREFIX, fox.ucfirst(transit.topic)].join(''), {
					answer: fox.isEmpty(message.response) ?
						message.message :
						message.response
				});
			}
		},

		send: function(message) {
			this.socket.send(message);
		}
	}, 'Controller');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('ThroughNotifications', {

		configure: function(options) {
			this.referenceData = {};

			this.registerOptions('', {
				doNotTrackPosNote: false,
				widgets: {
					throughNotificationsContainer: {
						widget: 'Widget',
						'embed.container': '.mc-through-notifications-container',
						autoRender: true,
						template: 'throughnotification_global_body',
						'widgets.notices': {
							widget: 'AdvancedList',
							'embed.container': '.list',
							'tpl.row': 'new_notice',
							'handleDom.closeNotice': {
								event: 'click',
								target: '.notice-close',
								callback: '@parent @parent:_removeNotification'
							}
						},

						handleWom: {
							onAddedToDom: {
								widget: '@parent .Widget',
								event: "addedToDom",
								callback: fox.bind(function () {
									if (!this.getOption('doNotTrackPosNote')) {
										this.handleScrolling({top: (window.scrollY || window.pageYOffset)});
									}
								}, this)
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.containerWidget = this.getContainerWidget();
			this.listWidget = this.getListWidget();

			this._defaultTemplate = fox.clone(this.listWidget.getOption('tpl.row'));

			if (!this.getOption('doNotTrackPosNote')) {
				this.handleEvent(this.wom1('@parent @parent #windowScrollHandler'), 'scrolling', this.handleScrolling, {prefix: 'notifications'});
			}

			this.callParent('running', arguments);
		},

		getContainerWidget: function () {
			return this.wom1('#throughNotificationsContainer');
		},

		getListWidget: function () {
			return this.getContainerWidget().wom1('#notices');
		},

		setListTemplate: function (tpl) {
			this.getListWidget().setOption('tpl.row', tpl);
		},

		resetListTemplate: function (tpl) {
			this.getListWidget().setOption('tpl.row', this._defaultTemplate);
		},

		pushNotification: function (params) {
			var noticeList = this.getListWidget();
			var alias = params.noticeAlias;

			if (!alias) {
				console.warn('notice alias is required');

				return;
			}

			this.resetListTemplate();

			if (params.noticeTemplate) {
				this.setListTemplate(params.noticeTemplate);
			}

			if (params.listenWidgetDeactivate) {
				this.addDeactivateHandler(params.listenWidgetDeactivate, alias);
			}

			if (this.referenceData[alias]) {

				this.updateNotification(alias, {
					type: params.noticeType,
					message: params.noticeMessage
				});

			} else {

				this.addNotification(alias, {
					type: params.noticeType,
					message: params.noticeMessage
				});

			}

			if (fox.isNumeric(params.delayClose)) {
				alias = fox.clone(alias);

				window.setTimeout(fox.bind(function () {
					this.pullNotification(alias);
				}, this), params.delayClose);
			}
		},

		pullNotification: function (alias) {
			var noticeList = this.getListWidget();
			var id  = this.getReferenceDataByAlias(alias);

			if (!id) {
				return;
			}

			var ind = this.getItemIndexById(id);

			$(noticeList.getRowNode(ind)).addClass('slide-up');

			window.setTimeout(fox.bind(function () {
				noticeList.remove(ind);
				this.removeNotification(alias);
			}, this), 500);
		},

		pullAllNotifications: function (argument) {
			fox.each(this.referenceData, function (val, alias) {
				this.pullNotification(alias);
			}, this);
		},

		updateNotification: function (alias, params) {
			var data = params;

			data.alias = alias;

			this.getListWidget().updateItem(data, this.getItemIndexById(this.referenceData[alias]));
		},

		addNotification: function (alias, params) {
			var data = params;

			data.alias = alias;

			this.getListWidget().appendItem(data);
			this.setReferenceData(alias);
		},

		removeNotification: function (alias) {
			var id = this.referenceData[alias];

			if (id) {
				delete this.referenceData[alias];
			}
		},

		_removeNotification: function (el) {
			this.pullNotification(fox.dom.wrap(el).attr('data-item-alias'));
		},

		handleScrolling: function (offset) {
			var y = offset.top,
				hHeight = this.getHeaderHeight();

			offset = y - hHeight;

			if (y < hHeight) {
				offset = 10;
			}

			this.setContainerOffsetTop(offset);
		},

		setContainerOffsetTop: function (offset) {
			$(this.getContainerWidget().element[0]).css('marginTop', offset + 'px');
		},

		setReferenceData: function (alias) {
			var dataModel = this.getListWidget().dataModel;
			var id;

			if (dataModel.length === 0) {
				this.referenceData[alias] = 1;

				return;
			}

			this.referenceData[alias] = dataModel[(dataModel.length - 1)]._id;
		},

		getReferenceData: function () {
			return this.referenceData;
		},

		getReferenceDataByAlias: function (alias) {
			if (!alias) {
				return;
			}

			return this.referenceData[alias] || null;
		},

		getItemIndexById: function (id) {
			var result = this.getListWidget().getDataById(id);

			return (result !== false ? result.indx : result);
		},

		addDeactivateHandler: function (w, noticeAlias) {
			this.handleEvent(w, 'deactivate', fox.bind(function (wAlias) {
				this.pullNotification(noticeAlias);
			}, this), {once: true, prefix: 'notificationRemove'});
		},

		getHeaderHeight: function (argument) {
			return this.wom1('@parent').getHeight();
		}

	}, 'Controller');

})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid List Widget */

(function(fox) {

	fox.registerWidget('Tools_TabsSwitcher', {
		configure: function(options) {
			this.registerOptions('', {
				'targetWidget': '@parent',
				'event': 'click',
				'activeClass': 'active',
				'switchOnEmbed': false,
			});
			
			return this.callParent('configure', arguments);
		},

		init: function() {
			this._activeItem = false;
			this.ac = this.getOption('activeClass');
			this._vWidget = this.rwom1(this.requireOption('targetWidget'));

			this.items = false;
			this.addDomHandler({
				target: this.requireOption('target'),
				event: this.requireOption('event'),
				targetWidget: this._vWidget,
				callback: 'processEvent'
			}, 'main');

			if (this.getOption('callback')) {
				this.cb = fox.oop.createCallback(this.getOption('callback'), this);
			}

			if (this.getOption('switchOnEmbed') === true) {
				this.getEm().handleHook(this._vWidget, 'onStopRendering', this._switchOnEmbed.bind(this));
			}

			this.callParent('init', arguments);
		},

		_switchOnEmbed: function () {
			var node, itemId;

			if (this._activeItem) {
				if (fox.isString(this._activeItem)) {
					node = this._vWidget.dom1(this._activeItem);
				} else if (fox.dom.isDomNode(this._activeItem)) {
					itemId = this._activeItem.getAttribute('data-' + this.requireOption('name'));

					node = this._vWidget.dom1(['[data-', this.requireOption('name'), '="', itemId, '"]'].join(''));
				}

				this.switchElClass(node);
			}
		},

		deactivate: function () {
			this.items = false;
		
			this.callParent('deactivate', arguments);
		},

		getItems: function() {
			if (this.items === false) {
				this.items = this._vWidget.dom(this.requireOption('target'));
			}
			return this.items;
		},

		getActiveItem: function () {
			return this._vWidget.dom1(['.', this.ac].join(''))
		},

		switchElClass: function (el) {
			fox.dom.removeClass(this.ac, this.getActiveItem());
			fox.dom.addClass(this.ac, el);

			return this;
		},

		processEvent: function(el) {
			this.switchElClass(el);

			this._activeItem = el;

			var itemId = el.getAttribute('data-' + this.requireOption('name'));
			
			if (this.cb) {
				fox.oop.getRealCallback(this.cb)(itemId);
			}
		}

	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SidebarSlider Widget

(function (fox, $) {
	
	fox.registerWidget('WindowScrollHandler', {

		configure: function (argument) {
			this.isDefaultState = true;
			this.topPointPassed = false;
			this.bottomPointPassed = false;

			this.registerOptions('', {
				rootElement: '.wrapper',
				customEnabling: false,
				topOffset: 100,
				bottomOffset: 100
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.topOffset = this.getOption('topOffset') || false;
			this.bottomOffset = this.getOption('bottomOffset') || false;

			this.callParent('init', arguments);
		},

		running: function () {
			if (!this.getOption('customEnabling')) {
				//$(window).on('scroll', {widget: this}, this._handleScroll);
				this.enable();
			}

			this.callParent('running', arguments);
		},

		enable: function () {
			this.disable();

			$(window).on('scroll', {widget: this}, this._handleScroll);
			this.isEnabled = true;
		},

		disable: function () {
			$(window).off('scroll', this._handleScroll);
			this.isEnabled = false;
		},

		isEnabled: function () {
			return this.isEnabled;
		},

		_handleScroll: function (e) {
			var widget = e.data.widget;

			widget.scrolled = widget.getScrolledHeight();
			widget.pageHeight = $(widget.getOption('rootElement')).height();
			widget.windowHeight = $(window).height();

			widget.dispatchEvent('scrolling', {top: widget.scrolled});

			if (widget.topOffset) {
				widget._checkTopOffsetPassing();
			};

			if (widget.bottomOffset) {
				widget._checkBottomOffsetPassing();
			};
		},

		_checkTopOffsetPassing: function () {
			var direction;
			var passed = false;

			if (!this.topPointPassed) {
				if (this.scrolled >= this.topOffset) {
					passed = true;
					this.topPointPassed = true;
					direction = 1
				}
			} else {
				if (this.scrolled < this.topOffset) {
					passed = true;
					this.topPointPassed = false;
					direction = -1;
				}
			}

			if (passed) {
				//console.log('topPointReached', direction)
				this.dispatchEvent('topPointReached', {direction: direction});	
			}
		},

		_checkBottomOffsetPassing: function (argument) {
			var direction;
			var passed = false;
			var total = this.pageHeight - this.scrolled - this.windowHeight;

			if (!this.bottomPointPassed) {
				if (total <= this.bottomOffset) {
					passed = true;
					direction = 1;
					this.bottomPointPassed = true;
				}
			} else {
				if (total > this.bottomOffset) {
					passed = true;
					direction = -1;
					this.bottomPointPassed = false;
				}
			}

			if (passed) {
				this.dispatchEvent('bottomPointReached', {direction: direction});	
			}
		},

		getRootElement: function () {
			this.rootElement = $(widget.getOption('rootElement'));
		},

		getScrolledHeight: function () {
			return window.scrollY || window.pageYOffset; // window.pageYOffset for IE
		},

		setTopOffset: function (offset) {
			this.topOffset = offset;
		},

		setBottomOffset: function (offset) {
			this.bottomOffset = offset;
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./advancedPager.tpl": 70,
	"./dialog.tpl": 71,
	"./throughNotification.tpl": 72
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("advanced_pager", [["ul",{},[["li",{"class":"ch-page"},[["if",{"notempty":"","addclass":"visible","addattr":"data-page:&&1&&"},[],[["prev","notempty",true],["prev","__internal"]]]]],["if",{"notempty":""},[["li",{"class":"ch-page","data-page":"1"},[["textNode",{"text":"1"}]]],["li",{},[["span",{"class":"spacer"},[["textNode",{"text":"..."}]]]]]],[["startSpacer","notempty",true]]],["foreach",{"from":"","item":"page"},[["li",{"class":"ch-page tab-item","data-page":""},[["span",{},[],[["page.page","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addclass":"active"},[],[["page.current","notempty",true]]]],[["page.page","data-page",true]]]],[["pages","from",true]]],["if",{"notempty":""},[["li",{},[["span",{"class":"spacer"},[["textNode",{"text":"..."}]]]]],["li",{"class":"ch-page","data-page":""},[["span",{},[],[["total","__text",true]]]],[["total","data-page",true]]]],[["endSpacer","notempty",true]]],["li",{"class":"ch-page"},[["if",{"notempty":"","addclass":"visible","addattr":"data-page:&&1&&"},[],[["next","notempty",true],["next","__internal"]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("dialog_global_body", [["div",{},[["div",{"class":"contents"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("throughnotification_global_body", [["div",{"class":"page-width list"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(fox) {
	//here we welcome static scope. This is static methods and variables container that is assigned both to constructor and prototype
	//i do not want to use standart for js constructor properties (which use a little less memory) because i want to can simply use static methods both from instance and 
	//constructor having some sugar from _ shorthand and having all data and logic consolidated in one simple declared object.

	var _ = {
		_helpers: {},

		registerHelper: function(name, obj) {
			_._helpers[name] = obj;
		},

		getBaseHelper: function() {
			return _._baseHelper;
		},

		_baseHelper: {
			_alias: '',
			_value: null,
			_message: '',
			_options: {},

			getAlias: function() {
				return this._alias;
			},

			setValue: function(value) {
				this._value = value;
				return this;
			}, 

			setMessage: function(msg) {
				this._message = msg;
				return this;
			},

			getMessage: function() {
				return this._message;
			},

			setOptions: function(options) {
				this._options = options;
				return this;
			}
		}
	};

	//private static. 
	var __getHelper = function(rule) {
		if (!fox.isSet(_._helpers[rule.validator])) {
			throw "No such validator";
		}

		var h = new _._helpers[rule.validator];
		return h.setMessage(rule.message || 'Value is invalid').setOptions(rule.options || {});
	};

	var __constructor = function () {
		this._ = _; 
		this._rules = {};
		this._validators = {};
		this._errorStack = {};
		this._state = false;
		this._fieldState = {};
		this._rulesChanged = true;
	};

	var Validator = fox.extend({

		setRules: function(rules) {
			fox.each(rules, function(ruleSet, field) {
				fox.each(ruleSet, function(rule){
					this.addRule(field, rule);
				}, this);
			}, this);

			return this;
		},

		addRule: function(field, rule) {
			this._rulesChanged = true;
			this._fieldState[field] = false;
			this._rules[field] = this._rules[field] || [];
			this._rules[field].push(rule);
			return this;
		},

		getInvalidFields: function() {
			var fields = [];

			fox.each(this._errorStack, function(desc, f) {
				fields.push(f);
			});

			return fields;
		},

		getErrors: function() {
			return this._errorStack;
		},

		isValid: function() {
			return this._state;
		},

		validate: function(field, value, option) {
			this._clearErrors(field)._compileRules();
			var fieldValid = true;

			if (fox.isSet(this._validators[field])) {
				fox.each(this._validators[field], function(v) {
					var result = v.setValue(value).validate(option);
					fieldValid = result && fieldValid;

					if (!result) {
						this._logError(field, v.getAlias(), value, v.getMessage());
					}
				}, this);
			}

			this._updateState(field, fieldValid);
			return fieldValid;
		},

		getFieldFirstMessage: function(field) {
			var
				fm;

			if (!this._fieldState[field] && this._errorStack[field] && this._errorStack[field][0]) {
				return this._errorStack[field][0]['message'];
			} else {
				fm = fox.toArray(this._errorStack).shift();

				return fm && fm.length && fm[0]['message'];
			}
		},

		getFieldMessages: function(field) {
			var messages = [];

			if (this._errorStack[field]) {
				fox.each(this._errorStack[field], function(error) {
					messages.push(error.message);
				}, this);
			}

			return messages;
		},

		_updateState: function(field, state) {
			this._fieldState[field] = state;
			this._state = true;

			fox.each(this._fieldState, function(fieldState) {
				this._state = fieldState && this._state;
			}, this);
		},

		_logError: function(field, validator, value, message) {
			this._errorStack[field] = this._errorStack[field] || [];
			this._errorStack[field].push({
				'validator': validator,
				'value': value,
				'message': message
			});
			return this;
		},

		_clearErrors: function(field) {
			field = field || null;

			if (!field) {
				this._errorStack = {};
				return this;
			}

			delete this._errorStack[field];

			return this;
		},

		_compileRules: function() {
			if (!this._rulesChanged) {
				return this;
			}

			this._validators = {};

			fox.each(this._rules, function(rules, field) {
				this._validators[field] = [];

				fox.each(rules, function(rule) {
					this._validators[field].push(__getHelper(rule));
				}, this);
			}, this);

			this._rulesChanged = false;

			return this;
		}

	}, null, __constructor, 'Validator');

	Validator._ = _;

	__webpack_require__(74)(fox, Validator);
	__webpack_require__(75)(fox, Validator);
	__webpack_require__(76)(fox, Validator);
	__webpack_require__(77)(fox, Validator);
	__webpack_require__(78)(fox, Validator);

	fox.Validator = Validator;
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (fox, v) {
	var alias = 'length';
	var Validator_Length = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Length, fox.mixin({
		validate: function() {
			var isValid = true;
			var value = fox.isString(this._value) ? this._value : this._value.toString();
			var valueLength = value.length;

			if (fox.isSet(this._options.min)) {
				isValid = (valueLength >= this._options.min) && isValid;
			}

			if (fox.isSet(this._options.max)) {
				isValid = (valueLength <= this._options.max) && isValid;
			}

			return isValid;
		}
	}, v._.getBaseHelper()), null, 'Validator_Length'));
};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function (fox, v) {
	var alias = 'mandatory';

	var Validator_Mandatory = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Mandatory, fox.mixin({
		validate: function() {
			return !((this._value === '') || (this._value === null));
		}
	}, v._.getBaseHelper()), null, 'Validator_Mandatory'));
};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (fox, v) {
	var alias = 'postalcode';
	var Validator_Postalcode = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Postalcode, fox.mixin({
		_regexpGroups: {
			0: /^[\w\W]*$/i,
			1: [/^\d{4}$/i, 'NNNN'],
			2: [/^\d{5}$/i, 'NNNNN'],
			3: [/^[a-zA-Z]{4}\s?\d[a-zA-Z]{2}$/i, 'AAAA[ ]NAA'],
			4: [/^\d{6}$/i, 'NNNNNN'],
			5: [/^\d{3}$/i, 'NNN'],
			6: [/^\d{3}\-?\d{4}$/i, 'NNN[-]NNNN'],
			7: [/^\d{4,5}$/i, 'NNNN[N]'],
			8: [/^\d{3}\s?\d{2}$/i, 'NNN[ ]NN'],
			9: [/^\d{2}$/i, 'NN'],
			10: [/^\d{5}(\-\d{4}|)$/i, 'NNNNN[-NNNN]'],
			11: [/^\d{3}\-?\s?\d{3}$/i, 'NNN[- ]NNN'],
			12: [/^[a-zA-Z]{2}\-?\s?\d{4}$/i, 'AA[- ]NNNN'],
			13: [/^[a-zA-Z]{2}\-?\s?\d{5}$/i, 'AA[- ]NNNNN'],
			14: [/^[a-zA-Z]{2}\d\d?\s?\d[a-zA-Z]{2}$/i, 'AAN[N ]AA'],
			15: [/^\d{7}$/i, 'NNNNNNN']
		},
		_countries: {
			'AC': 3, 'AE': 0, 'AF': 1, 'AG': 0, 'AL': 1, 'AM': 1, 'AO': 0, 'AT': 1, 'AU': 1, 'AW': 0, 'AX': 2, 'AZ': 12,
			'BA': 2, 'BB': 13, 'BD': 1, 'BE': 1, 'BF': 0, 'BG': 1, 'BI': 0, 'BJ': 0, 'BL': 2, 'BN': 12, 'BO': 1, 'BQ': 0, 'BS': 0, 'BT': 5, 'BW': 0, 'BY': 4, 'BZ': 0,
			'CC': 1, 'CD': 0, 'CF': 0, 'CG': 0, 'CH': 1, 'CI': 0, 'CK': 0, 'CL': 6, 'CM': 0, 'CN': 4, 'CO': 4, 'CR': 7, 'CU': 2, 'CV': 1, 'CW': 0, 'CX': 1, 'CY': 1, 'CZ': 8,
			'DE': 2, 'DJ': 0, 'DK': 1, 'DM': 0, 'DO': 2, 'DZ': 2,
			'EC': 4, 'EE': 2, 'EG': 2, 'ER': 0, 'ES': 2, 'ET': 1,
			'FI': 2, 'FJ': 0, 'FK': 3, 'FM': 2, 'FO': 5, 'FR': 2,
			'GD': 0, 'GE': 1, 'GF': 2, 'GG': 14, 'GH': 0, 'GL': 1, 'GM': 0, 'GN': 0, 'GP': 2, 'GQ': 0, 'GR': 8, 'GT': 2, 'GU': 2, 'GW': 1, 'GY': 0,
			'HK': 0, 'HM': 1, 'HN': 2, 'HR': 2, 'HT': 1, 'HU': 1,
			'ID': 2, 'IE': 0, 'IL': 15, 'IM': 14, 'IN': 11, 'IO': 3, 'IQ': 2, 'IS': 5, 'IT': 2,
			'JM': 9, 'JO': 2, 'JP': 6,
			'KE': 2, 'KG': 4, 'KH': 2, 'KI': 0, 'KM': 0, 'KN': 0, 'KP': 0, 'KR': 11, 'KW': 2, 'KY': 12, 'KZ': 4,
			'LA': 2, 'LC': 0, 'LI': 1, 'LK': 2, 'LR': 1, 'LS': 5, 'LT': 13, 'LU': 1, 'LV': 12, 'LY': 2,
			'MA': 2, 'MD': 12, 'ME': 2, 'MF': 2, 'MG': 5, 'MH': 2, 'MK': 1, 'ML': 0, 'MM': 2, 'MN': 2, 'MO': 0, 'MP': 2, 'MQ': 2, 'MR': 0, 'MS': 0, 'MU': 0, 'MV': 7, 'MW': 0, 'MX': 2, 'MY': 2, 'MZ': 1,
			'NA': 2, 'NC': 2, 'NE': 1, 'NF': 1, 'NG': 4, 'NI': 2, 'NO': 1, 'NP': 2, 'NR': 0, 'NU': 0, 'NZ': 1,
			'OM': 5,
			'PA': 4, 'PE': 2, 'PF': 2, 'PG': 5, 'PH': 1, 'PK': 2, 'PM': 2, 'PN': 3, 'PR': 2, 'PW': 2, 'PY': 1,
			'QA': 0,
			'RE': 2, 'RO': 4, 'RS': 2, 'RS': 2, 'RU': 4,
			'SA': 10, 'SB': 0, 'SC': 0, 'SD': 2, 'SE': 8, 'SG': 9, 'SK': 8, 'SL': 0, 'SM': 2, 'SN': 2, 'SO': 0, 'SR': 0, 'ST': 0, 'SX': 0, 'SY': 0,
			'TD': 2, 'TF': 0, 'TG': 0, 'TH': 2, 'TJ': 4, 'TK': 0, 'TL': 0, 'TM': 4, 'TN': 1, 'TO': 0, 'TR': 2, 'TT': 4, 'TV': 0, 'TW': 2, 'TZ': 0,
			'UA': 2, 'UG': 0, 'US': 10, 'UY': 2, 'UZ': 11,
			'VC': 12, 'VG': 12, 'VI': 2, 'VN': 4, 'VU': 0,
			'WF': 2,
			'XK': 2,
			'YE': 0, 'YT': 2,
			'ZA': 1, 'ZM': 2, 'ZW': 0,
			'AD': [/^AD\d{3}$/i, 'AANNN'], 'AI': [/^AI\-2640$/i, 'AI-2640'], 'AR': [/^[a-zA-Z]\d{4}[a-zA-Z]{3}$/i, 'ANNNNAAA'], 'AS': [/^\d{5}(\-\d{4,6}|)$/i, 'NNNNN[-NNNN[NN]]'],
			'BH': [/^\d{3,4}$/i, 'NNN[N]'], 'BM': [/^[a-zA-Z]{2}\s?(\d{2}|[a-zA-Z]{2})$/i, 'AA[ ]NN or AA[ ]AA)'], 'BR': [/^\d{5}-\d{3}$/i, 'NNNNN-NNN'],
			'CA': [/^([a-zA-Z]\d[a-zA-Z]\s+\d[a-zA-Z]\d)$/i, 'ANA NAN'],
			'GA': [/^\d{2}\s?\w*\s?\d{2}$/i, 'NN[ ]city[ ]NN'], 'GB': [/^[a-zA-Z]{1,2}\d[a-zA-Z0-9]?\s?\d[a-zA-Z]{2}$/i, 'A(A)N(A/N)NAA or A[A]N[A/N] NAA'], 'GI': [/GX11\s1AA/i, 'GX11 1AA'], 'GS': [/^SIQQ\s?1ZZ$/i, 'SIQQ 1ZZ'],
			'IR': [/^\d{5}\-\d{5}$/i, 'NNNNN-NNNNN'], 'JE': [/^JE\d\s?\d[a-zA-Z]{2}$/i, 'AAN[ ]NAA'],
			'LB': [/^\d{4}\s?\d{4}$/i, 'NNNN[ ]NNNN'],
			'MC': [/^980\d{2}$/i, '980NN'], 'MT': [/^[a-zA-Z]{3}\s?\d{4}$/i, 'AAA[ ]NNNN'],
			'NL': [/^\d{4}\s?[a-zA-Z]{2}$/i, 'NNNN[ ]AA'],
			'PL': [/^\d{2}\-?\d{3}$/i, 'NN-NNN'], 'PT': [/^\d{4}(\-|\s)\d{3}$/i, 'NNNN[- ]NNN'],
			/*'SH': [/^STHL\s?1ZZ$/i, 'STHL 1ZZ'],*/ 'SH': [/^TDCU\s?1ZZ$/i, 'TDCU 1ZZ'], 'SI': [/^(SI\s?|)\d{4}$/i, '[AA]NNNN'], 'SV': [/^01101$/i, '01101'], 'SZ': [/^[a-zA-Z]\d{3}$/i, 'ANNN'],
			'TC': [/^TKCA\s?1ZZ$/i, 'TKCA 1ZZ'],
			'VA': [/^00120$/i, '00120'], 'VE': [/^\d{4}(\s?[a-zA-Z]|)$/i, 'NNNN[ A]']
		},
		_regexp: null,

		_init: function() {
			if (this._options.country && this._countries[this._options.country] && this._regexpGroups[this._countries[this._options.country]]) {
				this._regexp = this._regexpGroups[this._countries[this._options.country]];
			}
		},

		validate: function(country) {
			var message = 'Wrong postal code';
			var regexp = null;

			if (country && fox.isSet(this._countries[country])) {
				if (fox.isNumeric(this._countries[country])) {
					check = this._regexpGroups[this._countries[country]];
				} else {
					check = this._countries[country];
				}

				if (fox.isArray(check)) {
					message += ' [format: ' + check[1] + ']';
					regexp = check[0];
				} else {
					regexp = check;
				}

				this.setMessage(message);
				return regexp.test(this._value);
			} else if (this._regexp) {
				return this._regexp.test(this._value);
			} else {
				return false;
			}
		}
	}, v._.getBaseHelper()), null, 'Validator_Postalcode'));
};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (fox, v) {
	var alias = 'range';
	var Validator_Range = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Range, fox.mixin({
		validate: function() {
			var isValid = true;

			if (fox.isSet(this._options.min)) {
				isValid = (this._value >= this._options.min) && isValid;
			}

			if (fox.isSet(this._options.max)) {
				isValid = (this._value <= this._options.max) && isValid;
			}

			return isValid;
		}
	}, v._.getBaseHelper()), null, 'Validator_Range'));
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (fox, v) {
	var alias = 'regexp';
	var Validator_Regexp = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Regexp, fox.mixin({
		_predefined: {
			emailCaseInsensitive: fox.regexp.email,
			email: /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
			decimal: fox.regexp.decimal,
			int: fox.regexp.int,
			onlyEnLet:/^[a-zA-Z][a-zA-Z0-9-_\.]{1,20}$/,
			onlyLatinText: /^[\w\s\.\-,\(\)\/\\]+$/i,
			hostname: fox.regexp.hostname,
			ip: fox.regexp.ip
		},
		_regexp: null,

		_init: function() {
			if (this._options.type && this._predefined[this._options.type]) {
				this._regexp = this._predefined[this._options.type];
			} else if (this._options.regexp) {
				if (fox.isString(this._options.regexp)) {
					this._regexp = new RegExp(this._options.regexp);
				} else {
					this._regexp = this._options.regexp;
				}
			}
		},

		validate: function() {
			if (this._regexp === null) {
				this._init();
			}

			if (!this._regexp) {
				return true;
			}

			return this._regexp.test(this._value);
		}
	}, v._.getBaseHelper()), null, 'Validator_Regexp'));
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	var servicesCtx = __webpack_require__(80);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			context(m)(fox);
		});
	}

	getDeps(servicesCtx);
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dataobject.js": 81,
	"./fileuploader.js": 82,
	"./ga.js": 83
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	var DataObject = function(layer) {
		this._index = fox.clone(layer._indexedCollection);
		this._pointer = 0;
		this._objClass = 'DataObject'; 
	};

	fox.registerService('DataObject', fox.extend(DataObject, fox.mixin({
		get: function(name) {
			if (name[0] == '_') return this.getMetaValue(name);
			
			if(/\./.test(name)) {
				var tmp = /^(.*?)\.(.*?)$/.exec(name);
				var rel = this.relation(tmp[1]);
				return rel.getObject().get(tmp[2]);
			}
			return this._index && this._index[this._pointer] ? this._index[this._pointer][name] : false;
		},
		getCount: function() {
			return this._index.length;
		},
		getRelatedObject: function (name) {
			var dl = this.relation(name);
			return dl ? dl.iterateObject('first') : false;
		},
		relation: function(name, dl) {
			var data = this.get(name);
			if (!data || !fox.isDl(data)) {
				return fox.hydrateDl(data, dl);
			}
			return data;
		},
		getMetaValue: function(name) {
			return fox.arrayRelation(this._index[this._pointer], name);
		},
		getAll: function() {
			return this._index[this._pointer] || false;
		},
		set: function(name, value) {
			this._index[this._pointer] && (fox.isObject(name) ? (this._index[this._pointer] = name) : (this._index[this._pointer][name] = value));
			return this;
		},
		merge: function(values) {
			this._index[this._pointer] && fox.merge(this._index[this._pointer], values);
			return this;
		},
		toJSON: function() {
			var value;
			return (value = this.getAll()) ? JSON.strigify(value) : false;
		},
		end: function() {
			this._pointer = this._index.length - 1;
		},
		
		//iteration methods
		next: function() {
			var max = this._index.length;
			return (++this._pointer < max) ? this : (this._pointer = max - 1) && false;
		},

		prev: function() {
			return (--this._pointer >= 0) ? this : (this._pointer = 0) || false;
		},
		
		reset: function() {
			return this._pointer = 0;
		}
	}), null, 'DataObject'));
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	var FileUploaderC = function() {
		this._objClass = 'FileUploader';
		fox.registerObject(this);
	};


	var FileUploader = fox.extend({
		configure: function(url, fileName, fileElm, callbacks) {
			this.url = url || '?';
			this.fileName = fileName || 'file';
			this.fileElm = fileElm;
			this.fileType = fileElm.type;
			this.callbacks = callbacks || {};
			this.status = null; // means uploader is not used yet
			this.progress = 0;
			this.xhr = new XMLHttpRequest;

			fox.each(['loadstart', 'progress', 'abort', 'error', 'load', 'timeout', 'loadend'], fox.bind(function(event) {
				fox.dom.on(event, this.xhr.upload, fox.bind(function(e) {
					if (event == 'loadstart') {
						this.progress = 0;
						this.oldonbeforeunload = window.onbeforeunload;
						window.onbeforeunload = this.unloadNotice;
					} else if (event == 'progress') {
						this.progress = e.loaded / e.total * 100;
					} else if (event == 'loadend' && window.onbeforeunload == this.unloadNotice) {
						window.onbeforeunload = this.oldonbeforeunload;
					}

					this.status = event;
					this.dispatchEvent(event, e);
				}, this));
			}, this));
		},

		unloadNotice: function() {
			return "File upload is in progress, please wait until it's over";
		},

		instance: function(indetifier) {
			return this;
		},

		getStatus: function() {
			return this.status;
		},

		getProgress: function() {
			return this.progress;
		},

		isFree: function() {
			return !fox.inArray(['loadstart', 'progress'], this.status);
		},

		setTypeFilter: function(regexp) {
			if (typeof regexp == 'object' && regexp.constructor == RegExp) {
				this._typeFilter = regexp;
			}
		},

		send: function(additionalFields) {
			var formData = new FormData;

			if (this._typeFilter && !this._typeFilter.test(this.fileType)) {
				this.dispatchEvent('unfiltered');
				return;
			}
			
			if (typeof additionalFields == 'object') {
				fox.each(additionalFields, function(value, field) {
					formData.append(field, value);
				});
			}
			
			formData.append(this.fileName, this.fileElm);

			/**
			 * Events:
			 *
			 * loadstart - When the request starts.
			 * progress - While sending and loading data.
			 * abort - When the request has been aborted. For instance, by invoking the abort() method.
			 * error - When the request has failed.
			 * load - When the request has successfully completed.
			 * timeout - When the author specified timeout has passed before the request could complete.
			 * loadend - When the request has completed (either in success or failure).
			 */

			this.xhr.open('POST', this.url, true);
			this.xhr.send(formData);
		},

		abort: function() {
			this.xhr.abort();
		}
	}, fox.BaseObject, FileUploaderC, 'FileUploader');

	FileUploader._instances = {};
	FileUploader.instance = function(alias) {
		if (!FileUploader._instances[alias]) {
			FileUploader._instances[alias] = new FileUploader;
		}

		return FileUploader._instances[alias];
	};

	FileUploader.instanceExists = function(alias) {
		return typeof FileUploader._instances[alias] != '[object]';
	};

	fox.registerService('FileUploader', FileUploader);
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerService('googleAnalytics', {
		_included: false,
		_accounts: [],

		include: function() {
			if (this._included) {
				return;
			}

			_gaq = [];
			var ga = document.createElement('script');
			ga.type = 'text/javascript';
			ga.async = true;
			ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
			_gaScriptLoaded = false;
			ga.onload = function() {
				_gaScriptLoaded = true;
			};
			document.body.appendChild(ga);
			this._included = true;
		},

		setAccounts: function(accounts) {
			var typeOfArg = Object.prototype.toString.call(accounts);

			switch (typeOfArg) {
				case '[object String]':
					this._accounts = accounts.split(',');
				break;

				case '[object Array]':
					this._accounts = accounts;
				break;

				default:
					throw 'The first argument should be an array or a string, ' + typeOfArg + ' passed';
			}
		},

		getAccounts: function() {
			return this._accounts;
		},

		_query: function(par) {
			fox.each(this._accounts, function(account, index) {
				var gaPrefix = 'account' + index + '.';

				_gaq.push([gaPrefix + '_setAccount', account]);
				_gaq.push([gaPrefix + '_setSiteSpeedSampleRate', 100]);
				_gaq.push([
					gaPrefix + '_setCustomVar',
					/* This custom var is set to slot #1.  Required parameter. */
					1,
					/* The name. Required parameter. */
					'isUser',
					/* This value of the custom variable.  Required parameter. */
					fox.isEmpty(fox.site.member) ? "0" : "1",
					/* Sets the scope to page-level. */
				 	3
				]);

				// @todo move to amc
				var foxref = null;
				var acode = null;

				if (foxref = fox.cookie.get('foxref')) {
					_gaq.push([gaPrefix + '_setCustomVar', 2, 'foxref',	foxref,	3]);
				}

				if (acode = fox.cookie.get('acode')) {
					_gaq.push([gaPrefix + '_setCustomVar', 3, 'acode', acode, 3]);
				}

				var queryData = par.params;
				queryData.unshift(gaPrefix + par.method);				
				_gaq.push(queryData);
				par.params.shift();
			});
		},

		trackPageview: function(page, logPage) {
			this._query({method: '_trackPageview', params: ['/' + page]});
			// @todo move to amc
			var logPage = typeof logPage !== 'undefined' ? logPage : false;

			if (fox.isEmpty(fox.site.member)) {
				var api = new fox.Api().method('affiliate.track');
				var data = {
					page: page
				};

				var foxref = null;

				if (foxref = fox.cookie.get('foxref')) {
					data.refCode = foxref;
				}

				api.send(data, false);
			}

			if (!fox.isEmpty(fox.site.member) && logPage) {
				var api = new fox.Api().method('logger.log');
				api.send({
					index: 'McUserActivity',
					path: fox.Navigator.getAll()
				}, false);	
			}
		},

		trackTiming: function(params) {
			this._query({method: '_trackTiming', params: params});
		}
		
	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

if(typeof fancentro_promo === 'undefined') {var e = new Error("Cannot find module \"fancentro_promo\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = fancentro_promo;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// pk.1.js